import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type ReactiveFunction<TParam> = () => TParam;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  Json: { input: any; output: any; }
  NaiveDateTime: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export enum AdDimension {
  Banner = 'BANNER',
  Billboard = 'BILLBOARD',
  LargeBanner = 'LARGE_BANNER',
  MediumRectangle = 'MEDIUM_RECTANGLE',
  MyShopiBanner = 'MY_SHOPI_BANNER',
  SplashAppBanner = 'SPLASH_APP_BANNER'
}

export enum AdDisplayAt {
  BlogDetailBottom = 'BLOG_DETAIL_BOTTOM',
  BlogDetailTop = 'BLOG_DETAIL_TOP',
  Brand = 'BRAND',
  BrochureAbove = 'BROCHURE_ABOVE',
  BrochureEndAboveGoogleMaps = 'BROCHURE_END_ABOVE_GOOGLE_MAPS',
  BrochureEndInteresting = 'BROCHURE_END_INTERESTING',
  BrochureEndLeft = 'BROCHURE_END_LEFT',
  BrochureEndRight = 'BROCHURE_END_RIGHT',
  BrochureStart = 'BROCHURE_START',
  BrochureStartBottom = 'BROCHURE_START_BOTTOM',
  BrochureViewerInterface = 'BROCHURE_VIEWER_INTERFACE',
  Categories = 'CATEGORIES',
  Category = 'CATEGORY',
  CategoryAboveBrochures = 'CATEGORY_ABOVE_BROCHURES',
  FavoritesEnd = 'FAVORITES_END',
  HomepageBottom = 'HOMEPAGE_BOTTOM',
  HomepageImpact = 'HOMEPAGE_IMPACT',
  HomepageTop = 'HOMEPAGE_TOP',
  ImpactApp = 'IMPACT_APP',
  NewBrochures = 'NEW_BROCHURES',
  NewBrochuresBottom = 'NEW_BROCHURES_BOTTOM',
  NewBrochuresWeb = 'NEW_BROCHURES_WEB',
  Shop = 'SHOP',
  ShopCard = 'SHOP_CARD',
  Splash = 'SPLASH',
  SplashApp = 'SPLASH_APP'
}

export type AdHtmlContent = {
  adDimension: AdDimension;
  content: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export enum AdPlatformType {
  Android = 'ANDROID',
  Ios = 'IOS',
  Web = 'WEB'
}

export enum AdStatusAll {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED',
  Paused = 'PAUSED',
  Removed = 'REMOVED'
}

export enum AdStatusV2 {
  Enabled = 'ENABLED',
  Paused = 'PAUSED',
  Removed = 'REMOVED'
}

export enum AdTargetType {
  Default = 'DEFAULT',
  Fallback = 'FALLBACK'
}

export enum AdTimeStepEnum {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK'
}

export enum AdType {
  HtmlEmbed = 'HTML_EMBED',
  ImageAd = 'IMAGE_AD'
}

export type AdUpload = {
  adDimension: AdDimension;
  file: Scalars['Upload']['input'];
  url: Scalars['String']['input'];
};

export type AdminBrochureReadEntity = {
  __typename?: 'AdminBrochureReadEntity';
  androidReads: Scalars['Int']['output'];
  date: Scalars['String']['output'];
  embedReads: Scalars['Int']['output'];
  iosReads: Scalars['Int']['output'];
  totalReads: Scalars['Int']['output'];
  webReads: Scalars['Int']['output'];
};

export type AdminBrochureReadsInput = {
  categoryIds: Array<InputMaybe<Scalars['ID']['input']>>;
  languageIds: Array<InputMaybe<Scalars['ID']['input']>>;
  shopIds: Array<InputMaybe<Scalars['ID']['input']>>;
  /** Brochures that are published from this date */
  startAt: Scalars['Date']['input'];
  /** Brochures that are published until this date */
  stopAt: Scalars['Date']['input'];
  timeStep: TimeStepEnum;
};

export type AdminFields = {
  /** The categories for which the brochure can be shown at the end of a brochure after the last page. */
  brochureAfterpage: Array<Scalars['ID']['input']>;
  brochureCategories: Array<Scalars['ID']['input']>;
  /** The categories for which the brochure can be shown as the top of a brochure stack. */
  brochureToplevel: Array<Scalars['ID']['input']>;
  customerLevel: CustomerLevel;
  hotspotMode: HotspotMode;
  local?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true then all products in the brochure will be removed from the search. */
  removedProductsFromSearch?: InputMaybe<Scalars['Boolean']['input']>;
  utmCampaign: Scalars['String']['input'];
  utmMedium: Scalars['String']['input'];
};

export type AdminShopEntity = {
  __typename?: 'AdminShopEntity';
  afterpage: Array<CategoryEntity>;
  autoParserSlugFr?: Maybe<Scalars['String']['output']>;
  autoParserSlugNl?: Maybe<Scalars['String']['output']>;
  autoParserType?: Maybe<AutoParserType>;
  categories: Array<CategoryEntity>;
  customerClient?: Maybe<CustomerClientEntity>;
  customerLevel: CustomerLevel;
  fileUrl?: Maybe<Scalars['String']['output']>;
  geminiTaggingPrompt?: Maybe<Scalars['String']['output']>;
  hotspotMode: HotspotMode;
  id: Scalars['ID']['output'];
  lastPage: Scalars['Boolean']['output'];
  localBrochures: Scalars['Boolean']['output'];
  locations: Array<LocationEntity>;
  name: Scalars['String']['output'];
  overwriteUtms: Scalars['Boolean']['output'];
  radius: Scalars['Float']['output'];
  regions: Array<RegionEntity>;
  removedFromSearch: Scalars['Boolean']['output'];
  removedProductsFromSearch: Scalars['Boolean']['output'];
  shopDescriptions: Array<ShopDescriptionEntity>;
  shopKeywords?: Maybe<Scalars['String']['output']>;
  showAds: Scalars['Boolean']['output'];
  slug: Scalars['String']['output'];
  toplevel: Array<CategoryEntity>;
};


export type AdminShopEntityFileUrlArgs = {
  version: ShopFileVersion;
};


export type AdminShopEntityLocationsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};

export type AdminShopInput = {
  shopId: Scalars['ID']['input'];
};

export enum AdminShopOrderBy {
  CustomerLevelAsc = 'CUSTOMER_LEVEL_ASC',
  CustomerLevelDesc = 'CUSTOMER_LEVEL_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  RadiusAsc = 'RADIUS_ASC',
  RadiusDesc = 'RADIUS_DESC'
}

export type AdminShopsInput = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  customerLevel?: InputMaybe<CustomerLevel>;
  hotspotMode?: InputMaybe<HotspotMode>;
  localBrochures?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy: AdminShopOrderBy;
  overwriteUtms?: InputMaybe<Scalars['Boolean']['input']>;
  removedFromSearch?: InputMaybe<Scalars['Boolean']['input']>;
  removedProductsFromSearch?: InputMaybe<Scalars['Boolean']['input']>;
  /** Search for shop name */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type AdsAdvertisementEntity = {
  adDimension: AdDimension;
  adType: AdType;
  adsCampaign?: Maybe<AdsCampaignEntity>;
  categories: Array<Maybe<CategoryEntity>>;
  displayAt: AdDisplayAt;
  /** @deprecated Use displayUrl on AdsAdvertismentImage instead */
  displayUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  impressionsLimit: Scalars['Int']['output'];
  platformType: AdPlatformType;
  shops: Array<Maybe<ShopEntity>>;
  status: AdStatusAll;
  targetType: AdTargetType;
  weight: Scalars['Int']['output'];
};

export type AdsAdvertisementHtmlEmbed = AdsAdvertisementEntity & {
  __typename?: 'AdsAdvertisementHtmlEmbed';
  adDimension: AdDimension;
  adType: AdType;
  adsCampaign?: Maybe<AdsCampaignEntity>;
  categories: Array<Maybe<CategoryEntity>>;
  content: Scalars['String']['output'];
  displayAt: AdDisplayAt;
  /** @deprecated HtmlEmbed ads will no longer have urls. Remove field from any query. */
  displayUrl: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  impressionsLimit: Scalars['Int']['output'];
  platformType: AdPlatformType;
  shops: Array<Maybe<ShopEntity>>;
  status: AdStatusAll;
  targetType: AdTargetType;
  weight: Scalars['Int']['output'];
};

export type AdsAdvertisementImage = AdsAdvertisementEntity & {
  __typename?: 'AdsAdvertisementImage';
  adDimension: AdDimension;
  adType: AdType;
  adsCampaign?: Maybe<AdsCampaignEntity>;
  categories: Array<Maybe<CategoryEntity>>;
  displayAt: AdDisplayAt;
  displayUrl: Scalars['String']['output'];
  fileUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  impressionsLimit: Scalars['Int']['output'];
  platformType: AdPlatformType;
  shops: Array<Maybe<ShopEntity>>;
  status: AdStatusAll;
  targetType: AdTargetType;
  weight: Scalars['Int']['output'];
};

export enum AdsAdvertisementOrderBy {
  DisplayAtAsc = 'DISPLAY_AT_ASC',
  DisplayAtDesc = 'DISPLAY_AT_DESC',
  ImpressionsLimitAsc = 'IMPRESSIONS_LIMIT_ASC',
  ImpressionsLimitDesc = 'IMPRESSIONS_LIMIT_DESC',
  PlatformTypeAsc = 'PLATFORM_TYPE_ASC',
  PlatformTypeDesc = 'PLATFORM_TYPE_DESC',
  StatusAtAsc = 'STATUS_AT_ASC',
  StatusAtDesc = 'STATUS_AT_DESC',
  WeightAsc = 'WEIGHT_ASC',
  WeightDesc = 'WEIGHT_DESC'
}

export type AdsAdvertisementStatisticsOverviewInput = {
  adsCampaignId: Scalars['ID']['input'];
  /** Stats from the campaign ads from this date */
  startAt: Scalars['Date']['input'];
  /** Stats from the campaign ads until this date */
  stopAt: Scalars['Date']['input'];
  timeStep: AdTimeStepEnum;
};

export type AdsAdvertisementStatisticsOverviewListResponse = {
  __typename?: 'AdsAdvertisementStatisticsOverviewListResponse';
  /** How many times all advertisements combined have been clicked. */
  clicks: Scalars['Int']['output'];
  /** Ad campaign id */
  id: Scalars['ID']['output'];
  /** How many times the advertisements have been seen. */
  impressions: Scalars['Int']['output'];
  /** An overview of statistics per advertisement. */
  statisticsEntries: Array<AdvertisementStatisticsEntryEntity>;
  /** The sum per key-value pair of the statistics_entries. */
  sumStatisticsEntry: AdvertisementStatisticsMapsEntity;
};

export type AdsCampaignAdvertisementInput = {
  id: Scalars['ID']['input'];
};

export type AdsCampaignAdvertisementsInput = {
  adsCampaignId: Scalars['ID']['input'];
  orderBy: AdsAdvertisementOrderBy;
};

export type AdsCampaignCreateFormEntity = {
  __typename?: 'AdsCampaignCreateFormEntity';
  adDimensions: Array<AdDimension>;
  displayAtPositions: Array<AdDisplayAt>;
  selectableCategories: Scalars['Boolean']['output'];
  selectableShops: Scalars['Boolean']['output'];
};

export type AdsCampaignCreateFormInput = {
  displayAtPositions: Array<AdDisplayAt>;
  platforms: Array<AdPlatformType>;
};

export type AdsCampaignEntity = {
  __typename?: 'AdsCampaignEntity';
  customerClient: CustomerClientEntity;
  id: Scalars['ID']['output'];
  languageId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  startAt: Scalars['DateTime']['output'];
  status: AdsCampaignStatus;
  stopAt: Scalars['DateTime']['output'];
  targetType: AdTargetType;
};

export type AdsCampaignInput = {
  id: Scalars['ID']['input'];
};

export enum AdsCampaignOrderBy {
  LanguageAsc = 'LANGUAGE_ASC',
  LanguageDesc = 'LANGUAGE_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  StartAtAsc = 'START_AT_ASC',
  StartAtDesc = 'START_AT_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC',
  StopAtAsc = 'STOP_AT_ASC',
  StopAtDesc = 'STOP_AT_DESC',
  TargetTypeAsc = 'TARGET_TYPE_ASC',
  TargetTypeDesc = 'TARGET_TYPE_DESC'
}

export enum AdsCampaignStatus {
  Enabled = 'ENABLED',
  Paused = 'PAUSED',
  Removed = 'REMOVED'
}

export type AdsCampaignsInput = {
  orderBy: AdsCampaignOrderBy;
  status?: InputMaybe<AdsCampaignStatus>;
};

export type AdvertisementStatisticsEntity = {
  __typename?: 'AdvertisementStatisticsEntity';
  displayAt: AdDisplayAt;
  fileUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  platformType: AdPlatformType;
  targetType: AdTargetType;
};

export type AdvertisementStatisticsEntryEntity = {
  __typename?: 'AdvertisementStatisticsEntryEntity';
  adsAdvertisement: AdvertisementStatisticsEntity;
  advertisementStatisticsMapsEntity: AdvertisementStatisticsMapsEntity;
};

export type AdvertisementStatisticsMapsEntity = {
  __typename?: 'AdvertisementStatisticsMapsEntity';
  clicksEntries: Array<StatisticsMap>;
  impressionsEntries: Array<StatisticsMap>;
};

export type AppEntity = {
  __typename?: 'AppEntity';
  domain: Scalars['String']['output'];
  geminiBrandAndOfferStrategy?: Maybe<GeminiBrandAndOfferStrategy>;
  geminiTaggingPrompt?: Maybe<Scalars['String']['output']>;
  genericProductSource?: Maybe<AppEntity>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  taggingStrategy?: Maybe<TaggingStrategy>;
};

export type AppLanguageEntity = {
  __typename?: 'AppLanguageEntity';
  description?: Maybe<Scalars['String']['output']>;
  disclaimer?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  info?: Maybe<Scalars['String']['output']>;
  language: LanguageEntity;
};

export type AppLanguageInput = {
  id: Scalars['ID']['input'];
};

/** A consumer of the app: either an account (identity_user) or a guest newsletter subscriber. */
export type AppUserEntity = {
  __typename?: 'AppUserEntity';
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  insertedAt: Scalars['NaiveDateTime']['output'];
  kind: AppUserKind;
  lastName?: Maybe<Scalars['String']['output']>;
};

export enum AppUserKind {
  IdentityUser = 'IDENTITY_USER',
  NewsletterSubscriber = 'NEWSLETTER_SUBSCRIBER'
}

export type AppUsersInput = {
  orderBy: IdentityUserOrderBy;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ApproveHotspotFieldsInput = {
  hotspotFields: Array<HotspotApprovalField>;
  hotspotId: Scalars['ID']['input'];
};

export type ApproveMergeRequestAsNew = {
  __typename?: 'ApproveMergeRequestAsNew';
  brochure?: Maybe<BrochureEntity>;
  status: MutatedStatus;
};

export type ApproveMergeRequestAsNewInput = {
  mergeRequestId: Scalars['ID']['input'];
};

export type ApproveMergeRequestAsUpdate = {
  __typename?: 'ApproveMergeRequestAsUpdate';
  status: MutatedStatus;
};

export type ApproveMergeRequestAsUpdateInput = {
  mergeRequestId: Scalars['ID']['input'];
  pageFilters?: InputMaybe<Array<PageFilter>>;
};

export type ApprovedAtHotspotField = {
  __typename?: 'ApprovedAtHotspotField';
  brandApprovedAt?: Maybe<Scalars['DateTime']['output']>;
  descriptionApprovedAt?: Maybe<Scalars['DateTime']['output']>;
  nameApprovedAt?: Maybe<Scalars['DateTime']['output']>;
  offerCategoryApprovedAt?: Maybe<Scalars['DateTime']['output']>;
  priceApprovedAt?: Maybe<Scalars['DateTime']['output']>;
  urlApprovedAt?: Maybe<Scalars['DateTime']['output']>;
  user: IdentityUserEntity;
};

export type AssigneeBrochureLog = BrochureLogEntity & {
  __typename?: 'AssigneeBrochureLog';
  content: Scalars['String']['output'];
  insertedAt: Scalars['DateTime']['output'];
  level: BrochureLogLevel;
};

export enum AutoParserType {
  Publitas = 'PUBLITAS',
  Publitasv3 = 'PUBLITASV3',
  Wepublish = 'WEPUBLISH',
  Wepublishv3 = 'WEPUBLISHV3'
}

export type BrandEntity = {
  __typename?: 'BrandEntity';
  app?: Maybe<AppEntity>;
  brandTags: Array<BrandTagEntity>;
  description?: Maybe<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  slug: Scalars['String']['output'];
  status?: Maybe<BrandStatus>;
  syncSource?: Maybe<BrandEntity>;
};


export type BrandEntityFileUrlArgs = {
  version: BrandFileVersion;
};

export enum BrandFileVersion {
  Small = 'SMALL'
}

export type BrandInput = {
  brandId: Scalars['ID']['input'];
};

export enum BrandOrderBy {
  InsertedAtAsc = 'INSERTED_AT_ASC',
  InsertedAtDesc = 'INSERTED_AT_DESC',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  StatusAsc = 'STATUS_ASC',
  StatusDesc = 'STATUS_DESC'
}

export enum BrandStatus {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED'
}

export type BrandTagEntity = {
  __typename?: 'BrandTagEntity';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type BrandsInput = {
  orderBy: BrandOrderBy;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type BrochureCityEntity = {
  __typename?: 'BrochureCityEntity';
  position: Scalars['Int']['output'];
};

export type BrochureCountersInput = {
  brochureExperiment?: InputMaybe<Scalars['Boolean']['input']>;
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  customerLevel?: InputMaybe<CustomerLevel>;
  languageId?: InputMaybe<Scalars['ID']['input']>;
  shopId?: InputMaybe<Scalars['ID']['input']>;
  toplevelCategoryId?: InputMaybe<Scalars['ID']['input']>;
};

export enum BrochureCreateStatus {
  Failed = 'FAILED',
  Finished = 'FINISHED',
  InProgress = 'IN_PROGRESS'
}

export type BrochureDetailStatiticsEntity = {
  __typename?: 'BrochureDetailStatiticsEntity';
  brochure: BrochureStatisticsEntity;
  interaction: InteractionEntryEntity;
  pages: Array<Maybe<PageEntryEntity>>;
};

export type BrochureEntity = {
  __typename?: 'BrochureEntity';
  activeFrom?: Maybe<Scalars['DateTime']['output']>;
  afterpage: Array<CategoryEntity>;
  assignee?: Maybe<IdentityUserEntity>;
  brochureCity?: Maybe<BrochureCityEntity>;
  brochureExperiment?: Maybe<BrochureExperimentEntity>;
  categories: Array<CategoryEntity>;
  cover?: Maybe<PageEntity>;
  customerLevel?: Maybe<CustomerLevel>;
  expireAfter?: Maybe<Scalars['DateTime']['output']>;
  hotspotMode: HotspotMode;
  id: Scalars['ID']['output'];
  insertedAt: Scalars['NaiveDateTime']['output'];
  language: LanguageEntity;
  local: Scalars['Boolean']['output'];
  mergeRequestAsNew?: Maybe<MergeRequestEntity>;
  mergeRequestAsOld?: Maybe<MergeRequestEntity>;
  name: Scalars['String']['output'];
  position?: Maybe<Scalars['Int']['output']>;
  positionFrozenTo?: Maybe<Scalars['DateTime']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  removedProductsFromSearch: Scalars['Boolean']['output'];
  shareUrl?: Maybe<Scalars['String']['output']>;
  shop: ShopEntity;
  state: BrochureState;
  toplevel: Array<CategoryEntity>;
  utmCampaign?: Maybe<Scalars['String']['output']>;
  utmMedium?: Maybe<Scalars['String']['output']>;
};


export type BrochureEntityBrochureCityArgs = {
  cityId?: InputMaybe<Scalars['ID']['input']>;
};

export enum BrochureExperimentCreateStatus {
  AlreadyInExperiment = 'ALREADY_IN_EXPERIMENT',
  DifferentShops = 'DIFFERENT_SHOPS',
  DuplicateBrochureId = 'DUPLICATE_BROCHURE_ID',
  MergeRequest = 'MERGE_REQUEST',
  NotFound = 'NOT_FOUND',
  NoInboxState = 'NO_INBOX_STATE',
  NoOtherBrochures = 'NO_OTHER_BROCHURES',
  Ok = 'OK'
}

export type BrochureExperimentEntity = {
  __typename?: 'BrochureExperimentEntity';
  brochureExperimentVariants: Array<BrochureExperimentVariantEntity>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  variantCount: Scalars['Int']['output'];
};

export type BrochureExperimentVariantEntity = {
  __typename?: 'BrochureExperimentVariantEntity';
  brochureRegions: Array<BrochureRegionEntity>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  variantNumber: Scalars['Int']['output'];
};

export type BrochureInput = {
  brochureId: Scalars['ID']['input'];
};

export type BrochureLogEntity = {
  content: Scalars['String']['output'];
  insertedAt: Scalars['DateTime']['output'];
  level: BrochureLogLevel;
};

export enum BrochureLogLevel {
  Debug = 'DEBUG',
  Error = 'ERROR',
  Info = 'INFO',
  Warning = 'WARNING'
}

export type BrochureLogsInput = {
  brochureId: Scalars['ID']['input'];
};

export enum BrochureOrderBy {
  PositionAsc = 'POSITION_ASC',
  PositionDesc = 'POSITION_DESC',
  PublishedAtAsc = 'PUBLISHED_AT_ASC',
  PublishedAtDesc = 'PUBLISHED_AT_DESC'
}

export type BrochurePagesStatisticsEntity = {
  __typename?: 'BrochurePagesStatisticsEntity';
  /** Average read time per page in hours */
  averagePageTime: Scalars['Float']['output'];
  /** Average read time per reader in seconds */
  averageTimePerReader: Scalars['Float']['output'];
  brochure: BrochureStatisticsEntity;
  numberOfPages: Scalars['Int']['output'];
  reads: Scalars['Int']['output'];
  /** Total read time in hours */
  totalReadTime: Scalars['Float']['output'];
};

export enum BrochurePagesStatisticsOrderBy {
  AveragePageTimeAsc = 'AVERAGE_PAGE_TIME_ASC',
  AveragePageTimeDesc = 'AVERAGE_PAGE_TIME_DESC',
  AverageTimePerReaderAsc = 'AVERAGE_TIME_PER_READER_ASC',
  AverageTimePerReaderDesc = 'AVERAGE_TIME_PER_READER_DESC',
  NumberOfPagesAsc = 'NUMBER_OF_PAGES_ASC',
  NumberOfPagesDesc = 'NUMBER_OF_PAGES_DESC',
  PublishedAtAsc = 'PUBLISHED_AT_ASC',
  PublishedAtDesc = 'PUBLISHED_AT_DESC',
  ReadsAsc = 'READS_ASC',
  ReadsDesc = 'READS_DESC',
  TotalReadTimeAsc = 'TOTAL_READ_TIME_ASC',
  TotalReadTimeDesc = 'TOTAL_READ_TIME_DESC'
}

export type BrochureReadStatisticsEntity = {
  __typename?: 'BrochureReadStatisticsEntity';
  addedToList: Scalars['Int']['output'];
  brochure: BrochureStatisticsEntity;
  /** @deprecated use hotspotLinkClicksCtr */
  clickThroughRate: Scalars['Float']['output'];
  hotspotClicks: Scalars['Int']['output'];
  hotspotClicksCtr: Scalars['Float']['output'];
  hotspotLinkClicks: Scalars['Int']['output'];
  hotspotLinkClicksCtr: Scalars['Float']['output'];
  impressions: Scalars['Int']['output'];
  reads: Scalars['Int']['output'];
};

export enum BrochureReadsStatisticsOrderBy {
  ClickThroughRateAsc = 'CLICK_THROUGH_RATE_ASC',
  ClickThroughRateDesc = 'CLICK_THROUGH_RATE_DESC',
  DeeplinkClicksAsc = 'DEEPLINK_CLICKS_ASC',
  DeeplinkClicksDesc = 'DEEPLINK_CLICKS_DESC',
  ImpressionsAsc = 'IMPRESSIONS_ASC',
  ImpressionsDesc = 'IMPRESSIONS_DESC',
  PublishedAtAsc = 'PUBLISHED_AT_ASC',
  PublishedAtDesc = 'PUBLISHED_AT_DESC',
  ReadsAsc = 'READS_ASC',
  ReadsDesc = 'READS_DESC'
}

export type BrochureRegionDifference = {
  __typename?: 'BrochureRegionDifference';
  differenceStatus: DifferenceStatus;
  pages: Array<PageDifference>;
  region: RegionEntity;
  /** @deprecated Use region instead */
  regionName: Scalars['String']['output'];
};

export type BrochureRegionEntity = {
  __typename?: 'BrochureRegionEntity';
  brochureExperimentVariant?: Maybe<BrochureExperimentVariantEntity>;
  id: Scalars['ID']['output'];
  parser?: Maybe<ParserEntity>;
  region: RegionEntity;
};

export type BrochureRegionInput = {
  brochureRegionId: Scalars['ID']['input'];
};

export enum BrochureRegionOrderBy {
  RegionNameAsc = 'REGION_NAME_ASC',
  RegionNameDesc = 'REGION_NAME_DESC'
}

export type BrochureRegionsInput = {
  brochureId: Scalars['ID']['input'];
  orderBy: BrochureRegionOrderBy;
};

export enum BrochureState {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  ForApproval = 'FOR_APPROVAL',
  Inbox = 'INBOX',
  NotPublished = 'NOT_PUBLISHED',
  ParsingFailed = 'PARSING_FAILED',
  Processing = 'PROCESSING',
  Trash = 'TRASH'
}

export type BrochureStateCount = {
  __typename?: 'BrochureStateCount';
  count: Scalars['Int']['output'];
  state: BrochureState;
};

export type BrochureStateTransitions = {
  __typename?: 'BrochureStateTransitions';
  currentState?: Maybe<TransitionState>;
  status: BrochureTransitionsStatus;
  transitionStates: Array<TransitionState>;
};

export type BrochureStateTransitionsInput = {
  brochureId: Scalars['ID']['input'];
};

export type BrochureStatisticsEntity = {
  __typename?: 'BrochureStatisticsEntity';
  activeFrom: Scalars['DateTime']['output'];
  expireAfter: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  language?: Maybe<Scalars['String']['output']>;
  pages?: Maybe<Array<Maybe<PageEntity>>>;
  publishedAt: Scalars['DateTime']['output'];
};


export type BrochureStatisticsEntityPagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type BrochureStatisticsEntryEntity = {
  __typename?: 'BrochureStatisticsEntryEntity';
  brochure: BrochureStatisticsEntity;
  brochureStatisticsMapsEntity: BrochureStatisticsMapsEntity;
};

export enum BrochureStatisticsFileVersion {
  Large = 'LARGE',
  Medium = 'MEDIUM',
  Small = 'SMALL'
}

export type BrochureStatisticsInput = {
  brochureId: Scalars['ID']['input'];
  /** Use this to get the statistics of a specific brochure region. Leave null to get the statistics of the brochure itself. */
  brochureRegionId?: InputMaybe<Scalars['ID']['input']>;
};

export type BrochureStatisticsMapsEntity = {
  __typename?: 'BrochureStatisticsMapsEntity';
  brochureReadsEntries: Array<Maybe<StatisticsMap>>;
  hotspotClicksEntries: Array<Maybe<StatisticsMap>>;
  hotspotLinkClicksEntries: Array<Maybe<StatisticsMap>>;
  impressionsEntries: Array<Maybe<StatisticsMap>>;
  pageReadsEntries: Array<Maybe<StatisticsMap>>;
};

export enum BrochureTransitionsStatus {
  BrochureInvalid = 'BROCHURE_INVALID',
  BrochureNotFound = 'BROCHURE_NOT_FOUND',
  Ok = 'OK'
}

export type BrochuresInput = {
  brochureExperiment?: InputMaybe<Scalars['Boolean']['input']>;
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  customerLevel?: InputMaybe<CustomerLevel>;
  isToplevel?: InputMaybe<Scalars['Boolean']['input']>;
  languageId?: InputMaybe<Scalars['ID']['input']>;
  orderBy: BrochureOrderBy;
  shopId?: InputMaybe<Scalars['ID']['input']>;
  state?: InputMaybe<BrochureState>;
  toplevelCategoryId?: InputMaybe<Scalars['ID']['input']>;
};

export type BrochuresPagesStatisticsInput = {
  orderBy: BrochurePagesStatisticsOrderBy;
  shopId: Scalars['ID']['input'];
  /** Brochures that are published from this date */
  startAt: Scalars['Date']['input'];
  /** Brochures that are published until this date */
  stopAt: Scalars['Date']['input'];
};

export type BrochuresReadsStatisticsInput = {
  orderBy: BrochureReadsStatisticsOrderBy;
  shopId: Scalars['ID']['input'];
  /** Brochures that are published from this date */
  startAt: Scalars['Date']['input'];
  /** Brochures that are published until this date */
  stopAt: Scalars['Date']['input'];
};

export type BrochuresStatisticsOverviewInput = {
  shopId: Scalars['ID']['input'];
  /** Brochures that are published from this date */
  startAt: Scalars['Date']['input'];
  /** Brochures that are published until this date */
  stopAt: Scalars['Date']['input'];
  timeStep: TimeStepEnum;
};

export type BrochuresStatisticsOverviewListResponse = {
  __typename?: 'BrochuresStatisticsOverviewListResponse';
  /** How many times all brochures combined have been read. */
  brochureReads: Scalars['Int']['output'];
  /**
   * How many times all deeplinks combined have been clicked.
   * @deprecated To be removed, please use hotspot_link_clicks.
   */
  deeplinkClicks: Scalars['Int']['output'];
  /** How many times all hotspots have been clicked */
  hotspotClicks: Scalars['Int']['output'];
  /** How many times all external url in hotspots have been clicked */
  hotspotLinkClicks: Scalars['Int']['output'];
  /** Shop id */
  id: Scalars['ID']['output'];
  /** How many times the brochures have been seen. */
  impressions: Scalars['Int']['output'];
  /** How many times all pages combined have been read. */
  pageReads: Scalars['Int']['output'];
  /** An overview of statistics per brochure. Each statistics entity holds key-value pairs for impressions, brochure reads, page reads, and deeplink clicks. */
  statisticsEntries: Array<Maybe<BrochureStatisticsEntryEntity>>;
  /** The sum per key-value pair of the statistics_entries. */
  sumStatisticsEntry: BrochureStatisticsMapsEntity;
};

export type CategoriesInput = {
  languageId: Scalars['ID']['input'];
};

export type CategoryEntity = {
  __typename?: 'CategoryEntity';
  about?: Maybe<Scalars['String']['output']>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  language: LanguageEntity;
  metaDescription?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  titleMain?: Maybe<Scalars['String']['output']>;
  titleSecondary?: Maybe<Scalars['String']['output']>;
};


export type CategoryEntityFileUrlArgs = {
  version: CategoryFileVersion;
};

export enum CategoryFileVersion {
  Small = 'SMALL'
}

export type CategoryInput = {
  id: Scalars['ID']['input'];
};

export type ChangePasswordIdentityUserInput = {
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};

export type CitiesInput = {
  orderBy: CitiesOrderBy;
  search?: InputMaybe<Scalars['String']['input']>;
};

export enum CitiesOrderBy {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC',
  PositionAsc = 'POSITION_ASC',
  PositionDesc = 'POSITION_DESC'
}

export type CityEntity = {
  __typename?: 'CityEntity';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  position?: Maybe<Scalars['Int']['output']>;
};

export type CityInput = {
  cityId: Scalars['ID']['input'];
};

export enum ClientPermissionsScope {
  Dashboard = 'DASHBOARD'
}

export type ClientPermissionsScopeInput = {
  scope: ClientPermissionsScope;
};

export type CloneBrochureRegionInput = {
  /** The BrochureRegion whose pages and hotspots are copied into the new region. Must belong to the same shop. */
  fromBrochureRegionId: Scalars['ID']['input'];
  regionId: Scalars['ID']['input'];
};

export type ConvertHotspotsInput = {
  brochureId: Scalars['ID']['input'];
};

export type ConvertLinkHotspotsStatusEntity = {
  __typename?: 'ConvertLinkHotspotsStatusEntity';
  status: MutatedStatus;
};

export type CopyHotspotsInput = {
  fromBrochureRegionId: Scalars['ID']['input'];
  toBrochureRegionId: Scalars['ID']['input'];
};

export enum CopyHotspotsStatus {
  Failed = 'FAILED',
  HotspotsPresent = 'HOTSPOTS_PRESENT',
  NothingToCopy = 'NOTHING_TO_COPY',
  Ok = 'OK',
  UnequalPageCount = 'UNEQUAL_PAGE_COUNT'
}

export type CopyHotspotsStatusEntity = {
  __typename?: 'CopyHotspotsStatusEntity';
  status: CopyHotspotsStatus;
};

export type CreateAdsCampaignAdvertisementHtmlEmbedInput = {
  adsCampaignId: Scalars['ID']['input'];
  categoryIds: Array<InputMaybe<Scalars['ID']['input']>>;
  content: Scalars['String']['input'];
  displayAt: AdDisplayAt;
  displayUrl: Scalars['String']['input'];
  impressionsLimit: Scalars['Int']['input'];
  platformType: AdPlatformType;
  shopIds: Array<InputMaybe<Scalars['ID']['input']>>;
  status: AdStatusV2;
  targetType: AdTargetType;
  weight: Scalars['Int']['input'];
};

export type CreateAdsCampaignAdvertisementImageAdInput = {
  adsCampaignId: Scalars['ID']['input'];
  categoryIds: Array<InputMaybe<Scalars['ID']['input']>>;
  displayAt: AdDisplayAt;
  displayUrl: Scalars['String']['input'];
  file?: InputMaybe<Scalars['Upload']['input']>;
  impressionsLimit: Scalars['Int']['input'];
  platformType: AdPlatformType;
  shopIds: Array<InputMaybe<Scalars['ID']['input']>>;
  status: AdStatusV2;
  targetType: AdTargetType;
  weight: Scalars['Int']['input'];
};

export type CreateAdsCampaignInput = {
  adDisplayAtPositions: Array<AdDisplayAt>;
  adHtmlContents: Array<AdHtmlContent>;
  adType: AdType;
  adUploads: Array<AdUpload>;
  categoryIds: Array<Scalars['ID']['input']>;
  customerClientId: Scalars['ID']['input'];
  impressionLimit: Scalars['Int']['input'];
  languageId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  platforms: Array<AdPlatformType>;
  shopIds: Array<Scalars['ID']['input']>;
  startAt: Scalars['DateTime']['input'];
  stopAt: Scalars['DateTime']['input'];
  targetType: AdTargetType;
  weight: Scalars['Int']['input'];
};

export type CreateBrandInput = {
  brandTags?: InputMaybe<Array<InputMaybe<CreateBrandTagInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  name: Scalars['String']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
  status: BrandStatus;
};

export type CreateBrandTagInput = {
  name: Scalars['String']['input'];
};

export type CreateBrochureByParser = {
  __typename?: 'CreateBrochureByParser';
  status: CreateBrochureByParserStatus;
};

export type CreateBrochureByParserInput = {
  brochureRegions: Array<CreateBrochureRegionInput>;
  /**
   * Regions that are copied from an existing BrochureRegion instead of being parsed, e.g. to keep regions
   *     unchanged in a merge request. Each region may only appear once across brochure_regions and cloned_brochure_regions.
   */
  clonedBrochureRegions?: InputMaybe<Array<CloneBrochureRegionInput>>;
  id: Scalars['ID']['input'];
  languageId: Scalars['ID']['input'];
  /**
   * If you want to create a new merge request then this field represents the old brochure.
   *     Leave empty if only creating a new brochure.
   */
  mergeRequestBrochureId?: InputMaybe<Scalars['ID']['input']>;
  parserClass: ParserClasses;
  shopId: Scalars['ID']['input'];
};

export enum CreateBrochureByParserStatus {
  CloneNotSupported = 'CLONE_NOT_SUPPORTED',
  CloneSourceNotFound = 'CLONE_SOURCE_NOT_FOUND',
  DuplicateRegion = 'DUPLICATE_REGION',
  MergeRequestAlreadyExists = 'MERGE_REQUEST_ALREADY_EXISTS',
  ProcessingStarted = 'PROCESSING_STARTED',
  RegionAmountMismatch = 'REGION_AMOUNT_MISMATCH'
}

export type CreateBrochureExperimentInput = {
  mainBrochureId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  otherBrochureIds: Array<Scalars['ID']['input']>;
};

export type CreateBrochureLog = BrochureLogEntity & {
  __typename?: 'CreateBrochureLog';
  content: Scalars['String']['output'];
  createStatus: BrochureCreateStatus;
  insertedAt: Scalars['DateTime']['output'];
  level: BrochureLogLevel;
};

export type CreateBrochureRegionInput = {
  regionId: Scalars['ID']['input'];
  url: Scalars['String']['input'];
};

export type CreateBrochureRegionParams = {
  __typename?: 'CreateBrochureRegionParams';
  region: RegionEntity;
  url?: Maybe<Scalars['String']['output']>;
};

export type CreateCategoryInput = {
  file?: InputMaybe<Scalars['Upload']['input']>;
  languageId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type CreateCityInput = {
  name: Scalars['String']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateCustomerClientInput = {
  features?: InputMaybe<Array<CustomerClientFeature>>;
  identityUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name: Scalars['String']['input'];
  shopIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type CreateGenericProductCategoryInput = {
  image?: InputMaybe<Scalars['Upload']['input']>;
  keywords?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name: Scalars['String']['input'];
  parentCategoryId?: InputMaybe<Scalars['ID']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  translations?: InputMaybe<Array<GenericProductCategoryTranslationInput>>;
};

export type CreateGenericProductInput = {
  categoryId: Scalars['ID']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
  keywords?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name: Scalars['String']['input'];
  published?: InputMaybe<Scalars['Boolean']['input']>;
  translations?: InputMaybe<Array<GenericProductTranslationInput>>;
};

export type CreateHotspotImageInput = {
  file: Scalars['Upload']['input'];
  height: Scalars['Float']['input'];
  pageId: Scalars['ID']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
  width: Scalars['Float']['input'];
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type CreateHotspotLinkInput = {
  height: Scalars['Float']['input'];
  pageId: Scalars['ID']['input'];
  url: Scalars['String']['input'];
  width: Scalars['Float']['input'];
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type CreateHotspotProductInput = {
  height: Scalars['Float']['input'];
  pageId: Scalars['ID']['input'];
  productTag: ProductInput;
  url?: InputMaybe<Scalars['String']['input']>;
  width: Scalars['Float']['input'];
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type CreateIdentityUserInput = {
  cityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  customerClientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  roles: Array<IdentityUserRole>;
};

export type CreateIdentityUserPasswordResetLinkInput = {
  id: Scalars['ID']['input'];
};

export type CreateLocationInput = {
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  name: Scalars['String']['input'];
  regionId: Scalars['ID']['input'];
  shopId: Scalars['ID']['input'];
  zipCode: Scalars['String']['input'];
};

export type CreateLocationsByImportInput = {
  locations: Array<LocationByImportInput>;
};

export type CreateNewsletterCategoryInput = {
  name: Scalars['String']['input'];
};

export type CreateOfferCategoryInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  languageId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  offerCategoryTags?: InputMaybe<Array<InputMaybe<CreateOfferCategoryTagInput>>>;
  position?: InputMaybe<Scalars['Int']['input']>;
  shopCategoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type CreateOfferCategoryTagInput = {
  name: Scalars['String']['input'];
};

export type CreatePdfInput = {
  id: Scalars['ID']['input'];
};

export type CreateRegionInput = {
  name: Scalars['String']['input'];
  shopId: Scalars['ID']['input'];
};

export type CreateShopCardTemplateInput = {
  image: Scalars['Upload']['input'];
  name: Scalars['String']['input'];
  shopIds: Array<Scalars['ID']['input']>;
};

export type CreateShopInput = {
  autoParserSlugFr?: InputMaybe<Scalars['String']['input']>;
  autoParserSlugNl?: InputMaybe<Scalars['String']['input']>;
  autoParserType?: InputMaybe<AutoParserType>;
  customerClientId?: InputMaybe<Scalars['ID']['input']>;
  customerLevel: CustomerLevel;
  file?: InputMaybe<Scalars['Upload']['input']>;
  hotspotMode: HotspotMode;
  lastPage: Scalars['Boolean']['input'];
  localBrochures: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  overwriteUtms: Scalars['Boolean']['input'];
  radius: Scalars['Float']['input'];
  removedFromSearch: Scalars['Boolean']['input'];
  removedProductsFromSearch: Scalars['Boolean']['input'];
  /** The categories for which the brochures in the shop can be shown at the end of a brochure after the last page. */
  shopAfterpage: Array<Scalars['ID']['input']>;
  shopCategories: Array<Scalars['ID']['input']>;
  shopDescriptions?: InputMaybe<Array<ShopDescriptionInput>>;
  shopKeywords?: InputMaybe<Scalars['String']['input']>;
  /** The categories for which brochures in the shop can be shown as the top of a brochure stack. */
  shopToplevel: Array<Scalars['ID']['input']>;
  showAds: Scalars['Boolean']['input'];
};

export type CreateWebsitePageInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  contentBlocks?: InputMaybe<Array<Scalars['String']['input']>>;
  contentQuestionsAnswers?: InputMaybe<Array<WebsitePageQuestionAnswerInput>>;
  languageId: Scalars['ID']['input'];
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  path: Scalars['String']['input'];
  positionInFooter?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleQuestionsAnswers?: InputMaybe<Scalars['String']['input']>;
  translationSetId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateWebsitePostInput = {
  categoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  content: Scalars['String']['input'];
  coverImage?: InputMaybe<Scalars['Upload']['input']>;
  languageId: Scalars['ID']['input'];
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  path: Scalars['String']['input'];
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  title: Scalars['String']['input'];
  translationSetId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** Current User */
export type CurrentUser = {
  __typename?: 'CurrentUser';
  bio?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  fileUrl?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  roles: Array<Maybe<Scalars['String']['output']>>;
};


/** Current User */
export type CurrentUserFileUrlArgs = {
  version: CurrentUserFileVersion;
};

export enum CurrentUserFileVersion {
  Small = 'SMALL'
}

export type CustomerClientEntity = {
  __typename?: 'CustomerClientEntity';
  apiKey?: Maybe<Scalars['String']['output']>;
  features: Array<CustomerClientFeature>;
  id: Scalars['ID']['output'];
  identityUsers: Array<Maybe<IdentityUserEntity>>;
  name: Scalars['String']['output'];
  shops: Array<Maybe<ShopEntity>>;
};

export enum CustomerClientFeature {
  BrochureCreate = 'BROCHURE_CREATE',
  BrochureEmbed = 'BROCHURE_EMBED',
  Statistics = 'STATISTICS'
}

export type CustomerClientInput = {
  customerClientId: Scalars['ID']['input'];
};

export enum CustomerClientOrderBy {
  NameAtAsc = 'NAME_AT_ASC',
  NameAtDesc = 'NAME_AT_DESC'
}

export enum CustomerClientPermission {
  BrochureCreate = 'BROCHURE_CREATE',
  Statistics = 'STATISTICS'
}

export type CustomerClientsInput = {
  orderBy: CustomerClientOrderBy;
  search?: InputMaybe<Scalars['String']['input']>;
};

export enum CustomerLevel {
  Five = 'FIVE',
  Four = 'FOUR',
  One = 'ONE',
  Three = 'THREE',
  Two = 'TWO'
}

export type DeleteAdsCampaignAdvertisementInput = {
  id: Scalars['ID']['input'];
};

export type DeleteAdsCampaignInput = {
  id: Scalars['ID']['input'];
};

export type DeleteBrandInput = {
  id: Scalars['ID']['input'];
};

export type DeleteBrandTagInput = {
  id: Scalars['ID']['input'];
};

export type DeleteCityInput = {
  id: Scalars['ID']['input'];
};

export type DeleteGenericProductCategoryInput = {
  id: Scalars['ID']['input'];
};

export type DeleteGenericProductInput = {
  id: Scalars['ID']['input'];
};

export type DeleteHotspotInput = {
  id: Scalars['ID']['input'];
};

export type DeleteHotspotsInput = {
  brochureRegionId: Scalars['ID']['input'];
};

export type DeleteHotspotsStatus = {
  __typename?: 'DeleteHotspotsStatus';
  status: MutatedStatus;
};

export type DeleteIdentityUserInput = {
  id: Scalars['ID']['input'];
};

export type DeleteLocationInput = {
  id: Scalars['ID']['input'];
};

export type DeleteLocationsInput = {
  ids: Array<Scalars['ID']['input']>;
};

export type DeleteNewsletterCategoryInput = {
  id: Scalars['ID']['input'];
};

export type DeleteNewsletterSubscriberInput = {
  id: Scalars['ID']['input'];
};

export type DeleteOfferCategoryInput = {
  id: Scalars['ID']['input'];
};

export type DeleteOfferCategoryTagInput = {
  id: Scalars['ID']['input'];
};

export type DeletePageInput = {
  id: Scalars['ID']['input'];
};

export enum DeletePageStatus {
  BrochureInActiveState = 'BROCHURE_IN_ACTIVE_STATE',
  Failed = 'FAILED',
  NotFound = 'NOT_FOUND',
  Ok = 'OK'
}

export type DeletePdfInput = {
  id: Scalars['ID']['input'];
};

export type DeleteProductPricesInput = {
  brochureRegionId: Scalars['ID']['input'];
};

export type DeleteProductPricesStatus = {
  __typename?: 'DeleteProductPricesStatus';
  status: MutatedStatus;
};

export type DeleteRegionInput = {
  regionId: Scalars['ID']['input'];
};

export type DeleteRegionsInput = {
  ids: Array<Scalars['ID']['input']>;
};

export type DeleteWebsitePageInput = {
  id: Scalars['ID']['input'];
};

export type DeliveryFailureReportEntity = {
  __typename?: 'DeliveryFailureReportEntity';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  reason: Scalars['String']['output'];
};

export type DeliveryFailureReportInput = {
  newsletterCategoryId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
  subscriberId: Scalars['ID']['input'];
};

export type DetectHotspotsForPageInput = {
  pageId: Scalars['ID']['input'];
};

export type DetectProductHotspotsEntity = {
  __typename?: 'DetectProductHotspotsEntity';
  status: DetectProductHotspotsState;
};

export type DetectProductHotspotsInput = {
  brochureId: Scalars['ID']['input'];
};

export enum DetectProductHotspotsState {
  Ok = 'OK'
}

export enum DifferenceStatus {
  Added = 'ADDED',
  Changed = 'CHANGED',
  NoChanges = 'NO_CHANGES',
  Removed = 'REMOVED'
}

export type ExportLocationsInput = {
  shopId: Scalars['ID']['input'];
};

export type ExportToPdfInput = {
  brochureRegionId: Scalars['ID']['input'];
};

export type ExportToPdfResponse = {
  __typename?: 'ExportToPdfResponse';
  status?: Maybe<MutatedStatus>;
};

export enum GeminiBrandAndOfferStrategy {
  Legacy = 'LEGACY',
  WithSuggestions = 'WITH_SUGGESTIONS'
}

export type GeneralFields = {
  activeFrom: Scalars['DateTime']['input'];
  expireAfter: Scalars['DateTime']['input'];
  name: Scalars['String']['input'];
  publishedAt: Scalars['DateTime']['input'];
};

export type GenericProductCategoryEntity = GenericTreeItem & {
  __typename?: 'GenericProductCategoryEntity';
  ancestors: Array<GenericProductCategoryEntity>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  keywords?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name: Scalars['String']['output'];
  parentCategoryId?: Maybe<Scalars['ID']['output']>;
  published: Scalars['Boolean']['output'];
  sortOrder?: Maybe<Scalars['Int']['output']>;
  translations: Array<GenericProductCategoryTranslationEntity>;
};


export type GenericProductCategoryEntityImageUrlArgs = {
  version: GenericProductImageVersion;
};

export type GenericProductCategoryInput = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
};

export type GenericProductCategoryTranslationEntity = {
  __typename?: 'GenericProductCategoryTranslationEntity';
  language: LanguageEntity;
  translation: Scalars['String']['output'];
};

export type GenericProductCategoryTranslationInput = {
  languageId: Scalars['ID']['input'];
  translation: Scalars['String']['input'];
};

export type GenericProductEntity = GenericTreeItem & {
  __typename?: 'GenericProductEntity';
  ancestors: Array<GenericProductCategoryEntity>;
  categoryId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  keywords?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name: Scalars['String']['output'];
  published: Scalars['Boolean']['output'];
  sortOrder?: Maybe<Scalars['Int']['output']>;
  translations: Array<GenericProductTranslationEntity>;
};


export type GenericProductEntityImageUrlArgs = {
  version: GenericProductImageVersion;
};

export enum GenericProductImageVersion {
  Original = 'ORIGINAL'
}

export type GenericProductInput = {
  id: Scalars['ID']['input'];
};

export type GenericProductTranslationEntity = {
  __typename?: 'GenericProductTranslationEntity';
  language: LanguageEntity;
  translation: Scalars['String']['output'];
};

export type GenericProductTranslationInput = {
  languageId: Scalars['ID']['input'];
  translation: Scalars['String']['input'];
};

export type GenericProductsInput = {
  genericProductCategoryId?: InputMaybe<Scalars['ID']['input']>;
};

export type GenericTreeItem = {
  ancestors: Array<GenericProductCategoryEntity>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  sortOrder?: Maybe<Scalars['Int']['output']>;
};


export type GenericTreeItemImageUrlArgs = {
  version: GenericProductImageVersion;
};

export type GenericTreeItemsInput = {
  /**
   * The parent category to retrieve items for.
   *     Use the zero GUID (00000000-0000-0000-0000-000000000000) for root categories.
   */
  parentId: Scalars['ID']['input'];
};

export enum HotspotApprovalField {
  Brand = 'BRAND',
  Description = 'DESCRIPTION',
  Name = 'NAME',
  OfferCategory = 'OFFER_CATEGORY',
  Price = 'PRICE',
  Url = 'URL'
}

export type HotspotDifference = {
  __typename?: 'HotspotDifference';
  differenceStatus: DifferenceStatus;
  differences: Array<HotspotMatchDifference>;
  newHotspot?: Maybe<HotspotEntity>;
  oldHotspot?: Maybe<HotspotEntity>;
};

export type HotspotEntity = {
  height: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  page: PageEntity;
  tagStatistics: Array<ApprovedAtHotspotField>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
  width: Scalars['Float']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export enum HotspotFileVersion {
  Original = 'ORIGINAL',
  Small = 'SMALL'
}

export type HotspotImageEntity = HotspotEntity & {
  __typename?: 'HotspotImageEntity';
  fileUrl?: Maybe<Scalars['String']['output']>;
  height: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  page: PageEntity;
  tagStatistics: Array<ApprovedAtHotspotField>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
  width: Scalars['Float']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};


export type HotspotImageEntityFileUrlArgs = {
  version: HotspotFileVersion;
};

export type HotspotInput = {
  hotspotId: Scalars['ID']['input'];
};

export type HotspotLinkEntity = HotspotEntity & {
  __typename?: 'HotspotLinkEntity';
  fileUrl?: Maybe<Scalars['String']['output']>;
  height: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  page: PageEntity;
  tagStatistics: Array<ApprovedAtHotspotField>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
  width: Scalars['Float']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};


export type HotspotLinkEntityFileUrlArgs = {
  version: HotspotFileVersion;
};

export enum HotspotMatchDifference {
  Coordinates = 'COORDINATES',
  ProductFields = 'PRODUCT_FIELDS',
  Type = 'TYPE',
  Url = 'URL'
}

export enum HotspotMode {
  Disabled = 'DISABLED',
  Links = 'LINKS',
  ProductsWithoutLink = 'PRODUCTS_WITHOUT_LINK',
  ProductsWithLink = 'PRODUCTS_WITH_LINK'
}

export enum HotspotOrderBy {
  InsertedAtAsc = 'INSERTED_AT_ASC',
  InsertedAtDesc = 'INSERTED_AT_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type HotspotPlacementInput = {
  height: Scalars['Float']['input'];
  pageId: Scalars['ID']['input'];
  width: Scalars['Float']['input'];
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type HotspotProductEntity = HotspotEntity & {
  __typename?: 'HotspotProductEntity';
  fileUrl?: Maybe<Scalars['String']['output']>;
  height: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  meta?: Maybe<Scalars['Json']['output']>;
  page: PageEntity;
  productTag: ProductTagEntity;
  tagStatistics: Array<ApprovedAtHotspotField>;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
  width: Scalars['Float']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};


export type HotspotProductEntityFileUrlArgs = {
  version: HotspotFileVersion;
};

export type HotspotStatistics = {
  __typename?: 'HotspotStatistics';
  brochureId: Scalars['ID']['output'];
  externalUrl?: Maybe<Scalars['String']['output']>;
  hotspot?: Maybe<HotspotEntity>;
  hotspotId: Scalars['ID']['output'];
  linkClicks: Scalars['Int']['output'];
  linkTimeSpent: Scalars['Float']['output'];
  pageIndex: Scalars['Int']['output'];
  productClicks: Scalars['Int']['output'];
  productLinkClicks: Scalars['Int']['output'];
  productLinkTimeSpent: Scalars['Float']['output'];
  productName?: Maybe<Scalars['String']['output']>;
  productSource?: Maybe<Scalars['String']['output']>;
  productTimeSpent: Scalars['Float']['output'];
  searchImpressions: Scalars['Int']['output'];
  searchProductClicks: Scalars['Int']['output'];
  timesAddedToList: Scalars['Int']['output'];
};

export enum HotspotStatisticsOrderBy {
  LinkClicksAsc = 'LINK_CLICKS_ASC',
  LinkClicksDesc = 'LINK_CLICKS_DESC',
  LinkTimeSpentAsc = 'LINK_TIME_SPENT_ASC',
  LinkTimeSpentDesc = 'LINK_TIME_SPENT_DESC',
  PageIndexAsc = 'PAGE_INDEX_ASC',
  PageIndexDesc = 'PAGE_INDEX_DESC',
  ProductClicksAsc = 'PRODUCT_CLICKS_ASC',
  ProductClicksDesc = 'PRODUCT_CLICKS_DESC',
  ProductLinkClicksAsc = 'PRODUCT_LINK_CLICKS_ASC',
  ProductLinkClicksDesc = 'PRODUCT_LINK_CLICKS_DESC',
  ProductLinkTimeSpentAsc = 'PRODUCT_LINK_TIME_SPENT_ASC',
  ProductLinkTimeSpentDesc = 'PRODUCT_LINK_TIME_SPENT_DESC',
  ProductTimeSpentAsc = 'PRODUCT_TIME_SPENT_ASC',
  ProductTimeSpentDesc = 'PRODUCT_TIME_SPENT_DESC',
  SearchImpressionsAsc = 'SEARCH_IMPRESSIONS_ASC',
  SearchImpressionsDesc = 'SEARCH_IMPRESSIONS_DESC',
  SearchProductClicksAsc = 'SEARCH_PRODUCT_CLICKS_ASC',
  SearchProductClicksDesc = 'SEARCH_PRODUCT_CLICKS_DESC',
  TimesAddedToListAsc = 'TIMES_ADDED_TO_LIST_ASC',
  TimesAddedToListDesc = 'TIMES_ADDED_TO_LIST_DESC'
}

export type HotspotsInput = {
  orderBy: HotspotOrderBy;
  pageId: Scalars['ID']['input'];
};

export type HotspotsStatisticsInput = {
  brochureId: Scalars['ID']['input'];
  /** Use this to get the statistics of a specific brochure region. Leave null to get the statistics of the brochure itself. */
  brochureRegionId?: InputMaybe<Scalars['ID']['input']>;
  orderBy: HotspotStatisticsOrderBy;
};

export type IdentityUserEntity = {
  __typename?: 'IdentityUserEntity';
  bio?: Maybe<Scalars['String']['output']>;
  cities: Array<CityEntity>;
  customerClients: Array<CustomerClientEntity>;
  email: Scalars['String']['output'];
  fileUrl?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  roles: Array<IdentityUserRole>;
};


export type IdentityUserEntityFileUrlArgs = {
  version: IdentityUserFileVersion;
};

export enum IdentityUserFileVersion {
  Small = 'SMALL'
}

export type IdentityUserInput = {
  id: Scalars['ID']['input'];
};

export enum IdentityUserOrderBy {
  EmailAtAsc = 'EMAIL_AT_ASC',
  EmailAtDesc = 'EMAIL_AT_DESC'
}

export enum IdentityUserRole {
  Admin = 'ADMIN',
  AdManager = 'AD_MANAGER',
  CityManager = 'CITY_MANAGER',
  Client = 'CLIENT',
  ClientManager = 'CLIENT_MANAGER',
  CustomerSupport = 'CUSTOMER_SUPPORT',
  StatisticsManager = 'STATISTICS_MANAGER',
  Superadmin = 'SUPERADMIN',
  Tagger = 'TAGGER',
  TagManager = 'TAG_MANAGER'
}

export type IdentityUsersInput = {
  orderBy: IdentityUserOrderBy;
  roles?: InputMaybe<Array<InputMaybe<IdentityUserRole>>>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ImportLocationsInput = {
  file: Scalars['Upload']['input'];
  regionId: Scalars['ID']['input'];
  shopId: Scalars['ID']['input'];
};

export type ImportedLocationEntity = {
  __typename?: 'ImportedLocationEntity';
  address: Scalars['String']['output'];
  city: Scalars['String']['output'];
  name: Scalars['String']['output'];
  point?: Maybe<LocationPoint>;
  regionId: Scalars['ID']['output'];
  shopId: Scalars['ID']['output'];
  zipCode: Scalars['String']['output'];
};

export enum InteractionCategoryEnum {
  /** From the also interesting screen */
  AlsoInteresting = 'ALSO_INTERESTING',
  /** From the share link */
  AppLink = 'APP_LINK',
  /** From the category screen */
  Category = 'CATEGORY',
  /** From the favorites screen */
  Favorites = 'FAVORITES',
  /** When a brochure is visited from recommendations given on a generic product */
  GenericProductRecommendations = 'GENERIC_PRODUCT_RECOMMENDATIONS',
  /** From the new offers screen */
  NewOpen = 'NEW_OPEN',
  /** When a brochure is still op when reopening from the background */
  ReopenBackground = 'REOPEN_BACKGROUND',
  /** As a result of searching */
  Search = 'SEARCH',
  /** When a brochure is seen on the shop card's detail page. */
  ShopCard = 'SHOP_CARD',
  /** From the main categories overview */
  Stack = 'STACK'
}

export type InteractionEntryEntity = {
  __typename?: 'InteractionEntryEntity';
  addedToList: Scalars['Int']['output'];
  /** @deprecated use hotspotLinkClicksCtr */
  clickThroughRate: Scalars['Float']['output'];
  hotspotClicks: Scalars['Int']['output'];
  hotspotClicksCtr: Scalars['Float']['output'];
  hotspotLinkClicks: Scalars['Int']['output'];
  hotspotLinkClicksCtr: Scalars['Float']['output'];
  impressions: Scalars['Int']['output'];
  interactionEntries: Array<Maybe<InteractionMap>>;
  openingRatio: Scalars['Float']['output'];
  reach: Scalars['Int']['output'];
  readers: Scalars['Int']['output'];
  reads: Scalars['Int']['output'];
};

export type InteractionMap = {
  __typename?: 'InteractionMap';
  category: InteractionCategoryEnum;
  impressions: Scalars['Int']['output'];
  reads: Scalars['Int']['output'];
};

export type LanguageEntity = {
  __typename?: 'LanguageEntity';
  fileUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
};


export type LanguageEntityFileUrlArgs = {
  version: LanguageFileVersion;
};

export enum LanguageFileVersion {
  Small = 'SMALL'
}

export type LanguageInput = {
  languageId: Scalars['ID']['input'];
};

export type LocationByImportInput = {
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  name: Scalars['String']['input'];
  point: Point;
  regionId: Scalars['ID']['input'];
  shopId: Scalars['ID']['input'];
  zipCode: Scalars['String']['input'];
};

export type LocationEntity = {
  __typename?: 'LocationEntity';
  address: Scalars['String']['output'];
  city: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  point?: Maybe<LocationPoint>;
  region: RegionEntity;
  zipCode: Scalars['String']['output'];
};

export type LocationInput = {
  locationId: Scalars['ID']['input'];
};

export type LocationPoint = {
  __typename?: 'LocationPoint';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type MergeRequestDetails = {
  __typename?: 'MergeRequestDetails';
  brochureRegions: Array<BrochureRegionDifference>;
  mergeRequest: MergeRequestEntity;
};

export type MergeRequestEntity = {
  __typename?: 'MergeRequestEntity';
  id: Scalars['ID']['output'];
  newBrochure: BrochureEntity;
  status: MergeRequestStatus;
};

export type MergeRequestInput = {
  id: Scalars['ID']['input'];
};

export enum MergeRequestOrderBy {
  PublishedAtAsc = 'PUBLISHED_AT_ASC',
  PublishedAtDesc = 'PUBLISHED_AT_DESC'
}

export enum MergeRequestStatus {
  Approved = 'APPROVED',
  Draft = 'DRAFT',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type MergeRequestsInput = {
  orderBy: MergeRequestOrderBy;
  status: MergeRequestStatus;
};

export type MigrateBrochureRegionMyshopiInput = {
  brochureRegionId: Scalars['ID']['input'];
  /** The ID of a brochure in myShopi to create a merge request for. Leave empty to only copy this brochure. */
  recreateBrochureId?: InputMaybe<Scalars['ID']['input']>;
};

export type MutatedChangePasswordIdentityUser = {
  __typename?: 'MutatedChangePasswordIdentityUser';
  identityUser?: Maybe<IdentityUserEntity>;
};

export type MutatedCreateAdsCampaign = {
  __typename?: 'MutatedCreateAdsCampaign';
  adsCampaign?: Maybe<AdsCampaignEntity>;
  status?: Maybe<MutatedStatus>;
};

export type MutatedCreateBrochureExperiment = {
  __typename?: 'MutatedCreateBrochureExperiment';
  brochureExperiment?: Maybe<BrochureExperimentEntity>;
  status: BrochureExperimentCreateStatus;
};

export type MutatedCreateIdentityUser = {
  __typename?: 'MutatedCreateIdentityUser';
  identityUser?: Maybe<IdentityUserEntity>;
};

export type MutatedCreateIdentityUserPasswordResetLink = {
  __typename?: 'MutatedCreateIdentityUserPasswordResetLink';
  url: Scalars['String']['output'];
};

export type MutatedCreateLocationsByImport = {
  __typename?: 'MutatedCreateLocationsByImport';
  status: MutatedStatus;
};

export type MutatedCreateShopCardTemplate = {
  __typename?: 'MutatedCreateShopCardTemplate';
  shopCardTemplate?: Maybe<ShopCardTemplateEntity>;
  status: MutatedStatus;
};

export type MutatedDeleteAdsAdvertisement = {
  __typename?: 'MutatedDeleteAdsAdvertisement';
  status?: Maybe<MutatedStatus>;
};

export type MutatedDeleteAdsCampaign = {
  __typename?: 'MutatedDeleteAdsCampaign';
  status?: Maybe<MutatedStatus>;
};

export type MutatedDeleteBrand = {
  __typename?: 'MutatedDeleteBrand';
  status?: Maybe<MutatedStatus>;
};

export type MutatedDeleteBrandTag = {
  __typename?: 'MutatedDeleteBrandTag';
  status: MutatedStatus;
};

export type MutatedDeleteCity = {
  __typename?: 'MutatedDeleteCity';
  status?: Maybe<MutatedStatus>;
};

export type MutatedDeleteGenericProduct = {
  __typename?: 'MutatedDeleteGenericProduct';
  status?: Maybe<MutatedStatus>;
};

export type MutatedDeleteGenericProductCategory = {
  __typename?: 'MutatedDeleteGenericProductCategory';
  status?: Maybe<MutatedStatus>;
};

export type MutatedDeleteHotspot = {
  __typename?: 'MutatedDeleteHotspot';
  status?: Maybe<MutatedStatus>;
};

export type MutatedDeleteIdentityUser = {
  __typename?: 'MutatedDeleteIdentityUser';
  status?: Maybe<MutatedStatus>;
};

export type MutatedDeleteLocation = {
  __typename?: 'MutatedDeleteLocation';
  status: MutatedStatus;
};

export type MutatedDeleteLocations = {
  __typename?: 'MutatedDeleteLocations';
  status: MutatedStatus;
};

export type MutatedDeleteNewsletterSubscriber = {
  __typename?: 'MutatedDeleteNewsletterSubscriber';
  status?: Maybe<MutatedStatus>;
};

export type MutatedDeleteOfferCategory = {
  __typename?: 'MutatedDeleteOfferCategory';
  status: MutatedStatus;
};

export type MutatedDeleteOfferCategoryTag = {
  __typename?: 'MutatedDeleteOfferCategoryTag';
  status: MutatedStatus;
};

export type MutatedDeletePage = {
  __typename?: 'MutatedDeletePage';
  status: DeletePageStatus;
};

export type MutatedDeletePdf = {
  __typename?: 'MutatedDeletePdf';
  status?: Maybe<MutatedStatus>;
};

export type MutatedDeleteRegion = {
  __typename?: 'MutatedDeleteRegion';
  status: MutatedStatus;
};

export type MutatedDeleteRegions = {
  __typename?: 'MutatedDeleteRegions';
  status: MutatedStatus;
};

export type MutatedDeleteWebsitePage = {
  __typename?: 'MutatedDeleteWebsitePage';
  status?: Maybe<MutatedStatus>;
};

export type MutatedExportLocations = {
  __typename?: 'MutatedExportLocations';
  fileUrl?: Maybe<Scalars['String']['output']>;
  status: MutatedStatus;
};

export type MutatedImportLocations = {
  __typename?: 'MutatedImportLocations';
  locationCount: Scalars['Int']['output'];
  status: MutatedImportLocationsStatus;
};

export enum MutatedImportLocationsStatus {
  Ok = 'OK'
}

export type MutatedLocation = {
  __typename?: 'MutatedLocation';
  location?: Maybe<LocationEntity>;
  status: MutatedLocationStatus;
};

export enum MutatedLocationStatus {
  Failed = 'FAILED',
  GeocodeFailedToFindLocation = 'GEOCODE_FAILED_TO_FIND_LOCATION',
  Ok = 'OK'
}

export type MutatedMergeRequest = {
  __typename?: 'MutatedMergeRequest';
  status: MutatedStatus;
};

export type MutatedMigrateBrochureRegionMyshopi = {
  __typename?: 'MutatedMigrateBrochureRegionMyshopi';
  status: MutatedStatus;
};

export type MutatedRegion = {
  __typename?: 'MutatedRegion';
  region?: Maybe<RegionEntity>;
  status: MutatedStatus;
};

export type MutatedResetPasswordIdentityUser = {
  __typename?: 'MutatedResetPasswordIdentityUser';
  status?: Maybe<ResetPasswordStatus>;
};

export type MutatedSetPasswordIdentityUser = {
  __typename?: 'MutatedSetPasswordIdentityUser';
  status?: Maybe<SetPasswordStatus>;
};

export type MutatedShop = {
  __typename?: 'MutatedShop';
  shop?: Maybe<AdminShopEntity>;
  status: MutatedStatus;
};

export enum MutatedStatus {
  Failed = 'FAILED',
  NotFound = 'NOT_FOUND',
  Ok = 'OK'
}

export type MutatedUnsubscribeIdentityUserFromNewsletters = {
  __typename?: 'MutatedUnsubscribeIdentityUserFromNewsletters';
  status?: Maybe<MutatedStatus>;
};

export type MutatedUnsubscribeNewsletterSubscriberFromNewsletters = {
  __typename?: 'MutatedUnsubscribeNewsletterSubscriberFromNewsletters';
  status?: Maybe<MutatedStatus>;
};

export type MutatedUpdateBrochure = {
  __typename?: 'MutatedUpdateBrochure';
  brochure?: Maybe<BrochureEntity>;
  status: UpdateBrochureStatus;
};

export type MutatedUpdateBrochureAssignee = {
  __typename?: 'MutatedUpdateBrochureAssignee';
  brochure?: Maybe<BrochureEntity>;
  status: UpdateBrochureAssigneeStatus;
};

export type MutatedUpdateCurrentUser = {
  __typename?: 'MutatedUpdateCurrentUser';
  currentUser?: Maybe<CurrentUser>;
};

export type MutatedUpdateIdentityUser = {
  __typename?: 'MutatedUpdateIdentityUser';
  identityUser?: Maybe<IdentityUserEntity>;
};

export type MutatedUpdateShopCardTemplate = {
  __typename?: 'MutatedUpdateShopCardTemplate';
  shopCardTemplate?: Maybe<ShopCardTemplateEntity>;
  status: MutatedUpdateShopCardTemplateStatus;
};

export enum MutatedUpdateShopCardTemplateStatus {
  Failed = 'FAILED',
  NotFound = 'NOT_FOUND',
  Ok = 'OK'
}

export type MutatedUpsertBrochureCity = {
  __typename?: 'MutatedUpsertBrochureCity';
  status: UpdateBrochureStatus;
};

export type MutatedUpsertSessionStatus = {
  __typename?: 'MutatedUpsertSessionStatus';
  status: MutatedStatus;
};

export type MyshopiShopBrochuresInput = {
  languageId: Scalars['ID']['input'];
  shopName: Scalars['String']['input'];
};

export type NewsletterCategoryEntity = {
  __typename?: 'NewsletterCategoryEntity';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type NewsletterSubscriberActive = {
  __typename?: 'NewsletterSubscriberActive';
  emailAddress: Scalars['String']['output'];
  favoriteShops?: Maybe<Array<ShopEntity>>;
  firstName?: Maybe<Scalars['String']['output']>;
  languageCode: Scalars['String']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  unsubscribeToken: Scalars['String']['output'];
};

export type NewsletterSubscriberDeleted = {
  __typename?: 'NewsletterSubscriberDeleted';
  deletedAt: Scalars['NaiveDateTime']['output'];
};

export type NewsletterSubscriberEntity = {
  __typename?: 'NewsletterSubscriberEntity';
  deliveryFailureReports: Array<DeliveryFailureReportEntity>;
  id: Scalars['ID']['output'];
  newsletterCategories: Array<NewsletterCategoryEntity>;
  status: NewsletterSubscriberStatus;
  updatedAt: Scalars['NaiveDateTime']['output'];
};

export type NewsletterSubscriberStatus = NewsletterSubscriberActive | NewsletterSubscriberDeleted;

export type OfferCategoriesInput = {
  languageId: Scalars['ID']['input'];
  orderBy: OfferCategoryOrderBy;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type OfferCategoryBlacklistTagEntity = {
  __typename?: 'OfferCategoryBlacklistTagEntity';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type OfferCategoryEntity = {
  __typename?: 'OfferCategoryEntity';
  app?: Maybe<AppEntity>;
  id: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  language: LanguageEntity;
  name: Scalars['String']['output'];
  offerCategoryBlacklistTags: Array<OfferCategoryBlacklistTagEntity>;
  offerCategoryTags: Array<OfferCategoryTagEntity>;
  position?: Maybe<Scalars['Int']['output']>;
  shopCategories: Array<CategoryEntity>;
  syncSource?: Maybe<OfferCategoryEntity>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type OfferCategoryInput = {
  id: Scalars['ID']['input'];
};

export enum OfferCategoryOrderBy {
  /** Puts items most similar to the search string first; equal to name_asc if not searching */
  Likeness = 'LIKENESS',
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC'
}

export type OfferCategoryTagEntity = {
  __typename?: 'OfferCategoryTagEntity';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type OfferCategoryTagSuggestionsInput = {
  hotspotId: Scalars['ID']['input'];
  offerCategoryId: Scalars['ID']['input'];
};

export type OfferInputSuggestion = {
  __typename?: 'OfferInputSuggestion';
  brands: Array<BrandEntity>;
  description?: Maybe<Scalars['String']['output']>;
  discountPercent?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  offerCategories: Array<OfferCategoryEntity>;
  priceAfterDiscount?: Maybe<Scalars['Float']['output']>;
  priceBeforeDiscount?: Maybe<Scalars['Float']['output']>;
};

export type OfferOcrSuggestion = {
  __typename?: 'OfferOcrSuggestion';
  croppedBlocks: Array<VisionBlock>;
  offerInputSuggestion?: Maybe<OfferInputSuggestion>;
  processor: OfferOcrSuggestionProcessorName;
  processorResponse?: Maybe<Scalars['String']['output']>;
};

export type OfferOcrSuggestionHotspotInput = {
  /** A saved hotspot. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** An area on a page, e.g. for a hotspot that hasn't been saved yet. */
  placement?: InputMaybe<HotspotPlacementInput>;
};

export enum OfferOcrSuggestionProcessor {
  Gemini = 'GEMINI'
}

export enum OfferOcrSuggestionProcessorName {
  Gemini = 'GEMINI'
}

export type PageDifference = {
  __typename?: 'PageDifference';
  added: Scalars['Int']['output'];
  changed: Scalars['Int']['output'];
  differenceStatus: DifferenceStatus;
  hotspots: Array<HotspotDifference>;
  newPage?: Maybe<PageEntity>;
  noChanges: Scalars['Int']['output'];
  oldPage?: Maybe<PageEntity>;
  removed: Scalars['Int']['output'];
};

export type PageEntity = {
  __typename?: 'PageEntity';
  fileUrl?: Maybe<Scalars['String']['output']>;
  hotspots?: Maybe<Array<HotspotEntity>>;
  id: Scalars['ID']['output'];
  index: Scalars['Int']['output'];
};


export type PageEntityFileUrlArgs = {
  version: BrochureStatisticsFileVersion;
};

export type PageEntryEntity = {
  __typename?: 'PageEntryEntity';
  averageTimeSeconds: Scalars['Float']['output'];
  index: Scalars['Int']['output'];
  percentageReadsPageOne: Scalars['Float']['output'];
  readers: Scalars['Int']['output'];
  reads: Scalars['Int']['output'];
  totalTimeSeconds: Scalars['Int']['output'];
};

export type PageFilter = {
  pageIndices: Array<Scalars['Int']['input']>;
  regionId: Scalars['ID']['input'];
};

export type PageInput = {
  pageId: Scalars['ID']['input'];
};

export enum PageOrderBy {
  IndexAsc = 'INDEX_ASC',
  IndexDesc = 'INDEX_DESC'
}

export type PagesInput = {
  brochureRegionId: Scalars['ID']['input'];
  orderBy: PageOrderBy;
};

export type PagesWithHotspotsInput = {
  brochureRegionId: Scalars['ID']['input'];
};

export type PaginatedAdminShops = {
  __typename?: 'PaginatedAdminShops';
  entries: Array<AdminShopEntity>;
  pagination: Pagination;
};

export type PaginatedAdsAdvertisements = {
  __typename?: 'PaginatedAdsAdvertisements';
  entries: Array<AdsAdvertisementEntity>;
  pagination: Pagination;
};

export type PaginatedAdsCampaigns = {
  __typename?: 'PaginatedAdsCampaigns';
  entries: Array<AdsCampaignEntity>;
  pagination: Pagination;
};

export type PaginatedAppUsers = {
  __typename?: 'PaginatedAppUsers';
  entries: Array<AppUserEntity>;
  pagination: Pagination;
};

export type PaginatedBrands = {
  __typename?: 'PaginatedBrands';
  entries: Array<BrandEntity>;
  pagination: Pagination;
};

export type PaginatedBrochureLogs = {
  __typename?: 'PaginatedBrochureLogs';
  entries: Array<BrochureLogEntity>;
  pagination: Pagination;
};

export type PaginatedBrochures = {
  __typename?: 'PaginatedBrochures';
  entries: Array<BrochureEntity>;
  pagination: Pagination;
};

export type PaginatedCities = {
  __typename?: 'PaginatedCities';
  entries: Array<CityEntity>;
  pagination: Pagination;
};

export type PaginatedCustomerClients = {
  __typename?: 'PaginatedCustomerClients';
  entries: Array<CustomerClientEntity>;
  pagination: Pagination;
};

export type PaginatedGenericTreeItems = {
  __typename?: 'PaginatedGenericTreeItems';
  entries: Array<GenericTreeItem>;
  pagination: Pagination;
};

export type PaginatedIdentityUsers = {
  __typename?: 'PaginatedIdentityUsers';
  entries: Array<IdentityUserEntity>;
  pagination: Pagination;
};

export type PaginatedNewsletterSubscribers = {
  __typename?: 'PaginatedNewsletterSubscribers';
  entries: Array<NewsletterSubscriberEntity>;
  pagination: Pagination;
};

export type PaginatedOfferCategories = {
  __typename?: 'PaginatedOfferCategories';
  entries: Array<OfferCategoryEntity>;
  pagination: Pagination;
};

export type PaginatedPagesWithHotspots = {
  __typename?: 'PaginatedPagesWithHotspots';
  entries: Array<PageEntity>;
  pagination: Pagination;
};

export type PaginatedShopCardTemplates = {
  __typename?: 'PaginatedShopCardTemplates';
  entries: Array<ShopCardTemplateEntity>;
  pagination: Pagination;
};

export type PaginatedShops = {
  __typename?: 'PaginatedShops';
  entries: Array<ShopEntity>;
  pagination: Pagination;
};

export type PaginatedWebsitePages = {
  __typename?: 'PaginatedWebsitePages';
  entries: Array<WebsitePageEntity>;
  pagination: Pagination;
};

/** Pagination */
export type Pagination = {
  __typename?: 'Pagination';
  currentPage: Scalars['Int']['output'];
  nextPage?: Maybe<Scalars['Int']['output']>;
  previousPage?: Maybe<Scalars['Int']['output']>;
  totalPages: Scalars['Int']['output'];
};

export type PaginationInput = {
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export enum ParseMethod {
  CreateByUrl = 'CREATE_BY_URL',
  Duplicate = 'DUPLICATE'
}

export type ParserClassByUrlInput = {
  url: Scalars['String']['input'];
};

export type ParserClassEntity = {
  __typename?: 'ParserClassEntity';
  class: ParserClasses;
  moduleName: ParserClasses;
};

export enum ParserClasses {
  Colruyt = 'COLRUYT',
  DuplicateBrochure = 'DUPLICATE_BROCHURE',
  Folderscheck = 'FOLDERSCHECK',
  Folderz = 'FOLDERZ',
  FolderzV2 = 'FOLDERZ_V2',
  IssuuV2 = 'ISSUU_V2',
  LidlFlyer = 'LIDL_FLYER',
  Pdf = 'PDF',
  PublishV2 = 'PUBLISH_V2',
  Publitas = 'PUBLITAS',
  PublitasV2 = 'PUBLITAS_V2',
  PublitasV3 = 'PUBLITAS_V3',
  ReclameFolder = 'RECLAME_FOLDER',
  WePublish = 'WE_PUBLISH',
  WePublishV2 = 'WE_PUBLISH_V2',
  WePublishV3 = 'WE_PUBLISH_V3',
  Yumpu = 'YUMPU',
  YumpuV2 = 'YUMPU_V2'
}

export type ParserEntity = {
  __typename?: 'ParserEntity';
  parserClass: ParserClassEntity;
  url: Scalars['String']['output'];
};

export type ParserParameters = {
  __typename?: 'ParserParameters';
  parserClass?: Maybe<ParserClasses>;
  parsers: Array<CreateBrochureRegionParams>;
};

export type ParserParametersInput = {
  brochureId: Scalars['ID']['input'];
  method: ParseMethod;
};

export type PdfEntity = {
  __typename?: 'PdfEntity';
  id: Scalars['ID']['output'];
  uploadUrl: Scalars['String']['output'];
};

export type PdfMessageEntity = {
  __typename?: 'PdfMessageEntity';
  coverUrl?: Maybe<Scalars['String']['output']>;
  indexUrl?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  pdfId: Scalars['ID']['output'];
};

export type Point = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type PositionBrochureLog = BrochureLogEntity & {
  __typename?: 'PositionBrochureLog';
  content: Scalars['String']['output'];
  insertedAt: Scalars['DateTime']['output'];
  level: BrochureLogLevel;
};

export enum PostProcessingStatus {
  Idle = 'IDLE',
  InProgress = 'IN_PROGRESS'
}

export type PostProcessingStatusInput = {
  brochureId: Scalars['ID']['input'];
};

export type ProductInput = {
  brandIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  brandName?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discountPercent?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  offerCategoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  priceAfterDiscount?: InputMaybe<Scalars['Float']['input']>;
  priceBeforeDiscount?: InputMaybe<Scalars['Float']['input']>;
};

export type ProductTagEntity = {
  __typename?: 'ProductTagEntity';
  brand?: Maybe<BrandEntity>;
  brandName?: Maybe<Scalars['String']['output']>;
  brands: Array<BrandEntity>;
  description?: Maybe<Scalars['String']['output']>;
  discountPercent?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  offerCategories: Array<OfferCategoryEntity>;
  priceAfterDiscount?: Maybe<Scalars['Float']['output']>;
  priceBeforeDiscount?: Maybe<Scalars['Float']['output']>;
};

export type PublicBrochuresInput = {
  languageId: Scalars['ID']['input'];
  point?: InputMaybe<Point>;
  shopId?: InputMaybe<Scalars['ID']['input']>;
};

export type PublishMergeRequestInput = {
  mergeRequestId: Scalars['ID']['input'];
};

export type RegionEntity = {
  __typename?: 'RegionEntity';
  id: Scalars['ID']['output'];
  locationsCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type RegionInput = {
  regionId: Scalars['ID']['input'];
};

export enum RegionOrderBy {
  NameAsc = 'NAME_ASC'
}

export type RegionsInput = {
  orderBy: RegionOrderBy;
  shopId: Scalars['ID']['input'];
};

export type RejectMergeRequestInput = {
  mergeRequestId: Scalars['ID']['input'];
};

export type ResetPasswordIdentityUserInput = {
  email: Scalars['String']['input'];
};

export enum ResetPasswordStatus {
  Ok = 'OK'
}

export type RootMutationType = {
  __typename?: 'RootMutationType';
  /** Approve hotspot fields */
  approveHotspotFields?: Maybe<HotspotEntity>;
  /** Approve request by archiving the old brochure and publishing the new brochure */
  approveMergeRequestAsNew: ApproveMergeRequestAsNew;
  /** Approve request by updating the old brochure with data from the new brochure */
  approveMergeRequestAsUpdate: ApproveMergeRequestAsUpdate;
  /** Change password identity_user */
  changePasswordIdentityUser?: Maybe<MutatedChangePasswordIdentityUser>;
  /** Convert all link hotspots of a brochure to product hotspots */
  convertLinkHotspotsToProductHotspots: ConvertLinkHotspotsStatusEntity;
  /** Copy hotspots from another BrochureRegion, but only if this one has no hotspots yet */
  copyHotspots?: Maybe<CopyHotspotsStatusEntity>;
  /** Create ads_campaign */
  createAdsCampaign: MutatedCreateAdsCampaign;
  /** Create ads_advertisement for html_embed */
  createAdsCampaignAdvertisementHtmlEmbed?: Maybe<AdsAdvertisementEntity>;
  /** Create ads_advertisement for image_ad */
  createAdsCampaignAdvertisementImageAd?: Maybe<AdsAdvertisementEntity>;
  /** Create brand. */
  createBrand?: Maybe<BrandEntity>;
  /** Brochure create by parser */
  createBrochureByParser: CreateBrochureByParser;
  /** Create Brochure Experiment */
  createBrochureExperiment: MutatedCreateBrochureExperiment;
  /** Create category. */
  createCategory?: Maybe<CategoryEntity>;
  /** Create city */
  createCity?: Maybe<CityEntity>;
  /** Create customer_client with a name and set_ids from other customer_clients. */
  createCustomerClient?: Maybe<CustomerClientEntity>;
  createDeliveryFailureReport?: Maybe<DeliveryFailureReportEntity>;
  /** Create a generic product */
  createGenericProduct?: Maybe<GenericProductEntity>;
  /** Create a generic product category */
  createGenericProductCategory?: Maybe<GenericProductCategoryEntity>;
  /** Create hotspot image */
  createHotspotImage?: Maybe<HotspotEntity>;
  /** Create hotspot link */
  createHotspotLink?: Maybe<HotspotEntity>;
  /** Create hotspot product */
  createHotspotProduct?: Maybe<HotspotEntity>;
  /** Create identity_user */
  createIdentityUser?: Maybe<MutatedCreateIdentityUser>;
  /** Create a password reset link for an app user, used by customer support */
  createIdentityUserPasswordResetLink?: Maybe<MutatedCreateIdentityUserPasswordResetLink>;
  /** Create location. */
  createLocation: MutatedLocation;
  /** Creates locations based on the result of the import_locations mutation. */
  createLocationsByImport: MutatedCreateLocationsByImport;
  createNewsletterCategory: NewsletterCategoryEntity;
  /** Create offer_category */
  createOfferCategory?: Maybe<OfferCategoryEntity>;
  /** Create pdf. */
  createPdf?: Maybe<PdfEntity>;
  /** Create region. */
  createRegion: MutatedRegion;
  /** Create shop. */
  createShop: MutatedShop;
  /** Create shop_card_template. */
  createShopCardTemplate: MutatedCreateShopCardTemplate;
  /** Create website_page with type page */
  createWebsitePage?: Maybe<WebsitePagePage>;
  /** Create website_page with type post */
  createWebsitePost?: Maybe<WebsitePagePost>;
  /** Delete ads_campaign */
  deleteAdsCampaign?: Maybe<MutatedDeleteAdsCampaign>;
  /**
   * Delete ads_advertisement
   * @deprecated Deleting ads without campaign will no longer be supported: use delete_ads_campaign_advertisement instead
   */
  deleteAdsCampaignAdvertisement?: Maybe<MutatedDeleteAdsAdvertisement>;
  /** Delete brand */
  deleteBrand?: Maybe<MutatedDeleteBrand>;
  /** Delete brand_tag */
  deleteBrandTag: MutatedDeleteBrandTag;
  /** Delete city */
  deleteCity?: Maybe<MutatedDeleteCity>;
  /** Delete a generic product */
  deleteGenericProduct: MutatedDeleteGenericProduct;
  /** Delete a generic product category */
  deleteGenericProductCategory: MutatedDeleteGenericProductCategory;
  /** Delete hotspot */
  deleteHotspot?: Maybe<MutatedDeleteHotspot>;
  /** Delete all hotspots for a brochure region */
  deleteHotspots: DeleteHotspotsStatus;
  /** Delete identity_user */
  deleteIdentityUser?: Maybe<MutatedDeleteIdentityUser>;
  /** Delete location. */
  deleteLocation: MutatedDeleteLocation;
  /** delete multiple locations. */
  deleteLocations: MutatedDeleteLocations;
  deleteNewsletterCategory: MutatedStatus;
  /** Delete a guest newsletter_subscriber */
  deleteNewsletterSubscriber?: Maybe<MutatedDeleteNewsletterSubscriber>;
  /** Delete offer_category */
  deleteOfferCategory?: Maybe<MutatedDeleteOfferCategory>;
  /** Delete offer_category_tag */
  deleteOfferCategoryTag: MutatedDeleteOfferCategoryTag;
  /** Delete page */
  deletePage: MutatedDeletePage;
  /** Delete pdf */
  deletePdf?: Maybe<MutatedDeletePdf>;
  /** Deletes all pricing information for a brochure region */
  deleteProductPrices: DeleteProductPricesStatus;
  /** Delete region. */
  deleteRegion: MutatedDeleteRegion;
  /** Delete multiple regions. */
  deleteRegions: MutatedDeleteRegions;
  /** Delete website_page with type post */
  deleteWebsitePage?: Maybe<MutatedDeleteWebsitePage>;
  /** Detect product hotspots for a single page */
  detectHotspotsForPage: DetectProductHotspotsEntity;
  /** Detect product hotspots on pages without hotspots using Google VertexAI & Vision */
  detectProductHotspots: DetectProductHotspotsEntity;
  /** Export a CSV file with locations including region name. */
  exportLocations: MutatedExportLocations;
  /** Export to pdf */
  exportToPdf: ExportToPdfResponse;
  /** Accepts CSV files. */
  importLocations: MutatedImportLocations;
  migrateBrochureRegionMyshopi: MutatedMigrateBrochureRegionMyshopi;
  /** Publish a merge request by updating its status from draft to pending */
  publishMergeRequest: MutatedMergeRequest;
  /** Reject request by setting the status of the merge request to 'rejected' and putting the new_brochure in trash */
  rejectMergeRequest: MutatedMergeRequest;
  /** Request a password reset link for an identity_user */
  resetPasswordIdentityUser?: Maybe<MutatedResetPasswordIdentityUser>;
  /** Set a new password for an identity_user using a reset token */
  setPasswordIdentityUser?: Maybe<MutatedSetPasswordIdentityUser>;
  /**
   * Sort the children of a generic tree node. Provide decimal sort indices to position
   *     items between existing ones — all items will be re-indexed to a continuous integer sequence.
   */
  sortGenericTreeItems: MutatedStatus;
  /** Unsubscribe identity_user from all newsletters */
  unsubscribeIdentityUserFromNewsletters?: Maybe<MutatedUnsubscribeIdentityUserFromNewsletters>;
  /** Unsubscribe a guest newsletter_subscriber from all newsletters */
  unsubscribeNewsletterSubscriberFromNewsletters?: Maybe<MutatedUnsubscribeNewsletterSubscriberFromNewsletters>;
  /** Update ads_campaign */
  updateAdsCampaign?: Maybe<AdsCampaignEntity>;
  /** Update ads_advertisement for html_embed */
  updateAdsCampaignAdvertisementHtmlEmbed?: Maybe<AdsAdvertisementEntity>;
  /** Update ads_advertisement for image_ad */
  updateAdsCampaignAdvertisementImageAd?: Maybe<AdsAdvertisementEntity>;
  /** Update the current app. */
  updateApp?: Maybe<AppEntity>;
  /** Update an app language. */
  updateAppLanguage?: Maybe<AppLanguageEntity>;
  /** Update brand. */
  updateBrand?: Maybe<BrandEntity>;
  /** Brochure update - with general and/or admin fields */
  updateBrochure: MutatedUpdateBrochure;
  /** Update the assignee on a brochure */
  updateBrochureAssignee: MutatedUpdateBrochureAssignee;
  /** Brochure update for position or fr */
  updateBrochurePosition: MutatedUpdateBrochure;
  /** Brochure update state */
  updateBrochureState?: Maybe<UpdateBrochureState>;
  /** Update category. */
  updateCategory?: Maybe<CategoryEntity>;
  /** Update city */
  updateCity?: Maybe<CityEntity>;
  /** Update current_user */
  updateCurrentUser?: Maybe<MutatedUpdateCurrentUser>;
  /** Update customer_client with a new name or additionals set_ids. */
  updateCustomerClient?: Maybe<CustomerClientEntity>;
  /** Update a generic product */
  updateGenericProduct?: Maybe<GenericProductEntity>;
  /** Update a generic product category */
  updateGenericProductCategory?: Maybe<GenericProductCategoryEntity>;
  /** Update hotspot image */
  updateHotspotImage?: Maybe<HotspotEntity>;
  /** Update hotspot link */
  updateHotspotLink?: Maybe<HotspotEntity>;
  /** Update hotspot product */
  updateHotspotProduct?: Maybe<HotspotEntity>;
  /** Update identity_user */
  updateIdentityUser?: Maybe<MutatedUpdateIdentityUser>;
  /** Updates a location */
  updateLocation?: Maybe<MutatedLocation>;
  updateNewsletterCategory: NewsletterCategoryEntity;
  /** Update offer_category */
  updateOfferCategory?: Maybe<OfferCategoryEntity>;
  /** Update region. */
  updateRegion: MutatedRegion;
  /** Update shop. */
  updateShop: MutatedShop;
  /** Update shop_card_template. */
  updateShopCardTemplate: MutatedUpdateShopCardTemplate;
  /** Update website_page with type page */
  updateWebsitePage?: Maybe<WebsitePagePage>;
  /** Update website_page with type post */
  updateWebsitePost?: Maybe<WebsitePagePost>;
  /** Upsert brochure city position */
  upsertBrochureCityPosition: MutatedUpsertBrochureCity;
  /** Upsert session */
  upsertSession: MutatedUpsertSessionStatus;
};


export type RootMutationTypeApproveHotspotFieldsArgs = {
  approveHotspotFields: ApproveHotspotFieldsInput;
};


export type RootMutationTypeApproveMergeRequestAsNewArgs = {
  approveMergeRequestAsNew: ApproveMergeRequestAsNewInput;
};


export type RootMutationTypeApproveMergeRequestAsUpdateArgs = {
  approveMergeRequestAsUpdate: ApproveMergeRequestAsUpdateInput;
};


export type RootMutationTypeChangePasswordIdentityUserArgs = {
  changePasswordIdentityUser: ChangePasswordIdentityUserInput;
};


export type RootMutationTypeConvertLinkHotspotsToProductHotspotsArgs = {
  convertHotspots: ConvertHotspotsInput;
};


export type RootMutationTypeCopyHotspotsArgs = {
  copyHotspots: CopyHotspotsInput;
};


export type RootMutationTypeCreateAdsCampaignArgs = {
  createAdsCampaign: CreateAdsCampaignInput;
};


export type RootMutationTypeCreateAdsCampaignAdvertisementHtmlEmbedArgs = {
  createAdsCampaignAdvertisementHtmlEmbed: CreateAdsCampaignAdvertisementHtmlEmbedInput;
};


export type RootMutationTypeCreateAdsCampaignAdvertisementImageAdArgs = {
  createAdsCampaignAdvertisementImageAd: CreateAdsCampaignAdvertisementImageAdInput;
};


export type RootMutationTypeCreateBrandArgs = {
  createBrand: CreateBrandInput;
};


export type RootMutationTypeCreateBrochureByParserArgs = {
  createBrochure: CreateBrochureByParserInput;
};


export type RootMutationTypeCreateBrochureExperimentArgs = {
  createBrochureExperiment: CreateBrochureExperimentInput;
};


export type RootMutationTypeCreateCategoryArgs = {
  createCategory: CreateCategoryInput;
};


export type RootMutationTypeCreateCityArgs = {
  createCity: CreateCityInput;
};


export type RootMutationTypeCreateCustomerClientArgs = {
  createCustomerClient: CreateCustomerClientInput;
};


export type RootMutationTypeCreateDeliveryFailureReportArgs = {
  createDeliveryFailureReport?: InputMaybe<DeliveryFailureReportInput>;
};


export type RootMutationTypeCreateGenericProductArgs = {
  createGenericProduct: CreateGenericProductInput;
};


export type RootMutationTypeCreateGenericProductCategoryArgs = {
  createGenericProductCategory: CreateGenericProductCategoryInput;
};


export type RootMutationTypeCreateHotspotImageArgs = {
  createHotspot: CreateHotspotImageInput;
};


export type RootMutationTypeCreateHotspotLinkArgs = {
  createHotspot: CreateHotspotLinkInput;
};


export type RootMutationTypeCreateHotspotProductArgs = {
  createHotspot: CreateHotspotProductInput;
};


export type RootMutationTypeCreateIdentityUserArgs = {
  createIdentityUser: CreateIdentityUserInput;
};


export type RootMutationTypeCreateIdentityUserPasswordResetLinkArgs = {
  createIdentityUserPasswordResetLink: CreateIdentityUserPasswordResetLinkInput;
};


export type RootMutationTypeCreateLocationArgs = {
  createLocation: CreateLocationInput;
};


export type RootMutationTypeCreateLocationsByImportArgs = {
  createLocationsByImport: CreateLocationsByImportInput;
};


export type RootMutationTypeCreateNewsletterCategoryArgs = {
  input: CreateNewsletterCategoryInput;
};


export type RootMutationTypeCreateOfferCategoryArgs = {
  createOfferCategory: CreateOfferCategoryInput;
};


export type RootMutationTypeCreatePdfArgs = {
  createPdf: CreatePdfInput;
};


export type RootMutationTypeCreateRegionArgs = {
  createRegion: CreateRegionInput;
};


export type RootMutationTypeCreateShopArgs = {
  createShop: CreateShopInput;
};


export type RootMutationTypeCreateShopCardTemplateArgs = {
  createShopCardTemplate: CreateShopCardTemplateInput;
};


export type RootMutationTypeCreateWebsitePageArgs = {
  createWebsitePage: CreateWebsitePageInput;
};


export type RootMutationTypeCreateWebsitePostArgs = {
  createWebsitePost: CreateWebsitePostInput;
};


export type RootMutationTypeDeleteAdsCampaignArgs = {
  deleteAdsCampaign: DeleteAdsCampaignInput;
};


export type RootMutationTypeDeleteAdsCampaignAdvertisementArgs = {
  deleteAdsCampaignAdvertisement: DeleteAdsCampaignAdvertisementInput;
};


export type RootMutationTypeDeleteBrandArgs = {
  deleteBrand: DeleteBrandInput;
};


export type RootMutationTypeDeleteBrandTagArgs = {
  deleteBrandTag: DeleteBrandTagInput;
};


export type RootMutationTypeDeleteCityArgs = {
  deleteCity: DeleteCityInput;
};


export type RootMutationTypeDeleteGenericProductArgs = {
  deleteGenericProduct: DeleteGenericProductInput;
};


export type RootMutationTypeDeleteGenericProductCategoryArgs = {
  deleteGenericProductCategory: DeleteGenericProductCategoryInput;
};


export type RootMutationTypeDeleteHotspotArgs = {
  deleteHotspot: DeleteHotspotInput;
};


export type RootMutationTypeDeleteHotspotsArgs = {
  deleteHotspots: DeleteHotspotsInput;
};


export type RootMutationTypeDeleteIdentityUserArgs = {
  deleteIdentityUser: DeleteIdentityUserInput;
};


export type RootMutationTypeDeleteLocationArgs = {
  deleteLocation: DeleteLocationInput;
};


export type RootMutationTypeDeleteLocationsArgs = {
  deleteLocations: DeleteLocationsInput;
};


export type RootMutationTypeDeleteNewsletterCategoryArgs = {
  input?: InputMaybe<DeleteNewsletterCategoryInput>;
};


export type RootMutationTypeDeleteNewsletterSubscriberArgs = {
  deleteNewsletterSubscriber: DeleteNewsletterSubscriberInput;
};


export type RootMutationTypeDeleteOfferCategoryArgs = {
  deleteOfferCategory: DeleteOfferCategoryInput;
};


export type RootMutationTypeDeleteOfferCategoryTagArgs = {
  deleteOfferCategoryTag: DeleteOfferCategoryTagInput;
};


export type RootMutationTypeDeletePageArgs = {
  deletePage: DeletePageInput;
};


export type RootMutationTypeDeletePdfArgs = {
  deletePdf: DeletePdfInput;
};


export type RootMutationTypeDeleteProductPricesArgs = {
  deleteProductPrices: DeleteProductPricesInput;
};


export type RootMutationTypeDeleteRegionArgs = {
  deleteRegion: DeleteRegionInput;
};


export type RootMutationTypeDeleteRegionsArgs = {
  deleteRegions: DeleteRegionsInput;
};


export type RootMutationTypeDeleteWebsitePageArgs = {
  deleteWebsitePage: DeleteWebsitePageInput;
};


export type RootMutationTypeDetectHotspotsForPageArgs = {
  detectHotspotsForPage: DetectHotspotsForPageInput;
};


export type RootMutationTypeDetectProductHotspotsArgs = {
  detectProductHotspots: DetectProductHotspotsInput;
};


export type RootMutationTypeExportLocationsArgs = {
  exportLocations: ExportLocationsInput;
};


export type RootMutationTypeExportToPdfArgs = {
  exportToPdf: ExportToPdfInput;
};


export type RootMutationTypeImportLocationsArgs = {
  importLocations: ImportLocationsInput;
};


export type RootMutationTypeMigrateBrochureRegionMyshopiArgs = {
  migrateBrochureRegionMyshopi: MigrateBrochureRegionMyshopiInput;
};


export type RootMutationTypePublishMergeRequestArgs = {
  publishMergeRequest: PublishMergeRequestInput;
};


export type RootMutationTypeRejectMergeRequestArgs = {
  rejectMergeRequest: RejectMergeRequestInput;
};


export type RootMutationTypeResetPasswordIdentityUserArgs = {
  resetPasswordIdentityUser: ResetPasswordIdentityUserInput;
};


export type RootMutationTypeSetPasswordIdentityUserArgs = {
  setPasswordIdentityUser: SetPasswordIdentityUserInput;
};


export type RootMutationTypeSortGenericTreeItemsArgs = {
  sortGenericTreeItems: SortGenericTreeItemsInput;
};


export type RootMutationTypeUnsubscribeIdentityUserFromNewslettersArgs = {
  unsubscribeIdentityUserFromNewsletters: UnsubscribeIdentityUserFromNewslettersInput;
};


export type RootMutationTypeUnsubscribeNewsletterSubscriberFromNewslettersArgs = {
  unsubscribeNewsletterSubscriberFromNewsletters: UnsubscribeNewsletterSubscriberFromNewslettersInput;
};


export type RootMutationTypeUpdateAdsCampaignArgs = {
  updateAdsCampaign: UpdateAdsCampaignInput;
};


export type RootMutationTypeUpdateAdsCampaignAdvertisementHtmlEmbedArgs = {
  updateAdsCampaignAdvertisementHtmlEmbed: UpdateAdsCampaignAdvertisementHtmlEmbedInput;
};


export type RootMutationTypeUpdateAdsCampaignAdvertisementImageAdArgs = {
  updateAdsCampaignAdvertisementImageAd: UpdateAdsCampaignAdvertisementImageAdInput;
};


export type RootMutationTypeUpdateAppArgs = {
  updateApp: UpdateAppInput;
};


export type RootMutationTypeUpdateAppLanguageArgs = {
  updateAppLanguage: UpdateAppLanguageInput;
};


export type RootMutationTypeUpdateBrandArgs = {
  updateBrand: UpdateBrandInput;
};


export type RootMutationTypeUpdateBrochureArgs = {
  updateBrochure: UpdateBrochureInput;
};


export type RootMutationTypeUpdateBrochureAssigneeArgs = {
  updateBrochureAssignee: UpdateBrochureAssigneeInput;
};


export type RootMutationTypeUpdateBrochurePositionArgs = {
  updateBrochurePosition: UpdateBrochurePositionInput;
};


export type RootMutationTypeUpdateBrochureStateArgs = {
  updateBrochureState: UpdateBrochureStateInput;
};


export type RootMutationTypeUpdateCategoryArgs = {
  updateCategory: UpdateCategoryInput;
};


export type RootMutationTypeUpdateCityArgs = {
  updateCity: UpdateCityInput;
};


export type RootMutationTypeUpdateCurrentUserArgs = {
  updateCurrentUser: UpdateCurrentUserInput;
};


export type RootMutationTypeUpdateCustomerClientArgs = {
  updateCustomerClient: UpdateCustomerClientInput;
};


export type RootMutationTypeUpdateGenericProductArgs = {
  updateGenericProduct: UpdateGenericProductInput;
};


export type RootMutationTypeUpdateGenericProductCategoryArgs = {
  updateGenericProductCategory: UpdateGenericProductCategoryInput;
};


export type RootMutationTypeUpdateHotspotImageArgs = {
  updateHotspot: UpdateHotspotImageInput;
};


export type RootMutationTypeUpdateHotspotLinkArgs = {
  updateHotspot: UpdateHotspotLinkInput;
};


export type RootMutationTypeUpdateHotspotProductArgs = {
  updateHotspot: UpdateHotspotProductInput;
};


export type RootMutationTypeUpdateIdentityUserArgs = {
  updateIdentityUser: UpdateIdentityUserInput;
};


export type RootMutationTypeUpdateLocationArgs = {
  updateLocation: UpdateLocationInput;
};


export type RootMutationTypeUpdateNewsletterCategoryArgs = {
  input: UpdateNewsletterCategoryInput;
};


export type RootMutationTypeUpdateOfferCategoryArgs = {
  updateOfferCategory: UpdateOfferCategoryInput;
};


export type RootMutationTypeUpdateRegionArgs = {
  updateRegion: UpdateRegionInput;
};


export type RootMutationTypeUpdateShopArgs = {
  updateShop: UpdateShopInput;
};


export type RootMutationTypeUpdateShopCardTemplateArgs = {
  updateShopCardTemplate: UpdateShopCardTemplateInput;
};


export type RootMutationTypeUpdateWebsitePageArgs = {
  updateWebsitePage: UpdateWebsitePageInput;
};


export type RootMutationTypeUpdateWebsitePostArgs = {
  updateWebsitePost: UpdateWebsitePostInput;
};


export type RootMutationTypeUpsertBrochureCityPositionArgs = {
  upsertBrochureCityPosition: UpsertBrochureCityPositionInput;
};

export type RootQueryType = {
  __typename?: 'RootQueryType';
  /** A list of brochures for the brochures statistics management page filtered by published date, shop/category ids, and time step (day/week/month). */
  adminBrochureReads?: Maybe<Array<Maybe<AdminBrochureReadEntity>>>;
  adminShop?: Maybe<AdminShopEntity>;
  adminShops: PaginatedAdminShops;
  /** A list of ads for the dashboard statistics overview page filtered by active time range and time step (day/week/month). */
  adsAdvertisementStatisticsOverview?: Maybe<AdsAdvertisementStatisticsOverviewListResponse>;
  /** Get an ads_campaign. */
  adsCampaign?: Maybe<AdsCampaignEntity>;
  /** Retrieve a single ads_advertisement's data. */
  adsCampaignAdvertisement?: Maybe<AdsAdvertisementEntity>;
  /** A list of ads_advertisements by AdsCampaign. */
  adsCampaignAdvertisements: PaginatedAdsAdvertisements;
  /**
   * Used in the create campaign form: based on the input arguments feasible values are returned.
   *     See the return type for possible values.
   */
  adsCampaignCreateForm: AdsCampaignCreateFormEntity;
  /** A list of ads_campaigns. */
  adsCampaigns: PaginatedAdsCampaigns;
  app: AppEntity;
  /** Retrieve a single app language. */
  appLanguage?: Maybe<AppLanguageEntity>;
  /** A list of app languages. */
  appLanguages?: Maybe<Array<Maybe<AppLanguageEntity>>>;
  /** A list of app users: consumer accounts and guest newsletter subscribers. */
  appUsers?: Maybe<PaginatedAppUsers>;
  /** Retrieve a single brand's data. */
  brand?: Maybe<BrandEntity>;
  /** A list of brands. */
  brands?: Maybe<PaginatedBrands>;
  /** Get brochure */
  brochure?: Maybe<BrochureEntity>;
  /** A list of brochure assignee users. */
  brochureAssignees: PaginatedIdentityUsers;
  /** Get the number of brochures per state */
  brochureCounters: Array<BrochureStateCount>;
  /** A list of brochure_logs. */
  brochureLogs: PaginatedBrochureLogs;
  /** Get brochure_region */
  brochureRegion?: Maybe<BrochureRegionEntity>;
  /** A list of brochure_regions. */
  brochureRegions?: Maybe<Array<Maybe<BrochureRegionEntity>>>;
  /** Brochure state transitions: list possible states from the current state */
  brochureStateTransitions: BrochureStateTransitions;
  /** Brochure statistics detail. */
  brochureStatistic?: Maybe<BrochureDetailStatiticsEntity>;
  /** A list of brochures. */
  brochures: PaginatedBrochures;
  /** A list of brochures for the brochures pages statistics page filtered by published date. */
  brochuresPagesStatistics?: Maybe<Array<Maybe<BrochurePagesStatisticsEntity>>>;
  /** A list of brochures for the brochures reads statistics page filtered by published date. */
  brochuresReadsStatistics?: Maybe<Array<Maybe<BrochureReadStatisticsEntity>>>;
  /** A list of brochures for the dashboard statistics overview page filtered by published date and time step (day/week/month). */
  brochuresStatisticsOverview?: Maybe<BrochuresStatisticsOverviewListResponse>;
  /** A list of categories. */
  categories?: Maybe<Array<Maybe<CategoryEntity>>>;
  category?: Maybe<CategoryEntity>;
  /** A list of cities. */
  cities?: Maybe<PaginatedCities>;
  /** Retrieve a single city's data. */
  city?: Maybe<CityEntity>;
  /** A list of allowed customer client features */
  clientPermissions: Array<CustomerClientPermission>;
  /** Retrieve a single customer_client's data. */
  customerClient: CustomerClientEntity;
  /** A list of customer_clients. */
  customerClients: PaginatedCustomerClients;
  /** A single generic product. */
  genericProduct?: Maybe<GenericProductEntity>;
  /** A single generic product category */
  genericProductCategory?: Maybe<GenericProductCategoryEntity>;
  /** A list of generic products. */
  genericProducts: Array<GenericProductEntity>;
  /** A mixed, paginated list of generic products and categories sorted by sort index. */
  genericTreeItems: PaginatedGenericTreeItems;
  /** Retrieve a single hotspot's data. */
  hotspot?: Maybe<HotspotEntity>;
  /** A list of hotspots. */
  hotspots?: Maybe<Array<Maybe<HotspotEntity>>>;
  /** A list of statistics per hotspot of the specified brochure. The statistics are based on the hotspots BigQuery table. See the developer handoff for more information. */
  hotspotsStatistics: Array<HotspotStatistics>;
  /** Retrieve a single identity_user's data. */
  identityUser?: Maybe<IdentityUserEntity>;
  /** A list of identity_users. */
  identityUsers?: Maybe<PaginatedIdentityUsers>;
  /** Retrieve a single language's data. */
  language?: Maybe<LanguageEntity>;
  /** A list of languages. */
  languages?: Maybe<Array<Maybe<LanguageEntity>>>;
  /** A single location */
  location?: Maybe<LocationEntity>;
  me?: Maybe<CurrentUser>;
  /** Merge request details including differences of pages and hotspots */
  mergeRequest?: Maybe<MergeRequestDetails>;
  /** A list of merge_requests. */
  mergeRequests: Array<MergeRequestEntity>;
  myshopiShopBrochures: PaginatedBrochures;
  newsletterCategories: Array<NewsletterCategoryEntity>;
  newsletterCategory?: Maybe<NewsletterCategoryEntity>;
  newsletterSubscribers?: Maybe<PaginatedNewsletterSubscribers>;
  /** A list of offer_categories. */
  offerCategories?: Maybe<PaginatedOfferCategories>;
  /** Retrieve a single offer_category's data. */
  offerCategory?: Maybe<OfferCategoryEntity>;
  offerCategoryTagSuggestions: Array<OfferCategoryTagEntity>;
  /** Get an offer suggestion for a hotspot, or for an area on a page. */
  offerOcrSuggestion?: Maybe<OfferOcrSuggestion>;
  /** Retrieve a single page's data. */
  page?: Maybe<PageEntity>;
  /** A list of pages. */
  pages?: Maybe<Array<Maybe<PageEntity>>>;
  /** Paginated pages with hotspots. */
  pagesWithHotspots: PaginatedPagesWithHotspots;
  /** Get a parser class that should be able to parse the input url. Null if none was found. */
  parserClassByUrl?: Maybe<ParserClasses>;
  /**
   * Get the parser class and url that was used to parse the brochure.
   *     Can be used to create new versions and prefill forms.
   */
  parserParameters: ParserParameters;
  /** Whether any hotspot/page/product/vision_cache post processing job is running */
  postProcessingStatus: PostProcessingStatus;
  /** A list of brochures as seen by users */
  publicBrochures: PaginatedBrochures;
  /** Retrieve a single region. */
  region?: Maybe<RegionEntity>;
  /** A list of regions. */
  regions: Array<RegionEntity>;
  /** Daily session time for a user given a start and end date. */
  sessions: Array<SessionStatistic>;
  /** Retrieve a single shop's basic information. */
  shop?: Maybe<ShopEntity>;
  /** Retrieve a single shop_card_template's data. */
  shopCardTemplate?: Maybe<ShopCardTemplateEntity>;
  /** A list of shop_card_templates. */
  shopCardTemplates: PaginatedShopCardTemplates;
  /** A list of shops. */
  shops?: Maybe<PaginatedShops>;
  /** Daily tag statistics for a user given a start and end date. */
  tagStatistics: Array<TagStatistic>;
  /** Tag statistics of all users given a start and end date. */
  tagStatisticsOverview: TagStatisticsOverview;
  /** A list of tagging users. */
  taggingUsers?: Maybe<PaginatedIdentityUsers>;
  /** Get a page. */
  websitePage?: Maybe<WebsitePageEntity>;
  /** A list of website_pages. Mainly used to retrieve the blog posts. */
  websitePages?: Maybe<PaginatedWebsitePages>;
};


export type RootQueryTypeAdminBrochureReadsArgs = {
  adminBrochureReads: AdminBrochureReadsInput;
};


export type RootQueryTypeAdminShopArgs = {
  adminShop: AdminShopInput;
};


export type RootQueryTypeAdminShopsArgs = {
  adminShops: AdminShopsInput;
  pagination: PaginationInput;
};


export type RootQueryTypeAdsAdvertisementStatisticsOverviewArgs = {
  adsAdvertisement: AdsAdvertisementStatisticsOverviewInput;
};


export type RootQueryTypeAdsCampaignArgs = {
  adsCampaign: AdsCampaignInput;
};


export type RootQueryTypeAdsCampaignAdvertisementArgs = {
  adsCampaignAdvertisement: AdsCampaignAdvertisementInput;
};


export type RootQueryTypeAdsCampaignAdvertisementsArgs = {
  adsCampaignAdvertisements: AdsCampaignAdvertisementsInput;
  pagination: PaginationInput;
};


export type RootQueryTypeAdsCampaignCreateFormArgs = {
  adsCampaignCreateForm: AdsCampaignCreateFormInput;
};


export type RootQueryTypeAdsCampaignsArgs = {
  adsCampaigns: AdsCampaignsInput;
  pagination: PaginationInput;
};


export type RootQueryTypeAppLanguageArgs = {
  appLanguage: AppLanguageInput;
};


export type RootQueryTypeAppUsersArgs = {
  appUsers: AppUsersInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type RootQueryTypeBrandArgs = {
  brand: BrandInput;
};


export type RootQueryTypeBrandsArgs = {
  brands: BrandsInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type RootQueryTypeBrochureArgs = {
  brochure: BrochureInput;
};


export type RootQueryTypeBrochureAssigneesArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type RootQueryTypeBrochureCountersArgs = {
  brochureCounters: BrochureCountersInput;
};


export type RootQueryTypeBrochureLogsArgs = {
  brochureLogs: BrochureLogsInput;
  pagination: PaginationInput;
};


export type RootQueryTypeBrochureRegionArgs = {
  brochureRegion: BrochureRegionInput;
};


export type RootQueryTypeBrochureRegionsArgs = {
  brochureRegions: BrochureRegionsInput;
};


export type RootQueryTypeBrochureStateTransitionsArgs = {
  brochureStateTransitions: BrochureStateTransitionsInput;
};


export type RootQueryTypeBrochureStatisticArgs = {
  brochure: BrochureStatisticsInput;
};


export type RootQueryTypeBrochuresArgs = {
  brochures: BrochuresInput;
  pagination: PaginationInput;
};


export type RootQueryTypeBrochuresPagesStatisticsArgs = {
  brochures: BrochuresPagesStatisticsInput;
};


export type RootQueryTypeBrochuresReadsStatisticsArgs = {
  brochures: BrochuresReadsStatisticsInput;
};


export type RootQueryTypeBrochuresStatisticsOverviewArgs = {
  brochures: BrochuresStatisticsOverviewInput;
};


export type RootQueryTypeCategoriesArgs = {
  categories?: InputMaybe<CategoriesInput>;
};


export type RootQueryTypeCategoryArgs = {
  category: CategoryInput;
};


export type RootQueryTypeCitiesArgs = {
  cities: CitiesInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type RootQueryTypeCityArgs = {
  city: CityInput;
};


export type RootQueryTypeClientPermissionsArgs = {
  clientPermissions: ClientPermissionsScopeInput;
};


export type RootQueryTypeCustomerClientArgs = {
  customerClient: CustomerClientInput;
};


export type RootQueryTypeCustomerClientsArgs = {
  customerClients: CustomerClientsInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type RootQueryTypeGenericProductArgs = {
  genericProduct: GenericProductInput;
};


export type RootQueryTypeGenericProductCategoryArgs = {
  genericProductCategory: GenericProductCategoryInput;
};


export type RootQueryTypeGenericProductsArgs = {
  genericProducts: GenericProductsInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type RootQueryTypeGenericTreeItemsArgs = {
  genericTreeItems: GenericTreeItemsInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type RootQueryTypeHotspotArgs = {
  hotspot: HotspotInput;
};


export type RootQueryTypeHotspotsArgs = {
  hotspots: HotspotsInput;
};


export type RootQueryTypeHotspotsStatisticsArgs = {
  hotspotsStatistics: HotspotsStatisticsInput;
};


export type RootQueryTypeIdentityUserArgs = {
  identityUser: IdentityUserInput;
};


export type RootQueryTypeIdentityUsersArgs = {
  identityUsers: IdentityUsersInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type RootQueryTypeLanguageArgs = {
  language: LanguageInput;
};


export type RootQueryTypeLocationArgs = {
  location: LocationInput;
};


export type RootQueryTypeMergeRequestArgs = {
  mergeRequest: MergeRequestInput;
};


export type RootQueryTypeMergeRequestsArgs = {
  mergeRequests: MergeRequestsInput;
};


export type RootQueryTypeMyshopiShopBrochuresArgs = {
  myshopiShopBrochures: MyshopiShopBrochuresInput;
  pagination: PaginationInput;
};


export type RootQueryTypeNewsletterCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeNewsletterSubscribersArgs = {
  pagination: PaginationInput;
  updatedSince?: InputMaybe<Scalars['NaiveDateTime']['input']>;
};


export type RootQueryTypeOfferCategoriesArgs = {
  offerCategories: OfferCategoriesInput;
  pagination?: InputMaybe<PaginationInput>;
};


export type RootQueryTypeOfferCategoryArgs = {
  offerCategory: OfferCategoryInput;
};


export type RootQueryTypeOfferCategoryTagSuggestionsArgs = {
  offerCategoryTagSuggestions: OfferCategoryTagSuggestionsInput;
};


export type RootQueryTypeOfferOcrSuggestionArgs = {
  hotspot: OfferOcrSuggestionHotspotInput;
  processor: OfferOcrSuggestionProcessor;
};


export type RootQueryTypePageArgs = {
  page: PageInput;
};


export type RootQueryTypePagesArgs = {
  pages: PagesInput;
};


export type RootQueryTypePagesWithHotspotsArgs = {
  pagesWithHotspots: PagesWithHotspotsInput;
  pagination: PaginationInput;
};


export type RootQueryTypeParserClassByUrlArgs = {
  parserClassByUrl: ParserClassByUrlInput;
};


export type RootQueryTypeParserParametersArgs = {
  parserParameters: ParserParametersInput;
};


export type RootQueryTypePostProcessingStatusArgs = {
  postProcessingStatus: PostProcessingStatusInput;
};


export type RootQueryTypePublicBrochuresArgs = {
  cityId?: InputMaybe<Scalars['ID']['input']>;
  pagination: PaginationInput;
  publicBrochures: PublicBrochuresInput;
};


export type RootQueryTypeRegionArgs = {
  region: RegionInput;
};


export type RootQueryTypeRegionsArgs = {
  regions: RegionsInput;
};


export type RootQueryTypeSessionsArgs = {
  sessions: SessionsInput;
};


export type RootQueryTypeShopArgs = {
  shop: ShopInput;
};


export type RootQueryTypeShopCardTemplateArgs = {
  shopCardTemplate: ShopCardTemplateInput;
};


export type RootQueryTypeShopCardTemplatesArgs = {
  pagination: PaginationInput;
  shopCardTemplates: ShopCardTemplatesInput;
};


export type RootQueryTypeShopsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  shops: ShopsInput;
};


export type RootQueryTypeTagStatisticsArgs = {
  tagStatistics: TagStatisticsInput;
};


export type RootQueryTypeTagStatisticsOverviewArgs = {
  tagStatisticsOverview: TagStatisticsOverviewInput;
};


export type RootQueryTypeTaggingUsersArgs = {
  pagination?: InputMaybe<PaginationInput>;
  taggingUsers: TaggingUsersInput;
};


export type RootQueryTypeWebsitePageArgs = {
  websitePage: WebsitePageInput;
};


export type RootQueryTypeWebsitePagesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  websitePages: WebsitePagesInput;
};

export type RootSubscriptionType = {
  __typename?: 'RootSubscriptionType';
  /** BrochureLog messages are received here. */
  brochureLogAdded: BrochureLogEntity;
  locationImported: ImportedLocationEntity;
  /** Pdf messages are received here. Those messages are produced by the Cloud Function while extracting the PDF. */
  pdfMessageAdded: PdfMessageEntity;
};


export type RootSubscriptionTypeBrochureLogAddedArgs = {
  brochureId: Scalars['ID']['input'];
};


export type RootSubscriptionTypeLocationImportedArgs = {
  shopId: Scalars['ID']['input'];
};


export type RootSubscriptionTypePdfMessageAddedArgs = {
  pdfId: Scalars['ID']['input'];
};

export type SessionStatistic = {
  __typename?: 'SessionStatistic';
  totalSessionTime: Scalars['Float']['output'];
  trackedAt: Scalars['Date']['output'];
};

export type SessionsInput = {
  /** Session time from this date */
  startAt: Scalars['Date']['input'];
  /** Session time until this date */
  stopAt: Scalars['Date']['input'];
  userId: Scalars['ID']['input'];
};

export type SetPasswordIdentityUserInput = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export enum SetPasswordStatus {
  InvalidPassword = 'INVALID_PASSWORD',
  NotFound = 'NOT_FOUND',
  Ok = 'OK'
}

export type ShopCardTemplateEntity = {
  __typename?: 'ShopCardTemplateEntity';
  fileUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  shops: Array<ShopEntity>;
  status: ShopCardTemplateStatus;
};


export type ShopCardTemplateEntityFileUrlArgs = {
  version: ShopCardTemplateImageVersion;
};

export enum ShopCardTemplateImageVersion {
  Medium = 'MEDIUM'
}

export type ShopCardTemplateInput = {
  shopCardTemplateId: Scalars['ID']['input'];
};

export enum ShopCardTemplateOrderBy {
  NameAsc = 'NAME_ASC',
  NameDesc = 'NAME_DESC'
}

export enum ShopCardTemplateStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Draft = 'DRAFT'
}

export type ShopCardTemplatesInput = {
  orderBy: ShopCardTemplateOrderBy;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<ShopCardTemplateStatus>>;
};

export type ShopDescriptionEntity = {
  __typename?: 'ShopDescriptionEntity';
  description?: Maybe<Scalars['String']['output']>;
  language: LanguageEntity;
  metaDescription?: Maybe<Scalars['String']['output']>;
  titleMain?: Maybe<Scalars['String']['output']>;
  titleSecondary?: Maybe<Scalars['String']['output']>;
};

export type ShopDescriptionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  languageId: Scalars['ID']['input'];
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  titleMain?: InputMaybe<Scalars['String']['input']>;
  titleSecondary?: InputMaybe<Scalars['String']['input']>;
};

export type ShopEntity = {
  __typename?: 'ShopEntity';
  customerClient?: Maybe<CustomerClientEntity>;
  fileUrl?: Maybe<Scalars['String']['output']>;
  hotspotMode: HotspotMode;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};


export type ShopEntityFileUrlArgs = {
  version: ShopFileVersion;
};

export enum ShopFileVersion {
  Small = 'SMALL'
}

export type ShopInput = {
  shopId: Scalars['ID']['input'];
};

export enum ShopOrderBy {
  NameAtAsc = 'NAME_AT_ASC',
  NameAtDesc = 'NAME_AT_DESC'
}

export type ShopsInput = {
  clientScope?: InputMaybe<CustomerClientFeature>;
  orderBy: ShopOrderBy;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type SortGenericTreeItemInput = {
  id: Scalars['ID']['input'];
  sortIndex: Scalars['Float']['input'];
};

export type SortGenericTreeItemsInput = {
  items: Array<SortGenericTreeItemInput>;
  /**
   * The parent category whose children to sort.
   *     Use the zero GUID (00000000-0000-0000-0000-000000000000) for root categories.
   */
  parentId: Scalars['ID']['input'];
};

export type StateBrochureLog = BrochureLogEntity & {
  __typename?: 'StateBrochureLog';
  content: Scalars['String']['output'];
  insertedAt: Scalars['DateTime']['output'];
  level: BrochureLogLevel;
};

export type StatisticsMap = {
  __typename?: 'StatisticsMap';
  key: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type TagStatistic = {
  __typename?: 'TagStatistic';
  taggedAt: Scalars['Date']['output'];
  totalTagged: Scalars['Int']['output'];
};

export type TagStatisticsInput = {
  /** Tag statistics that are created from this date */
  startAt: Scalars['Date']['input'];
  /** Tag statistics that are created until this date */
  stopAt: Scalars['Date']['input'];
  userId: Scalars['ID']['input'];
};

export type TagStatisticsOverview = {
  __typename?: 'TagStatisticsOverview';
  /** This field represents the amount of tag statistics per hotspot. */
  tagStatisticsPerHotspot?: Maybe<Scalars['Float']['output']>;
  /** This field represents the time the user has been active in the dashboard. */
  totalSessionTime: Scalars['Float']['output'];
  /** An overview of the total amount of tagged hotspots per user. */
  userTagStatistics: Array<UserTagStatistic>;
};

export type TagStatisticsOverviewInput = {
  /** Tag statistics that are created from this date */
  startAt: Scalars['Date']['input'];
  /** Tag statistics that are created until this date */
  stopAt: Scalars['Date']['input'];
};

export enum TaggingStrategy {
  /** Gemini */
  GeminiTagger = 'GEMINI_TAGGER'
}

export type TaggingUsersInput = {
  orderBy: IdentityUserOrderBy;
};

export enum TimeStepEnum {
  Day = 'DAY',
  Month = 'MONTH',
  Week = 'WEEK'
}

export type TransitionState = {
  __typename?: 'TransitionState';
  state: BrochureState;
  title: Scalars['String']['output'];
};

export type UnsubscribeIdentityUserFromNewslettersInput = {
  id: Scalars['ID']['input'];
};

export type UnsubscribeNewsletterSubscriberFromNewslettersInput = {
  id: Scalars['ID']['input'];
};

export type UpdateAdsCampaignAdvertisementHtmlEmbedInput = {
  adType?: InputMaybe<AdType>;
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  content?: InputMaybe<Scalars['String']['input']>;
  displayAt?: InputMaybe<AdDisplayAt>;
  displayUrl?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  impressionsLimit?: InputMaybe<Scalars['Int']['input']>;
  platformType?: InputMaybe<AdPlatformType>;
  shopIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  status?: InputMaybe<AdStatusV2>;
  targetType?: InputMaybe<AdTargetType>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateAdsCampaignAdvertisementImageAdInput = {
  adType?: InputMaybe<AdType>;
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  displayAt?: InputMaybe<AdDisplayAt>;
  displayUrl?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  id: Scalars['ID']['input'];
  impressionsLimit?: InputMaybe<Scalars['Int']['input']>;
  platformType?: InputMaybe<AdPlatformType>;
  shopIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  status?: InputMaybe<AdStatusV2>;
  targetType?: InputMaybe<AdTargetType>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateAdsCampaignInput = {
  id: Scalars['ID']['input'];
  languageId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<AdsCampaignStatus>;
  stopAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateAppInput = {
  geminiBrandAndOfferStrategy?: InputMaybe<GeminiBrandAndOfferStrategy>;
  geminiTaggingPrompt?: InputMaybe<Scalars['String']['input']>;
  taggingStrategy?: InputMaybe<TaggingStrategy>;
};

export type UpdateAppLanguageInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  disclaimer?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  info?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBrandInput = {
  brandTags?: InputMaybe<Array<InputMaybe<UpdateBrandTagInput>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<BrandStatus>;
};

export type UpdateBrandTagInput = {
  /** Add id to update/keep existing tags and set null for new tags */
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export type UpdateBrochureAssigneeInput = {
  id: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export enum UpdateBrochureAssigneeStatus {
  NotAllowed = 'NOT_ALLOWED',
  NotFound = 'NOT_FOUND',
  Ok = 'OK'
}

export type UpdateBrochureInput = {
  /** If the admin input fields are present then we will authorize the current user. */
  adminFields?: InputMaybe<AdminFields>;
  generalFields: GeneralFields;
  id: Scalars['ID']['input'];
};

export type UpdateBrochurePositionInput = {
  id: Scalars['ID']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
  positionFrozenTo?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateBrochureState = {
  __typename?: 'UpdateBrochureState';
  status: UpdateBrochureStateStatus;
};

export type UpdateBrochureStateInput = {
  id: Scalars['ID']['input'];
  state: BrochureState;
};

export enum UpdateBrochureStateStatus {
  NotAllowed = 'NOT_ALLOWED',
  NotFound = 'NOT_FOUND',
  Ok = 'OK'
}

export enum UpdateBrochureStatus {
  Failed = 'FAILED',
  NotAllowed = 'NOT_ALLOWED',
  NotFound = 'NOT_FOUND',
  Ok = 'OK'
}

export type UpdateCategoryInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  id: Scalars['ID']['input'];
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  titleMain?: InputMaybe<Scalars['String']['input']>;
  titleSecondary?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCityInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateCurrentUserInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
};

export type UpdateCustomerClientInput = {
  features?: InputMaybe<Array<CustomerClientFeature>>;
  id: Scalars['ID']['input'];
  identityUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  shopIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdateGenericProductCategoryInput = {
  id: Scalars['ID']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
  keywords?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentCategoryId?: InputMaybe<Scalars['ID']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  translations?: InputMaybe<Array<GenericProductCategoryTranslationInput>>;
};

export type UpdateGenericProductInput = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
  keywords?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Int']['input']>;
  translations?: InputMaybe<Array<GenericProductTranslationInput>>;
};

export type UpdateHotspotImageInput = {
  file?: InputMaybe<Scalars['Upload']['input']>;
  height: Scalars['Float']['input'];
  id: Scalars['ID']['input'];
  url?: InputMaybe<Scalars['String']['input']>;
  width: Scalars['Float']['input'];
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type UpdateHotspotLinkInput = {
  height: Scalars['Float']['input'];
  id: Scalars['ID']['input'];
  url: Scalars['String']['input'];
  width: Scalars['Float']['input'];
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type UpdateHotspotProductInput = {
  height: Scalars['Float']['input'];
  id: Scalars['ID']['input'];
  productTag: ProductInput;
  url?: InputMaybe<Scalars['String']['input']>;
  width: Scalars['Float']['input'];
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

export type UpdateIdentityUserInput = {
  cityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  customerClientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<IdentityUserRole>>;
};

export type UpdateLocationInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  regionId?: InputMaybe<Scalars['ID']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateNewsletterCategoryInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOfferCategoryInput = {
  id: Scalars['ID']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  languageId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offerCategoryBlacklistTags?: InputMaybe<Array<UpdateOfferCategoryTagInput>>;
  offerCategoryTags?: InputMaybe<Array<UpdateOfferCategoryTagInput>>;
  position?: InputMaybe<Scalars['Int']['input']>;
  shopCategoryIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type UpdateOfferCategoryTagInput = {
  /** Add id to update/keep existing tags and set null for new tags */
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export type UpdateRegionInput = {
  name: Scalars['String']['input'];
  regionId: Scalars['ID']['input'];
};

export type UpdateShopCardTemplateInput = {
  id: Scalars['ID']['input'];
  image?: InputMaybe<Scalars['Upload']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  shopIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<ShopCardTemplateStatus>;
};

export type UpdateShopInput = {
  autoParserSlugFr?: InputMaybe<Scalars['String']['input']>;
  autoParserSlugNl?: InputMaybe<Scalars['String']['input']>;
  autoParserType?: InputMaybe<AutoParserType>;
  customerClientId?: InputMaybe<Scalars['ID']['input']>;
  customerLevel?: InputMaybe<CustomerLevel>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  geminiTaggingPrompt?: InputMaybe<Scalars['String']['input']>;
  hotspotMode?: InputMaybe<HotspotMode>;
  id: Scalars['ID']['input'];
  lastPage?: InputMaybe<Scalars['Boolean']['input']>;
  localBrochures?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  overwriteUtms?: InputMaybe<Scalars['Boolean']['input']>;
  radius?: InputMaybe<Scalars['Float']['input']>;
  removedFromSearch?: InputMaybe<Scalars['Boolean']['input']>;
  removedProductsFromSearch?: InputMaybe<Scalars['Boolean']['input']>;
  /** The categories for which the brochures in the shop can be shown at the end of a brochure after the last page. */
  shopAfterpage?: InputMaybe<Array<Scalars['ID']['input']>>;
  shopCategories?: InputMaybe<Array<Scalars['ID']['input']>>;
  shopDescriptions?: InputMaybe<Array<ShopDescriptionInput>>;
  shopKeywords?: InputMaybe<Scalars['String']['input']>;
  /** The categories for which brochures in the shop can be shown as the top of a brochure stack. */
  shopToplevel?: InputMaybe<Array<Scalars['ID']['input']>>;
  showAds?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateWebsitePageInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  contentBlocks?: InputMaybe<Array<Scalars['String']['input']>>;
  contentQuestionsAnswers?: InputMaybe<Array<WebsitePageQuestionAnswerInput>>;
  id: Scalars['ID']['input'];
  languageId?: InputMaybe<Scalars['ID']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  positionInFooter?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  titleQuestionsAnswers?: InputMaybe<Scalars['String']['input']>;
  translationSetId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateWebsitePostInput = {
  categoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  content?: InputMaybe<Scalars['String']['input']>;
  coverImage?: InputMaybe<Scalars['Upload']['input']>;
  id: Scalars['ID']['input'];
  languageId?: InputMaybe<Scalars['ID']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  translationSetId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpsertBrochureCityPositionInput = {
  brochureId: Scalars['ID']['input'];
  cityId: Scalars['ID']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
};

export type UserTagStatistic = {
  __typename?: 'UserTagStatistic';
  fullName: Scalars['String']['output'];
  totalSessionTime: Scalars['Float']['output'];
  totalTagged: Scalars['Int']['output'];
};

export type VisionBlock = {
  __typename?: 'VisionBlock';
  confidence?: Maybe<Scalars['Float']['output']>;
  paragraphs: Array<VisionParagraph>;
};

export type VisionParagraph = {
  __typename?: 'VisionParagraph';
  brands: Array<BrandEntity>;
  confidence?: Maybe<Scalars['Float']['output']>;
  offerCategories: Array<OfferCategoryEntity>;
  text: Scalars['String']['output'];
};

export type WebsitePageEntity = {
  content?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  language: LanguageEntity;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  path: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  translationSetId?: Maybe<Scalars['ID']['output']>;
};

export enum WebsitePageFileVersion {
  Medium = 'MEDIUM'
}

export type WebsitePageInput = {
  id: Scalars['ID']['input'];
};

export enum WebsitePageOrderBy {
  InsertedAtAsc = 'INSERTED_AT_ASC',
  InsertedAtDesc = 'INSERTED_AT_DESC',
  PositionInFooterAsc = 'POSITION_IN_FOOTER_ASC',
  PositionInFooterDesc = 'POSITION_IN_FOOTER_DESC',
  PublishedAtAsc = 'PUBLISHED_AT_ASC',
  PublishedAtDesc = 'PUBLISHED_AT_DESC'
}

export type WebsitePagePage = WebsitePageEntity & {
  __typename?: 'WebsitePagePage';
  content?: Maybe<Scalars['String']['output']>;
  contentBlocks: Array<Scalars['String']['output']>;
  contentQuestionsAnswers: Array<WebsitePageQuestionAnswer>;
  id: Scalars['ID']['output'];
  language: LanguageEntity;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  path: Scalars['String']['output'];
  positionInFooter?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  titleQuestionsAnswers?: Maybe<Scalars['String']['output']>;
  translationSetId?: Maybe<Scalars['ID']['output']>;
  user?: Maybe<IdentityUserEntity>;
};

export type WebsitePagePost = WebsitePageEntity & {
  __typename?: 'WebsitePagePost';
  categories: Array<CategoryEntity>;
  content: Scalars['String']['output'];
  coverImage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  language: LanguageEntity;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  path: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['String']['output'];
  translationSetId?: Maybe<Scalars['ID']['output']>;
  user?: Maybe<IdentityUserEntity>;
};


export type WebsitePagePostCoverImageArgs = {
  version: WebsitePageFileVersion;
};

export type WebsitePageQuestionAnswer = {
  __typename?: 'WebsitePageQuestionAnswer';
  answer: Scalars['String']['output'];
  question: Scalars['String']['output'];
};

export type WebsitePageQuestionAnswerInput = {
  answer: Scalars['String']['input'];
  question: Scalars['String']['input'];
};

export enum WebsitePageType {
  Page = 'PAGE',
  Post = 'POST'
}

export type WebsitePagesInput = {
  categoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  languageId?: InputMaybe<Scalars['ID']['input']>;
  orderBy: WebsitePageOrderBy;
  search?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<WebsitePageType>;
};

/** One possible value for a given Enum. Enum values are unique values, not a placeholder for a string or numeric value. However an Enum value is returned in a JSON response as a string. */
export type __EnumValue = {
  __typename?: '__EnumValue';
  name: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  isDeprecated: Scalars['Boolean']['output'];
  deprecationReason?: Maybe<Scalars['String']['output']>;
};

/** Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type. */
export type __Field = {
  __typename?: '__Field';
  name: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  args: Array<__InputValue>;
  type: __Type;
  isDeprecated: Scalars['Boolean']['output'];
  deprecationReason?: Maybe<Scalars['String']['output']>;
};


/** Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type. */
export type __FieldArgsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Arguments provided to Fields or Directives and the input fields of an InputObject are represented as Input Values which describe their type and optionally a default value. */
export type __InputValue = {
  __typename?: '__InputValue';
  name: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  type: __Type;
  /** A GraphQL-formatted string representing the default value for this input value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  isDeprecated: Scalars['Boolean']['output'];
  deprecationReason?: Maybe<Scalars['String']['output']>;
};

/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByUrl`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __Type = {
  __typename?: '__Type';
  kind: __TypeKind;
  name?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  specifiedByUrl?: Maybe<Scalars['String']['output']>;
  fields?: Maybe<Array<__Field>>;
  interfaces?: Maybe<Array<__Type>>;
  possibleTypes?: Maybe<Array<__Type>>;
  enumValues?: Maybe<Array<__EnumValue>>;
  inputFields?: Maybe<Array<__InputValue>>;
  ofType?: Maybe<__Type>;
};


/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByUrl`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeFieldsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByUrl`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeEnumValuesArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.
 *
 * Depending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByUrl`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.
 */
export type __TypeInputFieldsArgs = {
  includeDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An enum describing what kind of type a given `__Type` is. */
export enum __TypeKind {
  /** Indicates this type is a scalar. */
  Scalar = 'SCALAR',
  /** Indicates this type is an object. `fields` and `interfaces` are valid fields. */
  Object = 'OBJECT',
  /** Indicates this type is an interface. `fields`, `interfaces`, and `possibleTypes` are valid fields. */
  Interface = 'INTERFACE',
  /** Indicates this type is a union. `possibleTypes` is a valid field. */
  Union = 'UNION',
  /** Indicates this type is an enum. `enumValues` is a valid field. */
  Enum = 'ENUM',
  /** Indicates this type is an input object. `inputFields` is a valid field. */
  InputObject = 'INPUT_OBJECT',
  /** Indicates this type is a list. `ofType` is a valid field. */
  List = 'LIST',
  /** Indicates this type is a non-null. `ofType` is a valid field. */
  NonNull = 'NON_NULL'
}

export type AdminShopDetailFragment = { __typename?: 'AdminShopEntity', id: string, name: string, customerLevel: CustomerLevel, autoParserSlugFr?: string | null, autoParserSlugNl?: string | null, autoParserType?: AutoParserType | null, fileUrl?: string | null, radius: number, removedFromSearch: boolean, removedProductsFromSearch: boolean, hotspotMode: HotspotMode, localBrochures: boolean, shopKeywords?: string | null, showAds: boolean, slug: string, overwriteUtms: boolean, lastPage: boolean, geminiTaggingPrompt?: string | null, afterpage: Array<{ __typename?: 'CategoryEntity', id: string, name?: string | null }>, toplevel: Array<{ __typename?: 'CategoryEntity', id: string, name?: string | null }>, customerClient?: { __typename?: 'CustomerClientEntity', id: string, name: string } | null, categories: Array<{ __typename?: 'CategoryEntity', id: string, name?: string | null }>, regions: Array<{ __typename?: 'RegionEntity', id: string, name: string, locationsCount: number }>, shopDescriptions: Array<{ __typename?: 'ShopDescriptionEntity', description?: string | null, metaDescription?: string | null, titleMain?: string | null, titleSecondary?: string | null, language: { __typename?: 'LanguageEntity', id: string, name: string } }> };

export type AdminShopOverviewFragment = { __typename?: 'AdminShopEntity', id: string, name: string, customerLevel: CustomerLevel, radius: number, removedFromSearch: boolean, hotspotMode: HotspotMode, localBrochures: boolean, locations: Array<{ __typename?: 'LocationEntity', id: string, name: string }>, categories: Array<{ __typename?: 'CategoryEntity', id: string, name?: string | null }> };

export type AppLanguageDetailFragment = { __typename?: 'AppLanguageEntity', id: string, description?: string | null, disclaimer?: string | null, info?: string | null, language: { __typename?: 'LanguageEntity', id: string, name: string, symbol: string } };

export type AppLanguageOverviewFragment = { __typename?: 'AppLanguageEntity', id: string, language: { __typename?: 'LanguageEntity', id: string, name: string, symbol: string } };

export type BrochureOverviewFragment = { __typename?: 'BrochureEntity', id: string, name: string, cover?: { __typename?: 'PageEntity', fileUrl?: string | null } | null };

export type CategoryDetailFragment = { __typename?: 'CategoryEntity', id: string, name?: string | null, about?: string | null, metaDescription?: string | null, titleMain?: string | null, titleSecondary?: string | null, fileUrl?: string | null, language: { __typename?: 'LanguageEntity', id: string, name: string, symbol: string, fileUrl?: string | null } };

export type CategoryOverviewFragment = { __typename?: 'CategoryEntity', id: string, name?: string | null };

export type CityDetailFragment = { __typename?: 'CityEntity', id: string, name: string, position?: number | null };

export type CityOverviewFragment = { __typename?: 'CityEntity', id: string, name: string };

export type CustomerClientOverviewFragment = { __typename?: 'CustomerClientEntity', id: string, name: string };

export type GenericProductCategoryDetailFragment = { __typename?: 'GenericProductCategoryEntity', id: string, name: string, parentCategoryId?: string | null, imageUrl?: string | null, published: boolean, translations: Array<{ __typename?: 'GenericProductCategoryTranslationEntity', translation: string, language: { __typename?: 'LanguageEntity', id: string, name: string, symbol: string } }> };

export type GenericProductDetailFragment = { __typename?: 'GenericProductEntity', id: string, name: string, categoryId: string, keywords?: Array<string | null> | null, sortOrder?: number | null, imageUrl?: string | null, published: boolean, translations: Array<{ __typename?: 'GenericProductTranslationEntity', translation: string, language: { __typename?: 'LanguageEntity', id: string, name: string, symbol: string } }> };

type GenericProductOverview_GenericProductCategoryEntity_Fragment = { __typename: 'GenericProductCategoryEntity', published: boolean, id: string, name: string, sortOrder?: number | null, imageUrl?: string | null, translations: Array<{ __typename?: 'GenericProductCategoryTranslationEntity', language: { __typename?: 'LanguageEntity', name: string, fileUrl?: string | null } }> };

type GenericProductOverview_GenericProductEntity_Fragment = { __typename: 'GenericProductEntity', published: boolean, id: string, name: string, sortOrder?: number | null, imageUrl?: string | null, translations: Array<{ __typename?: 'GenericProductTranslationEntity', language: { __typename?: 'LanguageEntity', name: string, fileUrl?: string | null } }> };

export type GenericProductOverviewFragment = GenericProductOverview_GenericProductCategoryEntity_Fragment | GenericProductOverview_GenericProductEntity_Fragment;

export type ShopCardTemplateDetailFragment = { __typename?: 'ShopCardTemplateEntity', id: string, name: string, fileUrl?: string | null, status: ShopCardTemplateStatus, shops: Array<{ __typename?: 'ShopEntity', id: string, name: string }> };

export type ShopLocationFragment = { __typename?: 'LocationEntity', id: string, address: string, city: string, name: string, zipCode: string, point?: { __typename?: 'LocationPoint', latitude: number, longitude: number } | null, region: { __typename?: 'RegionEntity', id: string, name: string } };

export type UserDetailFragment = { __typename?: 'IdentityUserEntity', id: string, fileUrl?: string | null, firstName?: string | null, lastName?: string | null, roles: Array<IdentityUserRole>, email: string, bio?: string | null, cities: Array<{ __typename?: 'CityEntity', id: string, name: string }>, customerClients: Array<{ __typename?: 'CustomerClientEntity', id: string, name: string }> };

export type UserOverviewFragment = { __typename?: 'IdentityUserEntity', id: string, fileUrl?: string | null, firstName?: string | null, lastName?: string | null, roles: Array<IdentityUserRole>, email: string };

export type ApprovedAtHotspotFieldFragment = { __typename?: 'ApprovedAtHotspotField', brandApprovedAt?: any | null, descriptionApprovedAt?: any | null, nameApprovedAt?: any | null, offerCategoryApprovedAt?: any | null, priceApprovedAt?: any | null, urlApprovedAt?: any | null, user: { __typename?: 'IdentityUserEntity', id: string, firstName?: string | null, lastName?: string | null } };

export type BrochureRegionDifferenceFragment = { __typename?: 'BrochureRegionDifference', differenceStatus: DifferenceStatus, region: { __typename?: 'RegionEntity', id: string, name: string }, pages: Array<{ __typename?: 'PageDifference', added: number, changed: number, differenceStatus: DifferenceStatus, noChanges: number, removed: number, newPage?: { __typename?: 'PageEntity', fileUrl?: string | null } | null, oldPage?: { __typename?: 'PageEntity', fileUrl?: string | null } | null, hotspots: Array<{ __typename?: 'HotspotDifference', differenceStatus: DifferenceStatus, differences: Array<HotspotMatchDifference>, oldHotspot?: { __typename?: 'HotspotImageEntity', fileUrl?: string | null, id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any } | { __typename?: 'HotspotLinkEntity', fileUrl?: string | null, url?: string | null, id: string, x: number, y: number, width: number, height: number, updatedAt: any } | { __typename?: 'HotspotProductEntity', fileUrl?: string | null, id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any, productTag: { __typename?: 'ProductTagEntity', id: string, name: string, brandName?: string | null, description?: string | null, discountPercent?: number | null, priceAfterDiscount?: number | null, priceBeforeDiscount?: number | null, brands: Array<{ __typename?: 'BrandEntity', id: string, name: string }>, offerCategories: Array<{ __typename?: 'OfferCategoryEntity', id: string, name: string, label?: string | null }> } } | null, newHotspot?: { __typename?: 'HotspotImageEntity', fileUrl?: string | null, id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any } | { __typename?: 'HotspotLinkEntity', fileUrl?: string | null, url?: string | null, id: string, x: number, y: number, width: number, height: number, updatedAt: any } | { __typename?: 'HotspotProductEntity', fileUrl?: string | null, id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any, productTag: { __typename?: 'ProductTagEntity', id: string, name: string, brandName?: string | null, description?: string | null, discountPercent?: number | null, priceAfterDiscount?: number | null, priceBeforeDiscount?: number | null, brands: Array<{ __typename?: 'BrandEntity', id: string, name: string }>, offerCategories: Array<{ __typename?: 'OfferCategoryEntity', id: string, name: string, label?: string | null }> } } | null }> }> };

type Hotspot_HotspotImageEntity_Fragment = { __typename: 'HotspotImageEntity', id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any, fileUrl?: string | null, tagStatistics: Array<{ __typename?: 'ApprovedAtHotspotField', brandApprovedAt?: any | null, descriptionApprovedAt?: any | null, nameApprovedAt?: any | null, offerCategoryApprovedAt?: any | null, priceApprovedAt?: any | null, urlApprovedAt?: any | null, user: { __typename?: 'IdentityUserEntity', id: string, firstName?: string | null, lastName?: string | null } }> };

type Hotspot_HotspotLinkEntity_Fragment = { __typename: 'HotspotLinkEntity', id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any, fileUrl?: string | null, tagStatistics: Array<{ __typename?: 'ApprovedAtHotspotField', brandApprovedAt?: any | null, descriptionApprovedAt?: any | null, nameApprovedAt?: any | null, offerCategoryApprovedAt?: any | null, priceApprovedAt?: any | null, urlApprovedAt?: any | null, user: { __typename?: 'IdentityUserEntity', id: string, firstName?: string | null, lastName?: string | null } }> };

type Hotspot_HotspotProductEntity_Fragment = { __typename: 'HotspotProductEntity', id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any, fileUrl?: string | null, tagStatistics: Array<{ __typename?: 'ApprovedAtHotspotField', brandApprovedAt?: any | null, descriptionApprovedAt?: any | null, nameApprovedAt?: any | null, offerCategoryApprovedAt?: any | null, priceApprovedAt?: any | null, urlApprovedAt?: any | null, user: { __typename?: 'IdentityUserEntity', id: string, firstName?: string | null, lastName?: string | null } }>, productTag: { __typename?: 'ProductTagEntity', id: string, name: string, brandName?: string | null, description?: string | null, discountPercent?: number | null, priceAfterDiscount?: number | null, priceBeforeDiscount?: number | null, brands: Array<{ __typename?: 'BrandEntity', id: string, name: string }>, offerCategories: Array<{ __typename?: 'OfferCategoryEntity', id: string, name: string, label?: string | null }> } };

export type HotspotFragment = Hotspot_HotspotImageEntity_Fragment | Hotspot_HotspotLinkEntity_Fragment | Hotspot_HotspotProductEntity_Fragment;

export type HotspotImageFragment = { __typename: 'HotspotImageEntity', id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any, fileUrl?: string | null, tagStatistics: Array<{ __typename?: 'ApprovedAtHotspotField', brandApprovedAt?: any | null, descriptionApprovedAt?: any | null, nameApprovedAt?: any | null, offerCategoryApprovedAt?: any | null, priceApprovedAt?: any | null, urlApprovedAt?: any | null, user: { __typename?: 'IdentityUserEntity', id: string, firstName?: string | null, lastName?: string | null } }> };

export type HotspotLinkFragment = { __typename: 'HotspotLinkEntity', id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any, fileUrl?: string | null, tagStatistics: Array<{ __typename?: 'ApprovedAtHotspotField', brandApprovedAt?: any | null, descriptionApprovedAt?: any | null, nameApprovedAt?: any | null, offerCategoryApprovedAt?: any | null, priceApprovedAt?: any | null, urlApprovedAt?: any | null, user: { __typename?: 'IdentityUserEntity', id: string, firstName?: string | null, lastName?: string | null } }> };

export type HotspotProductFragment = { __typename: 'HotspotProductEntity', id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any, fileUrl?: string | null, tagStatistics: Array<{ __typename?: 'ApprovedAtHotspotField', brandApprovedAt?: any | null, descriptionApprovedAt?: any | null, nameApprovedAt?: any | null, offerCategoryApprovedAt?: any | null, priceApprovedAt?: any | null, urlApprovedAt?: any | null, user: { __typename?: 'IdentityUserEntity', id: string, firstName?: string | null, lastName?: string | null } }>, productTag: { __typename?: 'ProductTagEntity', id: string, name: string, brandName?: string | null, description?: string | null, discountPercent?: number | null, priceAfterDiscount?: number | null, priceBeforeDiscount?: number | null, brands: Array<{ __typename?: 'BrandEntity', id: string, name: string }>, offerCategories: Array<{ __typename?: 'OfferCategoryEntity', id: string, name: string, label?: string | null }> } };

export type MergeRequestFragment = { __typename?: 'MergeRequestDetails', mergeRequest: { __typename?: 'MergeRequestEntity', id: string, status: MergeRequestStatus, newBrochure: { __typename?: 'BrochureEntity', id: string } }, brochureRegions: Array<{ __typename?: 'BrochureRegionDifference', differenceStatus: DifferenceStatus, region: { __typename?: 'RegionEntity', id: string, name: string }, pages: Array<{ __typename?: 'PageDifference', added: number, changed: number, differenceStatus: DifferenceStatus, noChanges: number, removed: number, newPage?: { __typename?: 'PageEntity', fileUrl?: string | null } | null, oldPage?: { __typename?: 'PageEntity', fileUrl?: string | null } | null, hotspots: Array<{ __typename?: 'HotspotDifference', differenceStatus: DifferenceStatus, differences: Array<HotspotMatchDifference>, oldHotspot?: { __typename?: 'HotspotImageEntity', fileUrl?: string | null, id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any } | { __typename?: 'HotspotLinkEntity', fileUrl?: string | null, url?: string | null, id: string, x: number, y: number, width: number, height: number, updatedAt: any } | { __typename?: 'HotspotProductEntity', fileUrl?: string | null, id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any, productTag: { __typename?: 'ProductTagEntity', id: string, name: string, brandName?: string | null, description?: string | null, discountPercent?: number | null, priceAfterDiscount?: number | null, priceBeforeDiscount?: number | null, brands: Array<{ __typename?: 'BrandEntity', id: string, name: string }>, offerCategories: Array<{ __typename?: 'OfferCategoryEntity', id: string, name: string, label?: string | null }> } } | null, newHotspot?: { __typename?: 'HotspotImageEntity', fileUrl?: string | null, id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any } | { __typename?: 'HotspotLinkEntity', fileUrl?: string | null, url?: string | null, id: string, x: number, y: number, width: number, height: number, updatedAt: any } | { __typename?: 'HotspotProductEntity', fileUrl?: string | null, id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any, productTag: { __typename?: 'ProductTagEntity', id: string, name: string, brandName?: string | null, description?: string | null, discountPercent?: number | null, priceAfterDiscount?: number | null, priceBeforeDiscount?: number | null, brands: Array<{ __typename?: 'BrandEntity', id: string, name: string }>, offerCategories: Array<{ __typename?: 'OfferCategoryEntity', id: string, name: string, label?: string | null }> } } | null }> }> }> };

export type PageWithHotspotsFragment = { __typename?: 'PageEntity', id: string, index: number, fileUrl?: string | null, hotspots?: Array<{ __typename: 'HotspotImageEntity', id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any, fileUrl?: string | null, tagStatistics: Array<{ __typename?: 'ApprovedAtHotspotField', brandApprovedAt?: any | null, descriptionApprovedAt?: any | null, nameApprovedAt?: any | null, offerCategoryApprovedAt?: any | null, priceApprovedAt?: any | null, urlApprovedAt?: any | null, user: { __typename?: 'IdentityUserEntity', id: string, firstName?: string | null, lastName?: string | null } }> } | { __typename: 'HotspotLinkEntity', id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any, fileUrl?: string | null, tagStatistics: Array<{ __typename?: 'ApprovedAtHotspotField', brandApprovedAt?: any | null, descriptionApprovedAt?: any | null, nameApprovedAt?: any | null, offerCategoryApprovedAt?: any | null, priceApprovedAt?: any | null, urlApprovedAt?: any | null, user: { __typename?: 'IdentityUserEntity', id: string, firstName?: string | null, lastName?: string | null } }> } | { __typename: 'HotspotProductEntity', id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any, fileUrl?: string | null, tagStatistics: Array<{ __typename?: 'ApprovedAtHotspotField', brandApprovedAt?: any | null, descriptionApprovedAt?: any | null, nameApprovedAt?: any | null, offerCategoryApprovedAt?: any | null, priceApprovedAt?: any | null, urlApprovedAt?: any | null, user: { __typename?: 'IdentityUserEntity', id: string, firstName?: string | null, lastName?: string | null } }>, productTag: { __typename?: 'ProductTagEntity', id: string, name: string, brandName?: string | null, description?: string | null, discountPercent?: number | null, priceAfterDiscount?: number | null, priceBeforeDiscount?: number | null, brands: Array<{ __typename?: 'BrandEntity', id: string, name: string }>, offerCategories: Array<{ __typename?: 'OfferCategoryEntity', id: string, name: string, label?: string | null }> } }> | null };

export type PaginationFragment = { __typename?: 'Pagination', currentPage: number, nextPage?: number | null, previousPage?: number | null, totalPages: number };

export type ApproveHotspotFieldsMutationVariables = Exact<{
  approveHotspotFields: ApproveHotspotFieldsInput;
}>;


export type ApproveHotspotFieldsMutation = { __typename?: 'RootMutationType', approveHotspotFields?: { __typename: 'HotspotImageEntity', id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any, fileUrl?: string | null, tagStatistics: Array<{ __typename?: 'ApprovedAtHotspotField', brandApprovedAt?: any | null, descriptionApprovedAt?: any | null, nameApprovedAt?: any | null, offerCategoryApprovedAt?: any | null, priceApprovedAt?: any | null, urlApprovedAt?: any | null, user: { __typename?: 'IdentityUserEntity', id: string, firstName?: string | null, lastName?: string | null } }> } | { __typename: 'HotspotLinkEntity', id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any, fileUrl?: string | null, tagStatistics: Array<{ __typename?: 'ApprovedAtHotspotField', brandApprovedAt?: any | null, descriptionApprovedAt?: any | null, nameApprovedAt?: any | null, offerCategoryApprovedAt?: any | null, priceApprovedAt?: any | null, urlApprovedAt?: any | null, user: { __typename?: 'IdentityUserEntity', id: string, firstName?: string | null, lastName?: string | null } }> } | { __typename: 'HotspotProductEntity', id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any, fileUrl?: string | null, tagStatistics: Array<{ __typename?: 'ApprovedAtHotspotField', brandApprovedAt?: any | null, descriptionApprovedAt?: any | null, nameApprovedAt?: any | null, offerCategoryApprovedAt?: any | null, priceApprovedAt?: any | null, urlApprovedAt?: any | null, user: { __typename?: 'IdentityUserEntity', id: string, firstName?: string | null, lastName?: string | null } }>, productTag: { __typename?: 'ProductTagEntity', id: string, name: string, brandName?: string | null, description?: string | null, discountPercent?: number | null, priceAfterDiscount?: number | null, priceBeforeDiscount?: number | null, brands: Array<{ __typename?: 'BrandEntity', id: string, name: string }>, offerCategories: Array<{ __typename?: 'OfferCategoryEntity', id: string, name: string, label?: string | null }> } } | null };

export type ApproveMergeRequestAsNewMutationVariables = Exact<{
  mergeRequestId: Scalars['ID']['input'];
}>;


export type ApproveMergeRequestAsNewMutation = { __typename?: 'RootMutationType', approveMergeRequestAsNew: { __typename?: 'ApproveMergeRequestAsNew', status: MutatedStatus } };

export type ApproveMergeRequestAsUpdateMutationVariables = Exact<{
  mergeRequestId: Scalars['ID']['input'];
  pageFilters?: InputMaybe<Array<PageFilter> | PageFilter>;
}>;


export type ApproveMergeRequestAsUpdateMutation = { __typename?: 'RootMutationType', approveMergeRequestAsUpdate: { __typename?: 'ApproveMergeRequestAsUpdate', status: MutatedStatus } };

export type ChangePasswordIdentityUserMutationVariables = Exact<{
  changePasswordIdentityUser: ChangePasswordIdentityUserInput;
}>;


export type ChangePasswordIdentityUserMutation = { __typename?: 'RootMutationType', changePasswordIdentityUser?: { __typename?: 'MutatedChangePasswordIdentityUser', identityUser?: { __typename?: 'IdentityUserEntity', id: string } | null } | null };

export type ConvertLinkHotspotsToProductHotspotsMutationVariables = Exact<{
  convertHotspotsInput: ConvertHotspotsInput;
}>;


export type ConvertLinkHotspotsToProductHotspotsMutation = { __typename?: 'RootMutationType', convertLinkHotspotsToProductHotspots: { __typename?: 'ConvertLinkHotspotsStatusEntity', status: MutatedStatus } };

export type CopyBrochureRegionMutationVariables = Exact<{
  copyBrochureRegionInput: CopyBrochureRegionInput;
}>;


export type CopyBrochureRegionMutation = { __typename?: 'RootMutationType', copyBrochureRegion: { __typename?: 'CopyBrochureRegionStatusEntity', status: CopyBrochureRegionStatus } };

export type CopyHotspotsMutationVariables = Exact<{
  copyHotspotsInput: CopyHotspotsInput;
}>;


export type CopyHotspotsMutation = { __typename?: 'RootMutationType', copyHotspots?: { __typename?: 'CopyHotspotsStatusEntity', status: CopyHotspotsStatus } | null };

export type CreateAdsCampaignMutationVariables = Exact<{
  createAdsCampaign: CreateAdsCampaignInput;
}>;


export type CreateAdsCampaignMutation = { __typename?: 'RootMutationType', createAdsCampaign: { __typename?: 'MutatedCreateAdsCampaign', status?: MutatedStatus | null, adsCampaign?: { __typename?: 'AdsCampaignEntity', id: string } | null } };

export type CreateBrandMutationVariables = Exact<{
  createBrandInput: CreateBrandInput;
}>;


export type CreateBrandMutation = { __typename?: 'RootMutationType', createBrand?: { __typename?: 'BrandEntity', id: string } | null };

export type CreateBrochureExperimentMutationVariables = Exact<{
  input: CreateBrochureExperimentInput;
}>;


export type CreateBrochureExperimentMutation = { __typename?: 'RootMutationType', createBrochureExperiment: { __typename?: 'MutatedCreateBrochureExperiment', status: BrochureExperimentCreateStatus, brochureExperiment?: { __typename?: 'BrochureExperimentEntity', name: string, variantCount: number, brochureExperimentVariants: Array<{ __typename?: 'BrochureExperimentVariantEntity', variantNumber: number, brochureRegions: Array<{ __typename?: 'BrochureRegionEntity', id: string }> }> } | null } };

export type CreateCategoryMutationVariables = Exact<{
  createCategoryInput: CreateCategoryInput;
}>;


export type CreateCategoryMutation = { __typename?: 'RootMutationType', createCategory?: { __typename?: 'CategoryEntity', id: string, name?: string | null, about?: string | null, metaDescription?: string | null, titleMain?: string | null, titleSecondary?: string | null, fileUrl?: string | null, language: { __typename?: 'LanguageEntity', id: string, name: string, symbol: string, fileUrl?: string | null } } | null };

export type CreateCityMutationVariables = Exact<{
  createCityInput: CreateCityInput;
}>;


export type CreateCityMutation = { __typename?: 'RootMutationType', createCity?: { __typename?: 'CityEntity', id: string } | null };

export type CreateCustomerClientMutationVariables = Exact<{
  createCustomerClientInput: CreateCustomerClientInput;
}>;


export type CreateCustomerClientMutation = { __typename?: 'RootMutationType', createCustomerClient?: { __typename?: 'CustomerClientEntity', id: string } | null };

export type CreateGenericProductMutationVariables = Exact<{
  input: CreateGenericProductInput;
}>;


export type CreateGenericProductMutation = { __typename?: 'RootMutationType', createGenericProduct?: { __typename?: 'GenericProductEntity', id: string, name: string, categoryId: string, keywords?: Array<string | null> | null, sortOrder?: number | null, imageUrl?: string | null, published: boolean, translations: Array<{ __typename?: 'GenericProductTranslationEntity', translation: string, language: { __typename?: 'LanguageEntity', id: string, name: string, symbol: string } }> } | null };

export type CreateGenericProductCategoryMutationVariables = Exact<{
  input: CreateGenericProductCategoryInput;
}>;


export type CreateGenericProductCategoryMutation = { __typename?: 'RootMutationType', createGenericProductCategory?: { __typename?: 'GenericProductCategoryEntity', id: string, name: string, parentCategoryId?: string | null, imageUrl?: string | null, published: boolean, translations: Array<{ __typename?: 'GenericProductCategoryTranslationEntity', translation: string, language: { __typename?: 'LanguageEntity', id: string, name: string, symbol: string } }> } | null };

export type CreateHotspotImageMutationVariables = Exact<{
  createHotspotInput: CreateHotspotImageInput;
}>;


export type CreateHotspotImageMutation = { __typename?: 'RootMutationType', createHotspotImage?: { __typename: 'HotspotImageEntity', id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any, fileUrl?: string | null, tagStatistics: Array<{ __typename?: 'ApprovedAtHotspotField', brandApprovedAt?: any | null, descriptionApprovedAt?: any | null, nameApprovedAt?: any | null, offerCategoryApprovedAt?: any | null, priceApprovedAt?: any | null, urlApprovedAt?: any | null, user: { __typename?: 'IdentityUserEntity', id: string, firstName?: string | null, lastName?: string | null } }> } | { __typename?: 'HotspotLinkEntity' } | { __typename?: 'HotspotProductEntity' } | null };

export type CreateHotspotLinkMutationVariables = Exact<{
  createHotspotInput: CreateHotspotLinkInput;
}>;


export type CreateHotspotLinkMutation = { __typename?: 'RootMutationType', createHotspotLink?: { __typename?: 'HotspotImageEntity' } | { __typename: 'HotspotLinkEntity', id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any, fileUrl?: string | null, tagStatistics: Array<{ __typename?: 'ApprovedAtHotspotField', brandApprovedAt?: any | null, descriptionApprovedAt?: any | null, nameApprovedAt?: any | null, offerCategoryApprovedAt?: any | null, priceApprovedAt?: any | null, urlApprovedAt?: any | null, user: { __typename?: 'IdentityUserEntity', id: string, firstName?: string | null, lastName?: string | null } }> } | { __typename?: 'HotspotProductEntity' } | null };

export type CreateHotspotProductMutationVariables = Exact<{
  createHotspotInput: CreateHotspotProductInput;
}>;


export type CreateHotspotProductMutation = { __typename?: 'RootMutationType', createHotspotProduct?: { __typename?: 'HotspotImageEntity' } | { __typename?: 'HotspotLinkEntity' } | { __typename: 'HotspotProductEntity', id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any, fileUrl?: string | null, tagStatistics: Array<{ __typename?: 'ApprovedAtHotspotField', brandApprovedAt?: any | null, descriptionApprovedAt?: any | null, nameApprovedAt?: any | null, offerCategoryApprovedAt?: any | null, priceApprovedAt?: any | null, urlApprovedAt?: any | null, user: { __typename?: 'IdentityUserEntity', id: string, firstName?: string | null, lastName?: string | null } }>, productTag: { __typename?: 'ProductTagEntity', id: string, name: string, brandName?: string | null, description?: string | null, discountPercent?: number | null, priceAfterDiscount?: number | null, priceBeforeDiscount?: number | null, brands: Array<{ __typename?: 'BrandEntity', id: string, name: string }>, offerCategories: Array<{ __typename?: 'OfferCategoryEntity', id: string, name: string, label?: string | null }> } } | null };

export type CreateIdentityUserMutationVariables = Exact<{
  input: CreateIdentityUserInput;
}>;


export type CreateIdentityUserMutation = { __typename?: 'RootMutationType', createIdentityUser?: { __typename?: 'MutatedCreateIdentityUser', identityUser?: { __typename?: 'IdentityUserEntity', id: string, fileUrl?: string | null, firstName?: string | null, lastName?: string | null, roles: Array<IdentityUserRole>, email: string, bio?: string | null, cities: Array<{ __typename?: 'CityEntity', id: string, name: string }>, customerClients: Array<{ __typename?: 'CustomerClientEntity', id: string, name: string }> } | null } | null };

export type CreateIdentityUserPasswordResetLinkMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CreateIdentityUserPasswordResetLinkMutation = { __typename?: 'RootMutationType', createIdentityUserPasswordResetLink?: { __typename?: 'MutatedCreateIdentityUserPasswordResetLink', url: string } | null };

export type CreateLocationMutationVariables = Exact<{
  input: CreateLocationInput;
}>;


export type CreateLocationMutation = { __typename?: 'RootMutationType', createLocation: { __typename?: 'MutatedLocation', location?: { __typename?: 'LocationEntity', id: string, address: string, city: string, name: string, zipCode: string, point?: { __typename?: 'LocationPoint', latitude: number, longitude: number } | null, region: { __typename?: 'RegionEntity', id: string, name: string } } | null } };

export type CreateLocationsByImportMutationVariables = Exact<{
  input: CreateLocationsByImportInput;
}>;


export type CreateLocationsByImportMutation = { __typename?: 'RootMutationType', createLocationsByImport: { __typename?: 'MutatedCreateLocationsByImport', status: MutatedStatus } };

export type CreateOfferCategoryMutationVariables = Exact<{
  createOfferCategoryInput: CreateOfferCategoryInput;
}>;


export type CreateOfferCategoryMutation = { __typename?: 'RootMutationType', createOfferCategory?: { __typename?: 'OfferCategoryEntity', id: string } | null };

export type CreatePdfMutationVariables = Exact<{
  createPdf: CreatePdfInput;
}>;


export type CreatePdfMutation = { __typename?: 'RootMutationType', createPdf?: { __typename?: 'PdfEntity', id: string, uploadUrl: string } | null };

export type CreateBrochureByParserMutationVariables = Exact<{
  createBrochure: CreateBrochureByParserInput;
}>;


export type CreateBrochureByParserMutation = { __typename?: 'RootMutationType', createBrochureByParser: { __typename?: 'CreateBrochureByParser', status: CreateBrochureByParserStatus } };

export type CreateRegionMutationVariables = Exact<{
  input: CreateRegionInput;
}>;


export type CreateRegionMutation = { __typename?: 'RootMutationType', createRegion: { __typename?: 'MutatedRegion', status: MutatedStatus, region?: { __typename: 'RegionEntity', id: string, name: string } | null } };

export type CreateShopMutationVariables = Exact<{
  createShopInput: CreateShopInput;
}>;


export type CreateShopMutation = { __typename?: 'RootMutationType', createShop: { __typename?: 'MutatedShop', status: MutatedStatus, shop?: { __typename?: 'AdminShopEntity', id: string, name: string, customerLevel: CustomerLevel, autoParserSlugFr?: string | null, autoParserSlugNl?: string | null, autoParserType?: AutoParserType | null, fileUrl?: string | null, radius: number, removedFromSearch: boolean, removedProductsFromSearch: boolean, hotspotMode: HotspotMode, localBrochures: boolean, shopKeywords?: string | null, showAds: boolean, slug: string, overwriteUtms: boolean, lastPage: boolean, geminiTaggingPrompt?: string | null, afterpage: Array<{ __typename?: 'CategoryEntity', id: string, name?: string | null }>, toplevel: Array<{ __typename?: 'CategoryEntity', id: string, name?: string | null }>, customerClient?: { __typename?: 'CustomerClientEntity', id: string, name: string } | null, categories: Array<{ __typename?: 'CategoryEntity', id: string, name?: string | null }>, regions: Array<{ __typename?: 'RegionEntity', id: string, name: string, locationsCount: number }>, shopDescriptions: Array<{ __typename?: 'ShopDescriptionEntity', description?: string | null, metaDescription?: string | null, titleMain?: string | null, titleSecondary?: string | null, language: { __typename?: 'LanguageEntity', id: string, name: string } }> } | null } };

export type CreateShopCardTemplateMutationVariables = Exact<{
  createShopCardTemplateInput: CreateShopCardTemplateInput;
}>;


export type CreateShopCardTemplateMutation = { __typename?: 'RootMutationType', createShopCardTemplate: { __typename?: 'MutatedCreateShopCardTemplate', status: MutatedStatus, shopCardTemplate?: { __typename?: 'ShopCardTemplateEntity', id: string, name: string, fileUrl?: string | null } | null } };

export type CreateWebsitePageMutationVariables = Exact<{
  createWebsitePage: CreateWebsitePageInput;
}>;


export type CreateWebsitePageMutation = { __typename?: 'RootMutationType', createWebsitePage?: { __typename?: 'WebsitePagePage', id: string, content?: string | null, metaDescription?: string | null, metaTitle?: string | null, path: string, title?: string | null } | null };

export type CreateWebsitePostMutationVariables = Exact<{
  createWebsitePost: CreateWebsitePostInput;
}>;


export type CreateWebsitePostMutation = { __typename?: 'RootMutationType', createWebsitePost?: { __typename?: 'WebsitePagePost', content: string, metaDescription?: string | null, metaTitle?: string | null, path: string, title: string } | null };

export type DeleteBrandMutationVariables = Exact<{
  deleteBrand: DeleteBrandInput;
}>;


export type DeleteBrandMutation = { __typename?: 'RootMutationType', deleteBrand?: { __typename?: 'MutatedDeleteBrand', status?: MutatedStatus | null } | null };

export type DeleteCityMutationVariables = Exact<{
  deleteCity: DeleteCityInput;
}>;


export type DeleteCityMutation = { __typename?: 'RootMutationType', deleteCity?: { __typename?: 'MutatedDeleteCity', status?: MutatedStatus | null } | null };

export type DeleteGenericProductMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteGenericProductMutation = { __typename?: 'RootMutationType', deleteGenericProduct: { __typename?: 'MutatedDeleteGenericProduct', status?: MutatedStatus | null } };

export type DeleteGenericProductCategoryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteGenericProductCategoryMutation = { __typename?: 'RootMutationType', deleteGenericProductCategory: { __typename?: 'MutatedDeleteGenericProductCategory', status?: MutatedStatus | null } };

export type DeleteHotspotMutationVariables = Exact<{
  deleteHotspotInput: DeleteHotspotInput;
}>;


export type DeleteHotspotMutation = { __typename?: 'RootMutationType', deleteHotspot?: { __typename?: 'MutatedDeleteHotspot', status?: MutatedStatus | null } | null };

export type DeleteHotspotsMutationVariables = Exact<{
  deleteHotspots: DeleteHotspotsInput;
}>;


export type DeleteHotspotsMutation = { __typename?: 'RootMutationType', deleteHotspots: { __typename?: 'DeleteHotspotsStatus', status: MutatedStatus } };

export type DeleteIdentityUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteIdentityUserMutation = { __typename?: 'RootMutationType', deleteIdentityUser?: { __typename?: 'MutatedDeleteIdentityUser', status?: MutatedStatus | null } | null };

export type DeleteLocationMutationVariables = Exact<{
  deleteLocation: DeleteLocationInput;
}>;


export type DeleteLocationMutation = { __typename?: 'RootMutationType', deleteLocation: { __typename?: 'MutatedDeleteLocation', status: MutatedStatus } };

export type DeleteLocationsMutationVariables = Exact<{
  deleteLocations: DeleteLocationsInput;
}>;


export type DeleteLocationsMutation = { __typename?: 'RootMutationType', deleteLocations: { __typename?: 'MutatedDeleteLocations', status: MutatedStatus } };

export type DeleteNewsletterSubscriberMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteNewsletterSubscriberMutation = { __typename?: 'RootMutationType', deleteNewsletterSubscriber?: { __typename?: 'MutatedDeleteNewsletterSubscriber', status?: MutatedStatus | null } | null };

export type DeleteOfferCategoryMutationVariables = Exact<{
  deleteOfferCategory: DeleteOfferCategoryInput;
}>;


export type DeleteOfferCategoryMutation = { __typename?: 'RootMutationType', deleteOfferCategory?: { __typename?: 'MutatedDeleteOfferCategory', status: MutatedStatus } | null };

export type DeleteOfferCategoryTagMutationVariables = Exact<{
  input: DeleteOfferCategoryTagInput;
}>;


export type DeleteOfferCategoryTagMutation = { __typename?: 'RootMutationType', deleteOfferCategoryTag: { __typename?: 'MutatedDeleteOfferCategoryTag', status: MutatedStatus } };

export type DeletePageMutationVariables = Exact<{
  deletePage: DeletePageInput;
}>;


export type DeletePageMutation = { __typename?: 'RootMutationType', deletePage: { __typename?: 'MutatedDeletePage', status: DeletePageStatus } };

export type DeleteProductPricesMutationVariables = Exact<{
  deleteProductPrices: DeleteProductPricesInput;
}>;


export type DeleteProductPricesMutation = { __typename?: 'RootMutationType', deleteProductPrices: { __typename?: 'DeleteProductPricesStatus', status: MutatedStatus } };

export type DeleteRegionMutationVariables = Exact<{
  deleteRegion: DeleteRegionInput;
}>;


export type DeleteRegionMutation = { __typename?: 'RootMutationType', deleteRegion: { __typename?: 'MutatedDeleteRegion', status: MutatedStatus } };

export type DeleteRegionsMutationVariables = Exact<{
  deleteRegions: DeleteRegionsInput;
}>;


export type DeleteRegionsMutation = { __typename?: 'RootMutationType', deleteRegions: { __typename?: 'MutatedDeleteRegions', status: MutatedStatus } };

export type DeleteWebsitePageMutationVariables = Exact<{
  deleteWebsitePage: DeleteWebsitePageInput;
}>;


export type DeleteWebsitePageMutation = { __typename?: 'RootMutationType', deleteWebsitePage?: { __typename?: 'MutatedDeleteWebsitePage', status?: MutatedStatus | null } | null };

export type DetectProductHotspotsMutationVariables = Exact<{
  detectProductHotspotsInput: DetectProductHotspotsInput;
}>;


export type DetectProductHotspotsMutation = { __typename?: 'RootMutationType', detectProductHotspots: { __typename?: 'DetectProductHotspotsEntity', status: DetectProductHotspotsState } };

export type DeleteAdsAdvertisementMutationVariables = Exact<{
  deleteAdsCampaignAdvertisement: DeleteAdsCampaignAdvertisementInput;
}>;


export type DeleteAdsAdvertisementMutation = { __typename?: 'RootMutationType', deleteAdsCampaignAdvertisement?: { __typename?: 'MutatedDeleteAdsAdvertisement', status?: MutatedStatus | null } | null };

export type ShopsLocationsCvsLinkMutationVariables = Exact<{
  input: ExportLocationsInput;
}>;


export type ShopsLocationsCvsLinkMutation = { __typename?: 'RootMutationType', exportLocations: { __typename?: 'MutatedExportLocations', fileUrl?: string | null } };

export type ExportToPdfMutationVariables = Exact<{
  exportToPdfInput: ExportToPdfInput;
}>;


export type ExportToPdfMutation = { __typename?: 'RootMutationType', exportToPdf: { __typename?: 'ExportToPdfResponse', status?: MutatedStatus | null } };

export type ImportLocationsMutationVariables = Exact<{
  input: ImportLocationsInput;
}>;


export type ImportLocationsMutation = { __typename?: 'RootMutationType', importLocations: { __typename?: 'MutatedImportLocations', locationCount: number, status: MutatedImportLocationsStatus } };

export type MigrateBrochureRegionMyshopiMutationVariables = Exact<{
  input: MigrateBrochureRegionMyshopiInput;
}>;


export type MigrateBrochureRegionMyshopiMutation = { __typename?: 'RootMutationType', migrateBrochureRegionMyshopi: { __typename?: 'MutatedMigrateBrochureRegionMyshopi', status: MutatedStatus } };

export type PublishMergeRequestMutationVariables = Exact<{
  mergeRequestId: Scalars['ID']['input'];
}>;


export type PublishMergeRequestMutation = { __typename?: 'RootMutationType', publishMergeRequest: { __typename?: 'MutatedMergeRequest', status: MutatedStatus } };

export type RejectMergeRequestMutationVariables = Exact<{
  mergeRequestId: Scalars['ID']['input'];
}>;


export type RejectMergeRequestMutation = { __typename?: 'RootMutationType', rejectMergeRequest: { __typename?: 'MutatedMergeRequest', status: MutatedStatus } };

export type ResetPasswordIdentityUserMutationVariables = Exact<{
  resetPasswordIdentityUser: ResetPasswordIdentityUserInput;
}>;


export type ResetPasswordIdentityUserMutation = { __typename?: 'RootMutationType', resetPasswordIdentityUser?: { __typename?: 'MutatedResetPasswordIdentityUser', status?: ResetPasswordStatus | null } | null };

export type SetPasswordIdentityUserMutationVariables = Exact<{
  setPasswordIdentityUser: SetPasswordIdentityUserInput;
}>;


export type SetPasswordIdentityUserMutation = { __typename?: 'RootMutationType', setPasswordIdentityUser?: { __typename?: 'MutatedSetPasswordIdentityUser', status?: SetPasswordStatus | null } | null };

export type SortGenericTreeItemsMutationVariables = Exact<{
  input: SortGenericTreeItemsInput;
}>;


export type SortGenericTreeItemsMutation = { __typename?: 'RootMutationType', sortGenericTreeItems: MutatedStatus };

export type UnsubscribeIdentityUserFromNewslettersMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UnsubscribeIdentityUserFromNewslettersMutation = { __typename?: 'RootMutationType', unsubscribeIdentityUserFromNewsletters?: { __typename?: 'MutatedUnsubscribeIdentityUserFromNewsletters', status?: MutatedStatus | null } | null };

export type UnsubscribeNewsletterSubscriberFromNewslettersMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UnsubscribeNewsletterSubscriberFromNewslettersMutation = { __typename?: 'RootMutationType', unsubscribeNewsletterSubscriberFromNewsletters?: { __typename?: 'MutatedUnsubscribeNewsletterSubscriberFromNewsletters', status?: MutatedStatus | null } | null };

export type UpdateAdsCampaignMutationVariables = Exact<{
  updateAdsCampaignInput: UpdateAdsCampaignInput;
}>;


export type UpdateAdsCampaignMutation = { __typename?: 'RootMutationType', updateAdsCampaign?: { __typename?: 'AdsCampaignEntity', status: AdsCampaignStatus } | null };

export type UpdateAppMutationVariables = Exact<{
  updateApp: UpdateAppInput;
}>;


export type UpdateAppMutation = { __typename?: 'RootMutationType', updateApp?: { __typename?: 'AppEntity', id: string, geminiTaggingPrompt?: string | null, taggingStrategy?: TaggingStrategy | null } | null };

export type UpdateAppLanguageMutationVariables = Exact<{
  updateAppLanguage: UpdateAppLanguageInput;
}>;


export type UpdateAppLanguageMutation = { __typename?: 'RootMutationType', updateAppLanguage?: { __typename?: 'AppLanguageEntity', id: string, description?: string | null, disclaimer?: string | null, info?: string | null, language: { __typename?: 'LanguageEntity', id: string, name: string, symbol: string } } | null };

export type UpdateBrandMutationVariables = Exact<{
  updateBrandInput: UpdateBrandInput;
}>;


export type UpdateBrandMutation = { __typename?: 'RootMutationType', updateBrand?: { __typename?: 'BrandEntity', id: string, name: string, fileUrl?: string | null, description?: string | null, position?: number | null, slug: string, status?: BrandStatus | null, brandTags: Array<{ __typename?: 'BrandTagEntity', id: string, name: string }> } | null };

export type UpdateBrochureMutationVariables = Exact<{
  updateBrochureInput: UpdateBrochureInput;
}>;


export type UpdateBrochureMutation = { __typename?: 'RootMutationType', updateBrochure: { __typename?: 'MutatedUpdateBrochure', status: UpdateBrochureStatus } };

export type UpdateBrochureAssigneeMutationVariables = Exact<{
  updateBrochureAssigneeInput: UpdateBrochureAssigneeInput;
}>;


export type UpdateBrochureAssigneeMutation = { __typename?: 'RootMutationType', updateBrochureAssignee: { __typename?: 'MutatedUpdateBrochureAssignee', status: UpdateBrochureAssigneeStatus, brochure?: { __typename?: 'BrochureEntity', assignee?: { __typename?: 'IdentityUserEntity', id: string, firstName?: string | null, fileUrl?: string | null } | null } | null } };

export type UpdateBrochurePositionMutationVariables = Exact<{
  input: UpdateBrochurePositionInput;
}>;


export type UpdateBrochurePositionMutation = { __typename?: 'RootMutationType', updateBrochurePosition: { __typename?: 'MutatedUpdateBrochure', status: UpdateBrochureStatus, brochure?: { __typename?: 'BrochureEntity', id: string, position?: number | null, positionFrozenTo?: any | null } | null } };

export type UpdateBrochureStateMutationVariables = Exact<{
  updateBrochureStateInput: UpdateBrochureStateInput;
}>;


export type UpdateBrochureStateMutation = { __typename?: 'RootMutationType', updateBrochureState?: { __typename?: 'UpdateBrochureState', status: UpdateBrochureStateStatus } | null };

export type UpdateAdsCampaignAdvertisementHtmlEmbedMutationVariables = Exact<{
  updateAdsCampaignAdvertisementHtmlEmbedInput: UpdateAdsCampaignAdvertisementHtmlEmbedInput;
}>;


export type UpdateAdsCampaignAdvertisementHtmlEmbedMutation = { __typename?: 'RootMutationType', updateAdsCampaignAdvertisementHtmlEmbed?: { __typename?: 'AdsAdvertisementHtmlEmbed', status: AdStatusAll } | { __typename?: 'AdsAdvertisementImage', status: AdStatusAll } | null };

export type UpdateAdsCampaignAdvertisementImageAdMutationVariables = Exact<{
  updateAdsCampaignAdvertisementImageAdInput: UpdateAdsCampaignAdvertisementImageAdInput;
}>;


export type UpdateAdsCampaignAdvertisementImageAdMutation = { __typename?: 'RootMutationType', updateAdsCampaignAdvertisementImageAd?: { __typename?: 'AdsAdvertisementHtmlEmbed', status: AdStatusAll } | { __typename?: 'AdsAdvertisementImage', status: AdStatusAll } | null };

export type UpdateCategoryMutationVariables = Exact<{
  updateCategoryInput: UpdateCategoryInput;
}>;


export type UpdateCategoryMutation = { __typename?: 'RootMutationType', updateCategory?: { __typename?: 'CategoryEntity', id: string, name?: string | null, about?: string | null, metaDescription?: string | null, titleMain?: string | null, titleSecondary?: string | null, fileUrl?: string | null, language: { __typename?: 'LanguageEntity', id: string, name: string, symbol: string, fileUrl?: string | null } } | null };

export type UpdateCityMutationVariables = Exact<{
  updateCityInput: UpdateCityInput;
}>;


export type UpdateCityMutation = { __typename?: 'RootMutationType', updateCity?: { __typename?: 'CityEntity', id: string } | null };

export type UpdateCurrentUserMutationVariables = Exact<{
  updateCurrentUser: UpdateCurrentUserInput;
}>;


export type UpdateCurrentUserMutation = { __typename?: 'RootMutationType', updateCurrentUser?: { __typename?: 'MutatedUpdateCurrentUser', currentUser?: { __typename?: 'CurrentUser', id: string } | null } | null };

export type UpdateCustomerClientMutationVariables = Exact<{
  updateCustomerClientInput: UpdateCustomerClientInput;
}>;


export type UpdateCustomerClientMutation = { __typename?: 'RootMutationType', updateCustomerClient?: { __typename?: 'CustomerClientEntity', id: string } | null };

export type UpdateGenericProductMutationVariables = Exact<{
  input: UpdateGenericProductInput;
}>;


export type UpdateGenericProductMutation = { __typename?: 'RootMutationType', updateGenericProduct?: { __typename?: 'GenericProductEntity', id: string, name: string, categoryId: string, keywords?: Array<string | null> | null, sortOrder?: number | null, imageUrl?: string | null, published: boolean, translations: Array<{ __typename?: 'GenericProductTranslationEntity', translation: string, language: { __typename?: 'LanguageEntity', id: string, name: string, symbol: string } }> } | null };

export type UpdateGenericProductCategoryMutationVariables = Exact<{
  input: UpdateGenericProductCategoryInput;
}>;


export type UpdateGenericProductCategoryMutation = { __typename?: 'RootMutationType', updateGenericProductCategory?: { __typename?: 'GenericProductCategoryEntity', id: string, name: string, parentCategoryId?: string | null, imageUrl?: string | null, published: boolean, translations: Array<{ __typename?: 'GenericProductCategoryTranslationEntity', translation: string, language: { __typename?: 'LanguageEntity', id: string, name: string, symbol: string } }> } | null };

export type UpdateHotspotImageMutationVariables = Exact<{
  updateHotspotInput: UpdateHotspotImageInput;
}>;


export type UpdateHotspotImageMutation = { __typename?: 'RootMutationType', updateHotspotImage?: { __typename: 'HotspotImageEntity', id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any, fileUrl?: string | null, tagStatistics: Array<{ __typename?: 'ApprovedAtHotspotField', brandApprovedAt?: any | null, descriptionApprovedAt?: any | null, nameApprovedAt?: any | null, offerCategoryApprovedAt?: any | null, priceApprovedAt?: any | null, urlApprovedAt?: any | null, user: { __typename?: 'IdentityUserEntity', id: string, firstName?: string | null, lastName?: string | null } }> } | { __typename?: 'HotspotLinkEntity' } | { __typename?: 'HotspotProductEntity' } | null };

export type UpdateHotspotLinkMutationVariables = Exact<{
  updateHotspotInput: UpdateHotspotLinkInput;
}>;


export type UpdateHotspotLinkMutation = { __typename?: 'RootMutationType', updateHotspotLink?: { __typename?: 'HotspotImageEntity' } | { __typename: 'HotspotLinkEntity', id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any, fileUrl?: string | null, tagStatistics: Array<{ __typename?: 'ApprovedAtHotspotField', brandApprovedAt?: any | null, descriptionApprovedAt?: any | null, nameApprovedAt?: any | null, offerCategoryApprovedAt?: any | null, priceApprovedAt?: any | null, urlApprovedAt?: any | null, user: { __typename?: 'IdentityUserEntity', id: string, firstName?: string | null, lastName?: string | null } }> } | { __typename?: 'HotspotProductEntity' } | null };

export type UpdateHotspotProductMutationVariables = Exact<{
  updateHotspotInput: UpdateHotspotProductInput;
}>;


export type UpdateHotspotProductMutation = { __typename?: 'RootMutationType', updateHotspotProduct?: { __typename?: 'HotspotImageEntity' } | { __typename?: 'HotspotLinkEntity' } | { __typename: 'HotspotProductEntity', id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any, fileUrl?: string | null, tagStatistics: Array<{ __typename?: 'ApprovedAtHotspotField', brandApprovedAt?: any | null, descriptionApprovedAt?: any | null, nameApprovedAt?: any | null, offerCategoryApprovedAt?: any | null, priceApprovedAt?: any | null, urlApprovedAt?: any | null, user: { __typename?: 'IdentityUserEntity', id: string, firstName?: string | null, lastName?: string | null } }>, productTag: { __typename?: 'ProductTagEntity', id: string, name: string, brandName?: string | null, description?: string | null, discountPercent?: number | null, priceAfterDiscount?: number | null, priceBeforeDiscount?: number | null, brands: Array<{ __typename?: 'BrandEntity', id: string, name: string }>, offerCategories: Array<{ __typename?: 'OfferCategoryEntity', id: string, name: string, label?: string | null }> } } | null };

export type UpdateIdentityUserMutationVariables = Exact<{
  input: UpdateIdentityUserInput;
}>;


export type UpdateIdentityUserMutation = { __typename?: 'RootMutationType', updateIdentityUser?: { __typename?: 'MutatedUpdateIdentityUser', identityUser?: { __typename?: 'IdentityUserEntity', id: string, fileUrl?: string | null, firstName?: string | null, lastName?: string | null, roles: Array<IdentityUserRole>, email: string, bio?: string | null, cities: Array<{ __typename?: 'CityEntity', id: string, name: string }>, customerClients: Array<{ __typename?: 'CustomerClientEntity', id: string, name: string }> } | null } | null };

export type UpdateOfferCategoryMutationVariables = Exact<{
  updateOfferCategoryInput: UpdateOfferCategoryInput;
}>;


export type UpdateOfferCategoryMutation = { __typename?: 'RootMutationType', updateOfferCategory?: { __typename?: 'OfferCategoryEntity', id: string } | null };

export type UpdateRegionMutationVariables = Exact<{
  input: UpdateRegionInput;
}>;


export type UpdateRegionMutation = { __typename?: 'RootMutationType', updateRegion: { __typename?: 'MutatedRegion', status: MutatedStatus, region?: { __typename: 'RegionEntity', id: string, name: string } | null } };

export type UpdateShopMutationVariables = Exact<{
  updateShopInput: UpdateShopInput;
}>;


export type UpdateShopMutation = { __typename?: 'RootMutationType', updateShop: { __typename?: 'MutatedShop', status: MutatedStatus, shop?: { __typename?: 'AdminShopEntity', id: string, name: string, customerLevel: CustomerLevel, autoParserSlugFr?: string | null, autoParserSlugNl?: string | null, autoParserType?: AutoParserType | null, fileUrl?: string | null, radius: number, removedFromSearch: boolean, removedProductsFromSearch: boolean, hotspotMode: HotspotMode, localBrochures: boolean, shopKeywords?: string | null, showAds: boolean, slug: string, overwriteUtms: boolean, lastPage: boolean, geminiTaggingPrompt?: string | null, afterpage: Array<{ __typename?: 'CategoryEntity', id: string, name?: string | null }>, toplevel: Array<{ __typename?: 'CategoryEntity', id: string, name?: string | null }>, customerClient?: { __typename?: 'CustomerClientEntity', id: string, name: string } | null, categories: Array<{ __typename?: 'CategoryEntity', id: string, name?: string | null }>, regions: Array<{ __typename?: 'RegionEntity', id: string, name: string, locationsCount: number }>, shopDescriptions: Array<{ __typename?: 'ShopDescriptionEntity', description?: string | null, metaDescription?: string | null, titleMain?: string | null, titleSecondary?: string | null, language: { __typename?: 'LanguageEntity', id: string, name: string } }> } | null } };

export type UpdateShopCardTemplateMutationVariables = Exact<{
  updateShopCardTemplateInput: UpdateShopCardTemplateInput;
}>;


export type UpdateShopCardTemplateMutation = { __typename?: 'RootMutationType', updateShopCardTemplate: { __typename?: 'MutatedUpdateShopCardTemplate', status: MutatedUpdateShopCardTemplateStatus, shopCardTemplate?: { __typename?: 'ShopCardTemplateEntity', id: string, name: string, fileUrl?: string | null, status: ShopCardTemplateStatus, shops: Array<{ __typename?: 'ShopEntity', id: string, name: string }> } | null } };

export type UpdateWebsitePageMutationVariables = Exact<{
  updateWebsitePage: UpdateWebsitePageInput;
}>;


export type UpdateWebsitePageMutation = { __typename?: 'RootMutationType', updateWebsitePage?: { __typename?: 'WebsitePagePage', id: string, content?: string | null, metaDescription?: string | null, metaTitle?: string | null, path: string, title?: string | null, translationSetId?: string | null, contentBlocks: Array<string>, titleQuestionsAnswers?: string | null, contentQuestionsAnswers: Array<{ __typename?: 'WebsitePageQuestionAnswer', question: string, answer: string }> } | null };

export type UpdateWebsitePostMutationVariables = Exact<{
  updateWebsitePost: UpdateWebsitePostInput;
}>;


export type UpdateWebsitePostMutation = { __typename?: 'RootMutationType', updateWebsitePost?: { __typename?: 'WebsitePagePost', content: string, metaDescription?: string | null, metaTitle?: string | null, path: string, title: string, translationSetId?: string | null } | null };

export type UpsertBrochureCityPositionMutationVariables = Exact<{
  input: UpsertBrochureCityPositionInput;
}>;


export type UpsertBrochureCityPositionMutation = { __typename?: 'RootMutationType', upsertBrochureCityPosition: { __typename?: 'MutatedUpsertBrochureCity', status: UpdateBrochureStatus } };

export type UpsertSessionMutationVariables = Exact<{ [key: string]: never; }>;


export type UpsertSessionMutation = { __typename?: 'RootMutationType', upsertSession: { __typename?: 'MutatedUpsertSessionStatus', status: MutatedStatus } };

export type UpdateLocationMutationVariables = Exact<{
  input: UpdateLocationInput;
}>;


export type UpdateLocationMutation = { __typename?: 'RootMutationType', updateLocation?: { __typename?: 'MutatedLocation', location?: { __typename?: 'LocationEntity', id: string, address: string, city: string, name: string, zipCode: string, point?: { __typename?: 'LocationPoint', latitude: number, longitude: number } | null, region: { __typename?: 'RegionEntity', id: string, name: string } } | null } | null };

export type BrochureStateQueryVariables = Exact<{
  brochureInput: BrochureInput;
}>;


export type BrochureStateQuery = { __typename?: 'RootQueryType', brochure?: { __typename?: 'BrochureEntity', id: string, name: string, state: BrochureState, assignee?: { __typename?: 'IdentityUserEntity', id: string, firstName?: string | null, lastName?: string | null, fileUrl?: string | null } | null, shop: { __typename?: 'ShopEntity', id: string, name: string, customerClient?: { __typename?: 'CustomerClientEntity', id: string, features: Array<CustomerClientFeature> } | null }, language: { __typename?: 'LanguageEntity', id: string }, mergeRequestAsNew?: { __typename?: 'MergeRequestEntity', id: string, status: MergeRequestStatus } | null, brochureExperiment?: { __typename?: 'BrochureExperimentEntity', id: string } | null } | null };

export type BrochureAssigneesQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
}>;


export type BrochureAssigneesQuery = { __typename?: 'RootQueryType', brochureAssignees: { __typename?: 'PaginatedIdentityUsers', pagination: { __typename?: 'Pagination', currentPage: number, totalPages: number, nextPage?: number | null, previousPage?: number | null }, entries: Array<{ __typename?: 'IdentityUserEntity', id: string, firstName?: string | null, lastName?: string | null, fileUrl?: string | null }> } };

export type BrochureDetailQueryVariables = Exact<{
  brochureInput: BrochureInput;
}>;


export type BrochureDetailQuery = { __typename?: 'RootQueryType', brochure?: { __typename?: 'BrochureEntity', id: string, name: string, publishedAt?: any | null, activeFrom?: any | null, position?: number | null, positionFrozenTo?: any | null, expireAfter?: any | null, hotspotMode: HotspotMode, customerLevel?: CustomerLevel | null, utmCampaign?: string | null, utmMedium?: string | null, local: boolean, removedProductsFromSearch: boolean, state: BrochureState, cover?: { __typename?: 'PageEntity', fileUrl?: string | null } | null, categories: Array<{ __typename?: 'CategoryEntity', id: string, name?: string | null }>, toplevel: Array<{ __typename?: 'CategoryEntity', id: string, name?: string | null }>, afterpage: Array<{ __typename?: 'CategoryEntity', id: string, name?: string | null }>, language: { __typename?: 'LanguageEntity', id: string, name: string, symbol: string }, shop: { __typename?: 'ShopEntity', id: string, slug: string, name: string } } | null };

export type BrochureLanguageQueryVariables = Exact<{
  brochureInput: BrochureInput;
}>;


export type BrochureLanguageQuery = { __typename?: 'RootQueryType', brochure?: { __typename?: 'BrochureEntity', language: { __typename?: 'LanguageEntity', id: string, name: string } } | null };

export type BrochurePageQueryQueryVariables = Exact<{
  pageInput: PageInput;
  fileVersion: BrochureStatisticsFileVersion;
}>;


export type BrochurePageQueryQuery = { __typename?: 'RootQueryType', page?: { __typename?: 'PageEntity', fileUrl?: string | null, id: string, index: number } | null };

export type BrochurePagesQueryQueryVariables = Exact<{
  pagesInput: PagesInput;
  fileVersion: BrochureStatisticsFileVersion;
}>;


export type BrochurePagesQueryQuery = { __typename?: 'RootQueryType', pages?: Array<{ __typename?: 'PageEntity', fileUrl?: string | null, id: string, index: number } | null> | null };

export type AdminBrochureReadsQueryVariables = Exact<{
  adminBrochureReads: AdminBrochureReadsInput;
}>;


export type AdminBrochureReadsQuery = { __typename?: 'RootQueryType', adminBrochureReads?: Array<{ __typename?: 'AdminBrochureReadEntity', date: string, totalReads: number, webReads: number, iosReads: number, androidReads: number } | null> | null };

export type BrochureRegionsQueryVariables = Exact<{
  brochureRegionsInput: BrochureRegionsInput;
}>;


export type BrochureRegionsQuery = { __typename?: 'RootQueryType', brochureRegions?: Array<{ __typename?: 'BrochureRegionEntity', id: string, region: { __typename?: 'RegionEntity', id: string, name: string }, brochureExperimentVariant?: { __typename?: 'BrochureExperimentVariantEntity', id: string, variantNumber: number } | null } | null> | null };

export type BrochureStateTransitionsQueryVariables = Exact<{
  brochureStateTransitionsInput: BrochureStateTransitionsInput;
}>;


export type BrochureStateTransitionsQuery = { __typename?: 'RootQueryType', brochureStateTransitions: { __typename?: 'BrochureStateTransitions', status: BrochureTransitionsStatus, transitionStates: Array<{ __typename?: 'TransitionState', state: BrochureState, title: string }>, currentState?: { __typename?: 'TransitionState', state: BrochureState, title: string } | null } };

export type BrochuresQueryQueryVariables = Exact<{
  brochuresInput: BrochuresInput;
  pagination: PaginationInput;
}>;


export type BrochuresQueryQuery = { __typename?: 'RootQueryType', brochures: { __typename?: 'PaginatedBrochures', entries: Array<{ __typename?: 'BrochureEntity', id: string, name: string, publishedAt?: any | null, activeFrom?: any | null, expireAfter?: any | null, position?: number | null, positionFrozenTo?: any | null, shop: { __typename?: 'ShopEntity', id: string, slug: string }, cover?: { __typename?: 'PageEntity', id: string, fileUrl?: string | null } | null, language: { __typename?: 'LanguageEntity', id: string, name: string, symbol: string }, assignee?: { __typename?: 'IdentityUserEntity', id: string, firstName?: string | null, lastName?: string | null, fileUrl?: string | null } | null, brochureExperiment?: { __typename?: 'BrochureExperimentEntity', id: string } | null, mergeRequestAsNew?: { __typename?: 'MergeRequestEntity', id: string, status: MergeRequestStatus, newBrochure: { __typename?: 'BrochureEntity', id: string } } | null }>, pagination: { __typename?: 'Pagination', currentPage: number, nextPage?: number | null, previousPage?: number | null, totalPages: number } } };

export type AdminShopQueryVariables = Exact<{
  input: AdminShopInput;
}>;


export type AdminShopQuery = { __typename?: 'RootQueryType', adminShop?: { __typename?: 'AdminShopEntity', id: string, name: string, customerLevel: CustomerLevel, autoParserSlugFr?: string | null, autoParserSlugNl?: string | null, autoParserType?: AutoParserType | null, fileUrl?: string | null, radius: number, removedFromSearch: boolean, removedProductsFromSearch: boolean, hotspotMode: HotspotMode, localBrochures: boolean, shopKeywords?: string | null, showAds: boolean, slug: string, overwriteUtms: boolean, lastPage: boolean, geminiTaggingPrompt?: string | null, afterpage: Array<{ __typename?: 'CategoryEntity', id: string, name?: string | null }>, toplevel: Array<{ __typename?: 'CategoryEntity', id: string, name?: string | null }>, customerClient?: { __typename?: 'CustomerClientEntity', id: string, name: string } | null, categories: Array<{ __typename?: 'CategoryEntity', id: string, name?: string | null }>, regions: Array<{ __typename?: 'RegionEntity', id: string, name: string, locationsCount: number }>, shopDescriptions: Array<{ __typename?: 'ShopDescriptionEntity', description?: string | null, metaDescription?: string | null, titleMain?: string | null, titleSecondary?: string | null, language: { __typename?: 'LanguageEntity', id: string, name: string } }> } | null };

export type AdminShopLocationsQueryVariables = Exact<{
  input: AdminShopInput;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type AdminShopLocationsQuery = { __typename?: 'RootQueryType', adminShop?: { __typename?: 'AdminShopEntity', id: string, locations: Array<{ __typename?: 'LocationEntity', id: string, address: string, city: string, name: string, zipCode: string, point?: { __typename?: 'LocationPoint', latitude: number, longitude: number } | null, region: { __typename?: 'RegionEntity', id: string, name: string } }> } | null };

export type AdminShopsQueryVariables = Exact<{
  input: AdminShopsInput;
  pagination: PaginationInput;
}>;


export type AdminShopsQuery = { __typename?: 'RootQueryType', adminShops: { __typename?: 'PaginatedAdminShops', entries: Array<{ __typename?: 'AdminShopEntity', id: string, name: string, customerLevel: CustomerLevel, radius: number, removedFromSearch: boolean, hotspotMode: HotspotMode, localBrochures: boolean, locations: Array<{ __typename?: 'LocationEntity', id: string, name: string }>, categories: Array<{ __typename?: 'CategoryEntity', id: string, name?: string | null }> }>, pagination: { __typename?: 'Pagination', currentPage: number, nextPage?: number | null, previousPage?: number | null, totalPages: number } } };

export type AdsCampaignQueryVariables = Exact<{
  adsCampaignInput: AdsCampaignInput;
}>;


export type AdsCampaignQuery = { __typename?: 'RootQueryType', adsCampaign?: { __typename?: 'AdsCampaignEntity', id: string, languageId: string, name: string, startAt: any, stopAt: any, targetType: AdTargetType, status: AdsCampaignStatus, customerClient: { __typename?: 'CustomerClientEntity', id: string, name: string } } | null };

export type AdsCampaignAdvertisementQueryVariables = Exact<{
  adsCampaignAdvertisementInput: AdsCampaignAdvertisementInput;
}>;


export type AdsCampaignAdvertisementQuery = { __typename?: 'RootQueryType', adsCampaignAdvertisement?: { __typename?: 'AdsAdvertisementHtmlEmbed', content: string, adDimension: AdDimension, id: string, weight: number, impressionsLimit: number, targetType: AdTargetType, platformType: AdPlatformType, adType: AdType, displayAt: AdDisplayAt, displayUrl: string, status: AdStatusAll, adsCampaign?: { __typename?: 'AdsCampaignEntity', id: string, name: string } | null, categories: Array<{ __typename?: 'CategoryEntity', id: string, name?: string | null } | null>, shops: Array<{ __typename?: 'ShopEntity', id: string, name: string } | null> } | { __typename?: 'AdsAdvertisementImage', fileUrl?: string | null, adDimension: AdDimension, id: string, weight: number, impressionsLimit: number, targetType: AdTargetType, platformType: AdPlatformType, adType: AdType, displayAt: AdDisplayAt, displayUrl: string, status: AdStatusAll, adsCampaign?: { __typename?: 'AdsCampaignEntity', id: string, name: string } | null, categories: Array<{ __typename?: 'CategoryEntity', id: string, name?: string | null } | null>, shops: Array<{ __typename?: 'ShopEntity', id: string, name: string } | null> } | null };

export type AdsCampaignAdvertisementsQueryVariables = Exact<{
  adsCampaignAdvertisementsInput: AdsCampaignAdvertisementsInput;
  pagination: PaginationInput;
}>;


export type AdsCampaignAdvertisementsQuery = { __typename?: 'RootQueryType', adsCampaignAdvertisements: { __typename?: 'PaginatedAdsAdvertisements', entries: Array<{ __typename?: 'AdsAdvertisementHtmlEmbed', adType: AdType, displayAt: AdDisplayAt, id: string, impressionsLimit: number, platformType: AdPlatformType, status: AdStatusAll, weight: number, categories: Array<{ __typename?: 'CategoryEntity', id: string, name?: string | null } | null>, shops: Array<{ __typename?: 'ShopEntity', id: string, name: string } | null> } | { __typename?: 'AdsAdvertisementImage', adType: AdType, displayAt: AdDisplayAt, id: string, impressionsLimit: number, platformType: AdPlatformType, status: AdStatusAll, weight: number, categories: Array<{ __typename?: 'CategoryEntity', id: string, name?: string | null } | null>, shops: Array<{ __typename?: 'ShopEntity', id: string, name: string } | null> }>, pagination: { __typename?: 'Pagination', currentPage: number, nextPage?: number | null, previousPage?: number | null, totalPages: number } } };

export type AdsCampaignCreateFormQueryVariables = Exact<{
  adsCampaignCreateFormInput: AdsCampaignCreateFormInput;
}>;


export type AdsCampaignCreateFormQuery = { __typename?: 'RootQueryType', adsCampaignCreateForm: { __typename?: 'AdsCampaignCreateFormEntity', adDimensions: Array<AdDimension>, displayAtPositions: Array<AdDisplayAt>, selectableCategories: boolean, selectableShops: boolean } };

export type AdsCampaignsQueryVariables = Exact<{
  adsCampaignsInput: AdsCampaignsInput;
  pagination: PaginationInput;
}>;


export type AdsCampaignsQuery = { __typename?: 'RootQueryType', adsCampaigns: { __typename?: 'PaginatedAdsCampaigns', entries: Array<{ __typename?: 'AdsCampaignEntity', id: string, name: string, startAt: any, stopAt: any, targetType: AdTargetType, status: AdsCampaignStatus, languageId: string, customerClient: { __typename?: 'CustomerClientEntity', id: string, name: string } }>, pagination: { __typename?: 'Pagination', currentPage: number, nextPage?: number | null, previousPage?: number | null, totalPages: number } } };

export type AppQueryVariables = Exact<{ [key: string]: never; }>;


export type AppQuery = { __typename?: 'RootQueryType', app: { __typename?: 'AppEntity', name: string, genericProductSource?: { __typename?: 'AppEntity', name: string } | null } };

export type AppConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type AppConfigQuery = { __typename?: 'RootQueryType', app: { __typename?: 'AppEntity', id: string, geminiTaggingPrompt?: string | null, taggingStrategy?: TaggingStrategy | null } };

export type AppLanguageQueryVariables = Exact<{
  appLanguageInput: AppLanguageInput;
}>;


export type AppLanguageQuery = { __typename?: 'RootQueryType', appLanguage?: { __typename?: 'AppLanguageEntity', id: string, description?: string | null, disclaimer?: string | null, info?: string | null, language: { __typename?: 'LanguageEntity', id: string, name: string, symbol: string } } | null };

export type AppLanguagesQueryVariables = Exact<{ [key: string]: never; }>;


export type AppLanguagesQuery = { __typename?: 'RootQueryType', appLanguages?: Array<{ __typename?: 'AppLanguageEntity', id: string, language: { __typename?: 'LanguageEntity', id: string, name: string, symbol: string } } | null> | null };

export type AppUsersQueryVariables = Exact<{
  appUsers: AppUsersInput;
  pagination: PaginationInput;
}>;


export type AppUsersQuery = { __typename?: 'RootQueryType', appUsers?: { __typename?: 'PaginatedAppUsers', entries: Array<{ __typename?: 'AppUserEntity', id: string, kind: AppUserKind, email: string, firstName?: string | null, lastName?: string | null }>, pagination: { __typename?: 'Pagination', currentPage: number, nextPage?: number | null, previousPage?: number | null, totalPages: number } } | null };

export type BlogAuthorsQueryVariables = Exact<{
  identityUsers: IdentityUsersInput;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type BlogAuthorsQuery = { __typename?: 'RootQueryType', identityUsers?: { __typename?: 'PaginatedIdentityUsers', entries: Array<{ __typename?: 'IdentityUserEntity', firstName?: string | null, lastName?: string | null, id: string }> } | null };

export type BrandQueryVariables = Exact<{
  brandInput: BrandInput;
}>;


export type BrandQuery = { __typename?: 'RootQueryType', brand?: { __typename?: 'BrandEntity', id: string, name: string, fileUrl?: string | null, description?: string | null, position?: number | null, slug: string, status?: BrandStatus | null, brandTags: Array<{ __typename?: 'BrandTagEntity', id: string, name: string }>, syncSource?: { __typename?: 'BrandEntity', app?: { __typename?: 'AppEntity', name: string } | null } | null } | null };

export type BrandsQueryVariables = Exact<{
  brandsInput: BrandsInput;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type BrandsQuery = { __typename?: 'RootQueryType', brands?: { __typename?: 'PaginatedBrands', entries: Array<{ __typename?: 'BrandEntity', id: string, name: string, fileUrl?: string | null, status?: BrandStatus | null, brandTags: Array<{ __typename?: 'BrandTagEntity', name: string }>, syncSource?: { __typename?: 'BrandEntity', app?: { __typename?: 'AppEntity', name: string } | null } | null }>, pagination: { __typename?: 'Pagination', currentPage: number, nextPage?: number | null, previousPage?: number | null, totalPages: number } } | null };

export type BrochureQueryQueryVariables = Exact<{
  brochureInput: BrochureInput;
}>;


export type BrochureQueryQuery = { __typename?: 'RootQueryType', brochure?: { __typename?: 'BrochureEntity', id: string, language: { __typename?: 'LanguageEntity', id: string } } | null };

export type BrochureCountersQueryVariables = Exact<{
  input: BrochureCountersInput;
}>;


export type BrochureCountersQuery = { __typename?: 'RootQueryType', brochureCounters: Array<{ __typename?: 'BrochureStateCount', state: BrochureState, count: number }> };

export type BrochureLogsQueryVariables = Exact<{
  brochureLogs: BrochureLogsInput;
  pagination: PaginationInput;
}>;


export type BrochureLogsQuery = { __typename?: 'RootQueryType', brochureLogs: { __typename?: 'PaginatedBrochureLogs', entries: Array<{ __typename?: 'AssigneeBrochureLog', content: string, level: BrochureLogLevel, insertedAt: any } | { __typename?: 'CreateBrochureLog', createStatus: BrochureCreateStatus, content: string, level: BrochureLogLevel, insertedAt: any } | { __typename?: 'PositionBrochureLog', content: string, level: BrochureLogLevel, insertedAt: any } | { __typename?: 'StateBrochureLog', content: string, level: BrochureLogLevel, insertedAt: any }>, pagination: { __typename?: 'Pagination', currentPage: number, totalPages: number, nextPage?: number | null, previousPage?: number | null } } };

export type BrochureRegionParserQueryVariables = Exact<{
  brochureRegionsInput: BrochureRegionsInput;
}>;


export type BrochureRegionParserQuery = { __typename?: 'RootQueryType', brochureRegions?: Array<{ __typename?: 'BrochureRegionEntity', id: string, parser?: { __typename?: 'ParserEntity', url: string, parserClass: { __typename?: 'ParserClassEntity', moduleName: ParserClasses } } | null, region: { __typename?: 'RegionEntity', id: string } } | null> | null };

export type BrochureShopLangQueryVariables = Exact<{
  brochureId: Scalars['ID']['input'];
}>;


export type BrochureShopLangQuery = { __typename?: 'RootQueryType', brochure?: { __typename?: 'BrochureEntity', language: { __typename?: 'LanguageEntity', id: string }, shop: { __typename?: 'ShopEntity', id: string } } | null };

export type BrochureQueryVariables = Exact<{
  brochure: BrochureStatisticsInput;
}>;


export type BrochureQuery = { __typename?: 'RootQueryType', brochureStatistic?: { __typename?: 'BrochureDetailStatiticsEntity', brochure: { __typename?: 'BrochureStatisticsEntity', id: string, publishedAt: any, expireAfter: any, language?: string | null, pages?: Array<{ __typename?: 'PageEntity', fileUrl?: string | null } | null> | null }, interaction: { __typename?: 'InteractionEntryEntity', impressions: number, reach: number, reads: number, readers: number, openingRatio: number, addedToList: number, hotspotClicks: number, hotspotClicksCtr: number, hotspotLinkClicks: number, hotspotLinkClicksCtr: number, clickThroughRate: number, interactionEntries: Array<{ __typename?: 'InteractionMap', category: InteractionCategoryEnum, impressions: number, reads: number } | null> }, pages: Array<{ __typename?: 'PageEntryEntity', index: number, readers: number, reads: number, percentageReadsPageOne: number, averageTimeSeconds: number, totalTimeSeconds: number } | null> } | null };

export type BrochurePagesStatisticsQueryVariables = Exact<{
  brochures: BrochuresPagesStatisticsInput;
}>;


export type BrochurePagesStatisticsQuery = { __typename?: 'RootQueryType', brochuresPagesStatistics?: Array<{ __typename?: 'BrochurePagesStatisticsEntity', averagePageTime: number, averageTimePerReader: number, numberOfPages: number, totalReadTime: number, reads: number, brochure: { __typename?: 'BrochureStatisticsEntity', id: string, publishedAt: any, expireAfter: any, language?: string | null, pages?: Array<{ __typename?: 'PageEntity', fileUrl?: string | null } | null> | null } } | null> | null };

export type BrochureReadsStatisticsQueryVariables = Exact<{
  brochures: BrochuresReadsStatisticsInput;
}>;


export type BrochureReadsStatisticsQuery = { __typename?: 'RootQueryType', brochuresReadsStatistics?: Array<{ __typename?: 'BrochureReadStatisticsEntity', clickThroughRate: number, addedToList: number, hotspotClicks: number, hotspotClicksCtr: number, hotspotLinkClicks: number, hotspotLinkClicksCtr: number, impressions: number, reads: number, brochure: { __typename?: 'BrochureStatisticsEntity', id: string, publishedAt: any, expireAfter: any, language?: string | null, pages?: Array<{ __typename?: 'PageEntity', fileUrl?: string | null } | null> | null } } | null> | null };

export type BrochuresQueryVariables = Exact<{
  brochures: BrochuresStatisticsOverviewInput;
}>;


export type BrochuresQuery = { __typename?: 'RootQueryType', brochuresStatisticsOverview?: { __typename?: 'BrochuresStatisticsOverviewListResponse', id: string, impressions: number, brochureReads: number, pageReads: number, hotspotClicks: number, hotspotLinkClicks: number, statisticsEntries: Array<{ __typename?: 'BrochureStatisticsEntryEntity', brochure: { __typename?: 'BrochureStatisticsEntity', id: string, publishedAt: any, expireAfter: any, language?: string | null, pages?: Array<{ __typename?: 'PageEntity', fileUrl?: string | null } | null> | null }, brochureStatisticsMapsEntity: { __typename?: 'BrochureStatisticsMapsEntity', impressionsEntries: Array<{ __typename?: 'StatisticsMap', key: string, value: number } | null>, brochureReadsEntries: Array<{ __typename?: 'StatisticsMap', key: string, value: number } | null>, pageReadsEntries: Array<{ __typename?: 'StatisticsMap', key: string, value: number } | null>, hotspotClicksEntries: Array<{ __typename?: 'StatisticsMap', key: string, value: number } | null>, hotspotLinkClicksEntries: Array<{ __typename?: 'StatisticsMap', key: string, value: number } | null> } } | null>, sumStatisticsEntry: { __typename?: 'BrochureStatisticsMapsEntity', impressionsEntries: Array<{ __typename?: 'StatisticsMap', key: string, value: number } | null>, brochureReadsEntries: Array<{ __typename?: 'StatisticsMap', key: string, value: number } | null>, pageReadsEntries: Array<{ __typename?: 'StatisticsMap', key: string, value: number } | null>, hotspotClicksEntries: Array<{ __typename?: 'StatisticsMap', key: string, value: number } | null>, hotspotLinkClicksEntries: Array<{ __typename?: 'StatisticsMap', key: string, value: number } | null> } } | null };

export type CategoriesQueryVariables = Exact<{
  categories?: InputMaybe<CategoriesInput>;
}>;


export type CategoriesQuery = { __typename?: 'RootQueryType', categories?: Array<{ __typename?: 'CategoryEntity', id: string, name?: string | null, about?: string | null, metaDescription?: string | null, titleMain?: string | null, titleSecondary?: string | null, fileUrl?: string | null, language: { __typename?: 'LanguageEntity', id: string, name: string, symbol: string, fileUrl?: string | null } } | null> | null };

export type CategoryQueryVariables = Exact<{
  categoryInput: CategoryInput;
}>;


export type CategoryQuery = { __typename?: 'RootQueryType', category?: { __typename?: 'CategoryEntity', id: string, name?: string | null, about?: string | null, metaDescription?: string | null, titleMain?: string | null, titleSecondary?: string | null, fileUrl?: string | null, language: { __typename?: 'LanguageEntity', id: string, name: string, symbol: string, fileUrl?: string | null } } | null };

export type CitiesQueryVariables = Exact<{
  citiesInput: CitiesInput;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type CitiesQuery = { __typename?: 'RootQueryType', cities?: { __typename?: 'PaginatedCities', entries: Array<{ __typename?: 'CityEntity', id: string, name: string }>, pagination: { __typename?: 'Pagination', currentPage: number, nextPage?: number | null, previousPage?: number | null, totalPages: number } } | null };

export type CityQueryVariables = Exact<{
  cityInput: CityInput;
}>;


export type CityQuery = { __typename?: 'RootQueryType', city?: { __typename?: 'CityEntity', id: string, name: string, position?: number | null } | null };

export type ClientPermissionsQueryVariables = Exact<{
  scope: ClientPermissionsScopeInput;
}>;


export type ClientPermissionsQuery = { __typename?: 'RootQueryType', clientPermissions: Array<CustomerClientPermission> };

export type CustomerClientQueryVariables = Exact<{
  customerClientInput: CustomerClientInput;
}>;


export type CustomerClientQuery = { __typename?: 'RootQueryType', customerClient: { __typename?: 'CustomerClientEntity', id: string, name: string, features: Array<CustomerClientFeature>, identityUsers: Array<{ __typename?: 'IdentityUserEntity', id: string, firstName?: string | null, lastName?: string | null, fileUrl?: string | null, email: string } | null>, shops: Array<{ __typename?: 'ShopEntity', id: string, name: string } | null> } };

export type CustomerClientsQueryVariables = Exact<{
  customerClientsInput: CustomerClientsInput;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type CustomerClientsQuery = { __typename?: 'RootQueryType', customerClients: { __typename?: 'PaginatedCustomerClients', entries: Array<{ __typename?: 'CustomerClientEntity', id: string, name: string }>, pagination: { __typename?: 'Pagination', currentPage: number, nextPage?: number | null, previousPage?: number | null, totalPages: number } } };

export type EnumValuesQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type EnumValuesQuery = { __typename?: 'RootQueryType', enum?: { __typename?: '__Type', enumValues?: Array<{ __typename?: '__EnumValue', name: string, description?: string | null, isDeprecated: boolean }> | null } | null };

export type GenericProductBreadcrumbQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GenericProductBreadcrumbQuery = { __typename?: 'RootQueryType', genericProduct?: { __typename?: 'GenericProductEntity', id: string, name: string, ancestors: Array<{ __typename?: 'GenericProductCategoryEntity', id: string, name: string }> } | null };

export type GenericProductCategoryBreadcrumbQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GenericProductCategoryBreadcrumbQuery = { __typename?: 'RootQueryType', genericProductCategory?: { __typename?: 'GenericProductCategoryEntity', id: string, name: string, imageUrl?: string | null, ancestors: Array<{ __typename?: 'GenericProductCategoryEntity', id: string, name: string, imageUrl?: string | null }> } | null };

export type GenericProductCategoryDetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GenericProductCategoryDetailQuery = { __typename?: 'RootQueryType', genericProductCategory?: { __typename?: 'GenericProductCategoryEntity', id: string, name: string, parentCategoryId?: string | null, imageUrl?: string | null, published: boolean, translations: Array<{ __typename?: 'GenericProductCategoryTranslationEntity', translation: string, language: { __typename?: 'LanguageEntity', id: string, name: string, symbol: string } }> } | null };

export type GenericProductDetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GenericProductDetailQuery = { __typename?: 'RootQueryType', genericProduct?: { __typename?: 'GenericProductEntity', id: string, name: string, categoryId: string, keywords?: Array<string | null> | null, sortOrder?: number | null, imageUrl?: string | null, published: boolean, translations: Array<{ __typename?: 'GenericProductTranslationEntity', translation: string, language: { __typename?: 'LanguageEntity', id: string, name: string, symbol: string } }> } | null };

export type GenericProductsQueryVariables = Exact<{
  genericProductsArgs: GenericProductsInput;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GenericProductsQuery = { __typename?: 'RootQueryType', genericProducts: Array<{ __typename?: 'GenericProductEntity', id: string, name: string, categoryId: string, keywords?: Array<string | null> | null, sortOrder?: number | null, imageUrl?: string | null, published: boolean, translations: Array<{ __typename?: 'GenericProductTranslationEntity', translation: string, language: { __typename?: 'LanguageEntity', id: string, name: string, symbol: string } }> }> };

export type GenericTreeItemsQueryVariables = Exact<{
  genericTreeItemsInput: GenericTreeItemsInput;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GenericTreeItemsQuery = { __typename?: 'RootQueryType', genericTreeItems: { __typename?: 'PaginatedGenericTreeItems', entries: Array<{ __typename: 'GenericProductCategoryEntity', published: boolean, id: string, name: string, sortOrder?: number | null, imageUrl?: string | null, translations: Array<{ __typename?: 'GenericProductCategoryTranslationEntity', language: { __typename?: 'LanguageEntity', name: string, fileUrl?: string | null } }> } | { __typename: 'GenericProductEntity', published: boolean, id: string, name: string, sortOrder?: number | null, imageUrl?: string | null, translations: Array<{ __typename?: 'GenericProductTranslationEntity', language: { __typename?: 'LanguageEntity', name: string, fileUrl?: string | null } }> }>, pagination: { __typename?: 'Pagination', currentPage: number, nextPage?: number | null, previousPage?: number | null, totalPages: number } } };

export type HotspotStatisticsQueryVariables = Exact<{
  hotspotsStatistics: HotspotsStatisticsInput;
}>;


export type HotspotStatisticsQuery = { __typename?: 'RootQueryType', hotspotsStatistics: Array<{ __typename?: 'HotspotStatistics', brochureId: string, externalUrl?: string | null, hotspotId: string, linkClicks: number, pageIndex: number, productClicks: number, productLinkClicks: number, productName?: string | null, productTimeSpent: number, productSource?: string | null, timesAddedToList: number, searchImpressions: number, searchProductClicks: number, hotspot?: { __typename: 'HotspotImageEntity' } | { __typename: 'HotspotLinkEntity' } | { __typename: 'HotspotProductEntity', id: string, fileUrl?: string | null } | null }> };

export type IdentityUserQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type IdentityUserQuery = { __typename?: 'RootQueryType', identityUser?: { __typename?: 'IdentityUserEntity', id: string, fileUrl?: string | null, firstName?: string | null, lastName?: string | null, roles: Array<IdentityUserRole>, email: string, bio?: string | null, cities: Array<{ __typename?: 'CityEntity', id: string, name: string }>, customerClients: Array<{ __typename?: 'CustomerClientEntity', id: string, name: string }> } | null };

export type IdentityUsersQueryVariables = Exact<{
  identityUsers: IdentityUsersInput;
  pagination: PaginationInput;
}>;


export type IdentityUsersQuery = { __typename?: 'RootQueryType', identityUsers?: { __typename?: 'PaginatedIdentityUsers', entries: Array<{ __typename?: 'IdentityUserEntity', id: string, fileUrl?: string | null, firstName?: string | null, lastName?: string | null, roles: Array<IdentityUserRole>, email: string }>, pagination: { __typename?: 'Pagination', currentPage: number, nextPage?: number | null, previousPage?: number | null, totalPages: number } } | null };

export type LanguagesQueryVariables = Exact<{ [key: string]: never; }>;


export type LanguagesQuery = { __typename?: 'RootQueryType', languages?: Array<{ __typename?: 'LanguageEntity', fileUrl?: string | null, id: string, name: string, symbol: string } | null> | null };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'CurrentUser', id: string, firstName?: string | null, lastName?: string | null, roles: Array<string | null>, email: string, fileUrl?: string | null, bio?: string | null } | null };

export type MergeRequestQueryVariables = Exact<{
  mergeRequest: MergeRequestInput;
}>;


export type MergeRequestQuery = { __typename?: 'RootQueryType', mergeRequest?: { __typename?: 'MergeRequestDetails', mergeRequest: { __typename?: 'MergeRequestEntity', id: string, status: MergeRequestStatus, newBrochure: { __typename?: 'BrochureEntity', id: string } }, brochureRegions: Array<{ __typename?: 'BrochureRegionDifference', differenceStatus: DifferenceStatus, region: { __typename?: 'RegionEntity', id: string, name: string }, pages: Array<{ __typename?: 'PageDifference', added: number, changed: number, differenceStatus: DifferenceStatus, noChanges: number, removed: number, newPage?: { __typename?: 'PageEntity', fileUrl?: string | null } | null, oldPage?: { __typename?: 'PageEntity', fileUrl?: string | null } | null, hotspots: Array<{ __typename?: 'HotspotDifference', differenceStatus: DifferenceStatus, differences: Array<HotspotMatchDifference>, oldHotspot?: { __typename?: 'HotspotImageEntity', fileUrl?: string | null, id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any } | { __typename?: 'HotspotLinkEntity', fileUrl?: string | null, url?: string | null, id: string, x: number, y: number, width: number, height: number, updatedAt: any } | { __typename?: 'HotspotProductEntity', fileUrl?: string | null, id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any, productTag: { __typename?: 'ProductTagEntity', id: string, name: string, brandName?: string | null, description?: string | null, discountPercent?: number | null, priceAfterDiscount?: number | null, priceBeforeDiscount?: number | null, brands: Array<{ __typename?: 'BrandEntity', id: string, name: string }>, offerCategories: Array<{ __typename?: 'OfferCategoryEntity', id: string, name: string, label?: string | null }> } } | null, newHotspot?: { __typename?: 'HotspotImageEntity', fileUrl?: string | null, id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any } | { __typename?: 'HotspotLinkEntity', fileUrl?: string | null, url?: string | null, id: string, x: number, y: number, width: number, height: number, updatedAt: any } | { __typename?: 'HotspotProductEntity', fileUrl?: string | null, id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any, productTag: { __typename?: 'ProductTagEntity', id: string, name: string, brandName?: string | null, description?: string | null, discountPercent?: number | null, priceAfterDiscount?: number | null, priceBeforeDiscount?: number | null, brands: Array<{ __typename?: 'BrandEntity', id: string, name: string }>, offerCategories: Array<{ __typename?: 'OfferCategoryEntity', id: string, name: string, label?: string | null }> } } | null }> }> }> } | null };

export type MergeRequestsQueryVariables = Exact<{
  mergeRequests: MergeRequestsInput;
}>;


export type MergeRequestsQuery = { __typename?: 'RootQueryType', mergeRequests: Array<{ __typename?: 'MergeRequestEntity', id: string, status: MergeRequestStatus, newBrochure: { __typename?: 'BrochureEntity', id: string, publishedAt?: any | null, cover?: { __typename?: 'PageEntity', fileUrl?: string | null } | null, language: { __typename?: 'LanguageEntity', id: string, name: string, symbol: string }, assignee?: { __typename?: 'IdentityUserEntity', firstName?: string | null, lastName?: string | null, fileUrl?: string | null } | null, mergeRequestAsNew?: { __typename?: 'MergeRequestEntity', id: string, status: MergeRequestStatus } | null } }> };

export type MyShopiShopBrochuresQueryVariables = Exact<{
  input: MyshopiShopBrochuresInput;
  pagination: PaginationInput;
}>;


export type MyShopiShopBrochuresQuery = { __typename?: 'RootQueryType', myshopiShopBrochures: { __typename?: 'PaginatedBrochures', entries: Array<{ __typename?: 'BrochureEntity', id: string, name: string, cover?: { __typename?: 'PageEntity', fileUrl?: string | null } | null }> } };

export type OfferCategoriesQueryVariables = Exact<{
  offerCategoriesInput: OfferCategoriesInput;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type OfferCategoriesQuery = { __typename?: 'RootQueryType', offerCategories?: { __typename?: 'PaginatedOfferCategories', entries: Array<{ __typename?: 'OfferCategoryEntity', id: string, name: string, label?: string | null, offerCategoryTags: Array<{ __typename?: 'OfferCategoryTagEntity', name: string }>, syncSource?: { __typename?: 'OfferCategoryEntity', app?: { __typename?: 'AppEntity', name: string } | null } | null }>, pagination: { __typename?: 'Pagination', currentPage: number, nextPage?: number | null, previousPage?: number | null, totalPages: number } } | null };

export type OfferCategoryQueryVariables = Exact<{
  offerCategoryInput: OfferCategoryInput;
}>;


export type OfferCategoryQuery = { __typename?: 'RootQueryType', offerCategory?: { __typename?: 'OfferCategoryEntity', id: string, name: string, label?: string | null, position?: number | null, updatedAt?: any | null, syncSource?: { __typename?: 'OfferCategoryEntity', app?: { __typename?: 'AppEntity', name: string } | null } | null, language: { __typename?: 'LanguageEntity', id: string, name: string, fileUrl?: string | null }, offerCategoryTags: Array<{ __typename?: 'OfferCategoryTagEntity', id: string, name: string }>, offerCategoryBlacklistTags: Array<{ __typename?: 'OfferCategoryBlacklistTagEntity', id: string, name: string }>, shopCategories: Array<{ __typename?: 'CategoryEntity', id: string, name?: string | null }> } | null };

export type OfferCategoryTagSuggestionsQueryVariables = Exact<{
  input: OfferCategoryTagSuggestionsInput;
}>;


export type OfferCategoryTagSuggestionsQuery = { __typename?: 'RootQueryType', offerCategoryTagSuggestions: Array<{ __typename?: 'OfferCategoryTagEntity', id: string, name: string }> };

export type OfferOcrSuggestionQueryVariables = Exact<{
  hotspot: OfferOcrSuggestionHotspotInput;
  processor: OfferOcrSuggestionProcessor;
}>;


export type OfferOcrSuggestionQuery = { __typename?: 'RootQueryType', offerOcrSuggestion?: { __typename?: 'OfferOcrSuggestion', processor: OfferOcrSuggestionProcessorName, processorResponse?: string | null, offerInputSuggestion?: { __typename?: 'OfferInputSuggestion', name?: string | null, description?: string | null, priceBeforeDiscount?: number | null, discountPercent?: number | null, priceAfterDiscount?: number | null, brands: Array<{ __typename?: 'BrandEntity', id: string, name: string }>, offerCategories: Array<{ __typename?: 'OfferCategoryEntity', id: string, name: string }> } | null, croppedBlocks: Array<{ __typename?: 'VisionBlock', confidence?: number | null, paragraphs: Array<{ __typename?: 'VisionParagraph', confidence?: number | null, text: string, brands: Array<{ __typename?: 'BrandEntity', id: string, name: string }>, offerCategories: Array<{ __typename?: 'OfferCategoryEntity', id: string, name: string }> }> }> } | null };

export type PagesWithHotspotsQueryVariables = Exact<{
  brochureRegionId: Scalars['ID']['input'];
  pagination: PaginationInput;
}>;


export type PagesWithHotspotsQuery = { __typename?: 'RootQueryType', pagesWithHotspots: { __typename?: 'PaginatedPagesWithHotspots', entries: Array<{ __typename?: 'PageEntity', id: string, index: number, fileUrl?: string | null, hotspots?: Array<{ __typename: 'HotspotImageEntity', id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any, fileUrl?: string | null, tagStatistics: Array<{ __typename?: 'ApprovedAtHotspotField', brandApprovedAt?: any | null, descriptionApprovedAt?: any | null, nameApprovedAt?: any | null, offerCategoryApprovedAt?: any | null, priceApprovedAt?: any | null, urlApprovedAt?: any | null, user: { __typename?: 'IdentityUserEntity', id: string, firstName?: string | null, lastName?: string | null } }> } | { __typename: 'HotspotLinkEntity', id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any, fileUrl?: string | null, tagStatistics: Array<{ __typename?: 'ApprovedAtHotspotField', brandApprovedAt?: any | null, descriptionApprovedAt?: any | null, nameApprovedAt?: any | null, offerCategoryApprovedAt?: any | null, priceApprovedAt?: any | null, urlApprovedAt?: any | null, user: { __typename?: 'IdentityUserEntity', id: string, firstName?: string | null, lastName?: string | null } }> } | { __typename: 'HotspotProductEntity', id: string, x: number, y: number, width: number, height: number, url?: string | null, updatedAt: any, fileUrl?: string | null, tagStatistics: Array<{ __typename?: 'ApprovedAtHotspotField', brandApprovedAt?: any | null, descriptionApprovedAt?: any | null, nameApprovedAt?: any | null, offerCategoryApprovedAt?: any | null, priceApprovedAt?: any | null, urlApprovedAt?: any | null, user: { __typename?: 'IdentityUserEntity', id: string, firstName?: string | null, lastName?: string | null } }>, productTag: { __typename?: 'ProductTagEntity', id: string, name: string, brandName?: string | null, description?: string | null, discountPercent?: number | null, priceAfterDiscount?: number | null, priceBeforeDiscount?: number | null, brands: Array<{ __typename?: 'BrandEntity', id: string, name: string }>, offerCategories: Array<{ __typename?: 'OfferCategoryEntity', id: string, name: string, label?: string | null }> } }> | null }>, pagination: { __typename?: 'Pagination', currentPage: number, nextPage?: number | null, previousPage?: number | null, totalPages: number } } };

export type PagesWithHotspotsUrlsQueryVariables = Exact<{
  brochureRegionId: Scalars['ID']['input'];
  pagination: PaginationInput;
}>;


export type PagesWithHotspotsUrlsQuery = { __typename?: 'RootQueryType', pagesWithHotspots: { __typename?: 'PaginatedPagesWithHotspots', entries: Array<{ __typename?: 'PageEntity', index: number, hotspots?: Array<{ __typename?: 'HotspotImageEntity', url?: string | null } | { __typename?: 'HotspotLinkEntity', url?: string | null } | { __typename?: 'HotspotProductEntity', url?: string | null }> | null }>, pagination: { __typename?: 'Pagination', currentPage: number, nextPage?: number | null, previousPage?: number | null, totalPages: number } } };

export type ParserClassByUrlQueryVariables = Exact<{
  parserClassByUrl: ParserClassByUrlInput;
}>;


export type ParserClassByUrlQuery = { __typename?: 'RootQueryType', parserClassByUrl?: ParserClasses | null };

export type ParserParametersQueryVariables = Exact<{
  parserParameters: ParserParametersInput;
}>;


export type ParserParametersQuery = { __typename?: 'RootQueryType', parserParameters: { __typename?: 'ParserParameters', parserClass?: ParserClasses | null, parsers: Array<{ __typename?: 'CreateBrochureRegionParams', url?: string | null, region: { __typename?: 'RegionEntity', id: string } }> } };

export type PostProcessingStatusQueryVariables = Exact<{
  postProcessingStatus: PostProcessingStatusInput;
}>;


export type PostProcessingStatusQuery = { __typename?: 'RootQueryType', postProcessingStatus: PostProcessingStatus };

export type PublicBrochuresQueryVariables = Exact<{
  input: PublicBrochuresInput;
  pagination: PaginationInput;
  cityId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type PublicBrochuresQuery = { __typename?: 'RootQueryType', publicBrochures: { __typename?: 'PaginatedBrochures', entries: Array<{ __typename?: 'BrochureEntity', id: string, position?: number | null, positionFrozenTo?: any | null, name: string, publishedAt?: any | null, activeFrom?: any | null, expireAfter?: any | null, cover?: { __typename?: 'PageEntity', fileUrl?: string | null } | null, brochureCity?: { __typename?: 'BrochureCityEntity', position: number } | null }>, pagination: { __typename?: 'Pagination', currentPage: number, totalPages: number, nextPage?: number | null, previousPage?: number | null } } };

export type RegionsQueryVariables = Exact<{
  regions: RegionsInput;
}>;


export type RegionsQuery = { __typename?: 'RootQueryType', regions: Array<{ __typename: 'RegionEntity', id: string, name: string, locationsCount: number }> };

export type SessionsQueryVariables = Exact<{
  input: SessionsInput;
}>;


export type SessionsQuery = { __typename?: 'RootQueryType', sessions: Array<{ __typename?: 'SessionStatistic', totalSessionTime: number, trackedAt: any }> };

export type ShopQueryVariables = Exact<{
  shop: ShopInput;
}>;


export type ShopQuery = { __typename?: 'RootQueryType', shop?: { __typename?: 'ShopEntity', id: string, name: string, fileUrl?: string | null } | null };

export type ShopCardTemplateQueryVariables = Exact<{
  input: ShopCardTemplateInput;
}>;


export type ShopCardTemplateQuery = { __typename?: 'RootQueryType', shopCardTemplate?: { __typename?: 'ShopCardTemplateEntity', id: string, name: string, fileUrl?: string | null, status: ShopCardTemplateStatus, shops: Array<{ __typename?: 'ShopEntity', id: string, name: string }> } | null };

export type ShopCardTemplatesQueryVariables = Exact<{
  input: ShopCardTemplatesInput;
  pagination: PaginationInput;
}>;


export type ShopCardTemplatesQuery = { __typename?: 'RootQueryType', shopCardTemplates: { __typename?: 'PaginatedShopCardTemplates', entries: Array<{ __typename?: 'ShopCardTemplateEntity', id: string, name: string, fileUrl?: string | null, status: ShopCardTemplateStatus }>, pagination: { __typename?: 'Pagination', currentPage: number, nextPage?: number | null, previousPage?: number | null, totalPages: number } } };

export type LocationQueryVariables = Exact<{
  location: LocationInput;
}>;


export type LocationQuery = { __typename?: 'RootQueryType', location?: { __typename?: 'LocationEntity', id: string, address: string, city: string, name: string, zipCode: string, point?: { __typename?: 'LocationPoint', latitude: number, longitude: number } | null, region: { __typename?: 'RegionEntity', id: string, name: string } } | null };

export type ShopsQueryVariables = Exact<{
  shops: ShopsInput;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type ShopsQuery = { __typename?: 'RootQueryType', shops?: { __typename?: 'PaginatedShops', entries: Array<{ __typename?: 'ShopEntity', id: string, name: string, fileUrl?: string | null, customerClient?: { __typename?: 'CustomerClientEntity', id: string, name: string } | null }> } | null };

export type TagStatisticsQueryVariables = Exact<{
  tagStatisticsInput: TagStatisticsInput;
}>;


export type TagStatisticsQuery = { __typename?: 'RootQueryType', tagStatistics: Array<{ __typename?: 'TagStatistic', totalTagged: number, taggedAt: any }> };

export type TagStatisticsOverviewQueryVariables = Exact<{
  tagStatisticsOverviewInput: TagStatisticsOverviewInput;
}>;


export type TagStatisticsOverviewQuery = { __typename?: 'RootQueryType', tagStatisticsOverview: { __typename?: 'TagStatisticsOverview', tagStatisticsPerHotspot?: number | null, totalSessionTime: number, userTagStatistics: Array<{ __typename?: 'UserTagStatistic', totalTagged: number, fullName: string, totalSessionTime: number }> } };

export type TaggingUsersQueryVariables = Exact<{
  taggingUsersInput: TaggingUsersInput;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type TaggingUsersQuery = { __typename?: 'RootQueryType', taggingUsers?: { __typename?: 'PaginatedIdentityUsers', pagination: { __typename?: 'Pagination', currentPage: number, totalPages: number, nextPage?: number | null, previousPage?: number | null }, entries: Array<{ __typename?: 'IdentityUserEntity', id: string, firstName?: string | null, lastName?: string | null }> } | null };

export type WebsitePageQueryQueryVariables = Exact<{
  websitePage: WebsitePageInput;
}>;


export type WebsitePageQueryQuery = { __typename?: 'RootQueryType', websitePage?: { __typename?: 'WebsitePagePage', positionInFooter?: number | null, contentBlocks: Array<string>, titleQuestionsAnswers?: string | null, id: string, content?: string | null, metaDescription?: string | null, metaTitle?: string | null, path: string, title?: string | null, translationSetId?: string | null, contentQuestionsAnswers: Array<{ __typename?: 'WebsitePageQuestionAnswer', question: string, answer: string }>, language: { __typename?: 'LanguageEntity', id: string } } | { __typename?: 'WebsitePagePost', coverImage?: string | null, publishedAt?: any | null, id: string, content: string, metaDescription?: string | null, metaTitle?: string | null, path: string, title: string, translationSetId?: string | null, user?: { __typename?: 'IdentityUserEntity', id: string } | null, categories: Array<{ __typename?: 'CategoryEntity', id: string, name?: string | null }>, language: { __typename?: 'LanguageEntity', id: string } } | null };

export type WebsitePagesQueryQueryVariables = Exact<{
  websitePages: WebsitePagesInput;
  pagination: PaginationInput;
}>;


export type WebsitePagesQueryQuery = { __typename?: 'RootQueryType', websitePages?: { __typename?: 'PaginatedWebsitePages', entries: Array<{ __typename?: 'WebsitePagePage', positionInFooter?: number | null, id: string, content?: string | null, metaDescription?: string | null, metaTitle?: string | null, path: string, title?: string | null, translationSetId?: string | null, language: { __typename?: 'LanguageEntity', id: string, name: string, symbol: string } } | { __typename?: 'WebsitePagePost', id: string, content: string, metaDescription?: string | null, metaTitle?: string | null, path: string, title: string, translationSetId?: string | null, language: { __typename?: 'LanguageEntity', id: string, name: string, symbol: string } }>, pagination: { __typename?: 'Pagination', currentPage: number, nextPage?: number | null, previousPage?: number | null, totalPages: number } } | null };

export type LocationImportedSubscriptionVariables = Exact<{
  shopId: Scalars['ID']['input'];
}>;


export type LocationImportedSubscription = { __typename?: 'RootSubscriptionType', locationImported: { __typename?: 'ImportedLocationEntity', address: string, city: string, name: string, regionId: string, zipCode: string, shopId: string, point?: { __typename?: 'LocationPoint', latitude: number, longitude: number } | null } };

export type PdfMessageAddedSubscriptionVariables = Exact<{
  pdfId: Scalars['ID']['input'];
}>;


export type PdfMessageAddedSubscription = { __typename?: 'RootSubscriptionType', pdfMessageAdded: { __typename?: 'PdfMessageEntity', coverUrl?: string | null, indexUrl?: string | null, message: string, pdfId: string } };

export type BrochureLogAddedSubscriptionVariables = Exact<{
  brochureId: Scalars['ID']['input'];
}>;


export type BrochureLogAddedSubscription = { __typename?: 'RootSubscriptionType', brochureLogAdded: { __typename?: 'AssigneeBrochureLog', content: string, insertedAt: any, level: BrochureLogLevel } | { __typename?: 'CreateBrochureLog', createStatus: BrochureCreateStatus, content: string, insertedAt: any, level: BrochureLogLevel } | { __typename?: 'PositionBrochureLog', content: string, insertedAt: any, level: BrochureLogLevel } | { __typename?: 'StateBrochureLog', content: string, insertedAt: any, level: BrochureLogLevel } };

export const CategoryOverviewFragmentDoc = gql`
    fragment CategoryOverview on CategoryEntity {
  id
  name
}
    `;
export const AdminShopDetailFragmentDoc = gql`
    fragment AdminShopDetail on AdminShopEntity {
  id
  name
  customerLevel
  afterpage {
    ...CategoryOverview
  }
  toplevel {
    ...CategoryOverview
  }
  autoParserSlugFr
  autoParserSlugNl
  autoParserType
  fileUrl(version: SMALL)
  customerClient {
    id
    name
  }
  radius
  categories {
    id
    name
  }
  removedFromSearch
  removedProductsFromSearch
  hotspotMode
  localBrochures
  shopKeywords
  showAds
  slug
  overwriteUtms
  regions {
    id
    name
    locationsCount
  }
  lastPage
  geminiTaggingPrompt
  shopDescriptions {
    description
    metaDescription
    titleMain
    titleSecondary
    language {
      id
      name
    }
  }
}
    ${CategoryOverviewFragmentDoc}`;
export const AdminShopOverviewFragmentDoc = gql`
    fragment AdminShopOverview on AdminShopEntity {
  id
  name
  customerLevel
  locations {
    id
    name
  }
  radius
  categories {
    id
    name
  }
  removedFromSearch
  hotspotMode
  localBrochures
}
    `;
export const AppLanguageDetailFragmentDoc = gql`
    fragment AppLanguageDetail on AppLanguageEntity {
  id
  description
  disclaimer
  info
  language {
    id
    name
    symbol
  }
}
    `;
export const AppLanguageOverviewFragmentDoc = gql`
    fragment AppLanguageOverview on AppLanguageEntity {
  id
  language {
    id
    name
    symbol
  }
}
    `;
export const BrochureOverviewFragmentDoc = gql`
    fragment BrochureOverview on BrochureEntity {
  id
  name
  cover {
    fileUrl(version: SMALL)
  }
}
    `;
export const CategoryDetailFragmentDoc = gql`
    fragment CategoryDetail on CategoryEntity {
  id
  name
  about
  metaDescription
  titleMain
  titleSecondary
  language {
    id
    name
    symbol
    fileUrl(version: SMALL)
  }
  fileUrl(version: SMALL)
}
    `;
export const CityDetailFragmentDoc = gql`
    fragment CityDetail on CityEntity {
  id
  name
  position
}
    `;
export const CityOverviewFragmentDoc = gql`
    fragment CityOverview on CityEntity {
  id
  name
}
    `;
export const GenericProductCategoryDetailFragmentDoc = gql`
    fragment GenericProductCategoryDetail on GenericProductCategoryEntity {
  id
  name
  parentCategoryId
  imageUrl(version: ORIGINAL)
  published
  translations {
    language {
      id
      name
      symbol
    }
    translation
  }
}
    `;
export const GenericProductDetailFragmentDoc = gql`
    fragment GenericProductDetail on GenericProductEntity {
  id
  name
  categoryId
  keywords
  sortOrder
  imageUrl(version: ORIGINAL)
  published
  translations {
    language {
      id
      name
      symbol
    }
    translation
  }
}
    `;
export const GenericProductOverviewFragmentDoc = gql`
    fragment genericProductOverview on GenericTreeItem {
  id
  name
  sortOrder
  imageUrl(version: ORIGINAL)
  __typename
  ... on GenericProductCategoryEntity {
    published
    translations {
      language {
        name
        fileUrl(version: SMALL)
      }
    }
  }
  ... on GenericProductEntity {
    published
    translations {
      language {
        name
        fileUrl(version: SMALL)
      }
    }
  }
}
    `;
export const ShopCardTemplateDetailFragmentDoc = gql`
    fragment ShopCardTemplateDetail on ShopCardTemplateEntity {
  id
  name
  fileUrl(version: MEDIUM)
  status
  shops {
    id
    name
  }
}
    `;
export const ShopLocationFragmentDoc = gql`
    fragment ShopLocation on LocationEntity {
  id
  address
  city
  name
  point {
    latitude
    longitude
  }
  region {
    id
    name
  }
  zipCode
}
    `;
export const CustomerClientOverviewFragmentDoc = gql`
    fragment CustomerClientOverview on CustomerClientEntity {
  id
  name
}
    `;
export const UserDetailFragmentDoc = gql`
    fragment UserDetail on IdentityUserEntity {
  id
  fileUrl(version: SMALL)
  firstName
  lastName
  roles
  email
  bio
  cities {
    id
    name
  }
  customerClients {
    ...CustomerClientOverview
  }
}
    ${CustomerClientOverviewFragmentDoc}`;
export const UserOverviewFragmentDoc = gql`
    fragment UserOverview on IdentityUserEntity {
  id
  fileUrl(version: SMALL)
  firstName
  lastName
  roles
  email
}
    `;
export const BrochureRegionDifferenceFragmentDoc = gql`
    fragment brochureRegionDifference on BrochureRegionDifference {
  differenceStatus
  region {
    id
    name
  }
  pages {
    added
    changed
    differenceStatus
    noChanges
    removed
    newPage {
      fileUrl(version: SMALL)
    }
    oldPage {
      fileUrl(version: SMALL)
    }
    hotspots {
      differenceStatus
      differences
      oldHotspot {
        id
        x
        y
        width
        height
        url
        updatedAt
        ... on HotspotImageEntity {
          fileUrl(version: SMALL)
        }
        ... on HotspotLinkEntity {
          fileUrl(version: SMALL)
          url
        }
        ... on HotspotProductEntity {
          fileUrl(version: SMALL)
          productTag {
            id
            name
            brandName
            brands {
              id
              name
            }
            offerCategories {
              id
              name
              label
            }
            description
            discountPercent
            priceAfterDiscount
            priceBeforeDiscount
          }
        }
      }
      newHotspot {
        id
        x
        y
        width
        height
        url
        updatedAt
        ... on HotspotImageEntity {
          fileUrl(version: SMALL)
        }
        ... on HotspotLinkEntity {
          fileUrl(version: SMALL)
          url
        }
        ... on HotspotProductEntity {
          fileUrl(version: SMALL)
          productTag {
            id
            name
            brandName
            brands {
              id
              name
            }
            offerCategories {
              id
              name
              label
            }
            description
            discountPercent
            priceAfterDiscount
            priceBeforeDiscount
          }
        }
      }
    }
  }
}
    `;
export const MergeRequestFragmentDoc = gql`
    fragment mergeRequest on MergeRequestDetails {
  mergeRequest {
    id
    newBrochure {
      id
    }
    status
  }
  brochureRegions {
    ...brochureRegionDifference
  }
}
    ${BrochureRegionDifferenceFragmentDoc}`;
export const ApprovedAtHotspotFieldFragmentDoc = gql`
    fragment approvedAtHotspotField on ApprovedAtHotspotField {
  brandApprovedAt
  descriptionApprovedAt
  nameApprovedAt
  offerCategoryApprovedAt
  priceApprovedAt
  urlApprovedAt
  user {
    id
    firstName
    lastName
  }
}
    `;
export const HotspotImageFragmentDoc = gql`
    fragment hotspotImage on HotspotImageEntity {
  id
  x
  y
  width
  height
  url
  updatedAt
  __typename
  fileUrl(version: ORIGINAL)
  tagStatistics {
    ...approvedAtHotspotField
  }
}
    ${ApprovedAtHotspotFieldFragmentDoc}`;
export const HotspotLinkFragmentDoc = gql`
    fragment hotspotLink on HotspotLinkEntity {
  id
  x
  y
  width
  height
  url
  updatedAt
  __typename
  fileUrl(version: ORIGINAL)
  url
  tagStatistics {
    ...approvedAtHotspotField
  }
}
    ${ApprovedAtHotspotFieldFragmentDoc}`;
export const HotspotProductFragmentDoc = gql`
    fragment hotspotProduct on HotspotProductEntity {
  id
  x
  y
  width
  height
  url
  updatedAt
  tagStatistics {
    ...approvedAtHotspotField
  }
  __typename
  fileUrl(version: ORIGINAL)
  productTag {
    id
    name
    brandName
    brands {
      id
      name
    }
    offerCategories {
      id
      name
      label
    }
    description
    discountPercent
    priceAfterDiscount
    priceBeforeDiscount
  }
}
    ${ApprovedAtHotspotFieldFragmentDoc}`;
export const HotspotFragmentDoc = gql`
    fragment hotspot on HotspotEntity {
  __typename
  id
  x
  y
  width
  height
  url
  updatedAt
  tagStatistics {
    ...approvedAtHotspotField
  }
  ... on HotspotImageEntity {
    __typename
    ...hotspotImage
  }
  ... on HotspotLinkEntity {
    __typename
    ...hotspotLink
  }
  ... on HotspotProductEntity {
    __typename
    ...hotspotProduct
  }
}
    ${ApprovedAtHotspotFieldFragmentDoc}
${HotspotImageFragmentDoc}
${HotspotLinkFragmentDoc}
${HotspotProductFragmentDoc}`;
export const PageWithHotspotsFragmentDoc = gql`
    fragment pageWithHotspots on PageEntity {
  id
  index
  fileUrl(version: LARGE)
  hotspots {
    ...hotspot
  }
}
    ${HotspotFragmentDoc}`;
export const PaginationFragmentDoc = gql`
    fragment pagination on Pagination {
  currentPage
  nextPage
  previousPage
  totalPages
}
    `;
export const ApproveHotspotFieldsDocument = gql`
    mutation ApproveHotspotFields($approveHotspotFields: ApproveHotspotFieldsInput!) {
  approveHotspotFields(approveHotspotFields: $approveHotspotFields) {
    ...hotspot
  }
}
    ${HotspotFragmentDoc}`;

/**
 * __useApproveHotspotFieldsMutation__
 *
 * To run a mutation, you first call `useApproveHotspotFieldsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useApproveHotspotFieldsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useApproveHotspotFieldsMutation({
 *   variables: {
 *     approveHotspotFields: // value for 'approveHotspotFields'
 *   },
 * });
 */
export function useApproveHotspotFieldsMutation(options: VueApolloComposable.UseMutationOptions<ApproveHotspotFieldsMutation, ApproveHotspotFieldsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ApproveHotspotFieldsMutation, ApproveHotspotFieldsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ApproveHotspotFieldsMutation, ApproveHotspotFieldsMutationVariables>(ApproveHotspotFieldsDocument, options);
}
export type ApproveHotspotFieldsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ApproveHotspotFieldsMutation, ApproveHotspotFieldsMutationVariables>;
export const ApproveMergeRequestAsNewDocument = gql`
    mutation ApproveMergeRequestAsNew($mergeRequestId: ID!) {
  approveMergeRequestAsNew(
    approveMergeRequestAsNew: {mergeRequestId: $mergeRequestId}
  ) {
    status
  }
}
    `;

/**
 * __useApproveMergeRequestAsNewMutation__
 *
 * To run a mutation, you first call `useApproveMergeRequestAsNewMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useApproveMergeRequestAsNewMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useApproveMergeRequestAsNewMutation({
 *   variables: {
 *     mergeRequestId: // value for 'mergeRequestId'
 *   },
 * });
 */
export function useApproveMergeRequestAsNewMutation(options: VueApolloComposable.UseMutationOptions<ApproveMergeRequestAsNewMutation, ApproveMergeRequestAsNewMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ApproveMergeRequestAsNewMutation, ApproveMergeRequestAsNewMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ApproveMergeRequestAsNewMutation, ApproveMergeRequestAsNewMutationVariables>(ApproveMergeRequestAsNewDocument, options);
}
export type ApproveMergeRequestAsNewMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ApproveMergeRequestAsNewMutation, ApproveMergeRequestAsNewMutationVariables>;
export const ApproveMergeRequestAsUpdateDocument = gql`
    mutation ApproveMergeRequestAsUpdate($mergeRequestId: ID!, $pageFilters: [PageFilter!]) {
  approveMergeRequestAsUpdate(
    approveMergeRequestAsUpdate: {mergeRequestId: $mergeRequestId, pageFilters: $pageFilters}
  ) {
    status
  }
}
    `;

/**
 * __useApproveMergeRequestAsUpdateMutation__
 *
 * To run a mutation, you first call `useApproveMergeRequestAsUpdateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useApproveMergeRequestAsUpdateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useApproveMergeRequestAsUpdateMutation({
 *   variables: {
 *     mergeRequestId: // value for 'mergeRequestId'
 *     pageFilters: // value for 'pageFilters'
 *   },
 * });
 */
export function useApproveMergeRequestAsUpdateMutation(options: VueApolloComposable.UseMutationOptions<ApproveMergeRequestAsUpdateMutation, ApproveMergeRequestAsUpdateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ApproveMergeRequestAsUpdateMutation, ApproveMergeRequestAsUpdateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ApproveMergeRequestAsUpdateMutation, ApproveMergeRequestAsUpdateMutationVariables>(ApproveMergeRequestAsUpdateDocument, options);
}
export type ApproveMergeRequestAsUpdateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ApproveMergeRequestAsUpdateMutation, ApproveMergeRequestAsUpdateMutationVariables>;
export const ChangePasswordIdentityUserDocument = gql`
    mutation ChangePasswordIdentityUser($changePasswordIdentityUser: ChangePasswordIdentityUserInput!) {
  changePasswordIdentityUser(
    changePasswordIdentityUser: $changePasswordIdentityUser
  ) {
    identityUser {
      id
    }
  }
}
    `;

/**
 * __useChangePasswordIdentityUserMutation__
 *
 * To run a mutation, you first call `useChangePasswordIdentityUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordIdentityUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useChangePasswordIdentityUserMutation({
 *   variables: {
 *     changePasswordIdentityUser: // value for 'changePasswordIdentityUser'
 *   },
 * });
 */
export function useChangePasswordIdentityUserMutation(options: VueApolloComposable.UseMutationOptions<ChangePasswordIdentityUserMutation, ChangePasswordIdentityUserMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ChangePasswordIdentityUserMutation, ChangePasswordIdentityUserMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ChangePasswordIdentityUserMutation, ChangePasswordIdentityUserMutationVariables>(ChangePasswordIdentityUserDocument, options);
}
export type ChangePasswordIdentityUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ChangePasswordIdentityUserMutation, ChangePasswordIdentityUserMutationVariables>;
export const ConvertLinkHotspotsToProductHotspotsDocument = gql`
    mutation ConvertLinkHotspotsToProductHotspots($convertHotspotsInput: ConvertHotspotsInput!) {
  convertLinkHotspotsToProductHotspots(convertHotspots: $convertHotspotsInput) {
    status
  }
}
    `;

/**
 * __useConvertLinkHotspotsToProductHotspotsMutation__
 *
 * To run a mutation, you first call `useConvertLinkHotspotsToProductHotspotsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useConvertLinkHotspotsToProductHotspotsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useConvertLinkHotspotsToProductHotspotsMutation({
 *   variables: {
 *     convertHotspotsInput: // value for 'convertHotspotsInput'
 *   },
 * });
 */
export function useConvertLinkHotspotsToProductHotspotsMutation(options: VueApolloComposable.UseMutationOptions<ConvertLinkHotspotsToProductHotspotsMutation, ConvertLinkHotspotsToProductHotspotsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ConvertLinkHotspotsToProductHotspotsMutation, ConvertLinkHotspotsToProductHotspotsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ConvertLinkHotspotsToProductHotspotsMutation, ConvertLinkHotspotsToProductHotspotsMutationVariables>(ConvertLinkHotspotsToProductHotspotsDocument, options);
}
export type ConvertLinkHotspotsToProductHotspotsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ConvertLinkHotspotsToProductHotspotsMutation, ConvertLinkHotspotsToProductHotspotsMutationVariables>;
export const CopyBrochureRegionDocument = gql`
    mutation CopyBrochureRegion($copyBrochureRegionInput: CopyBrochureRegionInput!) {
  copyBrochureRegion(copyBrochureRegion: $copyBrochureRegionInput) {
    status
  }
}
    `;

/**
 * __useCopyBrochureRegionMutation__
 *
 * To run a mutation, you first call `useCopyBrochureRegionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCopyBrochureRegionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCopyBrochureRegionMutation({
 *   variables: {
 *     copyBrochureRegionInput: // value for 'copyBrochureRegionInput'
 *   },
 * });
 */
export function useCopyBrochureRegionMutation(options: VueApolloComposable.UseMutationOptions<CopyBrochureRegionMutation, CopyBrochureRegionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CopyBrochureRegionMutation, CopyBrochureRegionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CopyBrochureRegionMutation, CopyBrochureRegionMutationVariables>(CopyBrochureRegionDocument, options);
}
export type CopyBrochureRegionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CopyBrochureRegionMutation, CopyBrochureRegionMutationVariables>;
export const CopyHotspotsDocument = gql`
    mutation CopyHotspots($copyHotspotsInput: CopyHotspotsInput!) {
  copyHotspots(copyHotspots: $copyHotspotsInput) {
    status
  }
}
    `;

/**
 * __useCopyHotspotsMutation__
 *
 * To run a mutation, you first call `useCopyHotspotsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCopyHotspotsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCopyHotspotsMutation({
 *   variables: {
 *     copyHotspotsInput: // value for 'copyHotspotsInput'
 *   },
 * });
 */
export function useCopyHotspotsMutation(options: VueApolloComposable.UseMutationOptions<CopyHotspotsMutation, CopyHotspotsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CopyHotspotsMutation, CopyHotspotsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CopyHotspotsMutation, CopyHotspotsMutationVariables>(CopyHotspotsDocument, options);
}
export type CopyHotspotsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CopyHotspotsMutation, CopyHotspotsMutationVariables>;
export const CreateAdsCampaignDocument = gql`
    mutation CreateAdsCampaign($createAdsCampaign: CreateAdsCampaignInput!) {
  createAdsCampaign(createAdsCampaign: $createAdsCampaign) {
    status
    adsCampaign {
      id
    }
  }
}
    `;

/**
 * __useCreateAdsCampaignMutation__
 *
 * To run a mutation, you first call `useCreateAdsCampaignMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdsCampaignMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateAdsCampaignMutation({
 *   variables: {
 *     createAdsCampaign: // value for 'createAdsCampaign'
 *   },
 * });
 */
export function useCreateAdsCampaignMutation(options: VueApolloComposable.UseMutationOptions<CreateAdsCampaignMutation, CreateAdsCampaignMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateAdsCampaignMutation, CreateAdsCampaignMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateAdsCampaignMutation, CreateAdsCampaignMutationVariables>(CreateAdsCampaignDocument, options);
}
export type CreateAdsCampaignMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateAdsCampaignMutation, CreateAdsCampaignMutationVariables>;
export const CreateBrandDocument = gql`
    mutation CreateBrand($createBrandInput: CreateBrandInput!) {
  createBrand(createBrand: $createBrandInput) {
    id
  }
}
    `;

/**
 * __useCreateBrandMutation__
 *
 * To run a mutation, you first call `useCreateBrandMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateBrandMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateBrandMutation({
 *   variables: {
 *     createBrandInput: // value for 'createBrandInput'
 *   },
 * });
 */
export function useCreateBrandMutation(options: VueApolloComposable.UseMutationOptions<CreateBrandMutation, CreateBrandMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateBrandMutation, CreateBrandMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateBrandMutation, CreateBrandMutationVariables>(CreateBrandDocument, options);
}
export type CreateBrandMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateBrandMutation, CreateBrandMutationVariables>;
export const CreateBrochureExperimentDocument = gql`
    mutation createBrochureExperiment($input: CreateBrochureExperimentInput!) {
  createBrochureExperiment(createBrochureExperiment: $input) {
    status
    brochureExperiment {
      name
      variantCount
      brochureExperimentVariants {
        variantNumber
        brochureRegions {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useCreateBrochureExperimentMutation__
 *
 * To run a mutation, you first call `useCreateBrochureExperimentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateBrochureExperimentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateBrochureExperimentMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateBrochureExperimentMutation(options: VueApolloComposable.UseMutationOptions<CreateBrochureExperimentMutation, CreateBrochureExperimentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateBrochureExperimentMutation, CreateBrochureExperimentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateBrochureExperimentMutation, CreateBrochureExperimentMutationVariables>(CreateBrochureExperimentDocument, options);
}
export type CreateBrochureExperimentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateBrochureExperimentMutation, CreateBrochureExperimentMutationVariables>;
export const CreateCategoryDocument = gql`
    mutation CreateCategory($createCategoryInput: CreateCategoryInput!) {
  createCategory(createCategory: $createCategoryInput) {
    ...CategoryDetail
  }
}
    ${CategoryDetailFragmentDoc}`;

/**
 * __useCreateCategoryMutation__
 *
 * To run a mutation, you first call `useCreateCategoryMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateCategoryMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateCategoryMutation({
 *   variables: {
 *     createCategoryInput: // value for 'createCategoryInput'
 *   },
 * });
 */
export function useCreateCategoryMutation(options: VueApolloComposable.UseMutationOptions<CreateCategoryMutation, CreateCategoryMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateCategoryMutation, CreateCategoryMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateCategoryMutation, CreateCategoryMutationVariables>(CreateCategoryDocument, options);
}
export type CreateCategoryMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateCategoryMutation, CreateCategoryMutationVariables>;
export const CreateCityDocument = gql`
    mutation CreateCity($createCityInput: CreateCityInput!) {
  createCity(createCity: $createCityInput) {
    id
  }
}
    `;

/**
 * __useCreateCityMutation__
 *
 * To run a mutation, you first call `useCreateCityMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateCityMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateCityMutation({
 *   variables: {
 *     createCityInput: // value for 'createCityInput'
 *   },
 * });
 */
export function useCreateCityMutation(options: VueApolloComposable.UseMutationOptions<CreateCityMutation, CreateCityMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateCityMutation, CreateCityMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateCityMutation, CreateCityMutationVariables>(CreateCityDocument, options);
}
export type CreateCityMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateCityMutation, CreateCityMutationVariables>;
export const CreateCustomerClientDocument = gql`
    mutation CreateCustomerClient($createCustomerClientInput: CreateCustomerClientInput!) {
  createCustomerClient(createCustomerClient: $createCustomerClientInput) {
    id
  }
}
    `;

/**
 * __useCreateCustomerClientMutation__
 *
 * To run a mutation, you first call `useCreateCustomerClientMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerClientMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateCustomerClientMutation({
 *   variables: {
 *     createCustomerClientInput: // value for 'createCustomerClientInput'
 *   },
 * });
 */
export function useCreateCustomerClientMutation(options: VueApolloComposable.UseMutationOptions<CreateCustomerClientMutation, CreateCustomerClientMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateCustomerClientMutation, CreateCustomerClientMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateCustomerClientMutation, CreateCustomerClientMutationVariables>(CreateCustomerClientDocument, options);
}
export type CreateCustomerClientMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateCustomerClientMutation, CreateCustomerClientMutationVariables>;
export const CreateGenericProductDocument = gql`
    mutation CreateGenericProduct($input: CreateGenericProductInput!) {
  createGenericProduct(createGenericProduct: $input) {
    ...GenericProductDetail
  }
}
    ${GenericProductDetailFragmentDoc}`;

/**
 * __useCreateGenericProductMutation__
 *
 * To run a mutation, you first call `useCreateGenericProductMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateGenericProductMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateGenericProductMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateGenericProductMutation(options: VueApolloComposable.UseMutationOptions<CreateGenericProductMutation, CreateGenericProductMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateGenericProductMutation, CreateGenericProductMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateGenericProductMutation, CreateGenericProductMutationVariables>(CreateGenericProductDocument, options);
}
export type CreateGenericProductMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateGenericProductMutation, CreateGenericProductMutationVariables>;
export const CreateGenericProductCategoryDocument = gql`
    mutation CreateGenericProductCategory($input: CreateGenericProductCategoryInput!) {
  createGenericProductCategory(createGenericProductCategory: $input) {
    ...GenericProductCategoryDetail
  }
}
    ${GenericProductCategoryDetailFragmentDoc}`;

/**
 * __useCreateGenericProductCategoryMutation__
 *
 * To run a mutation, you first call `useCreateGenericProductCategoryMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateGenericProductCategoryMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateGenericProductCategoryMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateGenericProductCategoryMutation(options: VueApolloComposable.UseMutationOptions<CreateGenericProductCategoryMutation, CreateGenericProductCategoryMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateGenericProductCategoryMutation, CreateGenericProductCategoryMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateGenericProductCategoryMutation, CreateGenericProductCategoryMutationVariables>(CreateGenericProductCategoryDocument, options);
}
export type CreateGenericProductCategoryMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateGenericProductCategoryMutation, CreateGenericProductCategoryMutationVariables>;
export const CreateHotspotImageDocument = gql`
    mutation CreateHotspotImage($createHotspotInput: CreateHotspotImageInput!) {
  createHotspotImage(createHotspot: $createHotspotInput) {
    ...hotspotImage
  }
}
    ${HotspotImageFragmentDoc}`;

/**
 * __useCreateHotspotImageMutation__
 *
 * To run a mutation, you first call `useCreateHotspotImageMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateHotspotImageMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateHotspotImageMutation({
 *   variables: {
 *     createHotspotInput: // value for 'createHotspotInput'
 *   },
 * });
 */
export function useCreateHotspotImageMutation(options: VueApolloComposable.UseMutationOptions<CreateHotspotImageMutation, CreateHotspotImageMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateHotspotImageMutation, CreateHotspotImageMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateHotspotImageMutation, CreateHotspotImageMutationVariables>(CreateHotspotImageDocument, options);
}
export type CreateHotspotImageMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateHotspotImageMutation, CreateHotspotImageMutationVariables>;
export const CreateHotspotLinkDocument = gql`
    mutation CreateHotspotLink($createHotspotInput: CreateHotspotLinkInput!) {
  createHotspotLink(createHotspot: $createHotspotInput) {
    ...hotspotLink
  }
}
    ${HotspotLinkFragmentDoc}`;

/**
 * __useCreateHotspotLinkMutation__
 *
 * To run a mutation, you first call `useCreateHotspotLinkMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateHotspotLinkMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateHotspotLinkMutation({
 *   variables: {
 *     createHotspotInput: // value for 'createHotspotInput'
 *   },
 * });
 */
export function useCreateHotspotLinkMutation(options: VueApolloComposable.UseMutationOptions<CreateHotspotLinkMutation, CreateHotspotLinkMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateHotspotLinkMutation, CreateHotspotLinkMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateHotspotLinkMutation, CreateHotspotLinkMutationVariables>(CreateHotspotLinkDocument, options);
}
export type CreateHotspotLinkMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateHotspotLinkMutation, CreateHotspotLinkMutationVariables>;
export const CreateHotspotProductDocument = gql`
    mutation CreateHotspotProduct($createHotspotInput: CreateHotspotProductInput!) {
  createHotspotProduct(createHotspot: $createHotspotInput) {
    ...hotspotProduct
  }
}
    ${HotspotProductFragmentDoc}`;

/**
 * __useCreateHotspotProductMutation__
 *
 * To run a mutation, you first call `useCreateHotspotProductMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateHotspotProductMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateHotspotProductMutation({
 *   variables: {
 *     createHotspotInput: // value for 'createHotspotInput'
 *   },
 * });
 */
export function useCreateHotspotProductMutation(options: VueApolloComposable.UseMutationOptions<CreateHotspotProductMutation, CreateHotspotProductMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateHotspotProductMutation, CreateHotspotProductMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateHotspotProductMutation, CreateHotspotProductMutationVariables>(CreateHotspotProductDocument, options);
}
export type CreateHotspotProductMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateHotspotProductMutation, CreateHotspotProductMutationVariables>;
export const CreateIdentityUserDocument = gql`
    mutation CreateIdentityUser($input: CreateIdentityUserInput!) {
  createIdentityUser(createIdentityUser: $input) {
    identityUser {
      ...UserDetail
    }
  }
}
    ${UserDetailFragmentDoc}`;

/**
 * __useCreateIdentityUserMutation__
 *
 * To run a mutation, you first call `useCreateIdentityUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateIdentityUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateIdentityUserMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateIdentityUserMutation(options: VueApolloComposable.UseMutationOptions<CreateIdentityUserMutation, CreateIdentityUserMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateIdentityUserMutation, CreateIdentityUserMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateIdentityUserMutation, CreateIdentityUserMutationVariables>(CreateIdentityUserDocument, options);
}
export type CreateIdentityUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateIdentityUserMutation, CreateIdentityUserMutationVariables>;
export const CreateIdentityUserPasswordResetLinkDocument = gql`
    mutation CreateIdentityUserPasswordResetLink($id: ID!) {
  createIdentityUserPasswordResetLink(
    createIdentityUserPasswordResetLink: {id: $id}
  ) {
    url
  }
}
    `;

/**
 * __useCreateIdentityUserPasswordResetLinkMutation__
 *
 * To run a mutation, you first call `useCreateIdentityUserPasswordResetLinkMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateIdentityUserPasswordResetLinkMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateIdentityUserPasswordResetLinkMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useCreateIdentityUserPasswordResetLinkMutation(options: VueApolloComposable.UseMutationOptions<CreateIdentityUserPasswordResetLinkMutation, CreateIdentityUserPasswordResetLinkMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateIdentityUserPasswordResetLinkMutation, CreateIdentityUserPasswordResetLinkMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateIdentityUserPasswordResetLinkMutation, CreateIdentityUserPasswordResetLinkMutationVariables>(CreateIdentityUserPasswordResetLinkDocument, options);
}
export type CreateIdentityUserPasswordResetLinkMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateIdentityUserPasswordResetLinkMutation, CreateIdentityUserPasswordResetLinkMutationVariables>;
export const CreateLocationDocument = gql`
    mutation CreateLocation($input: CreateLocationInput!) {
  createLocation(createLocation: $input) {
    location {
      ...ShopLocation
    }
  }
}
    ${ShopLocationFragmentDoc}`;

/**
 * __useCreateLocationMutation__
 *
 * To run a mutation, you first call `useCreateLocationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateLocationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateLocationMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateLocationMutation(options: VueApolloComposable.UseMutationOptions<CreateLocationMutation, CreateLocationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateLocationMutation, CreateLocationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateLocationMutation, CreateLocationMutationVariables>(CreateLocationDocument, options);
}
export type CreateLocationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateLocationMutation, CreateLocationMutationVariables>;
export const CreateLocationsByImportDocument = gql`
    mutation CreateLocationsByImport($input: CreateLocationsByImportInput!) {
  createLocationsByImport(createLocationsByImport: $input) {
    status
  }
}
    `;

/**
 * __useCreateLocationsByImportMutation__
 *
 * To run a mutation, you first call `useCreateLocationsByImportMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateLocationsByImportMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateLocationsByImportMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateLocationsByImportMutation(options: VueApolloComposable.UseMutationOptions<CreateLocationsByImportMutation, CreateLocationsByImportMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateLocationsByImportMutation, CreateLocationsByImportMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateLocationsByImportMutation, CreateLocationsByImportMutationVariables>(CreateLocationsByImportDocument, options);
}
export type CreateLocationsByImportMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateLocationsByImportMutation, CreateLocationsByImportMutationVariables>;
export const CreateOfferCategoryDocument = gql`
    mutation CreateOfferCategory($createOfferCategoryInput: CreateOfferCategoryInput!) {
  createOfferCategory(createOfferCategory: $createOfferCategoryInput) {
    id
  }
}
    `;

/**
 * __useCreateOfferCategoryMutation__
 *
 * To run a mutation, you first call `useCreateOfferCategoryMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateOfferCategoryMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateOfferCategoryMutation({
 *   variables: {
 *     createOfferCategoryInput: // value for 'createOfferCategoryInput'
 *   },
 * });
 */
export function useCreateOfferCategoryMutation(options: VueApolloComposable.UseMutationOptions<CreateOfferCategoryMutation, CreateOfferCategoryMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateOfferCategoryMutation, CreateOfferCategoryMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateOfferCategoryMutation, CreateOfferCategoryMutationVariables>(CreateOfferCategoryDocument, options);
}
export type CreateOfferCategoryMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateOfferCategoryMutation, CreateOfferCategoryMutationVariables>;
export const CreatePdfDocument = gql`
    mutation CreatePdf($createPdf: CreatePdfInput!) {
  createPdf(createPdf: $createPdf) {
    id
    uploadUrl
  }
}
    `;

/**
 * __useCreatePdfMutation__
 *
 * To run a mutation, you first call `useCreatePdfMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreatePdfMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreatePdfMutation({
 *   variables: {
 *     createPdf: // value for 'createPdf'
 *   },
 * });
 */
export function useCreatePdfMutation(options: VueApolloComposable.UseMutationOptions<CreatePdfMutation, CreatePdfMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreatePdfMutation, CreatePdfMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreatePdfMutation, CreatePdfMutationVariables>(CreatePdfDocument, options);
}
export type CreatePdfMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreatePdfMutation, CreatePdfMutationVariables>;
export const CreateBrochureByParserDocument = gql`
    mutation CreateBrochureByParser($createBrochure: CreateBrochureByParserInput!) {
  createBrochureByParser(createBrochure: $createBrochure) {
    status
  }
}
    `;

/**
 * __useCreateBrochureByParserMutation__
 *
 * To run a mutation, you first call `useCreateBrochureByParserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateBrochureByParserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateBrochureByParserMutation({
 *   variables: {
 *     createBrochure: // value for 'createBrochure'
 *   },
 * });
 */
export function useCreateBrochureByParserMutation(options: VueApolloComposable.UseMutationOptions<CreateBrochureByParserMutation, CreateBrochureByParserMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateBrochureByParserMutation, CreateBrochureByParserMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateBrochureByParserMutation, CreateBrochureByParserMutationVariables>(CreateBrochureByParserDocument, options);
}
export type CreateBrochureByParserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateBrochureByParserMutation, CreateBrochureByParserMutationVariables>;
export const CreateRegionDocument = gql`
    mutation CreateRegion($input: CreateRegionInput!) {
  createRegion(createRegion: $input) {
    region {
      __typename
      id
      name
    }
    status
  }
}
    `;

/**
 * __useCreateRegionMutation__
 *
 * To run a mutation, you first call `useCreateRegionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateRegionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateRegionMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useCreateRegionMutation(options: VueApolloComposable.UseMutationOptions<CreateRegionMutation, CreateRegionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateRegionMutation, CreateRegionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateRegionMutation, CreateRegionMutationVariables>(CreateRegionDocument, options);
}
export type CreateRegionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateRegionMutation, CreateRegionMutationVariables>;
export const CreateShopDocument = gql`
    mutation CreateShop($createShopInput: CreateShopInput!) {
  createShop(createShop: $createShopInput) {
    shop {
      ...AdminShopDetail
    }
    status
  }
}
    ${AdminShopDetailFragmentDoc}`;

/**
 * __useCreateShopMutation__
 *
 * To run a mutation, you first call `useCreateShopMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateShopMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateShopMutation({
 *   variables: {
 *     createShopInput: // value for 'createShopInput'
 *   },
 * });
 */
export function useCreateShopMutation(options: VueApolloComposable.UseMutationOptions<CreateShopMutation, CreateShopMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateShopMutation, CreateShopMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateShopMutation, CreateShopMutationVariables>(CreateShopDocument, options);
}
export type CreateShopMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateShopMutation, CreateShopMutationVariables>;
export const CreateShopCardTemplateDocument = gql`
    mutation CreateShopCardTemplate($createShopCardTemplateInput: CreateShopCardTemplateInput!) {
  createShopCardTemplate(createShopCardTemplate: $createShopCardTemplateInput) {
    status
    shopCardTemplate {
      id
      name
      fileUrl(version: MEDIUM)
    }
  }
}
    `;

/**
 * __useCreateShopCardTemplateMutation__
 *
 * To run a mutation, you first call `useCreateShopCardTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateShopCardTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateShopCardTemplateMutation({
 *   variables: {
 *     createShopCardTemplateInput: // value for 'createShopCardTemplateInput'
 *   },
 * });
 */
export function useCreateShopCardTemplateMutation(options: VueApolloComposable.UseMutationOptions<CreateShopCardTemplateMutation, CreateShopCardTemplateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateShopCardTemplateMutation, CreateShopCardTemplateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateShopCardTemplateMutation, CreateShopCardTemplateMutationVariables>(CreateShopCardTemplateDocument, options);
}
export type CreateShopCardTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateShopCardTemplateMutation, CreateShopCardTemplateMutationVariables>;
export const CreateWebsitePageDocument = gql`
    mutation CreateWebsitePage($createWebsitePage: CreateWebsitePageInput!) {
  createWebsitePage(createWebsitePage: $createWebsitePage) {
    id
    content
    metaDescription
    metaTitle
    path
    title
  }
}
    `;

/**
 * __useCreateWebsitePageMutation__
 *
 * To run a mutation, you first call `useCreateWebsitePageMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateWebsitePageMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateWebsitePageMutation({
 *   variables: {
 *     createWebsitePage: // value for 'createWebsitePage'
 *   },
 * });
 */
export function useCreateWebsitePageMutation(options: VueApolloComposable.UseMutationOptions<CreateWebsitePageMutation, CreateWebsitePageMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateWebsitePageMutation, CreateWebsitePageMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateWebsitePageMutation, CreateWebsitePageMutationVariables>(CreateWebsitePageDocument, options);
}
export type CreateWebsitePageMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateWebsitePageMutation, CreateWebsitePageMutationVariables>;
export const CreateWebsitePostDocument = gql`
    mutation CreateWebsitePost($createWebsitePost: CreateWebsitePostInput!) {
  createWebsitePost(createWebsitePost: $createWebsitePost) {
    content
    metaDescription
    metaTitle
    path
    title
  }
}
    `;

/**
 * __useCreateWebsitePostMutation__
 *
 * To run a mutation, you first call `useCreateWebsitePostMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useCreateWebsitePostMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useCreateWebsitePostMutation({
 *   variables: {
 *     createWebsitePost: // value for 'createWebsitePost'
 *   },
 * });
 */
export function useCreateWebsitePostMutation(options: VueApolloComposable.UseMutationOptions<CreateWebsitePostMutation, CreateWebsitePostMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<CreateWebsitePostMutation, CreateWebsitePostMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<CreateWebsitePostMutation, CreateWebsitePostMutationVariables>(CreateWebsitePostDocument, options);
}
export type CreateWebsitePostMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<CreateWebsitePostMutation, CreateWebsitePostMutationVariables>;
export const DeleteBrandDocument = gql`
    mutation DeleteBrand($deleteBrand: DeleteBrandInput!) {
  deleteBrand(deleteBrand: $deleteBrand) {
    status
  }
}
    `;

/**
 * __useDeleteBrandMutation__
 *
 * To run a mutation, you first call `useDeleteBrandMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBrandMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteBrandMutation({
 *   variables: {
 *     deleteBrand: // value for 'deleteBrand'
 *   },
 * });
 */
export function useDeleteBrandMutation(options: VueApolloComposable.UseMutationOptions<DeleteBrandMutation, DeleteBrandMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteBrandMutation, DeleteBrandMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteBrandMutation, DeleteBrandMutationVariables>(DeleteBrandDocument, options);
}
export type DeleteBrandMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteBrandMutation, DeleteBrandMutationVariables>;
export const DeleteCityDocument = gql`
    mutation DeleteCity($deleteCity: DeleteCityInput!) {
  deleteCity(deleteCity: $deleteCity) {
    status
  }
}
    `;

/**
 * __useDeleteCityMutation__
 *
 * To run a mutation, you first call `useDeleteCityMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCityMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteCityMutation({
 *   variables: {
 *     deleteCity: // value for 'deleteCity'
 *   },
 * });
 */
export function useDeleteCityMutation(options: VueApolloComposable.UseMutationOptions<DeleteCityMutation, DeleteCityMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteCityMutation, DeleteCityMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteCityMutation, DeleteCityMutationVariables>(DeleteCityDocument, options);
}
export type DeleteCityMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteCityMutation, DeleteCityMutationVariables>;
export const DeleteGenericProductDocument = gql`
    mutation DeleteGenericProduct($id: ID!) {
  deleteGenericProduct(deleteGenericProduct: {id: $id}) {
    status
  }
}
    `;

/**
 * __useDeleteGenericProductMutation__
 *
 * To run a mutation, you first call `useDeleteGenericProductMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGenericProductMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteGenericProductMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteGenericProductMutation(options: VueApolloComposable.UseMutationOptions<DeleteGenericProductMutation, DeleteGenericProductMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteGenericProductMutation, DeleteGenericProductMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteGenericProductMutation, DeleteGenericProductMutationVariables>(DeleteGenericProductDocument, options);
}
export type DeleteGenericProductMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteGenericProductMutation, DeleteGenericProductMutationVariables>;
export const DeleteGenericProductCategoryDocument = gql`
    mutation DeleteGenericProductCategory($id: ID!) {
  deleteGenericProductCategory(deleteGenericProductCategory: {id: $id}) {
    status
  }
}
    `;

/**
 * __useDeleteGenericProductCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteGenericProductCategoryMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGenericProductCategoryMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteGenericProductCategoryMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteGenericProductCategoryMutation(options: VueApolloComposable.UseMutationOptions<DeleteGenericProductCategoryMutation, DeleteGenericProductCategoryMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteGenericProductCategoryMutation, DeleteGenericProductCategoryMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteGenericProductCategoryMutation, DeleteGenericProductCategoryMutationVariables>(DeleteGenericProductCategoryDocument, options);
}
export type DeleteGenericProductCategoryMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteGenericProductCategoryMutation, DeleteGenericProductCategoryMutationVariables>;
export const DeleteHotspotDocument = gql`
    mutation DeleteHotspot($deleteHotspotInput: DeleteHotspotInput!) {
  deleteHotspot(deleteHotspot: $deleteHotspotInput) {
    status
  }
}
    `;

/**
 * __useDeleteHotspotMutation__
 *
 * To run a mutation, you first call `useDeleteHotspotMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteHotspotMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteHotspotMutation({
 *   variables: {
 *     deleteHotspotInput: // value for 'deleteHotspotInput'
 *   },
 * });
 */
export function useDeleteHotspotMutation(options: VueApolloComposable.UseMutationOptions<DeleteHotspotMutation, DeleteHotspotMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteHotspotMutation, DeleteHotspotMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteHotspotMutation, DeleteHotspotMutationVariables>(DeleteHotspotDocument, options);
}
export type DeleteHotspotMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteHotspotMutation, DeleteHotspotMutationVariables>;
export const DeleteHotspotsDocument = gql`
    mutation DeleteHotspots($deleteHotspots: DeleteHotspotsInput!) {
  deleteHotspots(deleteHotspots: $deleteHotspots) {
    status
  }
}
    `;

/**
 * __useDeleteHotspotsMutation__
 *
 * To run a mutation, you first call `useDeleteHotspotsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteHotspotsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteHotspotsMutation({
 *   variables: {
 *     deleteHotspots: // value for 'deleteHotspots'
 *   },
 * });
 */
export function useDeleteHotspotsMutation(options: VueApolloComposable.UseMutationOptions<DeleteHotspotsMutation, DeleteHotspotsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteHotspotsMutation, DeleteHotspotsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteHotspotsMutation, DeleteHotspotsMutationVariables>(DeleteHotspotsDocument, options);
}
export type DeleteHotspotsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteHotspotsMutation, DeleteHotspotsMutationVariables>;
export const DeleteIdentityUserDocument = gql`
    mutation DeleteIdentityUser($id: ID!) {
  deleteIdentityUser(deleteIdentityUser: {id: $id}) {
    status
  }
}
    `;

/**
 * __useDeleteIdentityUserMutation__
 *
 * To run a mutation, you first call `useDeleteIdentityUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIdentityUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteIdentityUserMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteIdentityUserMutation(options: VueApolloComposable.UseMutationOptions<DeleteIdentityUserMutation, DeleteIdentityUserMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteIdentityUserMutation, DeleteIdentityUserMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteIdentityUserMutation, DeleteIdentityUserMutationVariables>(DeleteIdentityUserDocument, options);
}
export type DeleteIdentityUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteIdentityUserMutation, DeleteIdentityUserMutationVariables>;
export const DeleteLocationDocument = gql`
    mutation DeleteLocation($deleteLocation: DeleteLocationInput!) {
  deleteLocation(deleteLocation: $deleteLocation) {
    status
  }
}
    `;

/**
 * __useDeleteLocationMutation__
 *
 * To run a mutation, you first call `useDeleteLocationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLocationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteLocationMutation({
 *   variables: {
 *     deleteLocation: // value for 'deleteLocation'
 *   },
 * });
 */
export function useDeleteLocationMutation(options: VueApolloComposable.UseMutationOptions<DeleteLocationMutation, DeleteLocationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteLocationMutation, DeleteLocationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteLocationMutation, DeleteLocationMutationVariables>(DeleteLocationDocument, options);
}
export type DeleteLocationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteLocationMutation, DeleteLocationMutationVariables>;
export const DeleteLocationsDocument = gql`
    mutation DeleteLocations($deleteLocations: DeleteLocationsInput!) {
  deleteLocations(deleteLocations: $deleteLocations) {
    status
  }
}
    `;

/**
 * __useDeleteLocationsMutation__
 *
 * To run a mutation, you first call `useDeleteLocationsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLocationsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteLocationsMutation({
 *   variables: {
 *     deleteLocations: // value for 'deleteLocations'
 *   },
 * });
 */
export function useDeleteLocationsMutation(options: VueApolloComposable.UseMutationOptions<DeleteLocationsMutation, DeleteLocationsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteLocationsMutation, DeleteLocationsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteLocationsMutation, DeleteLocationsMutationVariables>(DeleteLocationsDocument, options);
}
export type DeleteLocationsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteLocationsMutation, DeleteLocationsMutationVariables>;
export const DeleteNewsletterSubscriberDocument = gql`
    mutation DeleteNewsletterSubscriber($id: ID!) {
  deleteNewsletterSubscriber(deleteNewsletterSubscriber: {id: $id}) {
    status
  }
}
    `;

/**
 * __useDeleteNewsletterSubscriberMutation__
 *
 * To run a mutation, you first call `useDeleteNewsletterSubscriberMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNewsletterSubscriberMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteNewsletterSubscriberMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useDeleteNewsletterSubscriberMutation(options: VueApolloComposable.UseMutationOptions<DeleteNewsletterSubscriberMutation, DeleteNewsletterSubscriberMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteNewsletterSubscriberMutation, DeleteNewsletterSubscriberMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteNewsletterSubscriberMutation, DeleteNewsletterSubscriberMutationVariables>(DeleteNewsletterSubscriberDocument, options);
}
export type DeleteNewsletterSubscriberMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteNewsletterSubscriberMutation, DeleteNewsletterSubscriberMutationVariables>;
export const DeleteOfferCategoryDocument = gql`
    mutation DeleteOfferCategory($deleteOfferCategory: DeleteOfferCategoryInput!) {
  deleteOfferCategory(deleteOfferCategory: $deleteOfferCategory) {
    status
  }
}
    `;

/**
 * __useDeleteOfferCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteOfferCategoryMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOfferCategoryMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteOfferCategoryMutation({
 *   variables: {
 *     deleteOfferCategory: // value for 'deleteOfferCategory'
 *   },
 * });
 */
export function useDeleteOfferCategoryMutation(options: VueApolloComposable.UseMutationOptions<DeleteOfferCategoryMutation, DeleteOfferCategoryMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteOfferCategoryMutation, DeleteOfferCategoryMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteOfferCategoryMutation, DeleteOfferCategoryMutationVariables>(DeleteOfferCategoryDocument, options);
}
export type DeleteOfferCategoryMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteOfferCategoryMutation, DeleteOfferCategoryMutationVariables>;
export const DeleteOfferCategoryTagDocument = gql`
    mutation DeleteOfferCategoryTag($input: DeleteOfferCategoryTagInput!) {
  deleteOfferCategoryTag(deleteOfferCategoryTag: $input) {
    status
  }
}
    `;

/**
 * __useDeleteOfferCategoryTagMutation__
 *
 * To run a mutation, you first call `useDeleteOfferCategoryTagMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOfferCategoryTagMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteOfferCategoryTagMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useDeleteOfferCategoryTagMutation(options: VueApolloComposable.UseMutationOptions<DeleteOfferCategoryTagMutation, DeleteOfferCategoryTagMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteOfferCategoryTagMutation, DeleteOfferCategoryTagMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteOfferCategoryTagMutation, DeleteOfferCategoryTagMutationVariables>(DeleteOfferCategoryTagDocument, options);
}
export type DeleteOfferCategoryTagMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteOfferCategoryTagMutation, DeleteOfferCategoryTagMutationVariables>;
export const DeletePageDocument = gql`
    mutation DeletePage($deletePage: DeletePageInput!) {
  deletePage(deletePage: $deletePage) {
    status
  }
}
    `;

/**
 * __useDeletePageMutation__
 *
 * To run a mutation, you first call `useDeletePageMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeletePageMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeletePageMutation({
 *   variables: {
 *     deletePage: // value for 'deletePage'
 *   },
 * });
 */
export function useDeletePageMutation(options: VueApolloComposable.UseMutationOptions<DeletePageMutation, DeletePageMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeletePageMutation, DeletePageMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeletePageMutation, DeletePageMutationVariables>(DeletePageDocument, options);
}
export type DeletePageMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeletePageMutation, DeletePageMutationVariables>;
export const DeleteProductPricesDocument = gql`
    mutation DeleteProductPrices($deleteProductPrices: DeleteProductPricesInput!) {
  deleteProductPrices(deleteProductPrices: $deleteProductPrices) {
    status
  }
}
    `;

/**
 * __useDeleteProductPricesMutation__
 *
 * To run a mutation, you first call `useDeleteProductPricesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProductPricesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteProductPricesMutation({
 *   variables: {
 *     deleteProductPrices: // value for 'deleteProductPrices'
 *   },
 * });
 */
export function useDeleteProductPricesMutation(options: VueApolloComposable.UseMutationOptions<DeleteProductPricesMutation, DeleteProductPricesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteProductPricesMutation, DeleteProductPricesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteProductPricesMutation, DeleteProductPricesMutationVariables>(DeleteProductPricesDocument, options);
}
export type DeleteProductPricesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteProductPricesMutation, DeleteProductPricesMutationVariables>;
export const DeleteRegionDocument = gql`
    mutation DeleteRegion($deleteRegion: DeleteRegionInput!) {
  deleteRegion(deleteRegion: $deleteRegion) {
    status
  }
}
    `;

/**
 * __useDeleteRegionMutation__
 *
 * To run a mutation, you first call `useDeleteRegionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRegionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteRegionMutation({
 *   variables: {
 *     deleteRegion: // value for 'deleteRegion'
 *   },
 * });
 */
export function useDeleteRegionMutation(options: VueApolloComposable.UseMutationOptions<DeleteRegionMutation, DeleteRegionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteRegionMutation, DeleteRegionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteRegionMutation, DeleteRegionMutationVariables>(DeleteRegionDocument, options);
}
export type DeleteRegionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteRegionMutation, DeleteRegionMutationVariables>;
export const DeleteRegionsDocument = gql`
    mutation DeleteRegions($deleteRegions: DeleteRegionsInput!) {
  deleteRegions(deleteRegions: $deleteRegions) {
    status
  }
}
    `;

/**
 * __useDeleteRegionsMutation__
 *
 * To run a mutation, you first call `useDeleteRegionsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRegionsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteRegionsMutation({
 *   variables: {
 *     deleteRegions: // value for 'deleteRegions'
 *   },
 * });
 */
export function useDeleteRegionsMutation(options: VueApolloComposable.UseMutationOptions<DeleteRegionsMutation, DeleteRegionsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteRegionsMutation, DeleteRegionsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteRegionsMutation, DeleteRegionsMutationVariables>(DeleteRegionsDocument, options);
}
export type DeleteRegionsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteRegionsMutation, DeleteRegionsMutationVariables>;
export const DeleteWebsitePageDocument = gql`
    mutation DeleteWebsitePage($deleteWebsitePage: DeleteWebsitePageInput!) {
  deleteWebsitePage(deleteWebsitePage: $deleteWebsitePage) {
    status
  }
}
    `;

/**
 * __useDeleteWebsitePageMutation__
 *
 * To run a mutation, you first call `useDeleteWebsitePageMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWebsitePageMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteWebsitePageMutation({
 *   variables: {
 *     deleteWebsitePage: // value for 'deleteWebsitePage'
 *   },
 * });
 */
export function useDeleteWebsitePageMutation(options: VueApolloComposable.UseMutationOptions<DeleteWebsitePageMutation, DeleteWebsitePageMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteWebsitePageMutation, DeleteWebsitePageMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteWebsitePageMutation, DeleteWebsitePageMutationVariables>(DeleteWebsitePageDocument, options);
}
export type DeleteWebsitePageMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteWebsitePageMutation, DeleteWebsitePageMutationVariables>;
export const DetectProductHotspotsDocument = gql`
    mutation DetectProductHotspots($detectProductHotspotsInput: DetectProductHotspotsInput!) {
  detectProductHotspots(detectProductHotspots: $detectProductHotspotsInput) {
    status
  }
}
    `;

/**
 * __useDetectProductHotspotsMutation__
 *
 * To run a mutation, you first call `useDetectProductHotspotsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDetectProductHotspotsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDetectProductHotspotsMutation({
 *   variables: {
 *     detectProductHotspotsInput: // value for 'detectProductHotspotsInput'
 *   },
 * });
 */
export function useDetectProductHotspotsMutation(options: VueApolloComposable.UseMutationOptions<DetectProductHotspotsMutation, DetectProductHotspotsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DetectProductHotspotsMutation, DetectProductHotspotsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DetectProductHotspotsMutation, DetectProductHotspotsMutationVariables>(DetectProductHotspotsDocument, options);
}
export type DetectProductHotspotsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DetectProductHotspotsMutation, DetectProductHotspotsMutationVariables>;
export const DeleteAdsAdvertisementDocument = gql`
    mutation DeleteAdsAdvertisement($deleteAdsCampaignAdvertisement: DeleteAdsCampaignAdvertisementInput!) {
  deleteAdsCampaignAdvertisement(
    deleteAdsCampaignAdvertisement: $deleteAdsCampaignAdvertisement
  ) {
    status
  }
}
    `;

/**
 * __useDeleteAdsAdvertisementMutation__
 *
 * To run a mutation, you first call `useDeleteAdsAdvertisementMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAdsAdvertisementMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useDeleteAdsAdvertisementMutation({
 *   variables: {
 *     deleteAdsCampaignAdvertisement: // value for 'deleteAdsCampaignAdvertisement'
 *   },
 * });
 */
export function useDeleteAdsAdvertisementMutation(options: VueApolloComposable.UseMutationOptions<DeleteAdsAdvertisementMutation, DeleteAdsAdvertisementMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<DeleteAdsAdvertisementMutation, DeleteAdsAdvertisementMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<DeleteAdsAdvertisementMutation, DeleteAdsAdvertisementMutationVariables>(DeleteAdsAdvertisementDocument, options);
}
export type DeleteAdsAdvertisementMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<DeleteAdsAdvertisementMutation, DeleteAdsAdvertisementMutationVariables>;
export const ShopsLocationsCvsLinkDocument = gql`
    mutation ShopsLocationsCVSLink($input: ExportLocationsInput!) {
  exportLocations(exportLocations: $input) {
    fileUrl
  }
}
    `;

/**
 * __useShopsLocationsCvsLinkMutation__
 *
 * To run a mutation, you first call `useShopsLocationsCvsLinkMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useShopsLocationsCvsLinkMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useShopsLocationsCvsLinkMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useShopsLocationsCvsLinkMutation(options: VueApolloComposable.UseMutationOptions<ShopsLocationsCvsLinkMutation, ShopsLocationsCvsLinkMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ShopsLocationsCvsLinkMutation, ShopsLocationsCvsLinkMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ShopsLocationsCvsLinkMutation, ShopsLocationsCvsLinkMutationVariables>(ShopsLocationsCvsLinkDocument, options);
}
export type ShopsLocationsCvsLinkMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ShopsLocationsCvsLinkMutation, ShopsLocationsCvsLinkMutationVariables>;
export const ExportToPdfDocument = gql`
    mutation ExportToPdf($exportToPdfInput: ExportToPdfInput!) {
  exportToPdf(exportToPdf: $exportToPdfInput) {
    status
  }
}
    `;

/**
 * __useExportToPdfMutation__
 *
 * To run a mutation, you first call `useExportToPdfMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useExportToPdfMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useExportToPdfMutation({
 *   variables: {
 *     exportToPdfInput: // value for 'exportToPdfInput'
 *   },
 * });
 */
export function useExportToPdfMutation(options: VueApolloComposable.UseMutationOptions<ExportToPdfMutation, ExportToPdfMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ExportToPdfMutation, ExportToPdfMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ExportToPdfMutation, ExportToPdfMutationVariables>(ExportToPdfDocument, options);
}
export type ExportToPdfMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ExportToPdfMutation, ExportToPdfMutationVariables>;
export const ImportLocationsDocument = gql`
    mutation ImportLocations($input: ImportLocationsInput!) {
  importLocations(importLocations: $input) {
    locationCount
    status
  }
}
    `;

/**
 * __useImportLocationsMutation__
 *
 * To run a mutation, you first call `useImportLocationsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useImportLocationsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useImportLocationsMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useImportLocationsMutation(options: VueApolloComposable.UseMutationOptions<ImportLocationsMutation, ImportLocationsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ImportLocationsMutation, ImportLocationsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ImportLocationsMutation, ImportLocationsMutationVariables>(ImportLocationsDocument, options);
}
export type ImportLocationsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ImportLocationsMutation, ImportLocationsMutationVariables>;
export const MigrateBrochureRegionMyshopiDocument = gql`
    mutation MigrateBrochureRegionMyshopi($input: MigrateBrochureRegionMyshopiInput!) {
  migrateBrochureRegionMyshopi(migrateBrochureRegionMyshopi: $input) {
    status
  }
}
    `;

/**
 * __useMigrateBrochureRegionMyshopiMutation__
 *
 * To run a mutation, you first call `useMigrateBrochureRegionMyshopiMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useMigrateBrochureRegionMyshopiMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useMigrateBrochureRegionMyshopiMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useMigrateBrochureRegionMyshopiMutation(options: VueApolloComposable.UseMutationOptions<MigrateBrochureRegionMyshopiMutation, MigrateBrochureRegionMyshopiMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<MigrateBrochureRegionMyshopiMutation, MigrateBrochureRegionMyshopiMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<MigrateBrochureRegionMyshopiMutation, MigrateBrochureRegionMyshopiMutationVariables>(MigrateBrochureRegionMyshopiDocument, options);
}
export type MigrateBrochureRegionMyshopiMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<MigrateBrochureRegionMyshopiMutation, MigrateBrochureRegionMyshopiMutationVariables>;
export const PublishMergeRequestDocument = gql`
    mutation PublishMergeRequest($mergeRequestId: ID!) {
  publishMergeRequest(publishMergeRequest: {mergeRequestId: $mergeRequestId}) {
    status
  }
}
    `;

/**
 * __usePublishMergeRequestMutation__
 *
 * To run a mutation, you first call `usePublishMergeRequestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `usePublishMergeRequestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = usePublishMergeRequestMutation({
 *   variables: {
 *     mergeRequestId: // value for 'mergeRequestId'
 *   },
 * });
 */
export function usePublishMergeRequestMutation(options: VueApolloComposable.UseMutationOptions<PublishMergeRequestMutation, PublishMergeRequestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<PublishMergeRequestMutation, PublishMergeRequestMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<PublishMergeRequestMutation, PublishMergeRequestMutationVariables>(PublishMergeRequestDocument, options);
}
export type PublishMergeRequestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<PublishMergeRequestMutation, PublishMergeRequestMutationVariables>;
export const RejectMergeRequestDocument = gql`
    mutation RejectMergeRequest($mergeRequestId: ID!) {
  rejectMergeRequest(rejectMergeRequest: {mergeRequestId: $mergeRequestId}) {
    status
  }
}
    `;

/**
 * __useRejectMergeRequestMutation__
 *
 * To run a mutation, you first call `useRejectMergeRequestMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useRejectMergeRequestMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useRejectMergeRequestMutation({
 *   variables: {
 *     mergeRequestId: // value for 'mergeRequestId'
 *   },
 * });
 */
export function useRejectMergeRequestMutation(options: VueApolloComposable.UseMutationOptions<RejectMergeRequestMutation, RejectMergeRequestMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<RejectMergeRequestMutation, RejectMergeRequestMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<RejectMergeRequestMutation, RejectMergeRequestMutationVariables>(RejectMergeRequestDocument, options);
}
export type RejectMergeRequestMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<RejectMergeRequestMutation, RejectMergeRequestMutationVariables>;
export const ResetPasswordIdentityUserDocument = gql`
    mutation ResetPasswordIdentityUser($resetPasswordIdentityUser: ResetPasswordIdentityUserInput!) {
  resetPasswordIdentityUser(resetPasswordIdentityUser: $resetPasswordIdentityUser) {
    status
  }
}
    `;

/**
 * __useResetPasswordIdentityUserMutation__
 *
 * To run a mutation, you first call `useResetPasswordIdentityUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordIdentityUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useResetPasswordIdentityUserMutation({
 *   variables: {
 *     resetPasswordIdentityUser: // value for 'resetPasswordIdentityUser'
 *   },
 * });
 */
export function useResetPasswordIdentityUserMutation(options: VueApolloComposable.UseMutationOptions<ResetPasswordIdentityUserMutation, ResetPasswordIdentityUserMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<ResetPasswordIdentityUserMutation, ResetPasswordIdentityUserMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<ResetPasswordIdentityUserMutation, ResetPasswordIdentityUserMutationVariables>(ResetPasswordIdentityUserDocument, options);
}
export type ResetPasswordIdentityUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<ResetPasswordIdentityUserMutation, ResetPasswordIdentityUserMutationVariables>;
export const SetPasswordIdentityUserDocument = gql`
    mutation SetPasswordIdentityUser($setPasswordIdentityUser: SetPasswordIdentityUserInput!) {
  setPasswordIdentityUser(setPasswordIdentityUser: $setPasswordIdentityUser) {
    status
  }
}
    `;

/**
 * __useSetPasswordIdentityUserMutation__
 *
 * To run a mutation, you first call `useSetPasswordIdentityUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSetPasswordIdentityUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSetPasswordIdentityUserMutation({
 *   variables: {
 *     setPasswordIdentityUser: // value for 'setPasswordIdentityUser'
 *   },
 * });
 */
export function useSetPasswordIdentityUserMutation(options: VueApolloComposable.UseMutationOptions<SetPasswordIdentityUserMutation, SetPasswordIdentityUserMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SetPasswordIdentityUserMutation, SetPasswordIdentityUserMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SetPasswordIdentityUserMutation, SetPasswordIdentityUserMutationVariables>(SetPasswordIdentityUserDocument, options);
}
export type SetPasswordIdentityUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SetPasswordIdentityUserMutation, SetPasswordIdentityUserMutationVariables>;
export const SortGenericTreeItemsDocument = gql`
    mutation SortGenericTreeItems($input: SortGenericTreeItemsInput!) {
  sortGenericTreeItems(sortGenericTreeItems: $input)
}
    `;

/**
 * __useSortGenericTreeItemsMutation__
 *
 * To run a mutation, you first call `useSortGenericTreeItemsMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSortGenericTreeItemsMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSortGenericTreeItemsMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSortGenericTreeItemsMutation(options: VueApolloComposable.UseMutationOptions<SortGenericTreeItemsMutation, SortGenericTreeItemsMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SortGenericTreeItemsMutation, SortGenericTreeItemsMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SortGenericTreeItemsMutation, SortGenericTreeItemsMutationVariables>(SortGenericTreeItemsDocument, options);
}
export type SortGenericTreeItemsMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SortGenericTreeItemsMutation, SortGenericTreeItemsMutationVariables>;
export const UnsubscribeIdentityUserFromNewslettersDocument = gql`
    mutation UnsubscribeIdentityUserFromNewsletters($id: ID!) {
  unsubscribeIdentityUserFromNewsletters(
    unsubscribeIdentityUserFromNewsletters: {id: $id}
  ) {
    status
  }
}
    `;

/**
 * __useUnsubscribeIdentityUserFromNewslettersMutation__
 *
 * To run a mutation, you first call `useUnsubscribeIdentityUserFromNewslettersMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUnsubscribeIdentityUserFromNewslettersMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUnsubscribeIdentityUserFromNewslettersMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useUnsubscribeIdentityUserFromNewslettersMutation(options: VueApolloComposable.UseMutationOptions<UnsubscribeIdentityUserFromNewslettersMutation, UnsubscribeIdentityUserFromNewslettersMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UnsubscribeIdentityUserFromNewslettersMutation, UnsubscribeIdentityUserFromNewslettersMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UnsubscribeIdentityUserFromNewslettersMutation, UnsubscribeIdentityUserFromNewslettersMutationVariables>(UnsubscribeIdentityUserFromNewslettersDocument, options);
}
export type UnsubscribeIdentityUserFromNewslettersMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UnsubscribeIdentityUserFromNewslettersMutation, UnsubscribeIdentityUserFromNewslettersMutationVariables>;
export const UnsubscribeNewsletterSubscriberFromNewslettersDocument = gql`
    mutation UnsubscribeNewsletterSubscriberFromNewsletters($id: ID!) {
  unsubscribeNewsletterSubscriberFromNewsletters(
    unsubscribeNewsletterSubscriberFromNewsletters: {id: $id}
  ) {
    status
  }
}
    `;

/**
 * __useUnsubscribeNewsletterSubscriberFromNewslettersMutation__
 *
 * To run a mutation, you first call `useUnsubscribeNewsletterSubscriberFromNewslettersMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUnsubscribeNewsletterSubscriberFromNewslettersMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUnsubscribeNewsletterSubscriberFromNewslettersMutation({
 *   variables: {
 *     id: // value for 'id'
 *   },
 * });
 */
export function useUnsubscribeNewsletterSubscriberFromNewslettersMutation(options: VueApolloComposable.UseMutationOptions<UnsubscribeNewsletterSubscriberFromNewslettersMutation, UnsubscribeNewsletterSubscriberFromNewslettersMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UnsubscribeNewsletterSubscriberFromNewslettersMutation, UnsubscribeNewsletterSubscriberFromNewslettersMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UnsubscribeNewsletterSubscriberFromNewslettersMutation, UnsubscribeNewsletterSubscriberFromNewslettersMutationVariables>(UnsubscribeNewsletterSubscriberFromNewslettersDocument, options);
}
export type UnsubscribeNewsletterSubscriberFromNewslettersMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UnsubscribeNewsletterSubscriberFromNewslettersMutation, UnsubscribeNewsletterSubscriberFromNewslettersMutationVariables>;
export const UpdateAdsCampaignDocument = gql`
    mutation UpdateAdsCampaign($updateAdsCampaignInput: UpdateAdsCampaignInput!) {
  updateAdsCampaign(updateAdsCampaign: $updateAdsCampaignInput) {
    status
  }
}
    `;

/**
 * __useUpdateAdsCampaignMutation__
 *
 * To run a mutation, you first call `useUpdateAdsCampaignMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdsCampaignMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateAdsCampaignMutation({
 *   variables: {
 *     updateAdsCampaignInput: // value for 'updateAdsCampaignInput'
 *   },
 * });
 */
export function useUpdateAdsCampaignMutation(options: VueApolloComposable.UseMutationOptions<UpdateAdsCampaignMutation, UpdateAdsCampaignMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateAdsCampaignMutation, UpdateAdsCampaignMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateAdsCampaignMutation, UpdateAdsCampaignMutationVariables>(UpdateAdsCampaignDocument, options);
}
export type UpdateAdsCampaignMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateAdsCampaignMutation, UpdateAdsCampaignMutationVariables>;
export const UpdateAppDocument = gql`
    mutation UpdateApp($updateApp: UpdateAppInput!) {
  updateApp(updateApp: $updateApp) {
    id
    geminiTaggingPrompt
    taggingStrategy
  }
}
    `;

/**
 * __useUpdateAppMutation__
 *
 * To run a mutation, you first call `useUpdateAppMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAppMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateAppMutation({
 *   variables: {
 *     updateApp: // value for 'updateApp'
 *   },
 * });
 */
export function useUpdateAppMutation(options: VueApolloComposable.UseMutationOptions<UpdateAppMutation, UpdateAppMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateAppMutation, UpdateAppMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateAppMutation, UpdateAppMutationVariables>(UpdateAppDocument, options);
}
export type UpdateAppMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateAppMutation, UpdateAppMutationVariables>;
export const UpdateAppLanguageDocument = gql`
    mutation UpdateAppLanguage($updateAppLanguage: UpdateAppLanguageInput!) {
  updateAppLanguage(updateAppLanguage: $updateAppLanguage) {
    ...AppLanguageDetail
  }
}
    ${AppLanguageDetailFragmentDoc}`;

/**
 * __useUpdateAppLanguageMutation__
 *
 * To run a mutation, you first call `useUpdateAppLanguageMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAppLanguageMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateAppLanguageMutation({
 *   variables: {
 *     updateAppLanguage: // value for 'updateAppLanguage'
 *   },
 * });
 */
export function useUpdateAppLanguageMutation(options: VueApolloComposable.UseMutationOptions<UpdateAppLanguageMutation, UpdateAppLanguageMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateAppLanguageMutation, UpdateAppLanguageMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateAppLanguageMutation, UpdateAppLanguageMutationVariables>(UpdateAppLanguageDocument, options);
}
export type UpdateAppLanguageMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateAppLanguageMutation, UpdateAppLanguageMutationVariables>;
export const UpdateBrandDocument = gql`
    mutation UpdateBrand($updateBrandInput: UpdateBrandInput!) {
  updateBrand(updateBrand: $updateBrandInput) {
    id
    name
    fileUrl(version: SMALL)
    description
    position
    slug
    status
    brandTags {
      id
      name
    }
  }
}
    `;

/**
 * __useUpdateBrandMutation__
 *
 * To run a mutation, you first call `useUpdateBrandMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBrandMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateBrandMutation({
 *   variables: {
 *     updateBrandInput: // value for 'updateBrandInput'
 *   },
 * });
 */
export function useUpdateBrandMutation(options: VueApolloComposable.UseMutationOptions<UpdateBrandMutation, UpdateBrandMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateBrandMutation, UpdateBrandMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateBrandMutation, UpdateBrandMutationVariables>(UpdateBrandDocument, options);
}
export type UpdateBrandMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateBrandMutation, UpdateBrandMutationVariables>;
export const UpdateBrochureDocument = gql`
    mutation UpdateBrochure($updateBrochureInput: UpdateBrochureInput!) {
  updateBrochure(updateBrochure: $updateBrochureInput) {
    status
  }
}
    `;

/**
 * __useUpdateBrochureMutation__
 *
 * To run a mutation, you first call `useUpdateBrochureMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBrochureMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateBrochureMutation({
 *   variables: {
 *     updateBrochureInput: // value for 'updateBrochureInput'
 *   },
 * });
 */
export function useUpdateBrochureMutation(options: VueApolloComposable.UseMutationOptions<UpdateBrochureMutation, UpdateBrochureMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateBrochureMutation, UpdateBrochureMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateBrochureMutation, UpdateBrochureMutationVariables>(UpdateBrochureDocument, options);
}
export type UpdateBrochureMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateBrochureMutation, UpdateBrochureMutationVariables>;
export const UpdateBrochureAssigneeDocument = gql`
    mutation UpdateBrochureAssignee($updateBrochureAssigneeInput: UpdateBrochureAssigneeInput!) {
  updateBrochureAssignee(updateBrochureAssignee: $updateBrochureAssigneeInput) {
    brochure {
      assignee {
        id
        firstName
        fileUrl(version: SMALL)
      }
    }
    status
  }
}
    `;

/**
 * __useUpdateBrochureAssigneeMutation__
 *
 * To run a mutation, you first call `useUpdateBrochureAssigneeMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBrochureAssigneeMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateBrochureAssigneeMutation({
 *   variables: {
 *     updateBrochureAssigneeInput: // value for 'updateBrochureAssigneeInput'
 *   },
 * });
 */
export function useUpdateBrochureAssigneeMutation(options: VueApolloComposable.UseMutationOptions<UpdateBrochureAssigneeMutation, UpdateBrochureAssigneeMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateBrochureAssigneeMutation, UpdateBrochureAssigneeMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateBrochureAssigneeMutation, UpdateBrochureAssigneeMutationVariables>(UpdateBrochureAssigneeDocument, options);
}
export type UpdateBrochureAssigneeMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateBrochureAssigneeMutation, UpdateBrochureAssigneeMutationVariables>;
export const UpdateBrochurePositionDocument = gql`
    mutation UpdateBrochurePosition($input: UpdateBrochurePositionInput!) {
  updateBrochurePosition(updateBrochurePosition: $input) {
    brochure {
      id
      position
      positionFrozenTo
    }
    status
  }
}
    `;

/**
 * __useUpdateBrochurePositionMutation__
 *
 * To run a mutation, you first call `useUpdateBrochurePositionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBrochurePositionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateBrochurePositionMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBrochurePositionMutation(options: VueApolloComposable.UseMutationOptions<UpdateBrochurePositionMutation, UpdateBrochurePositionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateBrochurePositionMutation, UpdateBrochurePositionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateBrochurePositionMutation, UpdateBrochurePositionMutationVariables>(UpdateBrochurePositionDocument, options);
}
export type UpdateBrochurePositionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateBrochurePositionMutation, UpdateBrochurePositionMutationVariables>;
export const UpdateBrochureStateDocument = gql`
    mutation UpdateBrochureState($updateBrochureStateInput: UpdateBrochureStateInput!) {
  updateBrochureState(updateBrochureState: $updateBrochureStateInput) {
    status
  }
}
    `;

/**
 * __useUpdateBrochureStateMutation__
 *
 * To run a mutation, you first call `useUpdateBrochureStateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBrochureStateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateBrochureStateMutation({
 *   variables: {
 *     updateBrochureStateInput: // value for 'updateBrochureStateInput'
 *   },
 * });
 */
export function useUpdateBrochureStateMutation(options: VueApolloComposable.UseMutationOptions<UpdateBrochureStateMutation, UpdateBrochureStateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateBrochureStateMutation, UpdateBrochureStateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateBrochureStateMutation, UpdateBrochureStateMutationVariables>(UpdateBrochureStateDocument, options);
}
export type UpdateBrochureStateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateBrochureStateMutation, UpdateBrochureStateMutationVariables>;
export const UpdateAdsCampaignAdvertisementHtmlEmbedDocument = gql`
    mutation UpdateAdsCampaignAdvertisementHtmlEmbed($updateAdsCampaignAdvertisementHtmlEmbedInput: UpdateAdsCampaignAdvertisementHtmlEmbedInput!) {
  updateAdsCampaignAdvertisementHtmlEmbed(
    updateAdsCampaignAdvertisementHtmlEmbed: $updateAdsCampaignAdvertisementHtmlEmbedInput
  ) {
    status
  }
}
    `;

/**
 * __useUpdateAdsCampaignAdvertisementHtmlEmbedMutation__
 *
 * To run a mutation, you first call `useUpdateAdsCampaignAdvertisementHtmlEmbedMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdsCampaignAdvertisementHtmlEmbedMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateAdsCampaignAdvertisementHtmlEmbedMutation({
 *   variables: {
 *     updateAdsCampaignAdvertisementHtmlEmbedInput: // value for 'updateAdsCampaignAdvertisementHtmlEmbedInput'
 *   },
 * });
 */
export function useUpdateAdsCampaignAdvertisementHtmlEmbedMutation(options: VueApolloComposable.UseMutationOptions<UpdateAdsCampaignAdvertisementHtmlEmbedMutation, UpdateAdsCampaignAdvertisementHtmlEmbedMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateAdsCampaignAdvertisementHtmlEmbedMutation, UpdateAdsCampaignAdvertisementHtmlEmbedMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateAdsCampaignAdvertisementHtmlEmbedMutation, UpdateAdsCampaignAdvertisementHtmlEmbedMutationVariables>(UpdateAdsCampaignAdvertisementHtmlEmbedDocument, options);
}
export type UpdateAdsCampaignAdvertisementHtmlEmbedMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateAdsCampaignAdvertisementHtmlEmbedMutation, UpdateAdsCampaignAdvertisementHtmlEmbedMutationVariables>;
export const UpdateAdsCampaignAdvertisementImageAdDocument = gql`
    mutation UpdateAdsCampaignAdvertisementImageAd($updateAdsCampaignAdvertisementImageAdInput: UpdateAdsCampaignAdvertisementImageAdInput!) {
  updateAdsCampaignAdvertisementImageAd(
    updateAdsCampaignAdvertisementImageAd: $updateAdsCampaignAdvertisementImageAdInput
  ) {
    status
  }
}
    `;

/**
 * __useUpdateAdsCampaignAdvertisementImageAdMutation__
 *
 * To run a mutation, you first call `useUpdateAdsCampaignAdvertisementImageAdMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAdsCampaignAdvertisementImageAdMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateAdsCampaignAdvertisementImageAdMutation({
 *   variables: {
 *     updateAdsCampaignAdvertisementImageAdInput: // value for 'updateAdsCampaignAdvertisementImageAdInput'
 *   },
 * });
 */
export function useUpdateAdsCampaignAdvertisementImageAdMutation(options: VueApolloComposable.UseMutationOptions<UpdateAdsCampaignAdvertisementImageAdMutation, UpdateAdsCampaignAdvertisementImageAdMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateAdsCampaignAdvertisementImageAdMutation, UpdateAdsCampaignAdvertisementImageAdMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateAdsCampaignAdvertisementImageAdMutation, UpdateAdsCampaignAdvertisementImageAdMutationVariables>(UpdateAdsCampaignAdvertisementImageAdDocument, options);
}
export type UpdateAdsCampaignAdvertisementImageAdMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateAdsCampaignAdvertisementImageAdMutation, UpdateAdsCampaignAdvertisementImageAdMutationVariables>;
export const UpdateCategoryDocument = gql`
    mutation UpdateCategory($updateCategoryInput: UpdateCategoryInput!) {
  updateCategory(updateCategory: $updateCategoryInput) {
    ...CategoryDetail
  }
}
    ${CategoryDetailFragmentDoc}`;

/**
 * __useUpdateCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateCategoryMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCategoryMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateCategoryMutation({
 *   variables: {
 *     updateCategoryInput: // value for 'updateCategoryInput'
 *   },
 * });
 */
export function useUpdateCategoryMutation(options: VueApolloComposable.UseMutationOptions<UpdateCategoryMutation, UpdateCategoryMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateCategoryMutation, UpdateCategoryMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateCategoryMutation, UpdateCategoryMutationVariables>(UpdateCategoryDocument, options);
}
export type UpdateCategoryMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateCategoryMutation, UpdateCategoryMutationVariables>;
export const UpdateCityDocument = gql`
    mutation UpdateCity($updateCityInput: UpdateCityInput!) {
  updateCity(updateCity: $updateCityInput) {
    id
  }
}
    `;

/**
 * __useUpdateCityMutation__
 *
 * To run a mutation, you first call `useUpdateCityMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCityMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateCityMutation({
 *   variables: {
 *     updateCityInput: // value for 'updateCityInput'
 *   },
 * });
 */
export function useUpdateCityMutation(options: VueApolloComposable.UseMutationOptions<UpdateCityMutation, UpdateCityMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateCityMutation, UpdateCityMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateCityMutation, UpdateCityMutationVariables>(UpdateCityDocument, options);
}
export type UpdateCityMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateCityMutation, UpdateCityMutationVariables>;
export const UpdateCurrentUserDocument = gql`
    mutation UpdateCurrentUser($updateCurrentUser: UpdateCurrentUserInput!) {
  updateCurrentUser(updateCurrentUser: $updateCurrentUser) {
    currentUser {
      id
    }
  }
}
    `;

/**
 * __useUpdateCurrentUserMutation__
 *
 * To run a mutation, you first call `useUpdateCurrentUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCurrentUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateCurrentUserMutation({
 *   variables: {
 *     updateCurrentUser: // value for 'updateCurrentUser'
 *   },
 * });
 */
export function useUpdateCurrentUserMutation(options: VueApolloComposable.UseMutationOptions<UpdateCurrentUserMutation, UpdateCurrentUserMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateCurrentUserMutation, UpdateCurrentUserMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateCurrentUserMutation, UpdateCurrentUserMutationVariables>(UpdateCurrentUserDocument, options);
}
export type UpdateCurrentUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateCurrentUserMutation, UpdateCurrentUserMutationVariables>;
export const UpdateCustomerClientDocument = gql`
    mutation UpdateCustomerClient($updateCustomerClientInput: UpdateCustomerClientInput!) {
  updateCustomerClient(updateCustomerClient: $updateCustomerClientInput) {
    id
  }
}
    `;

/**
 * __useUpdateCustomerClientMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerClientMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerClientMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateCustomerClientMutation({
 *   variables: {
 *     updateCustomerClientInput: // value for 'updateCustomerClientInput'
 *   },
 * });
 */
export function useUpdateCustomerClientMutation(options: VueApolloComposable.UseMutationOptions<UpdateCustomerClientMutation, UpdateCustomerClientMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateCustomerClientMutation, UpdateCustomerClientMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateCustomerClientMutation, UpdateCustomerClientMutationVariables>(UpdateCustomerClientDocument, options);
}
export type UpdateCustomerClientMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateCustomerClientMutation, UpdateCustomerClientMutationVariables>;
export const UpdateGenericProductDocument = gql`
    mutation UpdateGenericProduct($input: UpdateGenericProductInput!) {
  updateGenericProduct(updateGenericProduct: $input) {
    ...GenericProductDetail
  }
}
    ${GenericProductDetailFragmentDoc}`;

/**
 * __useUpdateGenericProductMutation__
 *
 * To run a mutation, you first call `useUpdateGenericProductMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGenericProductMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateGenericProductMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGenericProductMutation(options: VueApolloComposable.UseMutationOptions<UpdateGenericProductMutation, UpdateGenericProductMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateGenericProductMutation, UpdateGenericProductMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateGenericProductMutation, UpdateGenericProductMutationVariables>(UpdateGenericProductDocument, options);
}
export type UpdateGenericProductMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateGenericProductMutation, UpdateGenericProductMutationVariables>;
export const UpdateGenericProductCategoryDocument = gql`
    mutation UpdateGenericProductCategory($input: UpdateGenericProductCategoryInput!) {
  updateGenericProductCategory(updateGenericProductCategory: $input) {
    ...GenericProductCategoryDetail
  }
}
    ${GenericProductCategoryDetailFragmentDoc}`;

/**
 * __useUpdateGenericProductCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateGenericProductCategoryMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGenericProductCategoryMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateGenericProductCategoryMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGenericProductCategoryMutation(options: VueApolloComposable.UseMutationOptions<UpdateGenericProductCategoryMutation, UpdateGenericProductCategoryMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateGenericProductCategoryMutation, UpdateGenericProductCategoryMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateGenericProductCategoryMutation, UpdateGenericProductCategoryMutationVariables>(UpdateGenericProductCategoryDocument, options);
}
export type UpdateGenericProductCategoryMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateGenericProductCategoryMutation, UpdateGenericProductCategoryMutationVariables>;
export const UpdateHotspotImageDocument = gql`
    mutation UpdateHotspotImage($updateHotspotInput: UpdateHotspotImageInput!) {
  updateHotspotImage(updateHotspot: $updateHotspotInput) {
    ...hotspotImage
  }
}
    ${HotspotImageFragmentDoc}`;

/**
 * __useUpdateHotspotImageMutation__
 *
 * To run a mutation, you first call `useUpdateHotspotImageMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHotspotImageMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateHotspotImageMutation({
 *   variables: {
 *     updateHotspotInput: // value for 'updateHotspotInput'
 *   },
 * });
 */
export function useUpdateHotspotImageMutation(options: VueApolloComposable.UseMutationOptions<UpdateHotspotImageMutation, UpdateHotspotImageMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateHotspotImageMutation, UpdateHotspotImageMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateHotspotImageMutation, UpdateHotspotImageMutationVariables>(UpdateHotspotImageDocument, options);
}
export type UpdateHotspotImageMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateHotspotImageMutation, UpdateHotspotImageMutationVariables>;
export const UpdateHotspotLinkDocument = gql`
    mutation UpdateHotspotLink($updateHotspotInput: UpdateHotspotLinkInput!) {
  updateHotspotLink(updateHotspot: $updateHotspotInput) {
    ...hotspotLink
  }
}
    ${HotspotLinkFragmentDoc}`;

/**
 * __useUpdateHotspotLinkMutation__
 *
 * To run a mutation, you first call `useUpdateHotspotLinkMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHotspotLinkMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateHotspotLinkMutation({
 *   variables: {
 *     updateHotspotInput: // value for 'updateHotspotInput'
 *   },
 * });
 */
export function useUpdateHotspotLinkMutation(options: VueApolloComposable.UseMutationOptions<UpdateHotspotLinkMutation, UpdateHotspotLinkMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateHotspotLinkMutation, UpdateHotspotLinkMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateHotspotLinkMutation, UpdateHotspotLinkMutationVariables>(UpdateHotspotLinkDocument, options);
}
export type UpdateHotspotLinkMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateHotspotLinkMutation, UpdateHotspotLinkMutationVariables>;
export const UpdateHotspotProductDocument = gql`
    mutation UpdateHotspotProduct($updateHotspotInput: UpdateHotspotProductInput!) {
  updateHotspotProduct(updateHotspot: $updateHotspotInput) {
    ...hotspotProduct
  }
}
    ${HotspotProductFragmentDoc}`;

/**
 * __useUpdateHotspotProductMutation__
 *
 * To run a mutation, you first call `useUpdateHotspotProductMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHotspotProductMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateHotspotProductMutation({
 *   variables: {
 *     updateHotspotInput: // value for 'updateHotspotInput'
 *   },
 * });
 */
export function useUpdateHotspotProductMutation(options: VueApolloComposable.UseMutationOptions<UpdateHotspotProductMutation, UpdateHotspotProductMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateHotspotProductMutation, UpdateHotspotProductMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateHotspotProductMutation, UpdateHotspotProductMutationVariables>(UpdateHotspotProductDocument, options);
}
export type UpdateHotspotProductMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateHotspotProductMutation, UpdateHotspotProductMutationVariables>;
export const UpdateIdentityUserDocument = gql`
    mutation UpdateIdentityUser($input: UpdateIdentityUserInput!) {
  updateIdentityUser(updateIdentityUser: $input) {
    identityUser {
      ...UserDetail
    }
  }
}
    ${UserDetailFragmentDoc}`;

/**
 * __useUpdateIdentityUserMutation__
 *
 * To run a mutation, you first call `useUpdateIdentityUserMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIdentityUserMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateIdentityUserMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateIdentityUserMutation(options: VueApolloComposable.UseMutationOptions<UpdateIdentityUserMutation, UpdateIdentityUserMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateIdentityUserMutation, UpdateIdentityUserMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateIdentityUserMutation, UpdateIdentityUserMutationVariables>(UpdateIdentityUserDocument, options);
}
export type UpdateIdentityUserMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateIdentityUserMutation, UpdateIdentityUserMutationVariables>;
export const UpdateOfferCategoryDocument = gql`
    mutation UpdateOfferCategory($updateOfferCategoryInput: UpdateOfferCategoryInput!) {
  updateOfferCategory(updateOfferCategory: $updateOfferCategoryInput) {
    id
  }
}
    `;

/**
 * __useUpdateOfferCategoryMutation__
 *
 * To run a mutation, you first call `useUpdateOfferCategoryMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOfferCategoryMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateOfferCategoryMutation({
 *   variables: {
 *     updateOfferCategoryInput: // value for 'updateOfferCategoryInput'
 *   },
 * });
 */
export function useUpdateOfferCategoryMutation(options: VueApolloComposable.UseMutationOptions<UpdateOfferCategoryMutation, UpdateOfferCategoryMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateOfferCategoryMutation, UpdateOfferCategoryMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateOfferCategoryMutation, UpdateOfferCategoryMutationVariables>(UpdateOfferCategoryDocument, options);
}
export type UpdateOfferCategoryMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateOfferCategoryMutation, UpdateOfferCategoryMutationVariables>;
export const UpdateRegionDocument = gql`
    mutation UpdateRegion($input: UpdateRegionInput!) {
  updateRegion(updateRegion: $input) {
    region {
      __typename
      id
      name
    }
    status
  }
}
    `;

/**
 * __useUpdateRegionMutation__
 *
 * To run a mutation, you first call `useUpdateRegionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRegionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateRegionMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRegionMutation(options: VueApolloComposable.UseMutationOptions<UpdateRegionMutation, UpdateRegionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateRegionMutation, UpdateRegionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateRegionMutation, UpdateRegionMutationVariables>(UpdateRegionDocument, options);
}
export type UpdateRegionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateRegionMutation, UpdateRegionMutationVariables>;
export const UpdateShopDocument = gql`
    mutation UpdateShop($updateShopInput: UpdateShopInput!) {
  updateShop(updateShop: $updateShopInput) {
    shop {
      ...AdminShopDetail
    }
    status
  }
}
    ${AdminShopDetailFragmentDoc}`;

/**
 * __useUpdateShopMutation__
 *
 * To run a mutation, you first call `useUpdateShopMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShopMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateShopMutation({
 *   variables: {
 *     updateShopInput: // value for 'updateShopInput'
 *   },
 * });
 */
export function useUpdateShopMutation(options: VueApolloComposable.UseMutationOptions<UpdateShopMutation, UpdateShopMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateShopMutation, UpdateShopMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateShopMutation, UpdateShopMutationVariables>(UpdateShopDocument, options);
}
export type UpdateShopMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateShopMutation, UpdateShopMutationVariables>;
export const UpdateShopCardTemplateDocument = gql`
    mutation UpdateShopCardTemplate($updateShopCardTemplateInput: UpdateShopCardTemplateInput!) {
  updateShopCardTemplate(updateShopCardTemplate: $updateShopCardTemplateInput) {
    status
    shopCardTemplate {
      ...ShopCardTemplateDetail
    }
  }
}
    ${ShopCardTemplateDetailFragmentDoc}`;

/**
 * __useUpdateShopCardTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateShopCardTemplateMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShopCardTemplateMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateShopCardTemplateMutation({
 *   variables: {
 *     updateShopCardTemplateInput: // value for 'updateShopCardTemplateInput'
 *   },
 * });
 */
export function useUpdateShopCardTemplateMutation(options: VueApolloComposable.UseMutationOptions<UpdateShopCardTemplateMutation, UpdateShopCardTemplateMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateShopCardTemplateMutation, UpdateShopCardTemplateMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateShopCardTemplateMutation, UpdateShopCardTemplateMutationVariables>(UpdateShopCardTemplateDocument, options);
}
export type UpdateShopCardTemplateMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateShopCardTemplateMutation, UpdateShopCardTemplateMutationVariables>;
export const UpdateWebsitePageDocument = gql`
    mutation UpdateWebsitePage($updateWebsitePage: UpdateWebsitePageInput!) {
  updateWebsitePage(updateWebsitePage: $updateWebsitePage) {
    id
    content
    metaDescription
    metaTitle
    path
    title
    translationSetId
    contentBlocks
    titleQuestionsAnswers
    contentQuestionsAnswers {
      question
      answer
    }
  }
}
    `;

/**
 * __useUpdateWebsitePageMutation__
 *
 * To run a mutation, you first call `useUpdateWebsitePageMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWebsitePageMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateWebsitePageMutation({
 *   variables: {
 *     updateWebsitePage: // value for 'updateWebsitePage'
 *   },
 * });
 */
export function useUpdateWebsitePageMutation(options: VueApolloComposable.UseMutationOptions<UpdateWebsitePageMutation, UpdateWebsitePageMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateWebsitePageMutation, UpdateWebsitePageMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateWebsitePageMutation, UpdateWebsitePageMutationVariables>(UpdateWebsitePageDocument, options);
}
export type UpdateWebsitePageMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateWebsitePageMutation, UpdateWebsitePageMutationVariables>;
export const UpdateWebsitePostDocument = gql`
    mutation UpdateWebsitePost($updateWebsitePost: UpdateWebsitePostInput!) {
  updateWebsitePost(updateWebsitePost: $updateWebsitePost) {
    content
    metaDescription
    metaTitle
    path
    title
    translationSetId
  }
}
    `;

/**
 * __useUpdateWebsitePostMutation__
 *
 * To run a mutation, you first call `useUpdateWebsitePostMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWebsitePostMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateWebsitePostMutation({
 *   variables: {
 *     updateWebsitePost: // value for 'updateWebsitePost'
 *   },
 * });
 */
export function useUpdateWebsitePostMutation(options: VueApolloComposable.UseMutationOptions<UpdateWebsitePostMutation, UpdateWebsitePostMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateWebsitePostMutation, UpdateWebsitePostMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateWebsitePostMutation, UpdateWebsitePostMutationVariables>(UpdateWebsitePostDocument, options);
}
export type UpdateWebsitePostMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateWebsitePostMutation, UpdateWebsitePostMutationVariables>;
export const UpsertBrochureCityPositionDocument = gql`
    mutation UpsertBrochureCityPosition($input: UpsertBrochureCityPositionInput!) {
  upsertBrochureCityPosition(upsertBrochureCityPosition: $input) {
    status
  }
}
    `;

/**
 * __useUpsertBrochureCityPositionMutation__
 *
 * To run a mutation, you first call `useUpsertBrochureCityPositionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpsertBrochureCityPositionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpsertBrochureCityPositionMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpsertBrochureCityPositionMutation(options: VueApolloComposable.UseMutationOptions<UpsertBrochureCityPositionMutation, UpsertBrochureCityPositionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpsertBrochureCityPositionMutation, UpsertBrochureCityPositionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpsertBrochureCityPositionMutation, UpsertBrochureCityPositionMutationVariables>(UpsertBrochureCityPositionDocument, options);
}
export type UpsertBrochureCityPositionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpsertBrochureCityPositionMutation, UpsertBrochureCityPositionMutationVariables>;
export const UpsertSessionDocument = gql`
    mutation UpsertSession {
  upsertSession {
    status
  }
}
    `;

/**
 * __useUpsertSessionMutation__
 *
 * To run a mutation, you first call `useUpsertSessionMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpsertSessionMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpsertSessionMutation();
 */
export function useUpsertSessionMutation(options: VueApolloComposable.UseMutationOptions<UpsertSessionMutation, UpsertSessionMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpsertSessionMutation, UpsertSessionMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpsertSessionMutation, UpsertSessionMutationVariables>(UpsertSessionDocument, options);
}
export type UpsertSessionMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpsertSessionMutation, UpsertSessionMutationVariables>;
export const UpdateLocationDocument = gql`
    mutation UpdateLocation($input: UpdateLocationInput!) {
  updateLocation(updateLocation: $input) {
    location {
      ...ShopLocation
    }
  }
}
    ${ShopLocationFragmentDoc}`;

/**
 * __useUpdateLocationMutation__
 *
 * To run a mutation, you first call `useUpdateLocationMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLocationMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateLocationMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useUpdateLocationMutation(options: VueApolloComposable.UseMutationOptions<UpdateLocationMutation, UpdateLocationMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateLocationMutation, UpdateLocationMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateLocationMutation, UpdateLocationMutationVariables>(UpdateLocationDocument, options);
}
export type UpdateLocationMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateLocationMutation, UpdateLocationMutationVariables>;
export const BrochureStateDocument = gql`
    query BrochureState($brochureInput: BrochureInput!) {
  brochure(brochure: $brochureInput) {
    id
    name
    assignee {
      id
      firstName
      lastName
      fileUrl(version: SMALL)
    }
    shop {
      id
      name
      customerClient {
        id
        features
      }
    }
    language {
      id
    }
    mergeRequestAsNew {
      id
      status
    }
    brochureExperiment {
      id
    }
    state
  }
}
    `;

/**
 * __useBrochureStateQuery__
 *
 * To run a query within a Vue component, call `useBrochureStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrochureStateQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useBrochureStateQuery({
 *   brochureInput: // value for 'brochureInput'
 * });
 */
export function useBrochureStateQuery(variables: BrochureStateQueryVariables | VueCompositionApi.Ref<BrochureStateQueryVariables> | ReactiveFunction<BrochureStateQueryVariables>, options: VueApolloComposable.UseQueryOptions<BrochureStateQuery, BrochureStateQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BrochureStateQuery, BrochureStateQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BrochureStateQuery, BrochureStateQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<BrochureStateQuery, BrochureStateQueryVariables>(BrochureStateDocument, variables, options);
}
export function useBrochureStateLazyQuery(variables?: BrochureStateQueryVariables | VueCompositionApi.Ref<BrochureStateQueryVariables> | ReactiveFunction<BrochureStateQueryVariables>, options: VueApolloComposable.UseQueryOptions<BrochureStateQuery, BrochureStateQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BrochureStateQuery, BrochureStateQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BrochureStateQuery, BrochureStateQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<BrochureStateQuery, BrochureStateQueryVariables>(BrochureStateDocument, variables, options);
}
export type BrochureStateQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<BrochureStateQuery, BrochureStateQueryVariables>;
export const BrochureAssigneesDocument = gql`
    query BrochureAssignees($pagination: PaginationInput) {
  brochureAssignees(pagination: $pagination) {
    pagination {
      currentPage
      totalPages
      nextPage
      previousPage
    }
    entries {
      id
      firstName
      lastName
      fileUrl(version: SMALL)
    }
  }
}
    `;

/**
 * __useBrochureAssigneesQuery__
 *
 * To run a query within a Vue component, call `useBrochureAssigneesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrochureAssigneesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useBrochureAssigneesQuery({
 *   pagination: // value for 'pagination'
 * });
 */
export function useBrochureAssigneesQuery(variables: BrochureAssigneesQueryVariables | VueCompositionApi.Ref<BrochureAssigneesQueryVariables> | ReactiveFunction<BrochureAssigneesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<BrochureAssigneesQuery, BrochureAssigneesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BrochureAssigneesQuery, BrochureAssigneesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BrochureAssigneesQuery, BrochureAssigneesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<BrochureAssigneesQuery, BrochureAssigneesQueryVariables>(BrochureAssigneesDocument, variables, options);
}
export function useBrochureAssigneesLazyQuery(variables: BrochureAssigneesQueryVariables | VueCompositionApi.Ref<BrochureAssigneesQueryVariables> | ReactiveFunction<BrochureAssigneesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<BrochureAssigneesQuery, BrochureAssigneesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BrochureAssigneesQuery, BrochureAssigneesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BrochureAssigneesQuery, BrochureAssigneesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<BrochureAssigneesQuery, BrochureAssigneesQueryVariables>(BrochureAssigneesDocument, variables, options);
}
export type BrochureAssigneesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<BrochureAssigneesQuery, BrochureAssigneesQueryVariables>;
export const BrochureDetailDocument = gql`
    query BrochureDetail($brochureInput: BrochureInput!) {
  brochure(brochure: $brochureInput) {
    id
    cover {
      fileUrl(version: SMALL)
    }
    name
    publishedAt
    activeFrom
    position
    positionFrozenTo
    expireAfter
    categories {
      id
      name
    }
    hotspotMode
    customerLevel
    toplevel {
      id
      name
    }
    afterpage {
      id
      name
    }
    utmCampaign
    utmMedium
    local
    language {
      id
      name
      symbol
    }
    shop {
      id
      slug
      name
    }
    removedProductsFromSearch
    state
  }
}
    `;

/**
 * __useBrochureDetailQuery__
 *
 * To run a query within a Vue component, call `useBrochureDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrochureDetailQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useBrochureDetailQuery({
 *   brochureInput: // value for 'brochureInput'
 * });
 */
export function useBrochureDetailQuery(variables: BrochureDetailQueryVariables | VueCompositionApi.Ref<BrochureDetailQueryVariables> | ReactiveFunction<BrochureDetailQueryVariables>, options: VueApolloComposable.UseQueryOptions<BrochureDetailQuery, BrochureDetailQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BrochureDetailQuery, BrochureDetailQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BrochureDetailQuery, BrochureDetailQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<BrochureDetailQuery, BrochureDetailQueryVariables>(BrochureDetailDocument, variables, options);
}
export function useBrochureDetailLazyQuery(variables?: BrochureDetailQueryVariables | VueCompositionApi.Ref<BrochureDetailQueryVariables> | ReactiveFunction<BrochureDetailQueryVariables>, options: VueApolloComposable.UseQueryOptions<BrochureDetailQuery, BrochureDetailQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BrochureDetailQuery, BrochureDetailQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BrochureDetailQuery, BrochureDetailQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<BrochureDetailQuery, BrochureDetailQueryVariables>(BrochureDetailDocument, variables, options);
}
export type BrochureDetailQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<BrochureDetailQuery, BrochureDetailQueryVariables>;
export const BrochureLanguageDocument = gql`
    query BrochureLanguage($brochureInput: BrochureInput!) {
  brochure(brochure: $brochureInput) {
    language {
      id
      name
    }
  }
}
    `;

/**
 * __useBrochureLanguageQuery__
 *
 * To run a query within a Vue component, call `useBrochureLanguageQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrochureLanguageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useBrochureLanguageQuery({
 *   brochureInput: // value for 'brochureInput'
 * });
 */
export function useBrochureLanguageQuery(variables: BrochureLanguageQueryVariables | VueCompositionApi.Ref<BrochureLanguageQueryVariables> | ReactiveFunction<BrochureLanguageQueryVariables>, options: VueApolloComposable.UseQueryOptions<BrochureLanguageQuery, BrochureLanguageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BrochureLanguageQuery, BrochureLanguageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BrochureLanguageQuery, BrochureLanguageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<BrochureLanguageQuery, BrochureLanguageQueryVariables>(BrochureLanguageDocument, variables, options);
}
export function useBrochureLanguageLazyQuery(variables?: BrochureLanguageQueryVariables | VueCompositionApi.Ref<BrochureLanguageQueryVariables> | ReactiveFunction<BrochureLanguageQueryVariables>, options: VueApolloComposable.UseQueryOptions<BrochureLanguageQuery, BrochureLanguageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BrochureLanguageQuery, BrochureLanguageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BrochureLanguageQuery, BrochureLanguageQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<BrochureLanguageQuery, BrochureLanguageQueryVariables>(BrochureLanguageDocument, variables, options);
}
export type BrochureLanguageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<BrochureLanguageQuery, BrochureLanguageQueryVariables>;
export const BrochurePageQueryDocument = gql`
    query BrochurePageQuery($pageInput: PageInput!, $fileVersion: BrochureStatisticsFileVersion!) {
  page(page: $pageInput) {
    fileUrl(version: $fileVersion)
    id
    index
  }
}
    `;

/**
 * __useBrochurePageQueryQuery__
 *
 * To run a query within a Vue component, call `useBrochurePageQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrochurePageQueryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useBrochurePageQueryQuery({
 *   pageInput: // value for 'pageInput'
 *   fileVersion: // value for 'fileVersion'
 * });
 */
export function useBrochurePageQueryQuery(variables: BrochurePageQueryQueryVariables | VueCompositionApi.Ref<BrochurePageQueryQueryVariables> | ReactiveFunction<BrochurePageQueryQueryVariables>, options: VueApolloComposable.UseQueryOptions<BrochurePageQueryQuery, BrochurePageQueryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BrochurePageQueryQuery, BrochurePageQueryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BrochurePageQueryQuery, BrochurePageQueryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<BrochurePageQueryQuery, BrochurePageQueryQueryVariables>(BrochurePageQueryDocument, variables, options);
}
export function useBrochurePageQueryLazyQuery(variables?: BrochurePageQueryQueryVariables | VueCompositionApi.Ref<BrochurePageQueryQueryVariables> | ReactiveFunction<BrochurePageQueryQueryVariables>, options: VueApolloComposable.UseQueryOptions<BrochurePageQueryQuery, BrochurePageQueryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BrochurePageQueryQuery, BrochurePageQueryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BrochurePageQueryQuery, BrochurePageQueryQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<BrochurePageQueryQuery, BrochurePageQueryQueryVariables>(BrochurePageQueryDocument, variables, options);
}
export type BrochurePageQueryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<BrochurePageQueryQuery, BrochurePageQueryQueryVariables>;
export const BrochurePagesQueryDocument = gql`
    query BrochurePagesQuery($pagesInput: PagesInput!, $fileVersion: BrochureStatisticsFileVersion!) {
  pages(pages: $pagesInput) {
    fileUrl(version: $fileVersion)
    id
    index
  }
}
    `;

/**
 * __useBrochurePagesQueryQuery__
 *
 * To run a query within a Vue component, call `useBrochurePagesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrochurePagesQueryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useBrochurePagesQueryQuery({
 *   pagesInput: // value for 'pagesInput'
 *   fileVersion: // value for 'fileVersion'
 * });
 */
export function useBrochurePagesQueryQuery(variables: BrochurePagesQueryQueryVariables | VueCompositionApi.Ref<BrochurePagesQueryQueryVariables> | ReactiveFunction<BrochurePagesQueryQueryVariables>, options: VueApolloComposable.UseQueryOptions<BrochurePagesQueryQuery, BrochurePagesQueryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BrochurePagesQueryQuery, BrochurePagesQueryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BrochurePagesQueryQuery, BrochurePagesQueryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<BrochurePagesQueryQuery, BrochurePagesQueryQueryVariables>(BrochurePagesQueryDocument, variables, options);
}
export function useBrochurePagesQueryLazyQuery(variables?: BrochurePagesQueryQueryVariables | VueCompositionApi.Ref<BrochurePagesQueryQueryVariables> | ReactiveFunction<BrochurePagesQueryQueryVariables>, options: VueApolloComposable.UseQueryOptions<BrochurePagesQueryQuery, BrochurePagesQueryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BrochurePagesQueryQuery, BrochurePagesQueryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BrochurePagesQueryQuery, BrochurePagesQueryQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<BrochurePagesQueryQuery, BrochurePagesQueryQueryVariables>(BrochurePagesQueryDocument, variables, options);
}
export type BrochurePagesQueryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<BrochurePagesQueryQuery, BrochurePagesQueryQueryVariables>;
export const AdminBrochureReadsDocument = gql`
    query AdminBrochureReads($adminBrochureReads: AdminBrochureReadsInput!) {
  adminBrochureReads(adminBrochureReads: $adminBrochureReads) {
    date
    totalReads
    webReads
    iosReads
    androidReads
  }
}
    `;

/**
 * __useAdminBrochureReadsQuery__
 *
 * To run a query within a Vue component, call `useAdminBrochureReadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminBrochureReadsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAdminBrochureReadsQuery({
 *   adminBrochureReads: // value for 'adminBrochureReads'
 * });
 */
export function useAdminBrochureReadsQuery(variables: AdminBrochureReadsQueryVariables | VueCompositionApi.Ref<AdminBrochureReadsQueryVariables> | ReactiveFunction<AdminBrochureReadsQueryVariables>, options: VueApolloComposable.UseQueryOptions<AdminBrochureReadsQuery, AdminBrochureReadsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AdminBrochureReadsQuery, AdminBrochureReadsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AdminBrochureReadsQuery, AdminBrochureReadsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AdminBrochureReadsQuery, AdminBrochureReadsQueryVariables>(AdminBrochureReadsDocument, variables, options);
}
export function useAdminBrochureReadsLazyQuery(variables?: AdminBrochureReadsQueryVariables | VueCompositionApi.Ref<AdminBrochureReadsQueryVariables> | ReactiveFunction<AdminBrochureReadsQueryVariables>, options: VueApolloComposable.UseQueryOptions<AdminBrochureReadsQuery, AdminBrochureReadsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AdminBrochureReadsQuery, AdminBrochureReadsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AdminBrochureReadsQuery, AdminBrochureReadsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AdminBrochureReadsQuery, AdminBrochureReadsQueryVariables>(AdminBrochureReadsDocument, variables, options);
}
export type AdminBrochureReadsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AdminBrochureReadsQuery, AdminBrochureReadsQueryVariables>;
export const BrochureRegionsDocument = gql`
    query BrochureRegions($brochureRegionsInput: BrochureRegionsInput!) {
  brochureRegions(brochureRegions: $brochureRegionsInput) {
    id
    region {
      id
      name
    }
    brochureExperimentVariant {
      id
      variantNumber
    }
  }
}
    `;

/**
 * __useBrochureRegionsQuery__
 *
 * To run a query within a Vue component, call `useBrochureRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrochureRegionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useBrochureRegionsQuery({
 *   brochureRegionsInput: // value for 'brochureRegionsInput'
 * });
 */
export function useBrochureRegionsQuery(variables: BrochureRegionsQueryVariables | VueCompositionApi.Ref<BrochureRegionsQueryVariables> | ReactiveFunction<BrochureRegionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<BrochureRegionsQuery, BrochureRegionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BrochureRegionsQuery, BrochureRegionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BrochureRegionsQuery, BrochureRegionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<BrochureRegionsQuery, BrochureRegionsQueryVariables>(BrochureRegionsDocument, variables, options);
}
export function useBrochureRegionsLazyQuery(variables?: BrochureRegionsQueryVariables | VueCompositionApi.Ref<BrochureRegionsQueryVariables> | ReactiveFunction<BrochureRegionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<BrochureRegionsQuery, BrochureRegionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BrochureRegionsQuery, BrochureRegionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BrochureRegionsQuery, BrochureRegionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<BrochureRegionsQuery, BrochureRegionsQueryVariables>(BrochureRegionsDocument, variables, options);
}
export type BrochureRegionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<BrochureRegionsQuery, BrochureRegionsQueryVariables>;
export const BrochureStateTransitionsDocument = gql`
    query BrochureStateTransitions($brochureStateTransitionsInput: BrochureStateTransitionsInput!) {
  brochureStateTransitions(
    brochureStateTransitions: $brochureStateTransitionsInput
  ) {
    transitionStates {
      state
      title
    }
    currentState {
      state
      title
    }
    status
  }
}
    `;

/**
 * __useBrochureStateTransitionsQuery__
 *
 * To run a query within a Vue component, call `useBrochureStateTransitionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrochureStateTransitionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useBrochureStateTransitionsQuery({
 *   brochureStateTransitionsInput: // value for 'brochureStateTransitionsInput'
 * });
 */
export function useBrochureStateTransitionsQuery(variables: BrochureStateTransitionsQueryVariables | VueCompositionApi.Ref<BrochureStateTransitionsQueryVariables> | ReactiveFunction<BrochureStateTransitionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<BrochureStateTransitionsQuery, BrochureStateTransitionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BrochureStateTransitionsQuery, BrochureStateTransitionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BrochureStateTransitionsQuery, BrochureStateTransitionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<BrochureStateTransitionsQuery, BrochureStateTransitionsQueryVariables>(BrochureStateTransitionsDocument, variables, options);
}
export function useBrochureStateTransitionsLazyQuery(variables?: BrochureStateTransitionsQueryVariables | VueCompositionApi.Ref<BrochureStateTransitionsQueryVariables> | ReactiveFunction<BrochureStateTransitionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<BrochureStateTransitionsQuery, BrochureStateTransitionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BrochureStateTransitionsQuery, BrochureStateTransitionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BrochureStateTransitionsQuery, BrochureStateTransitionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<BrochureStateTransitionsQuery, BrochureStateTransitionsQueryVariables>(BrochureStateTransitionsDocument, variables, options);
}
export type BrochureStateTransitionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<BrochureStateTransitionsQuery, BrochureStateTransitionsQueryVariables>;
export const BrochuresQueryDocument = gql`
    query BrochuresQuery($brochuresInput: BrochuresInput!, $pagination: PaginationInput!) {
  brochures(brochures: $brochuresInput, pagination: $pagination) {
    entries {
      id
      name
      publishedAt
      activeFrom
      expireAfter
      position
      positionFrozenTo
      shop {
        id
        slug
      }
      cover {
        id
        fileUrl(version: SMALL)
      }
      language {
        id
        name
        symbol
      }
      assignee {
        id
        firstName
        lastName
        fileUrl(version: SMALL)
      }
      brochureExperiment {
        id
      }
      mergeRequestAsNew {
        id
        status
        newBrochure {
          id
        }
      }
    }
    pagination {
      currentPage
      nextPage
      previousPage
      totalPages
    }
  }
}
    `;

/**
 * __useBrochuresQueryQuery__
 *
 * To run a query within a Vue component, call `useBrochuresQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrochuresQueryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useBrochuresQueryQuery({
 *   brochuresInput: // value for 'brochuresInput'
 *   pagination: // value for 'pagination'
 * });
 */
export function useBrochuresQueryQuery(variables: BrochuresQueryQueryVariables | VueCompositionApi.Ref<BrochuresQueryQueryVariables> | ReactiveFunction<BrochuresQueryQueryVariables>, options: VueApolloComposable.UseQueryOptions<BrochuresQueryQuery, BrochuresQueryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BrochuresQueryQuery, BrochuresQueryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BrochuresQueryQuery, BrochuresQueryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<BrochuresQueryQuery, BrochuresQueryQueryVariables>(BrochuresQueryDocument, variables, options);
}
export function useBrochuresQueryLazyQuery(variables?: BrochuresQueryQueryVariables | VueCompositionApi.Ref<BrochuresQueryQueryVariables> | ReactiveFunction<BrochuresQueryQueryVariables>, options: VueApolloComposable.UseQueryOptions<BrochuresQueryQuery, BrochuresQueryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BrochuresQueryQuery, BrochuresQueryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BrochuresQueryQuery, BrochuresQueryQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<BrochuresQueryQuery, BrochuresQueryQueryVariables>(BrochuresQueryDocument, variables, options);
}
export type BrochuresQueryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<BrochuresQueryQuery, BrochuresQueryQueryVariables>;
export const AdminShopDocument = gql`
    query AdminShop($input: AdminShopInput!) {
  adminShop(adminShop: $input) {
    ...AdminShopDetail
  }
}
    ${AdminShopDetailFragmentDoc}`;

/**
 * __useAdminShopQuery__
 *
 * To run a query within a Vue component, call `useAdminShopQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminShopQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAdminShopQuery({
 *   input: // value for 'input'
 * });
 */
export function useAdminShopQuery(variables: AdminShopQueryVariables | VueCompositionApi.Ref<AdminShopQueryVariables> | ReactiveFunction<AdminShopQueryVariables>, options: VueApolloComposable.UseQueryOptions<AdminShopQuery, AdminShopQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AdminShopQuery, AdminShopQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AdminShopQuery, AdminShopQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AdminShopQuery, AdminShopQueryVariables>(AdminShopDocument, variables, options);
}
export function useAdminShopLazyQuery(variables?: AdminShopQueryVariables | VueCompositionApi.Ref<AdminShopQueryVariables> | ReactiveFunction<AdminShopQueryVariables>, options: VueApolloComposable.UseQueryOptions<AdminShopQuery, AdminShopQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AdminShopQuery, AdminShopQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AdminShopQuery, AdminShopQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AdminShopQuery, AdminShopQueryVariables>(AdminShopDocument, variables, options);
}
export type AdminShopQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AdminShopQuery, AdminShopQueryVariables>;
export const AdminShopLocationsDocument = gql`
    query AdminShopLocations($input: AdminShopInput!, $search: String) {
  adminShop(adminShop: $input) {
    id
    locations(search: $search) {
      ...ShopLocation
    }
  }
}
    ${ShopLocationFragmentDoc}`;

/**
 * __useAdminShopLocationsQuery__
 *
 * To run a query within a Vue component, call `useAdminShopLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminShopLocationsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAdminShopLocationsQuery({
 *   input: // value for 'input'
 *   search: // value for 'search'
 * });
 */
export function useAdminShopLocationsQuery(variables: AdminShopLocationsQueryVariables | VueCompositionApi.Ref<AdminShopLocationsQueryVariables> | ReactiveFunction<AdminShopLocationsQueryVariables>, options: VueApolloComposable.UseQueryOptions<AdminShopLocationsQuery, AdminShopLocationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AdminShopLocationsQuery, AdminShopLocationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AdminShopLocationsQuery, AdminShopLocationsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AdminShopLocationsQuery, AdminShopLocationsQueryVariables>(AdminShopLocationsDocument, variables, options);
}
export function useAdminShopLocationsLazyQuery(variables?: AdminShopLocationsQueryVariables | VueCompositionApi.Ref<AdminShopLocationsQueryVariables> | ReactiveFunction<AdminShopLocationsQueryVariables>, options: VueApolloComposable.UseQueryOptions<AdminShopLocationsQuery, AdminShopLocationsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AdminShopLocationsQuery, AdminShopLocationsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AdminShopLocationsQuery, AdminShopLocationsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AdminShopLocationsQuery, AdminShopLocationsQueryVariables>(AdminShopLocationsDocument, variables, options);
}
export type AdminShopLocationsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AdminShopLocationsQuery, AdminShopLocationsQueryVariables>;
export const AdminShopsDocument = gql`
    query AdminShops($input: AdminShopsInput!, $pagination: PaginationInput!) {
  adminShops(adminShops: $input, pagination: $pagination) {
    entries {
      ...AdminShopOverview
    }
    pagination {
      ...pagination
    }
  }
}
    ${AdminShopOverviewFragmentDoc}
${PaginationFragmentDoc}`;

/**
 * __useAdminShopsQuery__
 *
 * To run a query within a Vue component, call `useAdminShopsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminShopsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAdminShopsQuery({
 *   input: // value for 'input'
 *   pagination: // value for 'pagination'
 * });
 */
export function useAdminShopsQuery(variables: AdminShopsQueryVariables | VueCompositionApi.Ref<AdminShopsQueryVariables> | ReactiveFunction<AdminShopsQueryVariables>, options: VueApolloComposable.UseQueryOptions<AdminShopsQuery, AdminShopsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AdminShopsQuery, AdminShopsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AdminShopsQuery, AdminShopsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AdminShopsQuery, AdminShopsQueryVariables>(AdminShopsDocument, variables, options);
}
export function useAdminShopsLazyQuery(variables?: AdminShopsQueryVariables | VueCompositionApi.Ref<AdminShopsQueryVariables> | ReactiveFunction<AdminShopsQueryVariables>, options: VueApolloComposable.UseQueryOptions<AdminShopsQuery, AdminShopsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AdminShopsQuery, AdminShopsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AdminShopsQuery, AdminShopsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AdminShopsQuery, AdminShopsQueryVariables>(AdminShopsDocument, variables, options);
}
export type AdminShopsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AdminShopsQuery, AdminShopsQueryVariables>;
export const AdsCampaignDocument = gql`
    query AdsCampaign($adsCampaignInput: AdsCampaignInput!) {
  adsCampaign(adsCampaign: $adsCampaignInput) {
    customerClient {
      id
      name
    }
    id
    languageId
    name
    startAt
    stopAt
    targetType
    status
  }
}
    `;

/**
 * __useAdsCampaignQuery__
 *
 * To run a query within a Vue component, call `useAdsCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdsCampaignQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAdsCampaignQuery({
 *   adsCampaignInput: // value for 'adsCampaignInput'
 * });
 */
export function useAdsCampaignQuery(variables: AdsCampaignQueryVariables | VueCompositionApi.Ref<AdsCampaignQueryVariables> | ReactiveFunction<AdsCampaignQueryVariables>, options: VueApolloComposable.UseQueryOptions<AdsCampaignQuery, AdsCampaignQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AdsCampaignQuery, AdsCampaignQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AdsCampaignQuery, AdsCampaignQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AdsCampaignQuery, AdsCampaignQueryVariables>(AdsCampaignDocument, variables, options);
}
export function useAdsCampaignLazyQuery(variables?: AdsCampaignQueryVariables | VueCompositionApi.Ref<AdsCampaignQueryVariables> | ReactiveFunction<AdsCampaignQueryVariables>, options: VueApolloComposable.UseQueryOptions<AdsCampaignQuery, AdsCampaignQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AdsCampaignQuery, AdsCampaignQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AdsCampaignQuery, AdsCampaignQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AdsCampaignQuery, AdsCampaignQueryVariables>(AdsCampaignDocument, variables, options);
}
export type AdsCampaignQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AdsCampaignQuery, AdsCampaignQueryVariables>;
export const AdsCampaignAdvertisementDocument = gql`
    query AdsCampaignAdvertisement($adsCampaignAdvertisementInput: AdsCampaignAdvertisementInput!) {
  adsCampaignAdvertisement(
    adsCampaignAdvertisement: $adsCampaignAdvertisementInput
  ) {
    id
    adsCampaign {
      id
      name
    }
    weight
    impressionsLimit
    targetType
    platformType
    adType
    displayAt
    displayUrl
    status
    categories {
      id
      name
    }
    shops {
      id
      name
    }
    ... on AdsAdvertisementImage {
      fileUrl
      adDimension
    }
    ... on AdsAdvertisementHtmlEmbed {
      content
      adDimension
    }
  }
}
    `;

/**
 * __useAdsCampaignAdvertisementQuery__
 *
 * To run a query within a Vue component, call `useAdsCampaignAdvertisementQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdsCampaignAdvertisementQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAdsCampaignAdvertisementQuery({
 *   adsCampaignAdvertisementInput: // value for 'adsCampaignAdvertisementInput'
 * });
 */
export function useAdsCampaignAdvertisementQuery(variables: AdsCampaignAdvertisementQueryVariables | VueCompositionApi.Ref<AdsCampaignAdvertisementQueryVariables> | ReactiveFunction<AdsCampaignAdvertisementQueryVariables>, options: VueApolloComposable.UseQueryOptions<AdsCampaignAdvertisementQuery, AdsCampaignAdvertisementQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AdsCampaignAdvertisementQuery, AdsCampaignAdvertisementQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AdsCampaignAdvertisementQuery, AdsCampaignAdvertisementQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AdsCampaignAdvertisementQuery, AdsCampaignAdvertisementQueryVariables>(AdsCampaignAdvertisementDocument, variables, options);
}
export function useAdsCampaignAdvertisementLazyQuery(variables?: AdsCampaignAdvertisementQueryVariables | VueCompositionApi.Ref<AdsCampaignAdvertisementQueryVariables> | ReactiveFunction<AdsCampaignAdvertisementQueryVariables>, options: VueApolloComposable.UseQueryOptions<AdsCampaignAdvertisementQuery, AdsCampaignAdvertisementQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AdsCampaignAdvertisementQuery, AdsCampaignAdvertisementQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AdsCampaignAdvertisementQuery, AdsCampaignAdvertisementQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AdsCampaignAdvertisementQuery, AdsCampaignAdvertisementQueryVariables>(AdsCampaignAdvertisementDocument, variables, options);
}
export type AdsCampaignAdvertisementQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AdsCampaignAdvertisementQuery, AdsCampaignAdvertisementQueryVariables>;
export const AdsCampaignAdvertisementsDocument = gql`
    query AdsCampaignAdvertisements($adsCampaignAdvertisementsInput: AdsCampaignAdvertisementsInput!, $pagination: PaginationInput!) {
  adsCampaignAdvertisements(
    adsCampaignAdvertisements: $adsCampaignAdvertisementsInput
    pagination: $pagination
  ) {
    entries {
      categories {
        id
        name
      }
      shops {
        id
        name
      }
      adType
      displayAt
      id
      impressionsLimit
      platformType
      status
      weight
    }
    pagination {
      currentPage
      nextPage
      previousPage
      totalPages
    }
  }
}
    `;

/**
 * __useAdsCampaignAdvertisementsQuery__
 *
 * To run a query within a Vue component, call `useAdsCampaignAdvertisementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdsCampaignAdvertisementsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAdsCampaignAdvertisementsQuery({
 *   adsCampaignAdvertisementsInput: // value for 'adsCampaignAdvertisementsInput'
 *   pagination: // value for 'pagination'
 * });
 */
export function useAdsCampaignAdvertisementsQuery(variables: AdsCampaignAdvertisementsQueryVariables | VueCompositionApi.Ref<AdsCampaignAdvertisementsQueryVariables> | ReactiveFunction<AdsCampaignAdvertisementsQueryVariables>, options: VueApolloComposable.UseQueryOptions<AdsCampaignAdvertisementsQuery, AdsCampaignAdvertisementsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AdsCampaignAdvertisementsQuery, AdsCampaignAdvertisementsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AdsCampaignAdvertisementsQuery, AdsCampaignAdvertisementsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AdsCampaignAdvertisementsQuery, AdsCampaignAdvertisementsQueryVariables>(AdsCampaignAdvertisementsDocument, variables, options);
}
export function useAdsCampaignAdvertisementsLazyQuery(variables?: AdsCampaignAdvertisementsQueryVariables | VueCompositionApi.Ref<AdsCampaignAdvertisementsQueryVariables> | ReactiveFunction<AdsCampaignAdvertisementsQueryVariables>, options: VueApolloComposable.UseQueryOptions<AdsCampaignAdvertisementsQuery, AdsCampaignAdvertisementsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AdsCampaignAdvertisementsQuery, AdsCampaignAdvertisementsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AdsCampaignAdvertisementsQuery, AdsCampaignAdvertisementsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AdsCampaignAdvertisementsQuery, AdsCampaignAdvertisementsQueryVariables>(AdsCampaignAdvertisementsDocument, variables, options);
}
export type AdsCampaignAdvertisementsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AdsCampaignAdvertisementsQuery, AdsCampaignAdvertisementsQueryVariables>;
export const AdsCampaignCreateFormDocument = gql`
    query AdsCampaignCreateForm($adsCampaignCreateFormInput: AdsCampaignCreateFormInput!) {
  adsCampaignCreateForm(adsCampaignCreateForm: $adsCampaignCreateFormInput) {
    adDimensions
    displayAtPositions
    selectableCategories
    selectableShops
  }
}
    `;

/**
 * __useAdsCampaignCreateFormQuery__
 *
 * To run a query within a Vue component, call `useAdsCampaignCreateFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdsCampaignCreateFormQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAdsCampaignCreateFormQuery({
 *   adsCampaignCreateFormInput: // value for 'adsCampaignCreateFormInput'
 * });
 */
export function useAdsCampaignCreateFormQuery(variables: AdsCampaignCreateFormQueryVariables | VueCompositionApi.Ref<AdsCampaignCreateFormQueryVariables> | ReactiveFunction<AdsCampaignCreateFormQueryVariables>, options: VueApolloComposable.UseQueryOptions<AdsCampaignCreateFormQuery, AdsCampaignCreateFormQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AdsCampaignCreateFormQuery, AdsCampaignCreateFormQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AdsCampaignCreateFormQuery, AdsCampaignCreateFormQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AdsCampaignCreateFormQuery, AdsCampaignCreateFormQueryVariables>(AdsCampaignCreateFormDocument, variables, options);
}
export function useAdsCampaignCreateFormLazyQuery(variables?: AdsCampaignCreateFormQueryVariables | VueCompositionApi.Ref<AdsCampaignCreateFormQueryVariables> | ReactiveFunction<AdsCampaignCreateFormQueryVariables>, options: VueApolloComposable.UseQueryOptions<AdsCampaignCreateFormQuery, AdsCampaignCreateFormQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AdsCampaignCreateFormQuery, AdsCampaignCreateFormQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AdsCampaignCreateFormQuery, AdsCampaignCreateFormQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AdsCampaignCreateFormQuery, AdsCampaignCreateFormQueryVariables>(AdsCampaignCreateFormDocument, variables, options);
}
export type AdsCampaignCreateFormQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AdsCampaignCreateFormQuery, AdsCampaignCreateFormQueryVariables>;
export const AdsCampaignsDocument = gql`
    query AdsCampaigns($adsCampaignsInput: AdsCampaignsInput!, $pagination: PaginationInput!) {
  adsCampaigns(adsCampaigns: $adsCampaignsInput, pagination: $pagination) {
    entries {
      id
      name
      startAt
      stopAt
      targetType
      status
      customerClient {
        id
        name
      }
      languageId
    }
    pagination {
      currentPage
      nextPage
      previousPage
      totalPages
    }
  }
}
    `;

/**
 * __useAdsCampaignsQuery__
 *
 * To run a query within a Vue component, call `useAdsCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdsCampaignsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAdsCampaignsQuery({
 *   adsCampaignsInput: // value for 'adsCampaignsInput'
 *   pagination: // value for 'pagination'
 * });
 */
export function useAdsCampaignsQuery(variables: AdsCampaignsQueryVariables | VueCompositionApi.Ref<AdsCampaignsQueryVariables> | ReactiveFunction<AdsCampaignsQueryVariables>, options: VueApolloComposable.UseQueryOptions<AdsCampaignsQuery, AdsCampaignsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AdsCampaignsQuery, AdsCampaignsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AdsCampaignsQuery, AdsCampaignsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AdsCampaignsQuery, AdsCampaignsQueryVariables>(AdsCampaignsDocument, variables, options);
}
export function useAdsCampaignsLazyQuery(variables?: AdsCampaignsQueryVariables | VueCompositionApi.Ref<AdsCampaignsQueryVariables> | ReactiveFunction<AdsCampaignsQueryVariables>, options: VueApolloComposable.UseQueryOptions<AdsCampaignsQuery, AdsCampaignsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AdsCampaignsQuery, AdsCampaignsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AdsCampaignsQuery, AdsCampaignsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AdsCampaignsQuery, AdsCampaignsQueryVariables>(AdsCampaignsDocument, variables, options);
}
export type AdsCampaignsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AdsCampaignsQuery, AdsCampaignsQueryVariables>;
export const AppDocument = gql`
    query App {
  app {
    genericProductSource {
      name
    }
    name
  }
}
    `;

/**
 * __useAppQuery__
 *
 * To run a query within a Vue component, call `useAppQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAppQuery();
 */
export function useAppQuery(options: VueApolloComposable.UseQueryOptions<AppQuery, AppQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AppQuery, AppQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AppQuery, AppQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AppQuery, AppQueryVariables>(AppDocument, {}, options);
}
export function useAppLazyQuery(options: VueApolloComposable.UseQueryOptions<AppQuery, AppQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AppQuery, AppQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AppQuery, AppQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AppQuery, AppQueryVariables>(AppDocument, {}, options);
}
export type AppQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AppQuery, AppQueryVariables>;
export const AppConfigDocument = gql`
    query AppConfig {
  app {
    id
    geminiTaggingPrompt
    taggingStrategy
  }
}
    `;

/**
 * __useAppConfigQuery__
 *
 * To run a query within a Vue component, call `useAppConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppConfigQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAppConfigQuery();
 */
export function useAppConfigQuery(options: VueApolloComposable.UseQueryOptions<AppConfigQuery, AppConfigQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AppConfigQuery, AppConfigQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AppConfigQuery, AppConfigQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AppConfigQuery, AppConfigQueryVariables>(AppConfigDocument, {}, options);
}
export function useAppConfigLazyQuery(options: VueApolloComposable.UseQueryOptions<AppConfigQuery, AppConfigQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AppConfigQuery, AppConfigQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AppConfigQuery, AppConfigQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AppConfigQuery, AppConfigQueryVariables>(AppConfigDocument, {}, options);
}
export type AppConfigQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AppConfigQuery, AppConfigQueryVariables>;
export const AppLanguageDocument = gql`
    query AppLanguage($appLanguageInput: AppLanguageInput!) {
  appLanguage(appLanguage: $appLanguageInput) {
    ...AppLanguageDetail
  }
}
    ${AppLanguageDetailFragmentDoc}`;

/**
 * __useAppLanguageQuery__
 *
 * To run a query within a Vue component, call `useAppLanguageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppLanguageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAppLanguageQuery({
 *   appLanguageInput: // value for 'appLanguageInput'
 * });
 */
export function useAppLanguageQuery(variables: AppLanguageQueryVariables | VueCompositionApi.Ref<AppLanguageQueryVariables> | ReactiveFunction<AppLanguageQueryVariables>, options: VueApolloComposable.UseQueryOptions<AppLanguageQuery, AppLanguageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AppLanguageQuery, AppLanguageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AppLanguageQuery, AppLanguageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AppLanguageQuery, AppLanguageQueryVariables>(AppLanguageDocument, variables, options);
}
export function useAppLanguageLazyQuery(variables?: AppLanguageQueryVariables | VueCompositionApi.Ref<AppLanguageQueryVariables> | ReactiveFunction<AppLanguageQueryVariables>, options: VueApolloComposable.UseQueryOptions<AppLanguageQuery, AppLanguageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AppLanguageQuery, AppLanguageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AppLanguageQuery, AppLanguageQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AppLanguageQuery, AppLanguageQueryVariables>(AppLanguageDocument, variables, options);
}
export type AppLanguageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AppLanguageQuery, AppLanguageQueryVariables>;
export const AppLanguagesDocument = gql`
    query AppLanguages {
  appLanguages {
    ...AppLanguageOverview
  }
}
    ${AppLanguageOverviewFragmentDoc}`;

/**
 * __useAppLanguagesQuery__
 *
 * To run a query within a Vue component, call `useAppLanguagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppLanguagesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAppLanguagesQuery();
 */
export function useAppLanguagesQuery(options: VueApolloComposable.UseQueryOptions<AppLanguagesQuery, AppLanguagesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AppLanguagesQuery, AppLanguagesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AppLanguagesQuery, AppLanguagesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AppLanguagesQuery, AppLanguagesQueryVariables>(AppLanguagesDocument, {}, options);
}
export function useAppLanguagesLazyQuery(options: VueApolloComposable.UseQueryOptions<AppLanguagesQuery, AppLanguagesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AppLanguagesQuery, AppLanguagesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AppLanguagesQuery, AppLanguagesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AppLanguagesQuery, AppLanguagesQueryVariables>(AppLanguagesDocument, {}, options);
}
export type AppLanguagesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AppLanguagesQuery, AppLanguagesQueryVariables>;
export const AppUsersDocument = gql`
    query AppUsers($appUsers: AppUsersInput!, $pagination: PaginationInput!) {
  appUsers(appUsers: $appUsers, pagination: $pagination) {
    entries {
      id
      kind
      email
      firstName
      lastName
    }
    pagination {
      ...pagination
    }
  }
}
    ${PaginationFragmentDoc}`;

/**
 * __useAppUsersQuery__
 *
 * To run a query within a Vue component, call `useAppUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppUsersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useAppUsersQuery({
 *   appUsers: // value for 'appUsers'
 *   pagination: // value for 'pagination'
 * });
 */
export function useAppUsersQuery(variables: AppUsersQueryVariables | VueCompositionApi.Ref<AppUsersQueryVariables> | ReactiveFunction<AppUsersQueryVariables>, options: VueApolloComposable.UseQueryOptions<AppUsersQuery, AppUsersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AppUsersQuery, AppUsersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AppUsersQuery, AppUsersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<AppUsersQuery, AppUsersQueryVariables>(AppUsersDocument, variables, options);
}
export function useAppUsersLazyQuery(variables?: AppUsersQueryVariables | VueCompositionApi.Ref<AppUsersQueryVariables> | ReactiveFunction<AppUsersQueryVariables>, options: VueApolloComposable.UseQueryOptions<AppUsersQuery, AppUsersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<AppUsersQuery, AppUsersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<AppUsersQuery, AppUsersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<AppUsersQuery, AppUsersQueryVariables>(AppUsersDocument, variables, options);
}
export type AppUsersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<AppUsersQuery, AppUsersQueryVariables>;
export const BlogAuthorsDocument = gql`
    query BlogAuthors($identityUsers: IdentityUsersInput!, $pagination: PaginationInput) {
  identityUsers(identityUsers: $identityUsers, pagination: $pagination) {
    entries {
      firstName
      lastName
      id
    }
  }
}
    `;

/**
 * __useBlogAuthorsQuery__
 *
 * To run a query within a Vue component, call `useBlogAuthorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlogAuthorsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useBlogAuthorsQuery({
 *   identityUsers: // value for 'identityUsers'
 *   pagination: // value for 'pagination'
 * });
 */
export function useBlogAuthorsQuery(variables: BlogAuthorsQueryVariables | VueCompositionApi.Ref<BlogAuthorsQueryVariables> | ReactiveFunction<BlogAuthorsQueryVariables>, options: VueApolloComposable.UseQueryOptions<BlogAuthorsQuery, BlogAuthorsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BlogAuthorsQuery, BlogAuthorsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BlogAuthorsQuery, BlogAuthorsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<BlogAuthorsQuery, BlogAuthorsQueryVariables>(BlogAuthorsDocument, variables, options);
}
export function useBlogAuthorsLazyQuery(variables?: BlogAuthorsQueryVariables | VueCompositionApi.Ref<BlogAuthorsQueryVariables> | ReactiveFunction<BlogAuthorsQueryVariables>, options: VueApolloComposable.UseQueryOptions<BlogAuthorsQuery, BlogAuthorsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BlogAuthorsQuery, BlogAuthorsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BlogAuthorsQuery, BlogAuthorsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<BlogAuthorsQuery, BlogAuthorsQueryVariables>(BlogAuthorsDocument, variables, options);
}
export type BlogAuthorsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<BlogAuthorsQuery, BlogAuthorsQueryVariables>;
export const BrandDocument = gql`
    query Brand($brandInput: BrandInput!) {
  brand(brand: $brandInput) {
    id
    name
    fileUrl(version: SMALL)
    description
    position
    slug
    status
    brandTags {
      id
      name
    }
    syncSource {
      app {
        name
      }
    }
  }
}
    `;

/**
 * __useBrandQuery__
 *
 * To run a query within a Vue component, call `useBrandQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useBrandQuery({
 *   brandInput: // value for 'brandInput'
 * });
 */
export function useBrandQuery(variables: BrandQueryVariables | VueCompositionApi.Ref<BrandQueryVariables> | ReactiveFunction<BrandQueryVariables>, options: VueApolloComposable.UseQueryOptions<BrandQuery, BrandQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BrandQuery, BrandQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BrandQuery, BrandQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<BrandQuery, BrandQueryVariables>(BrandDocument, variables, options);
}
export function useBrandLazyQuery(variables?: BrandQueryVariables | VueCompositionApi.Ref<BrandQueryVariables> | ReactiveFunction<BrandQueryVariables>, options: VueApolloComposable.UseQueryOptions<BrandQuery, BrandQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BrandQuery, BrandQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BrandQuery, BrandQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<BrandQuery, BrandQueryVariables>(BrandDocument, variables, options);
}
export type BrandQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<BrandQuery, BrandQueryVariables>;
export const BrandsDocument = gql`
    query Brands($brandsInput: BrandsInput!, $pagination: PaginationInput) {
  brands(brands: $brandsInput, pagination: $pagination) {
    entries {
      id
      name
      fileUrl(version: SMALL)
      status
      brandTags {
        name
      }
      syncSource {
        app {
          name
        }
      }
    }
    pagination {
      currentPage
      nextPage
      previousPage
      totalPages
    }
  }
}
    `;

/**
 * __useBrandsQuery__
 *
 * To run a query within a Vue component, call `useBrandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrandsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useBrandsQuery({
 *   brandsInput: // value for 'brandsInput'
 *   pagination: // value for 'pagination'
 * });
 */
export function useBrandsQuery(variables: BrandsQueryVariables | VueCompositionApi.Ref<BrandsQueryVariables> | ReactiveFunction<BrandsQueryVariables>, options: VueApolloComposable.UseQueryOptions<BrandsQuery, BrandsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BrandsQuery, BrandsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BrandsQuery, BrandsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<BrandsQuery, BrandsQueryVariables>(BrandsDocument, variables, options);
}
export function useBrandsLazyQuery(variables?: BrandsQueryVariables | VueCompositionApi.Ref<BrandsQueryVariables> | ReactiveFunction<BrandsQueryVariables>, options: VueApolloComposable.UseQueryOptions<BrandsQuery, BrandsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BrandsQuery, BrandsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BrandsQuery, BrandsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<BrandsQuery, BrandsQueryVariables>(BrandsDocument, variables, options);
}
export type BrandsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<BrandsQuery, BrandsQueryVariables>;
export const BrochureQueryDocument = gql`
    query BrochureQuery($brochureInput: BrochureInput!) {
  brochure(brochure: $brochureInput) {
    id
    language {
      id
    }
  }
}
    `;

/**
 * __useBrochureQueryQuery__
 *
 * To run a query within a Vue component, call `useBrochureQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrochureQueryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useBrochureQueryQuery({
 *   brochureInput: // value for 'brochureInput'
 * });
 */
export function useBrochureQueryQuery(variables: BrochureQueryQueryVariables | VueCompositionApi.Ref<BrochureQueryQueryVariables> | ReactiveFunction<BrochureQueryQueryVariables>, options: VueApolloComposable.UseQueryOptions<BrochureQueryQuery, BrochureQueryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BrochureQueryQuery, BrochureQueryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BrochureQueryQuery, BrochureQueryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<BrochureQueryQuery, BrochureQueryQueryVariables>(BrochureQueryDocument, variables, options);
}
export function useBrochureQueryLazyQuery(variables?: BrochureQueryQueryVariables | VueCompositionApi.Ref<BrochureQueryQueryVariables> | ReactiveFunction<BrochureQueryQueryVariables>, options: VueApolloComposable.UseQueryOptions<BrochureQueryQuery, BrochureQueryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BrochureQueryQuery, BrochureQueryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BrochureQueryQuery, BrochureQueryQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<BrochureQueryQuery, BrochureQueryQueryVariables>(BrochureQueryDocument, variables, options);
}
export type BrochureQueryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<BrochureQueryQuery, BrochureQueryQueryVariables>;
export const BrochureCountersDocument = gql`
    query BrochureCounters($input: BrochureCountersInput!) {
  brochureCounters(brochureCounters: $input) {
    state
    count
  }
}
    `;

/**
 * __useBrochureCountersQuery__
 *
 * To run a query within a Vue component, call `useBrochureCountersQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrochureCountersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useBrochureCountersQuery({
 *   input: // value for 'input'
 * });
 */
export function useBrochureCountersQuery(variables: BrochureCountersQueryVariables | VueCompositionApi.Ref<BrochureCountersQueryVariables> | ReactiveFunction<BrochureCountersQueryVariables>, options: VueApolloComposable.UseQueryOptions<BrochureCountersQuery, BrochureCountersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BrochureCountersQuery, BrochureCountersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BrochureCountersQuery, BrochureCountersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<BrochureCountersQuery, BrochureCountersQueryVariables>(BrochureCountersDocument, variables, options);
}
export function useBrochureCountersLazyQuery(variables?: BrochureCountersQueryVariables | VueCompositionApi.Ref<BrochureCountersQueryVariables> | ReactiveFunction<BrochureCountersQueryVariables>, options: VueApolloComposable.UseQueryOptions<BrochureCountersQuery, BrochureCountersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BrochureCountersQuery, BrochureCountersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BrochureCountersQuery, BrochureCountersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<BrochureCountersQuery, BrochureCountersQueryVariables>(BrochureCountersDocument, variables, options);
}
export type BrochureCountersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<BrochureCountersQuery, BrochureCountersQueryVariables>;
export const BrochureLogsDocument = gql`
    query BrochureLogs($brochureLogs: BrochureLogsInput!, $pagination: PaginationInput!) {
  brochureLogs(brochureLogs: $brochureLogs, pagination: $pagination) {
    entries {
      content
      level
      insertedAt
      ... on CreateBrochureLog {
        createStatus
      }
    }
    pagination {
      currentPage
      totalPages
      nextPage
      previousPage
    }
  }
}
    `;

/**
 * __useBrochureLogsQuery__
 *
 * To run a query within a Vue component, call `useBrochureLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrochureLogsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useBrochureLogsQuery({
 *   brochureLogs: // value for 'brochureLogs'
 *   pagination: // value for 'pagination'
 * });
 */
export function useBrochureLogsQuery(variables: BrochureLogsQueryVariables | VueCompositionApi.Ref<BrochureLogsQueryVariables> | ReactiveFunction<BrochureLogsQueryVariables>, options: VueApolloComposable.UseQueryOptions<BrochureLogsQuery, BrochureLogsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BrochureLogsQuery, BrochureLogsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BrochureLogsQuery, BrochureLogsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<BrochureLogsQuery, BrochureLogsQueryVariables>(BrochureLogsDocument, variables, options);
}
export function useBrochureLogsLazyQuery(variables?: BrochureLogsQueryVariables | VueCompositionApi.Ref<BrochureLogsQueryVariables> | ReactiveFunction<BrochureLogsQueryVariables>, options: VueApolloComposable.UseQueryOptions<BrochureLogsQuery, BrochureLogsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BrochureLogsQuery, BrochureLogsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BrochureLogsQuery, BrochureLogsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<BrochureLogsQuery, BrochureLogsQueryVariables>(BrochureLogsDocument, variables, options);
}
export type BrochureLogsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<BrochureLogsQuery, BrochureLogsQueryVariables>;
export const BrochureRegionParserDocument = gql`
    query BrochureRegionParser($brochureRegionsInput: BrochureRegionsInput!) {
  brochureRegions(brochureRegions: $brochureRegionsInput) {
    id
    parser {
      url
      parserClass {
        moduleName
      }
    }
    region {
      id
    }
  }
}
    `;

/**
 * __useBrochureRegionParserQuery__
 *
 * To run a query within a Vue component, call `useBrochureRegionParserQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrochureRegionParserQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useBrochureRegionParserQuery({
 *   brochureRegionsInput: // value for 'brochureRegionsInput'
 * });
 */
export function useBrochureRegionParserQuery(variables: BrochureRegionParserQueryVariables | VueCompositionApi.Ref<BrochureRegionParserQueryVariables> | ReactiveFunction<BrochureRegionParserQueryVariables>, options: VueApolloComposable.UseQueryOptions<BrochureRegionParserQuery, BrochureRegionParserQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BrochureRegionParserQuery, BrochureRegionParserQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BrochureRegionParserQuery, BrochureRegionParserQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<BrochureRegionParserQuery, BrochureRegionParserQueryVariables>(BrochureRegionParserDocument, variables, options);
}
export function useBrochureRegionParserLazyQuery(variables?: BrochureRegionParserQueryVariables | VueCompositionApi.Ref<BrochureRegionParserQueryVariables> | ReactiveFunction<BrochureRegionParserQueryVariables>, options: VueApolloComposable.UseQueryOptions<BrochureRegionParserQuery, BrochureRegionParserQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BrochureRegionParserQuery, BrochureRegionParserQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BrochureRegionParserQuery, BrochureRegionParserQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<BrochureRegionParserQuery, BrochureRegionParserQueryVariables>(BrochureRegionParserDocument, variables, options);
}
export type BrochureRegionParserQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<BrochureRegionParserQuery, BrochureRegionParserQueryVariables>;
export const BrochureShopLangDocument = gql`
    query BrochureShopLang($brochureId: ID!) {
  brochure(brochure: {brochureId: $brochureId}) {
    language {
      id
    }
    shop {
      id
    }
  }
}
    `;

/**
 * __useBrochureShopLangQuery__
 *
 * To run a query within a Vue component, call `useBrochureShopLangQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrochureShopLangQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useBrochureShopLangQuery({
 *   brochureId: // value for 'brochureId'
 * });
 */
export function useBrochureShopLangQuery(variables: BrochureShopLangQueryVariables | VueCompositionApi.Ref<BrochureShopLangQueryVariables> | ReactiveFunction<BrochureShopLangQueryVariables>, options: VueApolloComposable.UseQueryOptions<BrochureShopLangQuery, BrochureShopLangQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BrochureShopLangQuery, BrochureShopLangQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BrochureShopLangQuery, BrochureShopLangQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<BrochureShopLangQuery, BrochureShopLangQueryVariables>(BrochureShopLangDocument, variables, options);
}
export function useBrochureShopLangLazyQuery(variables?: BrochureShopLangQueryVariables | VueCompositionApi.Ref<BrochureShopLangQueryVariables> | ReactiveFunction<BrochureShopLangQueryVariables>, options: VueApolloComposable.UseQueryOptions<BrochureShopLangQuery, BrochureShopLangQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BrochureShopLangQuery, BrochureShopLangQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BrochureShopLangQuery, BrochureShopLangQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<BrochureShopLangQuery, BrochureShopLangQueryVariables>(BrochureShopLangDocument, variables, options);
}
export type BrochureShopLangQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<BrochureShopLangQuery, BrochureShopLangQueryVariables>;
export const BrochureDocument = gql`
    query Brochure($brochure: BrochureStatisticsInput!) {
  brochureStatistic(brochure: $brochure) {
    brochure {
      id
      publishedAt
      expireAfter
      language
      pages(limit: 1) {
        fileUrl(version: SMALL)
      }
    }
    interaction {
      impressions
      reach
      reads
      readers
      openingRatio
      addedToList
      hotspotClicks
      hotspotClicksCtr
      hotspotLinkClicks
      hotspotLinkClicksCtr
      interactionEntries {
        category
        impressions
        reads
      }
      clickThroughRate
    }
    pages {
      index
      readers
      reads
      percentageReadsPageOne
      averageTimeSeconds
      totalTimeSeconds
    }
  }
}
    `;

/**
 * __useBrochureQuery__
 *
 * To run a query within a Vue component, call `useBrochureQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrochureQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useBrochureQuery({
 *   brochure: // value for 'brochure'
 * });
 */
export function useBrochureQuery(variables: BrochureQueryVariables | VueCompositionApi.Ref<BrochureQueryVariables> | ReactiveFunction<BrochureQueryVariables>, options: VueApolloComposable.UseQueryOptions<BrochureQuery, BrochureQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BrochureQuery, BrochureQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BrochureQuery, BrochureQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<BrochureQuery, BrochureQueryVariables>(BrochureDocument, variables, options);
}
export function useBrochureLazyQuery(variables?: BrochureQueryVariables | VueCompositionApi.Ref<BrochureQueryVariables> | ReactiveFunction<BrochureQueryVariables>, options: VueApolloComposable.UseQueryOptions<BrochureQuery, BrochureQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BrochureQuery, BrochureQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BrochureQuery, BrochureQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<BrochureQuery, BrochureQueryVariables>(BrochureDocument, variables, options);
}
export type BrochureQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<BrochureQuery, BrochureQueryVariables>;
export const BrochurePagesStatisticsDocument = gql`
    query BrochurePagesStatistics($brochures: BrochuresPagesStatisticsInput!) {
  brochuresPagesStatistics(brochures: $brochures) {
    brochure {
      id
      publishedAt
      expireAfter
      language
      pages(limit: 1) {
        fileUrl(version: SMALL)
      }
    }
    averagePageTime
    averageTimePerReader
    numberOfPages
    totalReadTime
    reads
  }
}
    `;

/**
 * __useBrochurePagesStatisticsQuery__
 *
 * To run a query within a Vue component, call `useBrochurePagesStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrochurePagesStatisticsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useBrochurePagesStatisticsQuery({
 *   brochures: // value for 'brochures'
 * });
 */
export function useBrochurePagesStatisticsQuery(variables: BrochurePagesStatisticsQueryVariables | VueCompositionApi.Ref<BrochurePagesStatisticsQueryVariables> | ReactiveFunction<BrochurePagesStatisticsQueryVariables>, options: VueApolloComposable.UseQueryOptions<BrochurePagesStatisticsQuery, BrochurePagesStatisticsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BrochurePagesStatisticsQuery, BrochurePagesStatisticsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BrochurePagesStatisticsQuery, BrochurePagesStatisticsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<BrochurePagesStatisticsQuery, BrochurePagesStatisticsQueryVariables>(BrochurePagesStatisticsDocument, variables, options);
}
export function useBrochurePagesStatisticsLazyQuery(variables?: BrochurePagesStatisticsQueryVariables | VueCompositionApi.Ref<BrochurePagesStatisticsQueryVariables> | ReactiveFunction<BrochurePagesStatisticsQueryVariables>, options: VueApolloComposable.UseQueryOptions<BrochurePagesStatisticsQuery, BrochurePagesStatisticsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BrochurePagesStatisticsQuery, BrochurePagesStatisticsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BrochurePagesStatisticsQuery, BrochurePagesStatisticsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<BrochurePagesStatisticsQuery, BrochurePagesStatisticsQueryVariables>(BrochurePagesStatisticsDocument, variables, options);
}
export type BrochurePagesStatisticsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<BrochurePagesStatisticsQuery, BrochurePagesStatisticsQueryVariables>;
export const BrochureReadsStatisticsDocument = gql`
    query BrochureReadsStatistics($brochures: BrochuresReadsStatisticsInput!) {
  brochuresReadsStatistics(brochures: $brochures) {
    brochure {
      id
      publishedAt
      expireAfter
      language
      pages(limit: 1) {
        fileUrl(version: SMALL)
      }
    }
    clickThroughRate
    addedToList
    hotspotClicks
    hotspotClicksCtr
    hotspotLinkClicks
    hotspotLinkClicksCtr
    impressions
    reads
  }
}
    `;

/**
 * __useBrochureReadsStatisticsQuery__
 *
 * To run a query within a Vue component, call `useBrochureReadsStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrochureReadsStatisticsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useBrochureReadsStatisticsQuery({
 *   brochures: // value for 'brochures'
 * });
 */
export function useBrochureReadsStatisticsQuery(variables: BrochureReadsStatisticsQueryVariables | VueCompositionApi.Ref<BrochureReadsStatisticsQueryVariables> | ReactiveFunction<BrochureReadsStatisticsQueryVariables>, options: VueApolloComposable.UseQueryOptions<BrochureReadsStatisticsQuery, BrochureReadsStatisticsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BrochureReadsStatisticsQuery, BrochureReadsStatisticsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BrochureReadsStatisticsQuery, BrochureReadsStatisticsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<BrochureReadsStatisticsQuery, BrochureReadsStatisticsQueryVariables>(BrochureReadsStatisticsDocument, variables, options);
}
export function useBrochureReadsStatisticsLazyQuery(variables?: BrochureReadsStatisticsQueryVariables | VueCompositionApi.Ref<BrochureReadsStatisticsQueryVariables> | ReactiveFunction<BrochureReadsStatisticsQueryVariables>, options: VueApolloComposable.UseQueryOptions<BrochureReadsStatisticsQuery, BrochureReadsStatisticsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BrochureReadsStatisticsQuery, BrochureReadsStatisticsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BrochureReadsStatisticsQuery, BrochureReadsStatisticsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<BrochureReadsStatisticsQuery, BrochureReadsStatisticsQueryVariables>(BrochureReadsStatisticsDocument, variables, options);
}
export type BrochureReadsStatisticsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<BrochureReadsStatisticsQuery, BrochureReadsStatisticsQueryVariables>;
export const BrochuresDocument = gql`
    query Brochures($brochures: BrochuresStatisticsOverviewInput!) {
  brochuresStatisticsOverview(brochures: $brochures) {
    id
    statisticsEntries {
      brochure {
        id
        publishedAt
        expireAfter
        language
        pages(limit: 1) {
          fileUrl(version: SMALL)
        }
      }
      brochureStatisticsMapsEntity {
        impressionsEntries {
          key
          value
        }
        brochureReadsEntries {
          key
          value
        }
        pageReadsEntries {
          key
          value
        }
        hotspotClicksEntries {
          key
          value
        }
        hotspotLinkClicksEntries {
          key
          value
        }
      }
    }
    sumStatisticsEntry {
      impressionsEntries {
        key
        value
      }
      brochureReadsEntries {
        key
        value
      }
      pageReadsEntries {
        key
        value
      }
      hotspotClicksEntries {
        key
        value
      }
      hotspotLinkClicksEntries {
        key
        value
      }
    }
    impressions
    brochureReads
    pageReads
    hotspotClicks
    hotspotLinkClicks
  }
}
    `;

/**
 * __useBrochuresQuery__
 *
 * To run a query within a Vue component, call `useBrochuresQuery` and pass it any options that fit your needs.
 * When your component renders, `useBrochuresQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useBrochuresQuery({
 *   brochures: // value for 'brochures'
 * });
 */
export function useBrochuresQuery(variables: BrochuresQueryVariables | VueCompositionApi.Ref<BrochuresQueryVariables> | ReactiveFunction<BrochuresQueryVariables>, options: VueApolloComposable.UseQueryOptions<BrochuresQuery, BrochuresQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BrochuresQuery, BrochuresQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BrochuresQuery, BrochuresQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<BrochuresQuery, BrochuresQueryVariables>(BrochuresDocument, variables, options);
}
export function useBrochuresLazyQuery(variables?: BrochuresQueryVariables | VueCompositionApi.Ref<BrochuresQueryVariables> | ReactiveFunction<BrochuresQueryVariables>, options: VueApolloComposable.UseQueryOptions<BrochuresQuery, BrochuresQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<BrochuresQuery, BrochuresQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<BrochuresQuery, BrochuresQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<BrochuresQuery, BrochuresQueryVariables>(BrochuresDocument, variables, options);
}
export type BrochuresQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<BrochuresQuery, BrochuresQueryVariables>;
export const CategoriesDocument = gql`
    query Categories($categories: CategoriesInput) {
  categories(categories: $categories) {
    ...CategoryDetail
  }
}
    ${CategoryDetailFragmentDoc}`;

/**
 * __useCategoriesQuery__
 *
 * To run a query within a Vue component, call `useCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoriesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCategoriesQuery({
 *   categories: // value for 'categories'
 * });
 */
export function useCategoriesQuery(variables: CategoriesQueryVariables | VueCompositionApi.Ref<CategoriesQueryVariables> | ReactiveFunction<CategoriesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<CategoriesQuery, CategoriesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CategoriesQuery, CategoriesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CategoriesQuery, CategoriesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CategoriesQuery, CategoriesQueryVariables>(CategoriesDocument, variables, options);
}
export function useCategoriesLazyQuery(variables: CategoriesQueryVariables | VueCompositionApi.Ref<CategoriesQueryVariables> | ReactiveFunction<CategoriesQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<CategoriesQuery, CategoriesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CategoriesQuery, CategoriesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CategoriesQuery, CategoriesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<CategoriesQuery, CategoriesQueryVariables>(CategoriesDocument, variables, options);
}
export type CategoriesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CategoriesQuery, CategoriesQueryVariables>;
export const CategoryDocument = gql`
    query Category($categoryInput: CategoryInput!) {
  category(category: $categoryInput) {
    ...CategoryDetail
  }
}
    ${CategoryDetailFragmentDoc}`;

/**
 * __useCategoryQuery__
 *
 * To run a query within a Vue component, call `useCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCategoryQuery({
 *   categoryInput: // value for 'categoryInput'
 * });
 */
export function useCategoryQuery(variables: CategoryQueryVariables | VueCompositionApi.Ref<CategoryQueryVariables> | ReactiveFunction<CategoryQueryVariables>, options: VueApolloComposable.UseQueryOptions<CategoryQuery, CategoryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CategoryQuery, CategoryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CategoryQuery, CategoryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CategoryQuery, CategoryQueryVariables>(CategoryDocument, variables, options);
}
export function useCategoryLazyQuery(variables?: CategoryQueryVariables | VueCompositionApi.Ref<CategoryQueryVariables> | ReactiveFunction<CategoryQueryVariables>, options: VueApolloComposable.UseQueryOptions<CategoryQuery, CategoryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CategoryQuery, CategoryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CategoryQuery, CategoryQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<CategoryQuery, CategoryQueryVariables>(CategoryDocument, variables, options);
}
export type CategoryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CategoryQuery, CategoryQueryVariables>;
export const CitiesDocument = gql`
    query Cities($citiesInput: CitiesInput!, $pagination: PaginationInput) {
  cities(cities: $citiesInput, pagination: $pagination) {
    entries {
      id
      name
    }
    pagination {
      currentPage
      nextPage
      previousPage
      totalPages
    }
  }
}
    `;

/**
 * __useCitiesQuery__
 *
 * To run a query within a Vue component, call `useCitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCitiesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCitiesQuery({
 *   citiesInput: // value for 'citiesInput'
 *   pagination: // value for 'pagination'
 * });
 */
export function useCitiesQuery(variables: CitiesQueryVariables | VueCompositionApi.Ref<CitiesQueryVariables> | ReactiveFunction<CitiesQueryVariables>, options: VueApolloComposable.UseQueryOptions<CitiesQuery, CitiesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CitiesQuery, CitiesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CitiesQuery, CitiesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CitiesQuery, CitiesQueryVariables>(CitiesDocument, variables, options);
}
export function useCitiesLazyQuery(variables?: CitiesQueryVariables | VueCompositionApi.Ref<CitiesQueryVariables> | ReactiveFunction<CitiesQueryVariables>, options: VueApolloComposable.UseQueryOptions<CitiesQuery, CitiesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CitiesQuery, CitiesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CitiesQuery, CitiesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<CitiesQuery, CitiesQueryVariables>(CitiesDocument, variables, options);
}
export type CitiesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CitiesQuery, CitiesQueryVariables>;
export const CityDocument = gql`
    query City($cityInput: CityInput!) {
  city(city: $cityInput) {
    id
    name
    position
  }
}
    `;

/**
 * __useCityQuery__
 *
 * To run a query within a Vue component, call `useCityQuery` and pass it any options that fit your needs.
 * When your component renders, `useCityQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCityQuery({
 *   cityInput: // value for 'cityInput'
 * });
 */
export function useCityQuery(variables: CityQueryVariables | VueCompositionApi.Ref<CityQueryVariables> | ReactiveFunction<CityQueryVariables>, options: VueApolloComposable.UseQueryOptions<CityQuery, CityQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CityQuery, CityQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CityQuery, CityQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CityQuery, CityQueryVariables>(CityDocument, variables, options);
}
export function useCityLazyQuery(variables?: CityQueryVariables | VueCompositionApi.Ref<CityQueryVariables> | ReactiveFunction<CityQueryVariables>, options: VueApolloComposable.UseQueryOptions<CityQuery, CityQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CityQuery, CityQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CityQuery, CityQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<CityQuery, CityQueryVariables>(CityDocument, variables, options);
}
export type CityQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CityQuery, CityQueryVariables>;
export const ClientPermissionsDocument = gql`
    query ClientPermissions($scope: ClientPermissionsScopeInput!) {
  clientPermissions(clientPermissions: $scope)
}
    `;

/**
 * __useClientPermissionsQuery__
 *
 * To run a query within a Vue component, call `useClientPermissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientPermissionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useClientPermissionsQuery({
 *   scope: // value for 'scope'
 * });
 */
export function useClientPermissionsQuery(variables: ClientPermissionsQueryVariables | VueCompositionApi.Ref<ClientPermissionsQueryVariables> | ReactiveFunction<ClientPermissionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ClientPermissionsQuery, ClientPermissionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ClientPermissionsQuery, ClientPermissionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ClientPermissionsQuery, ClientPermissionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ClientPermissionsQuery, ClientPermissionsQueryVariables>(ClientPermissionsDocument, variables, options);
}
export function useClientPermissionsLazyQuery(variables?: ClientPermissionsQueryVariables | VueCompositionApi.Ref<ClientPermissionsQueryVariables> | ReactiveFunction<ClientPermissionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ClientPermissionsQuery, ClientPermissionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ClientPermissionsQuery, ClientPermissionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ClientPermissionsQuery, ClientPermissionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ClientPermissionsQuery, ClientPermissionsQueryVariables>(ClientPermissionsDocument, variables, options);
}
export type ClientPermissionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ClientPermissionsQuery, ClientPermissionsQueryVariables>;
export const CustomerClientDocument = gql`
    query CustomerClient($customerClientInput: CustomerClientInput!) {
  customerClient(customerClient: $customerClientInput) {
    id
    name
    features
    identityUsers {
      id
      firstName
      lastName
      fileUrl(version: SMALL)
      email
    }
    shops {
      id
      name
    }
  }
}
    `;

/**
 * __useCustomerClientQuery__
 *
 * To run a query within a Vue component, call `useCustomerClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerClientQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCustomerClientQuery({
 *   customerClientInput: // value for 'customerClientInput'
 * });
 */
export function useCustomerClientQuery(variables: CustomerClientQueryVariables | VueCompositionApi.Ref<CustomerClientQueryVariables> | ReactiveFunction<CustomerClientQueryVariables>, options: VueApolloComposable.UseQueryOptions<CustomerClientQuery, CustomerClientQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CustomerClientQuery, CustomerClientQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CustomerClientQuery, CustomerClientQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CustomerClientQuery, CustomerClientQueryVariables>(CustomerClientDocument, variables, options);
}
export function useCustomerClientLazyQuery(variables?: CustomerClientQueryVariables | VueCompositionApi.Ref<CustomerClientQueryVariables> | ReactiveFunction<CustomerClientQueryVariables>, options: VueApolloComposable.UseQueryOptions<CustomerClientQuery, CustomerClientQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CustomerClientQuery, CustomerClientQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CustomerClientQuery, CustomerClientQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<CustomerClientQuery, CustomerClientQueryVariables>(CustomerClientDocument, variables, options);
}
export type CustomerClientQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CustomerClientQuery, CustomerClientQueryVariables>;
export const CustomerClientsDocument = gql`
    query CustomerClients($customerClientsInput: CustomerClientsInput!, $pagination: PaginationInput) {
  customerClients(customerClients: $customerClientsInput, pagination: $pagination) {
    entries {
      id
      name
    }
    pagination {
      currentPage
      nextPage
      previousPage
      totalPages
    }
  }
}
    `;

/**
 * __useCustomerClientsQuery__
 *
 * To run a query within a Vue component, call `useCustomerClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerClientsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCustomerClientsQuery({
 *   customerClientsInput: // value for 'customerClientsInput'
 *   pagination: // value for 'pagination'
 * });
 */
export function useCustomerClientsQuery(variables: CustomerClientsQueryVariables | VueCompositionApi.Ref<CustomerClientsQueryVariables> | ReactiveFunction<CustomerClientsQueryVariables>, options: VueApolloComposable.UseQueryOptions<CustomerClientsQuery, CustomerClientsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CustomerClientsQuery, CustomerClientsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CustomerClientsQuery, CustomerClientsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CustomerClientsQuery, CustomerClientsQueryVariables>(CustomerClientsDocument, variables, options);
}
export function useCustomerClientsLazyQuery(variables?: CustomerClientsQueryVariables | VueCompositionApi.Ref<CustomerClientsQueryVariables> | ReactiveFunction<CustomerClientsQueryVariables>, options: VueApolloComposable.UseQueryOptions<CustomerClientsQuery, CustomerClientsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CustomerClientsQuery, CustomerClientsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CustomerClientsQuery, CustomerClientsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<CustomerClientsQuery, CustomerClientsQueryVariables>(CustomerClientsDocument, variables, options);
}
export type CustomerClientsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CustomerClientsQuery, CustomerClientsQueryVariables>;
export const EnumValuesDocument = gql`
    query EnumValues($name: String!) {
  enum: __type(name: $name) {
    enumValues(includeDeprecated: true) {
      name
      description
      isDeprecated
    }
  }
}
    `;

/**
 * __useEnumValuesQuery__
 *
 * To run a query within a Vue component, call `useEnumValuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnumValuesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useEnumValuesQuery({
 *   name: // value for 'name'
 * });
 */
export function useEnumValuesQuery(variables: EnumValuesQueryVariables | VueCompositionApi.Ref<EnumValuesQueryVariables> | ReactiveFunction<EnumValuesQueryVariables>, options: VueApolloComposable.UseQueryOptions<EnumValuesQuery, EnumValuesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<EnumValuesQuery, EnumValuesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<EnumValuesQuery, EnumValuesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<EnumValuesQuery, EnumValuesQueryVariables>(EnumValuesDocument, variables, options);
}
export function useEnumValuesLazyQuery(variables?: EnumValuesQueryVariables | VueCompositionApi.Ref<EnumValuesQueryVariables> | ReactiveFunction<EnumValuesQueryVariables>, options: VueApolloComposable.UseQueryOptions<EnumValuesQuery, EnumValuesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<EnumValuesQuery, EnumValuesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<EnumValuesQuery, EnumValuesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<EnumValuesQuery, EnumValuesQueryVariables>(EnumValuesDocument, variables, options);
}
export type EnumValuesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<EnumValuesQuery, EnumValuesQueryVariables>;
export const GenericProductBreadcrumbDocument = gql`
    query GenericProductBreadcrumb($id: ID!) {
  genericProduct(genericProduct: {id: $id}) {
    id
    name
    ancestors {
      id
      name
    }
  }
}
    `;

/**
 * __useGenericProductBreadcrumbQuery__
 *
 * To run a query within a Vue component, call `useGenericProductBreadcrumbQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenericProductBreadcrumbQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGenericProductBreadcrumbQuery({
 *   id: // value for 'id'
 * });
 */
export function useGenericProductBreadcrumbQuery(variables: GenericProductBreadcrumbQueryVariables | VueCompositionApi.Ref<GenericProductBreadcrumbQueryVariables> | ReactiveFunction<GenericProductBreadcrumbQueryVariables>, options: VueApolloComposable.UseQueryOptions<GenericProductBreadcrumbQuery, GenericProductBreadcrumbQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GenericProductBreadcrumbQuery, GenericProductBreadcrumbQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GenericProductBreadcrumbQuery, GenericProductBreadcrumbQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GenericProductBreadcrumbQuery, GenericProductBreadcrumbQueryVariables>(GenericProductBreadcrumbDocument, variables, options);
}
export function useGenericProductBreadcrumbLazyQuery(variables?: GenericProductBreadcrumbQueryVariables | VueCompositionApi.Ref<GenericProductBreadcrumbQueryVariables> | ReactiveFunction<GenericProductBreadcrumbQueryVariables>, options: VueApolloComposable.UseQueryOptions<GenericProductBreadcrumbQuery, GenericProductBreadcrumbQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GenericProductBreadcrumbQuery, GenericProductBreadcrumbQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GenericProductBreadcrumbQuery, GenericProductBreadcrumbQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GenericProductBreadcrumbQuery, GenericProductBreadcrumbQueryVariables>(GenericProductBreadcrumbDocument, variables, options);
}
export type GenericProductBreadcrumbQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GenericProductBreadcrumbQuery, GenericProductBreadcrumbQueryVariables>;
export const GenericProductCategoryBreadcrumbDocument = gql`
    query GenericProductCategoryBreadcrumb($id: ID) {
  genericProductCategory(genericProductCategory: {categoryId: $id}) {
    id
    name
    imageUrl(version: ORIGINAL)
    ancestors {
      id
      name
      imageUrl(version: ORIGINAL)
    }
  }
}
    `;

/**
 * __useGenericProductCategoryBreadcrumbQuery__
 *
 * To run a query within a Vue component, call `useGenericProductCategoryBreadcrumbQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenericProductCategoryBreadcrumbQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGenericProductCategoryBreadcrumbQuery({
 *   id: // value for 'id'
 * });
 */
export function useGenericProductCategoryBreadcrumbQuery(variables: GenericProductCategoryBreadcrumbQueryVariables | VueCompositionApi.Ref<GenericProductCategoryBreadcrumbQueryVariables> | ReactiveFunction<GenericProductCategoryBreadcrumbQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GenericProductCategoryBreadcrumbQuery, GenericProductCategoryBreadcrumbQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GenericProductCategoryBreadcrumbQuery, GenericProductCategoryBreadcrumbQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GenericProductCategoryBreadcrumbQuery, GenericProductCategoryBreadcrumbQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GenericProductCategoryBreadcrumbQuery, GenericProductCategoryBreadcrumbQueryVariables>(GenericProductCategoryBreadcrumbDocument, variables, options);
}
export function useGenericProductCategoryBreadcrumbLazyQuery(variables: GenericProductCategoryBreadcrumbQueryVariables | VueCompositionApi.Ref<GenericProductCategoryBreadcrumbQueryVariables> | ReactiveFunction<GenericProductCategoryBreadcrumbQueryVariables> = {}, options: VueApolloComposable.UseQueryOptions<GenericProductCategoryBreadcrumbQuery, GenericProductCategoryBreadcrumbQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GenericProductCategoryBreadcrumbQuery, GenericProductCategoryBreadcrumbQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GenericProductCategoryBreadcrumbQuery, GenericProductCategoryBreadcrumbQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GenericProductCategoryBreadcrumbQuery, GenericProductCategoryBreadcrumbQueryVariables>(GenericProductCategoryBreadcrumbDocument, variables, options);
}
export type GenericProductCategoryBreadcrumbQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GenericProductCategoryBreadcrumbQuery, GenericProductCategoryBreadcrumbQueryVariables>;
export const GenericProductCategoryDetailDocument = gql`
    query GenericProductCategoryDetail($id: ID!) {
  genericProductCategory(genericProductCategory: {categoryId: $id}) {
    ...GenericProductCategoryDetail
  }
}
    ${GenericProductCategoryDetailFragmentDoc}`;

/**
 * __useGenericProductCategoryDetailQuery__
 *
 * To run a query within a Vue component, call `useGenericProductCategoryDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenericProductCategoryDetailQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGenericProductCategoryDetailQuery({
 *   id: // value for 'id'
 * });
 */
export function useGenericProductCategoryDetailQuery(variables: GenericProductCategoryDetailQueryVariables | VueCompositionApi.Ref<GenericProductCategoryDetailQueryVariables> | ReactiveFunction<GenericProductCategoryDetailQueryVariables>, options: VueApolloComposable.UseQueryOptions<GenericProductCategoryDetailQuery, GenericProductCategoryDetailQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GenericProductCategoryDetailQuery, GenericProductCategoryDetailQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GenericProductCategoryDetailQuery, GenericProductCategoryDetailQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GenericProductCategoryDetailQuery, GenericProductCategoryDetailQueryVariables>(GenericProductCategoryDetailDocument, variables, options);
}
export function useGenericProductCategoryDetailLazyQuery(variables?: GenericProductCategoryDetailQueryVariables | VueCompositionApi.Ref<GenericProductCategoryDetailQueryVariables> | ReactiveFunction<GenericProductCategoryDetailQueryVariables>, options: VueApolloComposable.UseQueryOptions<GenericProductCategoryDetailQuery, GenericProductCategoryDetailQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GenericProductCategoryDetailQuery, GenericProductCategoryDetailQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GenericProductCategoryDetailQuery, GenericProductCategoryDetailQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GenericProductCategoryDetailQuery, GenericProductCategoryDetailQueryVariables>(GenericProductCategoryDetailDocument, variables, options);
}
export type GenericProductCategoryDetailQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GenericProductCategoryDetailQuery, GenericProductCategoryDetailQueryVariables>;
export const GenericProductDetailDocument = gql`
    query GenericProductDetail($id: ID!) {
  genericProduct(genericProduct: {id: $id}) {
    ...GenericProductDetail
  }
}
    ${GenericProductDetailFragmentDoc}`;

/**
 * __useGenericProductDetailQuery__
 *
 * To run a query within a Vue component, call `useGenericProductDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenericProductDetailQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGenericProductDetailQuery({
 *   id: // value for 'id'
 * });
 */
export function useGenericProductDetailQuery(variables: GenericProductDetailQueryVariables | VueCompositionApi.Ref<GenericProductDetailQueryVariables> | ReactiveFunction<GenericProductDetailQueryVariables>, options: VueApolloComposable.UseQueryOptions<GenericProductDetailQuery, GenericProductDetailQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GenericProductDetailQuery, GenericProductDetailQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GenericProductDetailQuery, GenericProductDetailQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GenericProductDetailQuery, GenericProductDetailQueryVariables>(GenericProductDetailDocument, variables, options);
}
export function useGenericProductDetailLazyQuery(variables?: GenericProductDetailQueryVariables | VueCompositionApi.Ref<GenericProductDetailQueryVariables> | ReactiveFunction<GenericProductDetailQueryVariables>, options: VueApolloComposable.UseQueryOptions<GenericProductDetailQuery, GenericProductDetailQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GenericProductDetailQuery, GenericProductDetailQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GenericProductDetailQuery, GenericProductDetailQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GenericProductDetailQuery, GenericProductDetailQueryVariables>(GenericProductDetailDocument, variables, options);
}
export type GenericProductDetailQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GenericProductDetailQuery, GenericProductDetailQueryVariables>;
export const GenericProductsDocument = gql`
    query GenericProducts($genericProductsArgs: GenericProductsInput!, $pagination: PaginationInput) {
  genericProducts(genericProducts: $genericProductsArgs, pagination: $pagination) {
    ...GenericProductDetail
  }
}
    ${GenericProductDetailFragmentDoc}`;

/**
 * __useGenericProductsQuery__
 *
 * To run a query within a Vue component, call `useGenericProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenericProductsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGenericProductsQuery({
 *   genericProductsArgs: // value for 'genericProductsArgs'
 *   pagination: // value for 'pagination'
 * });
 */
export function useGenericProductsQuery(variables: GenericProductsQueryVariables | VueCompositionApi.Ref<GenericProductsQueryVariables> | ReactiveFunction<GenericProductsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GenericProductsQuery, GenericProductsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GenericProductsQuery, GenericProductsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GenericProductsQuery, GenericProductsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GenericProductsQuery, GenericProductsQueryVariables>(GenericProductsDocument, variables, options);
}
export function useGenericProductsLazyQuery(variables?: GenericProductsQueryVariables | VueCompositionApi.Ref<GenericProductsQueryVariables> | ReactiveFunction<GenericProductsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GenericProductsQuery, GenericProductsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GenericProductsQuery, GenericProductsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GenericProductsQuery, GenericProductsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GenericProductsQuery, GenericProductsQueryVariables>(GenericProductsDocument, variables, options);
}
export type GenericProductsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GenericProductsQuery, GenericProductsQueryVariables>;
export const GenericTreeItemsDocument = gql`
    query GenericTreeItems($genericTreeItemsInput: GenericTreeItemsInput!, $pagination: PaginationInput) {
  genericTreeItems(
    genericTreeItems: $genericTreeItemsInput
    pagination: $pagination
  ) {
    entries {
      ...genericProductOverview
    }
    pagination {
      ...pagination
    }
  }
}
    ${GenericProductOverviewFragmentDoc}
${PaginationFragmentDoc}`;

/**
 * __useGenericTreeItemsQuery__
 *
 * To run a query within a Vue component, call `useGenericTreeItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGenericTreeItemsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGenericTreeItemsQuery({
 *   genericTreeItemsInput: // value for 'genericTreeItemsInput'
 *   pagination: // value for 'pagination'
 * });
 */
export function useGenericTreeItemsQuery(variables: GenericTreeItemsQueryVariables | VueCompositionApi.Ref<GenericTreeItemsQueryVariables> | ReactiveFunction<GenericTreeItemsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GenericTreeItemsQuery, GenericTreeItemsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GenericTreeItemsQuery, GenericTreeItemsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GenericTreeItemsQuery, GenericTreeItemsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GenericTreeItemsQuery, GenericTreeItemsQueryVariables>(GenericTreeItemsDocument, variables, options);
}
export function useGenericTreeItemsLazyQuery(variables?: GenericTreeItemsQueryVariables | VueCompositionApi.Ref<GenericTreeItemsQueryVariables> | ReactiveFunction<GenericTreeItemsQueryVariables>, options: VueApolloComposable.UseQueryOptions<GenericTreeItemsQuery, GenericTreeItemsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GenericTreeItemsQuery, GenericTreeItemsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GenericTreeItemsQuery, GenericTreeItemsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GenericTreeItemsQuery, GenericTreeItemsQueryVariables>(GenericTreeItemsDocument, variables, options);
}
export type GenericTreeItemsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GenericTreeItemsQuery, GenericTreeItemsQueryVariables>;
export const HotspotStatisticsDocument = gql`
    query HotspotStatistics($hotspotsStatistics: HotspotsStatisticsInput!) {
  hotspotsStatistics(hotspotsStatistics: $hotspotsStatistics) {
    brochureId
    externalUrl
    hotspotId
    linkClicks
    pageIndex
    productClicks
    productLinkClicks
    productName
    productTimeSpent
    productSource
    timesAddedToList
    searchImpressions
    searchProductClicks
    hotspot {
      __typename
      ... on HotspotProductEntity {
        id
        fileUrl(version: SMALL)
      }
    }
  }
}
    `;

/**
 * __useHotspotStatisticsQuery__
 *
 * To run a query within a Vue component, call `useHotspotStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHotspotStatisticsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useHotspotStatisticsQuery({
 *   hotspotsStatistics: // value for 'hotspotsStatistics'
 * });
 */
export function useHotspotStatisticsQuery(variables: HotspotStatisticsQueryVariables | VueCompositionApi.Ref<HotspotStatisticsQueryVariables> | ReactiveFunction<HotspotStatisticsQueryVariables>, options: VueApolloComposable.UseQueryOptions<HotspotStatisticsQuery, HotspotStatisticsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<HotspotStatisticsQuery, HotspotStatisticsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<HotspotStatisticsQuery, HotspotStatisticsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<HotspotStatisticsQuery, HotspotStatisticsQueryVariables>(HotspotStatisticsDocument, variables, options);
}
export function useHotspotStatisticsLazyQuery(variables?: HotspotStatisticsQueryVariables | VueCompositionApi.Ref<HotspotStatisticsQueryVariables> | ReactiveFunction<HotspotStatisticsQueryVariables>, options: VueApolloComposable.UseQueryOptions<HotspotStatisticsQuery, HotspotStatisticsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<HotspotStatisticsQuery, HotspotStatisticsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<HotspotStatisticsQuery, HotspotStatisticsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<HotspotStatisticsQuery, HotspotStatisticsQueryVariables>(HotspotStatisticsDocument, variables, options);
}
export type HotspotStatisticsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<HotspotStatisticsQuery, HotspotStatisticsQueryVariables>;
export const IdentityUserDocument = gql`
    query IdentityUser($id: ID!) {
  identityUser(identityUser: {id: $id}) {
    ...UserDetail
  }
}
    ${UserDetailFragmentDoc}`;

/**
 * __useIdentityUserQuery__
 *
 * To run a query within a Vue component, call `useIdentityUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdentityUserQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useIdentityUserQuery({
 *   id: // value for 'id'
 * });
 */
export function useIdentityUserQuery(variables: IdentityUserQueryVariables | VueCompositionApi.Ref<IdentityUserQueryVariables> | ReactiveFunction<IdentityUserQueryVariables>, options: VueApolloComposable.UseQueryOptions<IdentityUserQuery, IdentityUserQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IdentityUserQuery, IdentityUserQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IdentityUserQuery, IdentityUserQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<IdentityUserQuery, IdentityUserQueryVariables>(IdentityUserDocument, variables, options);
}
export function useIdentityUserLazyQuery(variables?: IdentityUserQueryVariables | VueCompositionApi.Ref<IdentityUserQueryVariables> | ReactiveFunction<IdentityUserQueryVariables>, options: VueApolloComposable.UseQueryOptions<IdentityUserQuery, IdentityUserQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IdentityUserQuery, IdentityUserQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IdentityUserQuery, IdentityUserQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<IdentityUserQuery, IdentityUserQueryVariables>(IdentityUserDocument, variables, options);
}
export type IdentityUserQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<IdentityUserQuery, IdentityUserQueryVariables>;
export const IdentityUsersDocument = gql`
    query IdentityUsers($identityUsers: IdentityUsersInput!, $pagination: PaginationInput!) {
  identityUsers(identityUsers: $identityUsers, pagination: $pagination) {
    entries {
      ...UserOverview
    }
    pagination {
      ...pagination
    }
  }
}
    ${UserOverviewFragmentDoc}
${PaginationFragmentDoc}`;

/**
 * __useIdentityUsersQuery__
 *
 * To run a query within a Vue component, call `useIdentityUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdentityUsersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useIdentityUsersQuery({
 *   identityUsers: // value for 'identityUsers'
 *   pagination: // value for 'pagination'
 * });
 */
export function useIdentityUsersQuery(variables: IdentityUsersQueryVariables | VueCompositionApi.Ref<IdentityUsersQueryVariables> | ReactiveFunction<IdentityUsersQueryVariables>, options: VueApolloComposable.UseQueryOptions<IdentityUsersQuery, IdentityUsersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IdentityUsersQuery, IdentityUsersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IdentityUsersQuery, IdentityUsersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<IdentityUsersQuery, IdentityUsersQueryVariables>(IdentityUsersDocument, variables, options);
}
export function useIdentityUsersLazyQuery(variables?: IdentityUsersQueryVariables | VueCompositionApi.Ref<IdentityUsersQueryVariables> | ReactiveFunction<IdentityUsersQueryVariables>, options: VueApolloComposable.UseQueryOptions<IdentityUsersQuery, IdentityUsersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<IdentityUsersQuery, IdentityUsersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<IdentityUsersQuery, IdentityUsersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<IdentityUsersQuery, IdentityUsersQueryVariables>(IdentityUsersDocument, variables, options);
}
export type IdentityUsersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<IdentityUsersQuery, IdentityUsersQueryVariables>;
export const LanguagesDocument = gql`
    query Languages {
  languages {
    fileUrl(version: SMALL)
    id
    name
    symbol
  }
}
    `;

/**
 * __useLanguagesQuery__
 *
 * To run a query within a Vue component, call `useLanguagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLanguagesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useLanguagesQuery();
 */
export function useLanguagesQuery(options: VueApolloComposable.UseQueryOptions<LanguagesQuery, LanguagesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LanguagesQuery, LanguagesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<LanguagesQuery, LanguagesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<LanguagesQuery, LanguagesQueryVariables>(LanguagesDocument, {}, options);
}
export function useLanguagesLazyQuery(options: VueApolloComposable.UseQueryOptions<LanguagesQuery, LanguagesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LanguagesQuery, LanguagesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<LanguagesQuery, LanguagesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<LanguagesQuery, LanguagesQueryVariables>(LanguagesDocument, {}, options);
}
export type LanguagesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<LanguagesQuery, LanguagesQueryVariables>;
export const MeDocument = gql`
    query me {
  me {
    id
    firstName
    lastName
    roles
    email
    fileUrl(version: SMALL)
    bio
  }
}
    `;

/**
 * __useMeQuery__
 *
 * To run a query within a Vue component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMeQuery();
 */
export function useMeQuery(options: VueApolloComposable.UseQueryOptions<MeQuery, MeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MeQuery, MeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MeQuery, MeQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<MeQuery, MeQueryVariables>(MeDocument, {}, options);
}
export function useMeLazyQuery(options: VueApolloComposable.UseQueryOptions<MeQuery, MeQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MeQuery, MeQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MeQuery, MeQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, {}, options);
}
export type MeQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<MeQuery, MeQueryVariables>;
export const MergeRequestDocument = gql`
    query MergeRequest($mergeRequest: MergeRequestInput!) {
  mergeRequest(mergeRequest: $mergeRequest) {
    ...mergeRequest
  }
}
    ${MergeRequestFragmentDoc}`;

/**
 * __useMergeRequestQuery__
 *
 * To run a query within a Vue component, call `useMergeRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useMergeRequestQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMergeRequestQuery({
 *   mergeRequest: // value for 'mergeRequest'
 * });
 */
export function useMergeRequestQuery(variables: MergeRequestQueryVariables | VueCompositionApi.Ref<MergeRequestQueryVariables> | ReactiveFunction<MergeRequestQueryVariables>, options: VueApolloComposable.UseQueryOptions<MergeRequestQuery, MergeRequestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MergeRequestQuery, MergeRequestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MergeRequestQuery, MergeRequestQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<MergeRequestQuery, MergeRequestQueryVariables>(MergeRequestDocument, variables, options);
}
export function useMergeRequestLazyQuery(variables?: MergeRequestQueryVariables | VueCompositionApi.Ref<MergeRequestQueryVariables> | ReactiveFunction<MergeRequestQueryVariables>, options: VueApolloComposable.UseQueryOptions<MergeRequestQuery, MergeRequestQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MergeRequestQuery, MergeRequestQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MergeRequestQuery, MergeRequestQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<MergeRequestQuery, MergeRequestQueryVariables>(MergeRequestDocument, variables, options);
}
export type MergeRequestQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<MergeRequestQuery, MergeRequestQueryVariables>;
export const MergeRequestsDocument = gql`
    query MergeRequests($mergeRequests: MergeRequestsInput!) {
  mergeRequests(mergeRequests: $mergeRequests) {
    id
    newBrochure {
      id
      publishedAt
      cover {
        fileUrl(version: SMALL)
      }
      language {
        id
        name
        symbol
      }
      assignee {
        firstName
        lastName
        fileUrl(version: SMALL)
      }
      mergeRequestAsNew {
        id
        status
      }
    }
    status
  }
}
    `;

/**
 * __useMergeRequestsQuery__
 *
 * To run a query within a Vue component, call `useMergeRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMergeRequestsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMergeRequestsQuery({
 *   mergeRequests: // value for 'mergeRequests'
 * });
 */
export function useMergeRequestsQuery(variables: MergeRequestsQueryVariables | VueCompositionApi.Ref<MergeRequestsQueryVariables> | ReactiveFunction<MergeRequestsQueryVariables>, options: VueApolloComposable.UseQueryOptions<MergeRequestsQuery, MergeRequestsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MergeRequestsQuery, MergeRequestsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MergeRequestsQuery, MergeRequestsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<MergeRequestsQuery, MergeRequestsQueryVariables>(MergeRequestsDocument, variables, options);
}
export function useMergeRequestsLazyQuery(variables?: MergeRequestsQueryVariables | VueCompositionApi.Ref<MergeRequestsQueryVariables> | ReactiveFunction<MergeRequestsQueryVariables>, options: VueApolloComposable.UseQueryOptions<MergeRequestsQuery, MergeRequestsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MergeRequestsQuery, MergeRequestsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MergeRequestsQuery, MergeRequestsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<MergeRequestsQuery, MergeRequestsQueryVariables>(MergeRequestsDocument, variables, options);
}
export type MergeRequestsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<MergeRequestsQuery, MergeRequestsQueryVariables>;
export const MyShopiShopBrochuresDocument = gql`
    query MyShopiShopBrochures($input: MyshopiShopBrochuresInput!, $pagination: PaginationInput!) {
  myshopiShopBrochures(myshopiShopBrochures: $input, pagination: $pagination) {
    entries {
      ...BrochureOverview
    }
  }
}
    ${BrochureOverviewFragmentDoc}`;

/**
 * __useMyShopiShopBrochuresQuery__
 *
 * To run a query within a Vue component, call `useMyShopiShopBrochuresQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyShopiShopBrochuresQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useMyShopiShopBrochuresQuery({
 *   input: // value for 'input'
 *   pagination: // value for 'pagination'
 * });
 */
export function useMyShopiShopBrochuresQuery(variables: MyShopiShopBrochuresQueryVariables | VueCompositionApi.Ref<MyShopiShopBrochuresQueryVariables> | ReactiveFunction<MyShopiShopBrochuresQueryVariables>, options: VueApolloComposable.UseQueryOptions<MyShopiShopBrochuresQuery, MyShopiShopBrochuresQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MyShopiShopBrochuresQuery, MyShopiShopBrochuresQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MyShopiShopBrochuresQuery, MyShopiShopBrochuresQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<MyShopiShopBrochuresQuery, MyShopiShopBrochuresQueryVariables>(MyShopiShopBrochuresDocument, variables, options);
}
export function useMyShopiShopBrochuresLazyQuery(variables?: MyShopiShopBrochuresQueryVariables | VueCompositionApi.Ref<MyShopiShopBrochuresQueryVariables> | ReactiveFunction<MyShopiShopBrochuresQueryVariables>, options: VueApolloComposable.UseQueryOptions<MyShopiShopBrochuresQuery, MyShopiShopBrochuresQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<MyShopiShopBrochuresQuery, MyShopiShopBrochuresQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<MyShopiShopBrochuresQuery, MyShopiShopBrochuresQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<MyShopiShopBrochuresQuery, MyShopiShopBrochuresQueryVariables>(MyShopiShopBrochuresDocument, variables, options);
}
export type MyShopiShopBrochuresQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<MyShopiShopBrochuresQuery, MyShopiShopBrochuresQueryVariables>;
export const OfferCategoriesDocument = gql`
    query OfferCategories($offerCategoriesInput: OfferCategoriesInput!, $pagination: PaginationInput) {
  offerCategories(offerCategories: $offerCategoriesInput, pagination: $pagination) {
    entries {
      id
      name
      offerCategoryTags {
        name
      }
      label
      syncSource {
        app {
          name
        }
      }
    }
    pagination {
      currentPage
      nextPage
      previousPage
      totalPages
    }
  }
}
    `;

/**
 * __useOfferCategoriesQuery__
 *
 * To run a query within a Vue component, call `useOfferCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfferCategoriesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useOfferCategoriesQuery({
 *   offerCategoriesInput: // value for 'offerCategoriesInput'
 *   pagination: // value for 'pagination'
 * });
 */
export function useOfferCategoriesQuery(variables: OfferCategoriesQueryVariables | VueCompositionApi.Ref<OfferCategoriesQueryVariables> | ReactiveFunction<OfferCategoriesQueryVariables>, options: VueApolloComposable.UseQueryOptions<OfferCategoriesQuery, OfferCategoriesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<OfferCategoriesQuery, OfferCategoriesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<OfferCategoriesQuery, OfferCategoriesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<OfferCategoriesQuery, OfferCategoriesQueryVariables>(OfferCategoriesDocument, variables, options);
}
export function useOfferCategoriesLazyQuery(variables?: OfferCategoriesQueryVariables | VueCompositionApi.Ref<OfferCategoriesQueryVariables> | ReactiveFunction<OfferCategoriesQueryVariables>, options: VueApolloComposable.UseQueryOptions<OfferCategoriesQuery, OfferCategoriesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<OfferCategoriesQuery, OfferCategoriesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<OfferCategoriesQuery, OfferCategoriesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<OfferCategoriesQuery, OfferCategoriesQueryVariables>(OfferCategoriesDocument, variables, options);
}
export type OfferCategoriesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<OfferCategoriesQuery, OfferCategoriesQueryVariables>;
export const OfferCategoryDocument = gql`
    query OfferCategory($offerCategoryInput: OfferCategoryInput!) {
  offerCategory(offerCategory: $offerCategoryInput) {
    id
    syncSource {
      app {
        name
      }
    }
    language {
      id
      name
      fileUrl(version: SMALL)
    }
    name
    offerCategoryTags {
      id
      name
    }
    offerCategoryBlacklistTags {
      id
      name
    }
    label
    position
    updatedAt
    shopCategories {
      id
      name
    }
  }
}
    `;

/**
 * __useOfferCategoryQuery__
 *
 * To run a query within a Vue component, call `useOfferCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfferCategoryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useOfferCategoryQuery({
 *   offerCategoryInput: // value for 'offerCategoryInput'
 * });
 */
export function useOfferCategoryQuery(variables: OfferCategoryQueryVariables | VueCompositionApi.Ref<OfferCategoryQueryVariables> | ReactiveFunction<OfferCategoryQueryVariables>, options: VueApolloComposable.UseQueryOptions<OfferCategoryQuery, OfferCategoryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<OfferCategoryQuery, OfferCategoryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<OfferCategoryQuery, OfferCategoryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<OfferCategoryQuery, OfferCategoryQueryVariables>(OfferCategoryDocument, variables, options);
}
export function useOfferCategoryLazyQuery(variables?: OfferCategoryQueryVariables | VueCompositionApi.Ref<OfferCategoryQueryVariables> | ReactiveFunction<OfferCategoryQueryVariables>, options: VueApolloComposable.UseQueryOptions<OfferCategoryQuery, OfferCategoryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<OfferCategoryQuery, OfferCategoryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<OfferCategoryQuery, OfferCategoryQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<OfferCategoryQuery, OfferCategoryQueryVariables>(OfferCategoryDocument, variables, options);
}
export type OfferCategoryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<OfferCategoryQuery, OfferCategoryQueryVariables>;
export const OfferCategoryTagSuggestionsDocument = gql`
    query offerCategoryTagSuggestions($input: OfferCategoryTagSuggestionsInput!) {
  offerCategoryTagSuggestions(offerCategoryTagSuggestions: $input) {
    id
    name
  }
}
    `;

/**
 * __useOfferCategoryTagSuggestionsQuery__
 *
 * To run a query within a Vue component, call `useOfferCategoryTagSuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfferCategoryTagSuggestionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useOfferCategoryTagSuggestionsQuery({
 *   input: // value for 'input'
 * });
 */
export function useOfferCategoryTagSuggestionsQuery(variables: OfferCategoryTagSuggestionsQueryVariables | VueCompositionApi.Ref<OfferCategoryTagSuggestionsQueryVariables> | ReactiveFunction<OfferCategoryTagSuggestionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<OfferCategoryTagSuggestionsQuery, OfferCategoryTagSuggestionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<OfferCategoryTagSuggestionsQuery, OfferCategoryTagSuggestionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<OfferCategoryTagSuggestionsQuery, OfferCategoryTagSuggestionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<OfferCategoryTagSuggestionsQuery, OfferCategoryTagSuggestionsQueryVariables>(OfferCategoryTagSuggestionsDocument, variables, options);
}
export function useOfferCategoryTagSuggestionsLazyQuery(variables?: OfferCategoryTagSuggestionsQueryVariables | VueCompositionApi.Ref<OfferCategoryTagSuggestionsQueryVariables> | ReactiveFunction<OfferCategoryTagSuggestionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<OfferCategoryTagSuggestionsQuery, OfferCategoryTagSuggestionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<OfferCategoryTagSuggestionsQuery, OfferCategoryTagSuggestionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<OfferCategoryTagSuggestionsQuery, OfferCategoryTagSuggestionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<OfferCategoryTagSuggestionsQuery, OfferCategoryTagSuggestionsQueryVariables>(OfferCategoryTagSuggestionsDocument, variables, options);
}
export type OfferCategoryTagSuggestionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<OfferCategoryTagSuggestionsQuery, OfferCategoryTagSuggestionsQueryVariables>;
export const OfferOcrSuggestionDocument = gql`
    query OfferOcrSuggestion($hotspot: OfferOcrSuggestionHotspotInput!, $processor: OfferOcrSuggestionProcessor!) {
  offerOcrSuggestion(hotspot: $hotspot, processor: $processor) {
    offerInputSuggestion {
      name
      brands {
        id
        name
      }
      offerCategories {
        id
        name
      }
      description
      priceBeforeDiscount
      discountPercent
      priceAfterDiscount
    }
    croppedBlocks {
      confidence
      paragraphs {
        confidence
        text
        brands {
          id
          name
        }
        offerCategories {
          id
          name
        }
      }
    }
    processor
    processorResponse
  }
}
    `;

/**
 * __useOfferOcrSuggestionQuery__
 *
 * To run a query within a Vue component, call `useOfferOcrSuggestionQuery` and pass it any options that fit your needs.
 * When your component renders, `useOfferOcrSuggestionQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useOfferOcrSuggestionQuery({
 *   hotspot: // value for 'hotspot'
 *   processor: // value for 'processor'
 * });
 */
export function useOfferOcrSuggestionQuery(variables: OfferOcrSuggestionQueryVariables | VueCompositionApi.Ref<OfferOcrSuggestionQueryVariables> | ReactiveFunction<OfferOcrSuggestionQueryVariables>, options: VueApolloComposable.UseQueryOptions<OfferOcrSuggestionQuery, OfferOcrSuggestionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<OfferOcrSuggestionQuery, OfferOcrSuggestionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<OfferOcrSuggestionQuery, OfferOcrSuggestionQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<OfferOcrSuggestionQuery, OfferOcrSuggestionQueryVariables>(OfferOcrSuggestionDocument, variables, options);
}
export function useOfferOcrSuggestionLazyQuery(variables?: OfferOcrSuggestionQueryVariables | VueCompositionApi.Ref<OfferOcrSuggestionQueryVariables> | ReactiveFunction<OfferOcrSuggestionQueryVariables>, options: VueApolloComposable.UseQueryOptions<OfferOcrSuggestionQuery, OfferOcrSuggestionQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<OfferOcrSuggestionQuery, OfferOcrSuggestionQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<OfferOcrSuggestionQuery, OfferOcrSuggestionQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<OfferOcrSuggestionQuery, OfferOcrSuggestionQueryVariables>(OfferOcrSuggestionDocument, variables, options);
}
export type OfferOcrSuggestionQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<OfferOcrSuggestionQuery, OfferOcrSuggestionQueryVariables>;
export const PagesWithHotspotsDocument = gql`
    query PagesWithHotspots($brochureRegionId: ID!, $pagination: PaginationInput!) {
  pagesWithHotspots(
    pagesWithHotspots: {brochureRegionId: $brochureRegionId}
    pagination: $pagination
  ) {
    entries {
      ...pageWithHotspots
    }
    pagination {
      ...pagination
    }
  }
}
    ${PageWithHotspotsFragmentDoc}
${PaginationFragmentDoc}`;

/**
 * __usePagesWithHotspotsQuery__
 *
 * To run a query within a Vue component, call `usePagesWithHotspotsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePagesWithHotspotsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePagesWithHotspotsQuery({
 *   brochureRegionId: // value for 'brochureRegionId'
 *   pagination: // value for 'pagination'
 * });
 */
export function usePagesWithHotspotsQuery(variables: PagesWithHotspotsQueryVariables | VueCompositionApi.Ref<PagesWithHotspotsQueryVariables> | ReactiveFunction<PagesWithHotspotsQueryVariables>, options: VueApolloComposable.UseQueryOptions<PagesWithHotspotsQuery, PagesWithHotspotsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PagesWithHotspotsQuery, PagesWithHotspotsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PagesWithHotspotsQuery, PagesWithHotspotsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<PagesWithHotspotsQuery, PagesWithHotspotsQueryVariables>(PagesWithHotspotsDocument, variables, options);
}
export function usePagesWithHotspotsLazyQuery(variables?: PagesWithHotspotsQueryVariables | VueCompositionApi.Ref<PagesWithHotspotsQueryVariables> | ReactiveFunction<PagesWithHotspotsQueryVariables>, options: VueApolloComposable.UseQueryOptions<PagesWithHotspotsQuery, PagesWithHotspotsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PagesWithHotspotsQuery, PagesWithHotspotsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PagesWithHotspotsQuery, PagesWithHotspotsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<PagesWithHotspotsQuery, PagesWithHotspotsQueryVariables>(PagesWithHotspotsDocument, variables, options);
}
export type PagesWithHotspotsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<PagesWithHotspotsQuery, PagesWithHotspotsQueryVariables>;
export const PagesWithHotspotsUrlsDocument = gql`
    query PagesWithHotspotsUrls($brochureRegionId: ID!, $pagination: PaginationInput!) {
  pagesWithHotspots(
    pagesWithHotspots: {brochureRegionId: $brochureRegionId}
    pagination: $pagination
  ) {
    entries {
      index
      hotspots {
        url
      }
    }
    pagination {
      ...pagination
    }
  }
}
    ${PaginationFragmentDoc}`;

/**
 * __usePagesWithHotspotsUrlsQuery__
 *
 * To run a query within a Vue component, call `usePagesWithHotspotsUrlsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePagesWithHotspotsUrlsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePagesWithHotspotsUrlsQuery({
 *   brochureRegionId: // value for 'brochureRegionId'
 *   pagination: // value for 'pagination'
 * });
 */
export function usePagesWithHotspotsUrlsQuery(variables: PagesWithHotspotsUrlsQueryVariables | VueCompositionApi.Ref<PagesWithHotspotsUrlsQueryVariables> | ReactiveFunction<PagesWithHotspotsUrlsQueryVariables>, options: VueApolloComposable.UseQueryOptions<PagesWithHotspotsUrlsQuery, PagesWithHotspotsUrlsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PagesWithHotspotsUrlsQuery, PagesWithHotspotsUrlsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PagesWithHotspotsUrlsQuery, PagesWithHotspotsUrlsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<PagesWithHotspotsUrlsQuery, PagesWithHotspotsUrlsQueryVariables>(PagesWithHotspotsUrlsDocument, variables, options);
}
export function usePagesWithHotspotsUrlsLazyQuery(variables?: PagesWithHotspotsUrlsQueryVariables | VueCompositionApi.Ref<PagesWithHotspotsUrlsQueryVariables> | ReactiveFunction<PagesWithHotspotsUrlsQueryVariables>, options: VueApolloComposable.UseQueryOptions<PagesWithHotspotsUrlsQuery, PagesWithHotspotsUrlsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PagesWithHotspotsUrlsQuery, PagesWithHotspotsUrlsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PagesWithHotspotsUrlsQuery, PagesWithHotspotsUrlsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<PagesWithHotspotsUrlsQuery, PagesWithHotspotsUrlsQueryVariables>(PagesWithHotspotsUrlsDocument, variables, options);
}
export type PagesWithHotspotsUrlsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<PagesWithHotspotsUrlsQuery, PagesWithHotspotsUrlsQueryVariables>;
export const ParserClassByUrlDocument = gql`
    query ParserClassByUrl($parserClassByUrl: ParserClassByUrlInput!) {
  parserClassByUrl(parserClassByUrl: $parserClassByUrl)
}
    `;

/**
 * __useParserClassByUrlQuery__
 *
 * To run a query within a Vue component, call `useParserClassByUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useParserClassByUrlQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useParserClassByUrlQuery({
 *   parserClassByUrl: // value for 'parserClassByUrl'
 * });
 */
export function useParserClassByUrlQuery(variables: ParserClassByUrlQueryVariables | VueCompositionApi.Ref<ParserClassByUrlQueryVariables> | ReactiveFunction<ParserClassByUrlQueryVariables>, options: VueApolloComposable.UseQueryOptions<ParserClassByUrlQuery, ParserClassByUrlQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ParserClassByUrlQuery, ParserClassByUrlQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ParserClassByUrlQuery, ParserClassByUrlQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ParserClassByUrlQuery, ParserClassByUrlQueryVariables>(ParserClassByUrlDocument, variables, options);
}
export function useParserClassByUrlLazyQuery(variables?: ParserClassByUrlQueryVariables | VueCompositionApi.Ref<ParserClassByUrlQueryVariables> | ReactiveFunction<ParserClassByUrlQueryVariables>, options: VueApolloComposable.UseQueryOptions<ParserClassByUrlQuery, ParserClassByUrlQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ParserClassByUrlQuery, ParserClassByUrlQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ParserClassByUrlQuery, ParserClassByUrlQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ParserClassByUrlQuery, ParserClassByUrlQueryVariables>(ParserClassByUrlDocument, variables, options);
}
export type ParserClassByUrlQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ParserClassByUrlQuery, ParserClassByUrlQueryVariables>;
export const ParserParametersDocument = gql`
    query ParserParameters($parserParameters: ParserParametersInput!) {
  parserParameters(parserParameters: $parserParameters) {
    parserClass
    parsers {
      region {
        id
      }
      url
    }
  }
}
    `;

/**
 * __useParserParametersQuery__
 *
 * To run a query within a Vue component, call `useParserParametersQuery` and pass it any options that fit your needs.
 * When your component renders, `useParserParametersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useParserParametersQuery({
 *   parserParameters: // value for 'parserParameters'
 * });
 */
export function useParserParametersQuery(variables: ParserParametersQueryVariables | VueCompositionApi.Ref<ParserParametersQueryVariables> | ReactiveFunction<ParserParametersQueryVariables>, options: VueApolloComposable.UseQueryOptions<ParserParametersQuery, ParserParametersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ParserParametersQuery, ParserParametersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ParserParametersQuery, ParserParametersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ParserParametersQuery, ParserParametersQueryVariables>(ParserParametersDocument, variables, options);
}
export function useParserParametersLazyQuery(variables?: ParserParametersQueryVariables | VueCompositionApi.Ref<ParserParametersQueryVariables> | ReactiveFunction<ParserParametersQueryVariables>, options: VueApolloComposable.UseQueryOptions<ParserParametersQuery, ParserParametersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ParserParametersQuery, ParserParametersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ParserParametersQuery, ParserParametersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ParserParametersQuery, ParserParametersQueryVariables>(ParserParametersDocument, variables, options);
}
export type ParserParametersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ParserParametersQuery, ParserParametersQueryVariables>;
export const PostProcessingStatusDocument = gql`
    query PostProcessingStatus($postProcessingStatus: PostProcessingStatusInput!) {
  postProcessingStatus(postProcessingStatus: $postProcessingStatus)
}
    `;

/**
 * __usePostProcessingStatusQuery__
 *
 * To run a query within a Vue component, call `usePostProcessingStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostProcessingStatusQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePostProcessingStatusQuery({
 *   postProcessingStatus: // value for 'postProcessingStatus'
 * });
 */
export function usePostProcessingStatusQuery(variables: PostProcessingStatusQueryVariables | VueCompositionApi.Ref<PostProcessingStatusQueryVariables> | ReactiveFunction<PostProcessingStatusQueryVariables>, options: VueApolloComposable.UseQueryOptions<PostProcessingStatusQuery, PostProcessingStatusQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PostProcessingStatusQuery, PostProcessingStatusQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PostProcessingStatusQuery, PostProcessingStatusQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<PostProcessingStatusQuery, PostProcessingStatusQueryVariables>(PostProcessingStatusDocument, variables, options);
}
export function usePostProcessingStatusLazyQuery(variables?: PostProcessingStatusQueryVariables | VueCompositionApi.Ref<PostProcessingStatusQueryVariables> | ReactiveFunction<PostProcessingStatusQueryVariables>, options: VueApolloComposable.UseQueryOptions<PostProcessingStatusQuery, PostProcessingStatusQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PostProcessingStatusQuery, PostProcessingStatusQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PostProcessingStatusQuery, PostProcessingStatusQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<PostProcessingStatusQuery, PostProcessingStatusQueryVariables>(PostProcessingStatusDocument, variables, options);
}
export type PostProcessingStatusQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<PostProcessingStatusQuery, PostProcessingStatusQueryVariables>;
export const PublicBrochuresDocument = gql`
    query PublicBrochures($input: PublicBrochuresInput!, $pagination: PaginationInput!, $cityId: ID) {
  publicBrochures(
    publicBrochures: $input
    cityId: $cityId
    pagination: $pagination
  ) {
    entries {
      id
      position
      positionFrozenTo
      cover {
        fileUrl(version: SMALL)
      }
      name
      publishedAt
      activeFrom
      expireAfter
      brochureCity(cityId: $cityId) {
        position
      }
    }
    pagination {
      currentPage
      totalPages
      nextPage
      previousPage
    }
  }
}
    `;

/**
 * __usePublicBrochuresQuery__
 *
 * To run a query within a Vue component, call `usePublicBrochuresQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicBrochuresQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = usePublicBrochuresQuery({
 *   input: // value for 'input'
 *   pagination: // value for 'pagination'
 *   cityId: // value for 'cityId'
 * });
 */
export function usePublicBrochuresQuery(variables: PublicBrochuresQueryVariables | VueCompositionApi.Ref<PublicBrochuresQueryVariables> | ReactiveFunction<PublicBrochuresQueryVariables>, options: VueApolloComposable.UseQueryOptions<PublicBrochuresQuery, PublicBrochuresQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PublicBrochuresQuery, PublicBrochuresQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PublicBrochuresQuery, PublicBrochuresQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<PublicBrochuresQuery, PublicBrochuresQueryVariables>(PublicBrochuresDocument, variables, options);
}
export function usePublicBrochuresLazyQuery(variables?: PublicBrochuresQueryVariables | VueCompositionApi.Ref<PublicBrochuresQueryVariables> | ReactiveFunction<PublicBrochuresQueryVariables>, options: VueApolloComposable.UseQueryOptions<PublicBrochuresQuery, PublicBrochuresQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<PublicBrochuresQuery, PublicBrochuresQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<PublicBrochuresQuery, PublicBrochuresQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<PublicBrochuresQuery, PublicBrochuresQueryVariables>(PublicBrochuresDocument, variables, options);
}
export type PublicBrochuresQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<PublicBrochuresQuery, PublicBrochuresQueryVariables>;
export const RegionsDocument = gql`
    query Regions($regions: RegionsInput!) {
  regions(regions: $regions) {
    __typename
    id
    name
    locationsCount
  }
}
    `;

/**
 * __useRegionsQuery__
 *
 * To run a query within a Vue component, call `useRegionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useRegionsQuery({
 *   regions: // value for 'regions'
 * });
 */
export function useRegionsQuery(variables: RegionsQueryVariables | VueCompositionApi.Ref<RegionsQueryVariables> | ReactiveFunction<RegionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<RegionsQuery, RegionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RegionsQuery, RegionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<RegionsQuery, RegionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<RegionsQuery, RegionsQueryVariables>(RegionsDocument, variables, options);
}
export function useRegionsLazyQuery(variables?: RegionsQueryVariables | VueCompositionApi.Ref<RegionsQueryVariables> | ReactiveFunction<RegionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<RegionsQuery, RegionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<RegionsQuery, RegionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<RegionsQuery, RegionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<RegionsQuery, RegionsQueryVariables>(RegionsDocument, variables, options);
}
export type RegionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<RegionsQuery, RegionsQueryVariables>;
export const SessionsDocument = gql`
    query Sessions($input: SessionsInput!) {
  sessions(sessions: $input) {
    totalSessionTime
    trackedAt
  }
}
    `;

/**
 * __useSessionsQuery__
 *
 * To run a query within a Vue component, call `useSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSessionsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSessionsQuery({
 *   input: // value for 'input'
 * });
 */
export function useSessionsQuery(variables: SessionsQueryVariables | VueCompositionApi.Ref<SessionsQueryVariables> | ReactiveFunction<SessionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<SessionsQuery, SessionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SessionsQuery, SessionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SessionsQuery, SessionsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SessionsQuery, SessionsQueryVariables>(SessionsDocument, variables, options);
}
export function useSessionsLazyQuery(variables?: SessionsQueryVariables | VueCompositionApi.Ref<SessionsQueryVariables> | ReactiveFunction<SessionsQueryVariables>, options: VueApolloComposable.UseQueryOptions<SessionsQuery, SessionsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SessionsQuery, SessionsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SessionsQuery, SessionsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SessionsQuery, SessionsQueryVariables>(SessionsDocument, variables, options);
}
export type SessionsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SessionsQuery, SessionsQueryVariables>;
export const ShopDocument = gql`
    query Shop($shop: ShopInput!) {
  shop(shop: $shop) {
    id
    name
    fileUrl(version: SMALL)
  }
}
    `;

/**
 * __useShopQuery__
 *
 * To run a query within a Vue component, call `useShopQuery` and pass it any options that fit your needs.
 * When your component renders, `useShopQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useShopQuery({
 *   shop: // value for 'shop'
 * });
 */
export function useShopQuery(variables: ShopQueryVariables | VueCompositionApi.Ref<ShopQueryVariables> | ReactiveFunction<ShopQueryVariables>, options: VueApolloComposable.UseQueryOptions<ShopQuery, ShopQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ShopQuery, ShopQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ShopQuery, ShopQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ShopQuery, ShopQueryVariables>(ShopDocument, variables, options);
}
export function useShopLazyQuery(variables?: ShopQueryVariables | VueCompositionApi.Ref<ShopQueryVariables> | ReactiveFunction<ShopQueryVariables>, options: VueApolloComposable.UseQueryOptions<ShopQuery, ShopQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ShopQuery, ShopQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ShopQuery, ShopQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ShopQuery, ShopQueryVariables>(ShopDocument, variables, options);
}
export type ShopQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ShopQuery, ShopQueryVariables>;
export const ShopCardTemplateDocument = gql`
    query ShopCardTemplate($input: ShopCardTemplateInput!) {
  shopCardTemplate(shopCardTemplate: $input) {
    ...ShopCardTemplateDetail
  }
}
    ${ShopCardTemplateDetailFragmentDoc}`;

/**
 * __useShopCardTemplateQuery__
 *
 * To run a query within a Vue component, call `useShopCardTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useShopCardTemplateQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useShopCardTemplateQuery({
 *   input: // value for 'input'
 * });
 */
export function useShopCardTemplateQuery(variables: ShopCardTemplateQueryVariables | VueCompositionApi.Ref<ShopCardTemplateQueryVariables> | ReactiveFunction<ShopCardTemplateQueryVariables>, options: VueApolloComposable.UseQueryOptions<ShopCardTemplateQuery, ShopCardTemplateQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ShopCardTemplateQuery, ShopCardTemplateQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ShopCardTemplateQuery, ShopCardTemplateQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ShopCardTemplateQuery, ShopCardTemplateQueryVariables>(ShopCardTemplateDocument, variables, options);
}
export function useShopCardTemplateLazyQuery(variables?: ShopCardTemplateQueryVariables | VueCompositionApi.Ref<ShopCardTemplateQueryVariables> | ReactiveFunction<ShopCardTemplateQueryVariables>, options: VueApolloComposable.UseQueryOptions<ShopCardTemplateQuery, ShopCardTemplateQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ShopCardTemplateQuery, ShopCardTemplateQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ShopCardTemplateQuery, ShopCardTemplateQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ShopCardTemplateQuery, ShopCardTemplateQueryVariables>(ShopCardTemplateDocument, variables, options);
}
export type ShopCardTemplateQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ShopCardTemplateQuery, ShopCardTemplateQueryVariables>;
export const ShopCardTemplatesDocument = gql`
    query ShopCardTemplates($input: ShopCardTemplatesInput!, $pagination: PaginationInput!) {
  shopCardTemplates(shopCardTemplates: $input, pagination: $pagination) {
    entries {
      id
      name
      fileUrl(version: MEDIUM)
      status
    }
    pagination {
      currentPage
      nextPage
      previousPage
      totalPages
    }
  }
}
    `;

/**
 * __useShopCardTemplatesQuery__
 *
 * To run a query within a Vue component, call `useShopCardTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useShopCardTemplatesQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useShopCardTemplatesQuery({
 *   input: // value for 'input'
 *   pagination: // value for 'pagination'
 * });
 */
export function useShopCardTemplatesQuery(variables: ShopCardTemplatesQueryVariables | VueCompositionApi.Ref<ShopCardTemplatesQueryVariables> | ReactiveFunction<ShopCardTemplatesQueryVariables>, options: VueApolloComposable.UseQueryOptions<ShopCardTemplatesQuery, ShopCardTemplatesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ShopCardTemplatesQuery, ShopCardTemplatesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ShopCardTemplatesQuery, ShopCardTemplatesQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ShopCardTemplatesQuery, ShopCardTemplatesQueryVariables>(ShopCardTemplatesDocument, variables, options);
}
export function useShopCardTemplatesLazyQuery(variables?: ShopCardTemplatesQueryVariables | VueCompositionApi.Ref<ShopCardTemplatesQueryVariables> | ReactiveFunction<ShopCardTemplatesQueryVariables>, options: VueApolloComposable.UseQueryOptions<ShopCardTemplatesQuery, ShopCardTemplatesQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ShopCardTemplatesQuery, ShopCardTemplatesQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ShopCardTemplatesQuery, ShopCardTemplatesQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ShopCardTemplatesQuery, ShopCardTemplatesQueryVariables>(ShopCardTemplatesDocument, variables, options);
}
export type ShopCardTemplatesQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ShopCardTemplatesQuery, ShopCardTemplatesQueryVariables>;
export const LocationDocument = gql`
    query Location($location: LocationInput!) {
  location(location: $location) {
    ...ShopLocation
  }
}
    ${ShopLocationFragmentDoc}`;

/**
 * __useLocationQuery__
 *
 * To run a query within a Vue component, call `useLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useLocationQuery({
 *   location: // value for 'location'
 * });
 */
export function useLocationQuery(variables: LocationQueryVariables | VueCompositionApi.Ref<LocationQueryVariables> | ReactiveFunction<LocationQueryVariables>, options: VueApolloComposable.UseQueryOptions<LocationQuery, LocationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LocationQuery, LocationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<LocationQuery, LocationQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<LocationQuery, LocationQueryVariables>(LocationDocument, variables, options);
}
export function useLocationLazyQuery(variables?: LocationQueryVariables | VueCompositionApi.Ref<LocationQueryVariables> | ReactiveFunction<LocationQueryVariables>, options: VueApolloComposable.UseQueryOptions<LocationQuery, LocationQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<LocationQuery, LocationQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<LocationQuery, LocationQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<LocationQuery, LocationQueryVariables>(LocationDocument, variables, options);
}
export type LocationQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<LocationQuery, LocationQueryVariables>;
export const ShopsDocument = gql`
    query Shops($shops: ShopsInput!, $pagination: PaginationInput) {
  shops(shops: $shops, pagination: $pagination) {
    entries {
      id
      name
      fileUrl(version: SMALL)
      customerClient {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useShopsQuery__
 *
 * To run a query within a Vue component, call `useShopsQuery` and pass it any options that fit your needs.
 * When your component renders, `useShopsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useShopsQuery({
 *   shops: // value for 'shops'
 *   pagination: // value for 'pagination'
 * });
 */
export function useShopsQuery(variables: ShopsQueryVariables | VueCompositionApi.Ref<ShopsQueryVariables> | ReactiveFunction<ShopsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ShopsQuery, ShopsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ShopsQuery, ShopsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ShopsQuery, ShopsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ShopsQuery, ShopsQueryVariables>(ShopsDocument, variables, options);
}
export function useShopsLazyQuery(variables?: ShopsQueryVariables | VueCompositionApi.Ref<ShopsQueryVariables> | ReactiveFunction<ShopsQueryVariables>, options: VueApolloComposable.UseQueryOptions<ShopsQuery, ShopsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ShopsQuery, ShopsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ShopsQuery, ShopsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ShopsQuery, ShopsQueryVariables>(ShopsDocument, variables, options);
}
export type ShopsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ShopsQuery, ShopsQueryVariables>;
export const TagStatisticsDocument = gql`
    query TagStatistics($tagStatisticsInput: TagStatisticsInput!) {
  tagStatistics(tagStatistics: $tagStatisticsInput) {
    totalTagged
    taggedAt
  }
}
    `;

/**
 * __useTagStatisticsQuery__
 *
 * To run a query within a Vue component, call `useTagStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagStatisticsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTagStatisticsQuery({
 *   tagStatisticsInput: // value for 'tagStatisticsInput'
 * });
 */
export function useTagStatisticsQuery(variables: TagStatisticsQueryVariables | VueCompositionApi.Ref<TagStatisticsQueryVariables> | ReactiveFunction<TagStatisticsQueryVariables>, options: VueApolloComposable.UseQueryOptions<TagStatisticsQuery, TagStatisticsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TagStatisticsQuery, TagStatisticsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TagStatisticsQuery, TagStatisticsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TagStatisticsQuery, TagStatisticsQueryVariables>(TagStatisticsDocument, variables, options);
}
export function useTagStatisticsLazyQuery(variables?: TagStatisticsQueryVariables | VueCompositionApi.Ref<TagStatisticsQueryVariables> | ReactiveFunction<TagStatisticsQueryVariables>, options: VueApolloComposable.UseQueryOptions<TagStatisticsQuery, TagStatisticsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TagStatisticsQuery, TagStatisticsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TagStatisticsQuery, TagStatisticsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TagStatisticsQuery, TagStatisticsQueryVariables>(TagStatisticsDocument, variables, options);
}
export type TagStatisticsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TagStatisticsQuery, TagStatisticsQueryVariables>;
export const TagStatisticsOverviewDocument = gql`
    query TagStatisticsOverview($tagStatisticsOverviewInput: TagStatisticsOverviewInput!) {
  tagStatisticsOverview(tagStatisticsOverview: $tagStatisticsOverviewInput) {
    userTagStatistics {
      totalTagged
      fullName
      totalSessionTime
    }
    tagStatisticsPerHotspot
    totalSessionTime
  }
}
    `;

/**
 * __useTagStatisticsOverviewQuery__
 *
 * To run a query within a Vue component, call `useTagStatisticsOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagStatisticsOverviewQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTagStatisticsOverviewQuery({
 *   tagStatisticsOverviewInput: // value for 'tagStatisticsOverviewInput'
 * });
 */
export function useTagStatisticsOverviewQuery(variables: TagStatisticsOverviewQueryVariables | VueCompositionApi.Ref<TagStatisticsOverviewQueryVariables> | ReactiveFunction<TagStatisticsOverviewQueryVariables>, options: VueApolloComposable.UseQueryOptions<TagStatisticsOverviewQuery, TagStatisticsOverviewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TagStatisticsOverviewQuery, TagStatisticsOverviewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TagStatisticsOverviewQuery, TagStatisticsOverviewQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TagStatisticsOverviewQuery, TagStatisticsOverviewQueryVariables>(TagStatisticsOverviewDocument, variables, options);
}
export function useTagStatisticsOverviewLazyQuery(variables?: TagStatisticsOverviewQueryVariables | VueCompositionApi.Ref<TagStatisticsOverviewQueryVariables> | ReactiveFunction<TagStatisticsOverviewQueryVariables>, options: VueApolloComposable.UseQueryOptions<TagStatisticsOverviewQuery, TagStatisticsOverviewQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TagStatisticsOverviewQuery, TagStatisticsOverviewQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TagStatisticsOverviewQuery, TagStatisticsOverviewQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TagStatisticsOverviewQuery, TagStatisticsOverviewQueryVariables>(TagStatisticsOverviewDocument, variables, options);
}
export type TagStatisticsOverviewQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TagStatisticsOverviewQuery, TagStatisticsOverviewQueryVariables>;
export const TaggingUsersDocument = gql`
    query TaggingUsers($taggingUsersInput: TaggingUsersInput!, $pagination: PaginationInput) {
  taggingUsers(taggingUsers: $taggingUsersInput, pagination: $pagination) {
    pagination {
      currentPage
      totalPages
      nextPage
      previousPage
    }
    entries {
      id
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useTaggingUsersQuery__
 *
 * To run a query within a Vue component, call `useTaggingUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaggingUsersQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useTaggingUsersQuery({
 *   taggingUsersInput: // value for 'taggingUsersInput'
 *   pagination: // value for 'pagination'
 * });
 */
export function useTaggingUsersQuery(variables: TaggingUsersQueryVariables | VueCompositionApi.Ref<TaggingUsersQueryVariables> | ReactiveFunction<TaggingUsersQueryVariables>, options: VueApolloComposable.UseQueryOptions<TaggingUsersQuery, TaggingUsersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TaggingUsersQuery, TaggingUsersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TaggingUsersQuery, TaggingUsersQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<TaggingUsersQuery, TaggingUsersQueryVariables>(TaggingUsersDocument, variables, options);
}
export function useTaggingUsersLazyQuery(variables?: TaggingUsersQueryVariables | VueCompositionApi.Ref<TaggingUsersQueryVariables> | ReactiveFunction<TaggingUsersQueryVariables>, options: VueApolloComposable.UseQueryOptions<TaggingUsersQuery, TaggingUsersQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<TaggingUsersQuery, TaggingUsersQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<TaggingUsersQuery, TaggingUsersQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<TaggingUsersQuery, TaggingUsersQueryVariables>(TaggingUsersDocument, variables, options);
}
export type TaggingUsersQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<TaggingUsersQuery, TaggingUsersQueryVariables>;
export const WebsitePageQueryDocument = gql`
    query WebsitePageQuery($websitePage: WebsitePageInput!) {
  websitePage(websitePage: $websitePage) {
    id
    content
    metaDescription
    metaTitle
    path
    title
    translationSetId
    language {
      id
    }
    ... on WebsitePagePage {
      positionInFooter
      contentBlocks
      titleQuestionsAnswers
      contentQuestionsAnswers {
        question
        answer
      }
    }
    ... on WebsitePagePost {
      coverImage(version: MEDIUM)
      publishedAt
      user {
        id
      }
      categories {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useWebsitePageQueryQuery__
 *
 * To run a query within a Vue component, call `useWebsitePageQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebsitePageQueryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useWebsitePageQueryQuery({
 *   websitePage: // value for 'websitePage'
 * });
 */
export function useWebsitePageQueryQuery(variables: WebsitePageQueryQueryVariables | VueCompositionApi.Ref<WebsitePageQueryQueryVariables> | ReactiveFunction<WebsitePageQueryQueryVariables>, options: VueApolloComposable.UseQueryOptions<WebsitePageQueryQuery, WebsitePageQueryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<WebsitePageQueryQuery, WebsitePageQueryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<WebsitePageQueryQuery, WebsitePageQueryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<WebsitePageQueryQuery, WebsitePageQueryQueryVariables>(WebsitePageQueryDocument, variables, options);
}
export function useWebsitePageQueryLazyQuery(variables?: WebsitePageQueryQueryVariables | VueCompositionApi.Ref<WebsitePageQueryQueryVariables> | ReactiveFunction<WebsitePageQueryQueryVariables>, options: VueApolloComposable.UseQueryOptions<WebsitePageQueryQuery, WebsitePageQueryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<WebsitePageQueryQuery, WebsitePageQueryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<WebsitePageQueryQuery, WebsitePageQueryQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<WebsitePageQueryQuery, WebsitePageQueryQueryVariables>(WebsitePageQueryDocument, variables, options);
}
export type WebsitePageQueryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<WebsitePageQueryQuery, WebsitePageQueryQueryVariables>;
export const WebsitePagesQueryDocument = gql`
    query WebsitePagesQuery($websitePages: WebsitePagesInput!, $pagination: PaginationInput!) {
  websitePages(websitePages: $websitePages, pagination: $pagination) {
    entries {
      id
      content
      metaDescription
      metaTitle
      path
      title
      translationSetId
      language {
        id
        name
        symbol
      }
      ... on WebsitePagePage {
        positionInFooter
      }
    }
    pagination {
      currentPage
      nextPage
      previousPage
      totalPages
    }
  }
}
    `;

/**
 * __useWebsitePagesQueryQuery__
 *
 * To run a query within a Vue component, call `useWebsitePagesQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useWebsitePagesQueryQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useWebsitePagesQueryQuery({
 *   websitePages: // value for 'websitePages'
 *   pagination: // value for 'pagination'
 * });
 */
export function useWebsitePagesQueryQuery(variables: WebsitePagesQueryQueryVariables | VueCompositionApi.Ref<WebsitePagesQueryQueryVariables> | ReactiveFunction<WebsitePagesQueryQueryVariables>, options: VueApolloComposable.UseQueryOptions<WebsitePagesQueryQuery, WebsitePagesQueryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<WebsitePagesQueryQuery, WebsitePagesQueryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<WebsitePagesQueryQuery, WebsitePagesQueryQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<WebsitePagesQueryQuery, WebsitePagesQueryQueryVariables>(WebsitePagesQueryDocument, variables, options);
}
export function useWebsitePagesQueryLazyQuery(variables?: WebsitePagesQueryQueryVariables | VueCompositionApi.Ref<WebsitePagesQueryQueryVariables> | ReactiveFunction<WebsitePagesQueryQueryVariables>, options: VueApolloComposable.UseQueryOptions<WebsitePagesQueryQuery, WebsitePagesQueryQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<WebsitePagesQueryQuery, WebsitePagesQueryQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<WebsitePagesQueryQuery, WebsitePagesQueryQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<WebsitePagesQueryQuery, WebsitePagesQueryQueryVariables>(WebsitePagesQueryDocument, variables, options);
}
export type WebsitePagesQueryQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<WebsitePagesQueryQuery, WebsitePagesQueryQueryVariables>;
export const LocationImportedDocument = gql`
    subscription LocationImported($shopId: ID!) {
  locationImported(shopId: $shopId) {
    address
    city
    name
    point {
      latitude
      longitude
    }
    regionId
    zipCode
    shopId
  }
}
    `;

/**
 * __useLocationImportedSubscription__
 *
 * To run a query within a Vue component, call `useLocationImportedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useLocationImportedSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useLocationImportedSubscription({
 *   shopId: // value for 'shopId'
 * });
 */
export function useLocationImportedSubscription(variables: LocationImportedSubscriptionVariables | VueCompositionApi.Ref<LocationImportedSubscriptionVariables> | ReactiveFunction<LocationImportedSubscriptionVariables>, options: VueApolloComposable.UseSubscriptionOptions<LocationImportedSubscription, LocationImportedSubscriptionVariables> | VueCompositionApi.Ref<VueApolloComposable.UseSubscriptionOptions<LocationImportedSubscription, LocationImportedSubscriptionVariables>> | ReactiveFunction<VueApolloComposable.UseSubscriptionOptions<LocationImportedSubscription, LocationImportedSubscriptionVariables>> = {}) {
  return VueApolloComposable.useSubscription<LocationImportedSubscription, LocationImportedSubscriptionVariables>(LocationImportedDocument, variables, options);
}
export type LocationImportedSubscriptionCompositionFunctionResult = VueApolloComposable.UseSubscriptionReturn<LocationImportedSubscription, LocationImportedSubscriptionVariables>;
export const PdfMessageAddedDocument = gql`
    subscription pdfMessageAdded($pdfId: ID!) {
  pdfMessageAdded(pdfId: $pdfId) {
    coverUrl
    indexUrl
    message
    pdfId
  }
}
    `;

/**
 * __usePdfMessageAddedSubscription__
 *
 * To run a query within a Vue component, call `usePdfMessageAddedSubscription` and pass it any options that fit your needs.
 * When your component renders, `usePdfMessageAddedSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = usePdfMessageAddedSubscription({
 *   pdfId: // value for 'pdfId'
 * });
 */
export function usePdfMessageAddedSubscription(variables: PdfMessageAddedSubscriptionVariables | VueCompositionApi.Ref<PdfMessageAddedSubscriptionVariables> | ReactiveFunction<PdfMessageAddedSubscriptionVariables>, options: VueApolloComposable.UseSubscriptionOptions<PdfMessageAddedSubscription, PdfMessageAddedSubscriptionVariables> | VueCompositionApi.Ref<VueApolloComposable.UseSubscriptionOptions<PdfMessageAddedSubscription, PdfMessageAddedSubscriptionVariables>> | ReactiveFunction<VueApolloComposable.UseSubscriptionOptions<PdfMessageAddedSubscription, PdfMessageAddedSubscriptionVariables>> = {}) {
  return VueApolloComposable.useSubscription<PdfMessageAddedSubscription, PdfMessageAddedSubscriptionVariables>(PdfMessageAddedDocument, variables, options);
}
export type PdfMessageAddedSubscriptionCompositionFunctionResult = VueApolloComposable.UseSubscriptionReturn<PdfMessageAddedSubscription, PdfMessageAddedSubscriptionVariables>;
export const BrochureLogAddedDocument = gql`
    subscription brochureLogAdded($brochureId: ID!) {
  brochureLogAdded(brochureId: $brochureId) {
    content
    insertedAt
    level
    ... on CreateBrochureLog {
      createStatus
    }
  }
}
    `;

/**
 * __useBrochureLogAddedSubscription__
 *
 * To run a query within a Vue component, call `useBrochureLogAddedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useBrochureLogAddedSubscription` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the subscription
 * @param options that will be passed into the subscription, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/subscription.html#options;
 *
 * @example
 * const { result, loading, error } = useBrochureLogAddedSubscription({
 *   brochureId: // value for 'brochureId'
 * });
 */
export function useBrochureLogAddedSubscription(variables: BrochureLogAddedSubscriptionVariables | VueCompositionApi.Ref<BrochureLogAddedSubscriptionVariables> | ReactiveFunction<BrochureLogAddedSubscriptionVariables>, options: VueApolloComposable.UseSubscriptionOptions<BrochureLogAddedSubscription, BrochureLogAddedSubscriptionVariables> | VueCompositionApi.Ref<VueApolloComposable.UseSubscriptionOptions<BrochureLogAddedSubscription, BrochureLogAddedSubscriptionVariables>> | ReactiveFunction<VueApolloComposable.UseSubscriptionOptions<BrochureLogAddedSubscription, BrochureLogAddedSubscriptionVariables>> = {}) {
  return VueApolloComposable.useSubscription<BrochureLogAddedSubscription, BrochureLogAddedSubscriptionVariables>(BrochureLogAddedDocument, variables, options);
}
export type BrochureLogAddedSubscriptionCompositionFunctionResult = VueApolloComposable.UseSubscriptionReturn<BrochureLogAddedSubscription, BrochureLogAddedSubscriptionVariables>;